webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/dGRl6k/%3F1718182736761&title=The%20Epistle%20to%20the%20Romans%2C%20New%20International%20Commentary%20on%20the%20New%20Testament%20%28NICNT%29&summary=Douglas%20Moo%26%2339%3Bs%20work%20on%20the%20Epistle%20to%20the%20Romans%20is%20part%20of%20The%20New%20International%20Commentary%20on%20the%20New%20Testament.%20Prepared%20by%20some%20of%20the%20world%26%2339%3Bs%20leading%20scholars%2C%20the%20series%20provides%20an%20exposition%20of%20the%20New%20Testament%20books%20that%20is%20thorough%20and%20f&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/dGRl6k/%3F1718182736761",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Douglas%20Moo%26%2339%3Bs%20work%20on%20the%20Epistle%20to%20the%20Romans%20is%20part%20of%20The%20New%20International%20Commentary%20on%20the%20New%20Testament.%20Prepared%20by%20some%20of%20the%20wo%0Dhttps://textcafe.co/books/dGRl6k/%3F1718182736761&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/dGRl6k/%3F1718182736761&posttype=link&caption=Douglas%20Moo%26%2339%3Bs%20work%20on%20the%20Epistle%20to%20the%20Romans%20is%20part%20of%20The%20New%20International%20Commentary%20on%20the%20New%20Testament.%20Prepared%20by%20some%20of%20the%20world%26%2339%3Bs%20leading%20scholars%2C%20the%20series%20provides%20an%20exposition%20of%20the%20New%20Testament%20books%20that%20is%20thorough%20and%20f",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/dGRl6k/%3F1718182736761&description=Douglas%20Moo%26%2339%3Bs%20work%20on%20the%20Epistle%20to%20the%20Romans%20is%20part%20of%20The%20New%20International%20Commentary%20on%20the%20New%20Testament.%20Prepared%20by%20some%20of%20the%20world%26%2339%3Bs%20leading%20scholars%2C%20the%20series%20provides%20an%20exposition%20of%20the%20New%20Testament%20books%20that%20is%20thorough%20and%20f&media=https://textcafe.co/books/dGRl6k/tc-custom/9781467422697.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781467422697&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=q2NyCgAAQBAJ&amp;rdid=book-q2NyCgAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467422697').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/dGRl6k/tc-custom/9781467422697.jpg?1718182736761',
        alt: 'The Epistle to the Romans, New International Commentary on the New Testament (NICNT)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "eernicnt66ro0001", "eernicnt66ro0002", "eernicnt66ro0003", "eernicnt66ro0004", "eernicnt66ro0005", "eernicnt66ro0006", "eernicnt66ro0007", "eernicnt66ro0008", "eernicnt66ro0009", "eernicnt66ro0010", "eernicnt66ro0011", "eernicnt66ro0011a", "eernicnt66ro0011b", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/dGRl6k/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_eernicnt66ro0001__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_eernicnt66ro0001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_eernicnt66ro0001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_eernicnt66ro0002__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_eernicnt66ro0002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_eernicnt66ro0002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_eernicnt66ro0003__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_eernicnt66ro0003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_eernicnt66ro0003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eernicnt66ro0004__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eernicnt66ro0004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_eernicnt66ro0004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_eernicnt66ro0005__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_eernicnt66ro0005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_eernicnt66ro0005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_eernicnt66ro0006__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_eernicnt66ro0006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_eernicnt66ro0006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_eernicnt66ro0007__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_eernicnt66ro0007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_eernicnt66ro0007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_eernicnt66ro0008__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_eernicnt66ro0008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_eernicnt66ro0008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eernicnt66ro0009__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eernicnt66ro0009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_eernicnt66ro0009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eernicnt66ro0010__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eernicnt66ro0010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_eernicnt66ro0010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_eernicnt66ro0011__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_eernicnt66ro0011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_eernicnt66ro0011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_eernicnt66ro0011a__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_eernicnt66ro0011a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_eernicnt66ro0011a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_eernicnt66ro0011b__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_eernicnt66ro0011b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_eernicnt66ro0011b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_eernicnt66ro0011c__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_eernicnt66ro0011c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_eernicnt66ro0011c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_eernicnt66ro0011d__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_eernicnt66ro0011d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_eernicnt66ro0011d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_eernicnt66ro0011e__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_eernicnt66ro0011e___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_eernicnt66ro0011e__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_eernicnt66ro0011f__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_eernicnt66ro0011f___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_eernicnt66ro0011f__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_eernicnt66ro0011g__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_eernicnt66ro0011g___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_eernicnt66ro0011g__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_eernicnt66ro0011h__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_eernicnt66ro0011h___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_eernicnt66ro0011h__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_eernicnt66ro0011i__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_eernicnt66ro0011i___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_eernicnt66ro0011i__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_eernicnt66ro0012__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_eernicnt66ro0012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_eernicnt66ro0012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_eernicnt66ro0012a__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_eernicnt66ro0012a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_eernicnt66ro0012a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_eernicnt66ro0013__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_eernicnt66ro0013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_eernicnt66ro0013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_eernicnt66ro0013a__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_eernicnt66ro0013a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_eernicnt66ro0013a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_eernicnt66ro0014__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_eernicnt66ro0014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_eernicnt66ro0014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_eernicnt66ro0014a__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_eernicnt66ro0014a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_eernicnt66ro0014a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_eernicnt66ro0015__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_eernicnt66ro0015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_eernicnt66ro0015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_eernicnt66ro0015a__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_eernicnt66ro0015a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_eernicnt66ro0015a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_eernicnt66ro0016__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_eernicnt66ro0016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_eernicnt66ro0016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_eernicnt66ro0016a__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_eernicnt66ro0016a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_eernicnt66ro0016a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_eernicnt66ro0017__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_eernicnt66ro0017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_eernicnt66ro0017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_eernicnt66ro0018__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_eernicnt66ro0018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_eernicnt66ro0018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_eernicnt66ro0019__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_eernicnt66ro0019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_eernicnt66ro0019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_eernicnt66ro0019a__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_eernicnt66ro0019a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_eernicnt66ro0019a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_eernicnt66ro0020__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_eernicnt66ro0020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_eernicnt66ro0020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_eernicnt66ro0020a__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_eernicnt66ro0020a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_eernicnt66ro0020a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_eernicnt66ro0020b__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_eernicnt66ro0020b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_eernicnt66ro0020b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_eernicnt66ro0020c__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_eernicnt66ro0020c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_eernicnt66ro0020c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_eernicnt66ro0020d__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_eernicnt66ro0020d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_eernicnt66ro0020d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_eernicnt66ro0021__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_eernicnt66ro0021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_eernicnt66ro0021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_last__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_last__);
/*jshint esversion: 6 */















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/eernicnt66ro0001",
    "name": "eernicnt66ro0001",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_eernicnt66ro0001___default.a
  }, {
    "path": "/eernicnt66ro0002",
    "name": "eernicnt66ro0002",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_eernicnt66ro0002___default.a
  }, {
    "path": "/eernicnt66ro0003",
    "name": "eernicnt66ro0003",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_eernicnt66ro0003___default.a
  }, {
    "path": "/eernicnt66ro0004",
    "name": "eernicnt66ro0004",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_eernicnt66ro0004___default.a
  }, {
    "path": "/eernicnt66ro0005",
    "name": "eernicnt66ro0005",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_eernicnt66ro0005___default.a
  }, {
    "path": "/eernicnt66ro0006",
    "name": "eernicnt66ro0006",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_eernicnt66ro0006___default.a
  }, {
    "path": "/eernicnt66ro0007",
    "name": "eernicnt66ro0007",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_eernicnt66ro0007___default.a
  }, {
    "path": "/eernicnt66ro0008",
    "name": "eernicnt66ro0008",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_eernicnt66ro0008___default.a
  }, {
    "path": "/eernicnt66ro0009",
    "name": "eernicnt66ro0009",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_eernicnt66ro0009___default.a
  }, {
    "path": "/eernicnt66ro0010",
    "name": "eernicnt66ro0010",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_eernicnt66ro0010___default.a
  }, {
    "path": "/eernicnt66ro0011",
    "name": "eernicnt66ro0011",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_eernicnt66ro0011___default.a
  }, {
    "path": "/eernicnt66ro0011a",
    "name": "eernicnt66ro0011a",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_eernicnt66ro0011a___default.a
  }, {
    "path": "/eernicnt66ro0011b",
    "name": "eernicnt66ro0011b",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_eernicnt66ro0011b___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_44__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Douglas J. Moo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Douglas J. Moo")]), _vm._v(" is professor emeritus of biblical studies at Wheaton College. His other commentaries include the New International Commentary on the New Testament volume on Romans and the Pillar New Testament Commentary volume on James. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dGRl6k/tc-custom/9781467422697.jpg?1718182736761",
      "alt": "This image is the cover for the book The Epistle to the Romans, New International Commentary on the New Testament (NICNT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Epistle to the Romans, New International Commentary on the New Testament (NICNT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Douglas Moo's work on the Epistle to the Romans is part of The New International Commentary on the New Testament. Prepared by some of the world's leading scholars, the series provides an exposition of the New Testament books that is thorough and fully abreast of modern scholarship yet faithful to the Scriptures as the infallible Word of God.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cvi"
    }
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "750",
      "src": "images/eer-nicnt66ro-cover.jpg",
      "width": "530"
    }
  })])])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "bk"
    }
  }, [_c('p', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.i"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.ii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.iii"
    }
  }), _vm._v("The Epistle to the")]), _vm._v(" "), _c('p', {
    staticClass: "bk1"
  }, [_vm._v("ROMANS")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("DOUGLAS J. MOO")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ERDMANS")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("UBLISHING")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMPANY")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RAND")]), _vm._v(" R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("APIDS,")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ICHIGAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMBRIDGE,")]), _vm._v(" U"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("K"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")])])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.iv"
    }
  }), _vm._v("© 1996 Wm. B. Eerdmans Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("P.O. Box 163, Cambridge CB3 9PU U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Moo, Douglas J.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("The Epistle to the Romans / Douglas J. Moo")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("— (The new international commentary on the New Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Includes "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0008#BIBLIO"
    }
  }, [_vm._v("bibliographical references")]), _vm._v(" and "), _c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0018#INDEX1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("indexes.")])]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("eISBN 978-1-4674-2269-7")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 0-8028-2317-3")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("1. Bible. N.T. Romans—Commentaries. I. Title. II. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("BS2665.3.M55 1966")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("227′.107—dc20          96-26077")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0005#PRE1",
      "id": "rPRE1"
    }
  }, [_vm._v("Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0006#PRE2",
      "id": "rPRE2"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR",
      "id": "rABBR"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0008#BIBLIO",
      "id": "rBIBLIO"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO",
      "id": "rINTRO"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.1",
      "id": "rINTRO.1"
    }
  }, [_vm._v("I. General Circumstances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.2",
      "id": "rINTRO.2"
    }
  }, [_vm._v("II. Integrity, Literary History, and Text")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.3",
      "id": "rINTRO.3"
    }
  }, [_vm._v("III. Audience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.4",
      "id": "rINTRO.4"
    }
  }, [_vm._v("IV. Nature and Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.5",
      "id": "rINTRO.5"
    }
  }, [_vm._v("V. Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.6",
      "id": "rINTRO.6"
    }
  }, [_vm._v("VI. Theme")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.7",
      "id": "rINTRO.7"
    }
  }, [_vm._v("VII. Text and Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.8",
      "id": "rINTRO.8"
    }
  }, [_vm._v("VIII. Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0009#INTRO.9",
      "id": "rINTRO.9"
    }
  }, [_vm._v("IX. Analysis of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#pt01",
      "id": "rpt01"
    }
  }, [_vm._v("TEXT, EXPOSITION, AND NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1",
      "id": "rBODY1"
    }
  }, [_vm._v("I. The Letter Opening (1:1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3",
      "id": "rBODY3"
    }
  }, [_vm._v("II. The Heart of the Gospel: Justification by Faith (1:18–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5",
      "id": "rBODY5"
    }
  }, [_vm._v("III. The Assurance Provided by the Gospel: The Hope of Salvation (5:1–8:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7",
      "id": "rBODY7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "page.vi"
    }
  }), _vm._v("IV. The Defense of the Gospel: The Problem of Israel (9:1–11:36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8",
      "id": "rBODY8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. The Transforming Power of the Gospel: Christian Conduct (12:1–15:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY9",
      "id": "rBODY9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. The Letter Closing (15:14–16:27)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0012#notes",
      "id": "rnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_vm._v("INDEXES")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0018#INDEX1",
      "id": "rINDEX1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0019#INDEX2",
      "id": "rINDEX2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0020#INDEX3",
      "id": "rINDEX3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Scripture References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0021#INDEX4",
      "id": "rINDEX4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Early Extrabiblical Literature")])])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "PRE1"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.vii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rPRE1"
    }
  }, [_vm._v("EDITOR’S PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("With this volume a new day has dawned for this series of commentaries. Not only is it the first volume (not counting my own "), _c('i', [_vm._v("Philippians")]), _vm._v(") to appear under the third editorship of the series, but it is also the first among several of the new and/or replacement volumes that represent a younger generation of evangelical scholars, thus signaling in part the “coming of age” of evangelical scholarship at the end of the present millennium.")]), _vm._v(" "), _c('p', [_vm._v("Dr. Moo, for many years a teacher at the Trinity Evangelical Divinity School (Deerfield, Illinois) and editor of the "), _c('i', [_vm._v("Trinity Journal,")]), _vm._v(" brings to this commentary the rigors of a first-rate exegete who is equally concerned for the theological and practical implications of the text of Romans. In his “Author’s Preface,” he details the happy circumstances by which his (now completed) commentary became a part of the present series.")]), _vm._v(" "), _c('p', [_vm._v("But if this volume in some ways inaugurates a new day for the series, it also has some strong ties to the past. This series began in a context of evangelical theology that was also decidedly within the Reformed tradition. It is therefore fitting that the replacement commentary on Romans in particular, originally written by John Murray (professor of systematic theology at Westminster Theological Seminary), should be written by someone whose theological sympathies lie in this direction. Although it will be clear to the perceptive reader that Dr. Moo has struck an independent course at many significant places (most notably with his interpretation of 7:7–25), he has nonetheless here articulated a (more traditional) view of Romans that is not notably popular among Romans specialists these days. In so doing, he has put everyone in his debt with his careful and clear articulation of this view, and with his equally knowledgeable and gracious interaction with those who take different views. And his careful work on the details of the text, which made it such a joy to edit, also makes it a “must” commentary for those who want to get at the meaning of this crucial Pauline letter.")]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORDON")]), _vm._v(" D"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" F"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EE")])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "PRE2"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.viii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rPRE2"
    }
  }, [_vm._v("AUTHOR’S PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The “traditions-history” of this commentary is convoluted. In 1983 I was asked by Moody Press to contribute a commentary on Romans to their new Wycliffe Exegetical Commentary series. I began work and produced the first volume of that commentary in 1991 "), _c('i', [_vm._v("(Romans 1–8).")]), _vm._v(" Shortly after the appearance of that volume, however, Moody Press decided the cancel the series. I therefore began searching desperately for a publisher who would be willing to republish "), _c('i', [_vm._v("Romans 1–8")]), _vm._v(" along with the second volume of the commentary, on which I was already at work. In the providence of God, the William B. Eerdmans Publishing Company was at that very time seeking an author to write a revised commentary on Romans for their New International Commentary on the New Testament series. I gladly accepted their offer to put my commentary in their series.")]), _vm._v(" "), _c('p', [_vm._v("The very different natures of the two commentary series required rather extensive revisions of my first volume. This I found to be both a curse and a blessing. The curse was having to transfer much detailed argumentation of my Wycliffe volume into footnotes in the New International Commentary series—requiring extensive rewriting of both text and notes. But the blessing was that this rewriting enabled me to sharpen my arguments and improve my style at a number of places. Readers of my Wycliffe "), _c('i', [_vm._v("Romans 1–8")]), _vm._v(" should know, however, that I made few substantive changes—a nuance here, a caveat there, and, of course, interaction with scholarly literature that had appeared since "), _c('i', [_vm._v("Romans 1–8")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("I wrote in the preface to my Wycliffe volume that I did not (in 1990) regret my decision to write a commentary on the much-worked-over letter of Paul to the Romans. I still do not. For what makes study of Romans so challenging is just what makes it so rewarding—being forced to think about so many issues basic to Christian theology and practice. At the same time I am more convinced than ever of the need for interaction with the “new perspective on Paul” that I feature in this commentary. I pray that what I have "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.ix"
    }
  }), _vm._v("written will be of service to the church and that readers of this commentary will grow in that “practical divinity” which counts before God: “the doctrine of living to God,” as the Puritan divine William Ames put it.")]), _vm._v(" "), _c('p', [_vm._v("Many people contributed to this commentary. Several research assistants at Trinity Evangelical Divinity School helped compile bibliography and proofread various part of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(": Joe Anderson, Harrison Skeele, David Johnson, Jay Smith, and George Goldman. Many students, too numerous to mention, sharpened my thinking about the text through their papers and class interaction. I am grateful to the Board and Administration of Trinity for their generous sabbatical program. The editors of the Wycliffe volume, Moisés Silva and Ken Barker, helped me think through several issues and polish my grammar; their contributions may still be discerned in this revised commentary. And I want especially to thank Milton Essenburg at Eerdmans and Gordon Fee, series editor, for taking my commentary on and interacting fully with my work.")]), _vm._v(" "), _c('p', [_vm._v("Most of all, I thank my family, who have supported me and prayed for my work: my wife Jenny, and my children Jonathan, David, Lukas, Rebecca, and Christy. My youngest daughter (twelve years old), Christy, brought home to me just how long they have given this support when she commented as I finished the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(" that my Romans was as old as she was.")]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("D"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OUGLAS")]), _vm._v(" J"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OO")])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ABBR"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.x"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rABBR"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AAR"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AAR")]), _vm._v(" American Academy of Religion")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AB")]), _vm._v(" Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ABOTR.NAT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("ʾAbot R. Nat.")])]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ʾAbot de Rabbi Nathan")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ABOD.ZAR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("ʿAbod. Zar.")])]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ʿAboda Zara")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-sm"
  }, [_vm._v("A.D.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("anno Domini")]), _vm._v(" (in the year of our Lord)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Add. Esth.")]), _vm._v(" Additions to Esther")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Adv. Haer.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Adversus Haereses")]), _vm._v(" (Irenaeus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AG.AP"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Ag. Ap.")]), _vm._v(" "), _c('i', [_vm._v("Against Apion")]), _vm._v(" (Josephus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AGAINSTJUL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Against Jul.")]), _vm._v(" "), _c('i', [_vm._v("Against Julian")]), _vm._v(" (Augustine)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ALBO"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ALBO")]), _vm._v(" Analecta lovaniensia biblica et orientalia")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ANBIB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AnBib")]), _vm._v(" Analecta Biblica")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ANN"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Ann.")]), _vm._v(" "), _c('i', [_vm._v("Annales")]), _vm._v(" (Tacitus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ANRW"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ANRW")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Aufstieg und Niedergang der römischen Welt")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ANT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Ant.")]), _vm._v(" "), _c('i', [_vm._v("Antiquities")]), _vm._v(" (Josephus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ANT.ROM"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Ant. Rom.")]), _vm._v(" "), _c('i', [_vm._v("Antiquities of Rome")]), _vm._v(" (Dionysius of Halicarnassus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.APOC.ABR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Apoc. Abr.")]), _vm._v(" "), _c('i', [_vm._v("Apocalypse of Abraham")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("2 Apoc. Bar.")]), _vm._v(" Syriac "), _c('i', [_vm._v("Apocalypse of Baruch")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.APOC.MOS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Apoc. Mos.")]), _vm._v(" "), _c('i', [_vm._v("Apocalypse of Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.APOL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Apol.")]), _vm._v(" "), _c('i', [_vm._v("Apology")]), _vm._v(" (Justin)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.APOSTCONST"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Apost. Const.")]), _vm._v(" "), _c('i', [_vm._v("Apostolic Constitutions")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AS.MOS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("As. Mos.")]), _vm._v(" "), _c('i', [_vm._v("Assumption of Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ATANT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ATANT")]), _vm._v(" Abhandlungen zur Theologie des Alten und Neuen Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AUSBR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AusBR")]), _vm._v(" "), _c('i', [_vm._v("Australian Biblical Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.AUSS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AUSS")]), _vm._v(" "), _c('i', [_vm._v("Andrews University Seminary Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BAGD"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BAGD")]), _vm._v(" W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, "), _c('i', [_vm._v("Greek-English Lexicon of the NT and Other Early Christian Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BAR"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Bar.")]), _vm._v(" Baruch")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Barn.")]), _vm._v(" "), _c('i', [_vm._v("Barnabas")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BBB"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xi"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("BBB")]), _vm._v(" Bonner biblische Beiträge")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BBET"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BBET")]), _vm._v(" Beiträge zur biblischen Exegese und Theologie")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-sm"
  }, [_vm._v("B.C.")]), _vm._v(" before Christ")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BDB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BDB")]), _vm._v(" F. Brown, S. R. Driver, and C. A. Briggs, "), _c('i', [_vm._v("Hebrew and English Lexicon of the OT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BDF"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BDF")]), _vm._v(" F. Blass, A. Debrunner, and R. W. Funk, "), _c('i', [_vm._v("A Greek Grammar of the NT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BDR"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BDR")]), _vm._v(" F. Blass, A. Debrunner, and F. Rehkopf, "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Grammatik des neutestamentlichen Griechisch")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BECNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BECNT")]), _vm._v(" Baker Exegetical Commentary on the NT")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BET"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BET")]), _vm._v(" Bibliotheca ecclesiastica. Torino")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BETL"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BETL")]), _vm._v(" Bibliotheca ephemeridum theologicarum lovaniensium")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BEVT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BEvT")]), _vm._v(" Beiträge zur evangelischen Theologie")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BFCT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BFCT")]), _vm._v(" Beiträge zur Förderung christlicher Theologie")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BIB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Bib.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BIBANT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Bib. Ant.")]), _vm._v(" "), _c('i', [_vm._v("Biblical Antiquities")]), _vm._v(" (Pseudo-Philo)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BJRL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BJRL")]), _vm._v(" "), _c('i', [_vm._v("Bulletin of the John Rylands Library of Manchester")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("B. Meṣ.")])]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Baba Meṣiʿa")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BSAC"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BSac")]), _vm._v(" "), _c('i', [_vm._v("Bibliotheca Sacra")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BT")]), _vm._v(" "), _c('i', [_vm._v("Bible Translator")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BTB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BTB")]), _vm._v(" "), _c('i', [_vm._v("Biblical Theology Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BWANT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BWANT")]), _vm._v(" Beitrage zur Wissenschaft vom Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BZ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BZ")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Biblische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BZHT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BZHT")]), _vm._v(" Beihefte zur historischen Theologie")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.BZNW"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BZNW")]), _vm._v(" Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.C"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("c.")]), _vm._v(" "), _c('i', [_vm._v("circa")]), _vm._v(" (around)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.CBNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CBNT")]), _vm._v(" Coniectanea biblica. NT")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.CBQ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("CBQ")]), _vm._v(" "), _c('i', [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.CD"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("CD")]), _vm._v(" "), _c('i', [_vm._v("Church Dogmatics")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.CD2"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CD")]), _vm._v(" Cairo Damascus (Document)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.CENT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("cent.")]), _vm._v(" century")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("cf.")]), _vm._v(" confer (compare)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("chaps.")]), _vm._v(" chapters")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("1 Clem.")]), _vm._v(" "), _c('i', [_vm._v("1 Clement")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.COL"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("col.")]), _vm._v(" column")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.CRINT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("CRINT")]), _vm._v(" Compendia rerum iudaicarum ad Novum Testamentum")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Cyr.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Cyropaedia")]), _vm._v(" (Xenophon)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.DID"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Did.")]), _vm._v(" "), _c('i', [_vm._v("Didache")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.DISS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("diss.")]), _vm._v(" dissertation")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Diss.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dissertationes")]), _vm._v(" (Epictetus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.DSS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("DSS")]), _vm._v(" Dead Sea Scrolls")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EBIB"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xii"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("Ebib")]), _vm._v(" Etudes bibliques")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Ecclus.")]), _vm._v(" Ecclesiasticus")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ed.")]), _vm._v(" editor, edition")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EDNT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("EDNT")]), _vm._v(" H. Balz and G. Schneider (eds.), "), _c('i', [_vm._v("Exegetical Dictionary of the NT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("e.g.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("exempli gratia")]), _vm._v(" (for example)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EKKNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("EKKNT")]), _vm._v(" Evangelisch-katholischer Kommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EP.ARIST"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Ep. Arist.")]), _vm._v(" "), _c('i', [_vm._v("Epistle of Aristeas")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Eph.")]), _vm._v(" "), _c('i', [_vm._v("Ephesians")]), _vm._v(" (Ignatius)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EQ.MAG"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Eq. Mag.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("De Equitum Magistro")]), _vm._v(" (Xenophon)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM1ESDR"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1 Esdr.")]), _vm._v(" 1 Esdras")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("esp.")]), _vm._v(" especially")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ET"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ET")]), _vm._v(" English translation")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ETL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ETL")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ephemerides theologicae lovanienses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ETR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ETR")]), _vm._v(" "), _c('i', [_vm._v("Etudes théologiques et religieuses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EVQ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("EvQ")]), _vm._v(" "), _c('i', [_vm._v("Evangelical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EVT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("EvT")]), _vm._v(" "), _c('i', [_vm._v("Evangelische Theologie")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EXOD.RAB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Exod. Rab.")]), _vm._v(" "), _c('i', [_vm._v("Exodus Rabbah")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.EXPTIM"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ExpTim")]), _vm._v(" "), _c('i', [_vm._v("Expository Times")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.FBBS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FBBS")]), _vm._v(" Facet Books, Biblical Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.FRLANT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FRLANT")]), _vm._v(" Forschungen zur Religion und Literatur des Alten und Neuen Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.FZB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FzB")]), _vm._v(" Forschungen zur Bibel")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.GEL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("GEL")]), _vm._v(" J. Louw and E. Nida (eds.), "), _c('i', [_vm._v("Greek-English Lexicon")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.GEN.RAB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Gen. Rab.")]), _vm._v(" "), _c('i', [_vm._v("Genesis Rabbah")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.GERM"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Germ.")]), _vm._v(" German")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Gk.")]), _vm._v(" Greek")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Haer.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Haereses")]), _vm._v(" (Epiphanius)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HBT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HBT")]), _vm._v(" "), _c('i', [_vm._v("Horizons in Biblical Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("H.E.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Historia Ecclesiastica")]), _vm._v(" (Eusebius)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Heb.")]), _vm._v(" Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Herm. "), _c('i', [_vm._v("Sim.")])]), _vm._v(" Hermas, "), _c('i', [_vm._v("Similitudes")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HERM.VIS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Herm. "), _c('i', [_vm._v("Vis.")])]), _vm._v(" Hermas, "), _c('i', [_vm._v("Visions")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Hist.")]), _vm._v(" "), _c('i', [_vm._v("Historia")]), _vm._v(" (Polybius)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HKNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HKNT")]), _vm._v(" Handkommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HNT")]), _vm._v(" Handbuch zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HNTC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HNTC")]), _vm._v(" Harper’s NT Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HTKNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HTKNT")]), _vm._v(" Herders theologischer Kommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HTR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HTR")]), _vm._v(" "), _c('i', [_vm._v("Harvard Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HUCA"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HUCA")]), _vm._v(" "), _c('i', [_vm._v("Hebrew Union College Annual")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.HUTH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HUTh")]), _vm._v(" Hermeneutische Untersuchungen zur Theologie")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xiii"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_c('i', [_vm._v("IB")])]), _vm._v(" "), _c('i', [_vm._v("Interpreter’s Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ICC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ICC")]), _vm._v(" International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.IDBSUP"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IDBSup")]), _vm._v(" G. A. Buttrick (ed.), "), _c('i', [_vm._v("Interpreter’s Dictionary of the Bible, Supplementary Volume")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("i.e.")]), _vm._v(" "), _c('i', [_vm._v("id est")]), _vm._v(" (that is)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.INT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Int")]), _vm._v(" "), _c('i', [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ITQ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ITQ")]), _vm._v(" "), _c('i', [_vm._v("Irish Theological Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JAAR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JAAR")]), _vm._v(" "), _c('i', [_vm._v("Journal of the American Academy of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JAC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JAC")]), _vm._v(" Jahrbuch für Antike und Christentum")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JB")]), _vm._v(" Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JBL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JBL")]), _vm._v(" "), _c('i', [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JETS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JETS")]), _vm._v(" "), _c('i', [_vm._v("Journal of the Evangelical Theological Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JOS.ANDAS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Jos. and As.")]), _vm._v(" "), _c('i', [_vm._v("Joseph and Asenath")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JPS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JPS")]), _vm._v(" Jewish Publication Society")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.J.W"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Jewish War")]), _vm._v(" (Josephus)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JR")]), _vm._v(" "), _c('i', [_vm._v("Journal of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JSNT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSNT")]), _vm._v(" "), _c('i', [_vm._v("Journal for the Study of the NT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JSNTSUP"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JSNTSup")]), _vm._v(" "), _c('i', [_vm._v("Journal for the Study of the NT,")]), _vm._v(" Supplementary Volume")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JSOT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSOT")]), _vm._v(" "), _c('i', [_vm._v("Journal for the Study of the OT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.JTS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JTS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Jub.")]), _vm._v(" "), _c('i', [_vm._v("Jubilees")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Jud.")]), _vm._v(" Judith")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.KD"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("KD")]), _vm._v(" "), _c('i', [_vm._v("Kerygma und Dogma")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1, 2, 3, and 4 Kgdms.")]), _vm._v(" 1, 2, 3, and 4 Kingdoms")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.KJV"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("KJV")]), _vm._v(" King James Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("J.W.")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LAT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Lat.")]), _vm._v(" Latin")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LD"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LD")]), _vm._v(" Lectio divina")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LIT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("lit.")]), _vm._v(" literally")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LSJ"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LSJ")]), _vm._v(" Liddell-Scott-Jones, "), _c('i', [_vm._v("Greek-English Lexicon")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LUA"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LUÅ")]), _vm._v(" Lunds universiteits årsskrift")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LW"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("LW")]), _vm._v(" "), _c('i', [_vm._v("Lutheran World")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.LXX"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LXX")]), _vm._v(" The Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1, 2, 3, and 4 Macc.")]), _vm._v(" 1, 2, 3, and 4 Maccabees")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MEK"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Mek.")]), _vm._v(" "), _c('i', [_vm._v("Mekilta")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MEYERK"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MeyerK")]), _vm._v(" H. A. W. Meyer, "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Kritisch-exegetischer Kommentar über das Neue Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MIDR.QOH"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Midr. Qoh.")]), _vm._v(" "), _c('i', [_vm._v("Midrash Qohelet")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("mg.")]), _vm._v(" margin")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MM"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MM")]), _vm._v(" J. H. Moulton and G. Milligan, "), _c('i', [_vm._v("The Vocabulary of the Greek Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MNTC"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xiv"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("MNTC")]), _vm._v(" Moffatt NT Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MS(S)")]), _vm._v(" manuscript(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MSS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MS(S)")]), _vm._v(" manuscript(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MT")]), _vm._v(" Massoretic Text")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.MTZ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("MTZ")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Munchener theologische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NA"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NA")]), _vm._v(" Nestle-Aland, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum Graece,")]), _vm._v(" 27th ed.")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NAB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NAB")]), _vm._v(" New American Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NASB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NASB")]), _vm._v(" New American Standard Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.N.D"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("n.d.")]), _vm._v(" no date")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NEB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NEB")]), _vm._v(" New English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NEOT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Neot")]), _vm._v(" "), _c('i', [_vm._v("Neotestamentica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("New Docs.")]), _vm._v(" "), _c('i', [_vm._v("New Documents Illustrating Early Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NICNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NICNT")]), _vm._v(" New International Commentary on the NT")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NICOT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NICOT")]), _vm._v(" New International Commentary on the OT")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NIDNTT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NIDNTT")]), _vm._v(" "), _c('i', [_vm._v("New International Dictionary of NT Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NIGTC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIGTC")]), _vm._v(" New International Greek Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NIV"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIV")]), _vm._v(" New International Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NJB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NJB")]), _vm._v(" New Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NKZ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NKZ")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Neue kirchliche Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("n(n).")]), _vm._v(" note(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NOVT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NovT")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NOVTSUP"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NovTSup")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum,")]), _vm._v(" Supplements")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NPNF"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NPNF")]), _vm._v(" "), _c('i', [_vm._v("Nicene and Post-Nicene Fathers")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NRSV"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NRSV")]), _vm._v(" New Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NRT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NRT")]), _vm._v(" "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("La nouvelle revue théologique")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.N.S"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("n.s.")]), _vm._v(" new series")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NT")]), _vm._v(" New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NTA")]), _vm._v(" "), _c('i', [_vm._v("New Testament Abstracts")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NTABH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NTAbh")]), _vm._v(" Neutestamentliche Abhandlungen")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NTD"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NTD")]), _vm._v(" Das Neue Testament Deutsch")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NTS"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NTS")]), _vm._v(" "), _c('i', [_vm._v("New Testament Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NTTS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NTTS")]), _vm._v(" New Testament Tools and Studies")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Odes Sol.")]), _vm._v(" "), _c('i', [_vm._v("Odes of Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.OL"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OL")]), _vm._v(" Old Latin")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OT")]), _vm._v(" Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PAR"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("par(s).")]), _vm._v(" parallels")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PARS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("par(s).")]), _vm._v(" parallels")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Par. Jer.")]), _vm._v(" "), _c('i', [_vm._v("Paralipomena Jeremiou")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PESAH"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("Pesaḥ.")])]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Pesaḥim")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PESIQ.R"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Pesiq. R.")]), _vm._v(" "), _c('i', [_vm._v("Pesiqta Rabbati")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PG"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PG")]), _vm._v(" J. Migne, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Patrologia Graeca")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PL")]), _vm._v(" J. Migne, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Patrologia Latina")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Plant.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("De Plantis")]), _vm._v(" (Aristotle)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.POL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Pol.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Politica")]), _vm._v(" (Aristotle)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xv"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("P.Oxy.")]), _vm._v(" "), _c('i', [_vm._v("Oxyrhynchus Papyri")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Prel. Stud.")]), _vm._v(" "), _c('i', [_vm._v("Preliminary Studies")]), _vm._v(" (Philo)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PR.MAN"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Pr. Man.")]), _vm._v(" Prayer of Manasseh")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Ps.-Clem. Hom.")]), _vm._v(" "), _c('i', [_vm._v("Pseudo-Clementine Homilies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.PSS.SOL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Pss. Sol.")]), _vm._v(" "), _c('i', [_vm._v("Psalms of Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.QIDD"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Qidd.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Qiddushin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM1QH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1QH")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Hôdāyôt")]), _vm._v(" (Thanksgiving Hymns) from Qumran Cave 1")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM1QM"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1QM")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Milḥāmāḥ")]), _vm._v(" "), _c('i', [_vm._v("(War Scroll) from Qumran Cave 1")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM1QPHAB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1QpHab")]), _vm._v(" Pesher on Habakkuk (Habakkuk Commentary) from Qumran Cave 1")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM1QPNAH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1QpNah")]), _vm._v(" Pesher on Nahum (Nahum Commentary) from Qumran Cave 1")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM1QS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("1QS")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Serek hayyaḥad")]), _vm._v(" (Rule of the Community) from Qumran Cave 1")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM4QFLOR"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("4QFlor")]), _vm._v(" "), _c('i', [_vm._v("Florilegium")]), _vm._v(" from Qumran Cave 4")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM4QMMT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("4QMMT")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Miqsat Maʿaseh")]), _vm._v(" "), _c('i', [_vm._v("Torah")]), _vm._v(" from Qumran Cave 4")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.NUM11QMELCH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("11QMelch")]), _vm._v(" "), _c('i', [_vm._v("Melchizedek")]), _vm._v(" text from Qumran Cave 11")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RB")]), _vm._v(" "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Revue biblique")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.REB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("REB")]), _vm._v(" Revised English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Res.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("De Resurrectione Carnis")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RESTQ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RestQ")]), _vm._v(" "), _c('i', [_vm._v("Restoration Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.REV.ED"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("rev. ed.")]), _vm._v(" revised edition")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.REVEXP"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RevExp")]), _vm._v(" "), _c('i', [_vm._v("Review and Expositor")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.REVISTB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RevistB")]), _vm._v(" "), _c('i', [_vm._v("Revista biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.REVQ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RevQ")]), _vm._v(" "), _c('i', [_vm._v("Revue de Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.REVTHOM"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RevThom")]), _vm._v(" "), _c('i', [_vm._v("Revue thomiste")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Rh.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Rhetorica")]), _vm._v(" (Aristotle)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RHPR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RHPR")]), _vm._v(" "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Revue d’histoire des religions")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("RNT")]), _vm._v(" Regensburger Neues Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RPT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("rpt.")]), _vm._v(" reprint")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RSPT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RSPT")]), _vm._v(" "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Revue des sciences philosophiques et theologiques")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RSR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RSR")]), _vm._v(" "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Recherches de science religieuse")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RSV"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("RSV")]), _vm._v(" Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.RTP"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RTP")]), _vm._v(" "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Revue de théologie et de philosophie")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SANH"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sanh.")]), _vm._v(" "), _c('i', [_vm._v("Sanhedrin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SANT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SANT")]), _vm._v(" Studien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SB")]), _vm._v(" Sources bibliques")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SBLDS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLDS")]), _vm._v(" Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SBS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBS")]), _vm._v(" Stuttgarter Bibelstudien")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SBT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBT")]), _vm._v(" Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SD"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SD")]), _vm._v(" Studies and Documents")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SE"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SE")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Studia Evangelica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SEA"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xvi"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SEÅ")]), _vm._v(" "), _c('i', [_vm._v("Svensk exegetisk årsbok")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("S-H")]), _vm._v(" W. Sanday and A. C. Headlam, "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SHABB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Shabb.")]), _vm._v(" "), _c('i', [_vm._v("Shabbat")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SIB.OR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sib. Or.")]), _vm._v(" "), _c('i', [_vm._v("Sibylline Oracles")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SIFREDEUT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sifre Deut.")]), _vm._v(" "), _c('i', [_vm._v("Sifre Deuteronomy")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sipre Lev.")]), _vm._v(" "), _c('i', [_vm._v("Sipre Leviticus")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sipre Num.")]), _vm._v(" "), _c('i', [_vm._v("Sipre Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Sir.")]), _vm._v(" Sirach")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SJLA"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SJLA")]), _vm._v(" Studies in Judaism in Late Antiquity")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SJT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SJT")]), _vm._v(" "), _c('i', [_vm._v("Scottish Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SMYRN"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Smyrn.")]), _vm._v(" "), _c('i', [_vm._v("To the Smyrneans")]), _vm._v(" (Ignatius)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SNT")]), _vm._v(" Studien zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SNTSMS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SNTSMS")]), _vm._v(" Society for NT Studies Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SPB"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SPB")]), _vm._v(" Studia postbiblica")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SPCIC"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SPCIC")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Studiorum Paulinorum Congressus Internationalis Catholicus")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ST"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ST")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Studia Theologica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("StrB")]), _vm._v(" H. Strack and P. Billerbeck, "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Kommentar zum Neuen Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.SUNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SUNT")]), _vm._v(" Studien zur Umwelt des Neuen Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TANCH.B"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Tanch. B.")]), _vm._v(" "), _c('i', [_vm._v("Tanchuma Buber")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TBEI"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TBei")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Theologische Beiträge")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TBL"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TBl")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Theologische Blätter")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TBU"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TBü")]), _vm._v(" Theologische Bücherei")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TDNT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TDNT")]), _vm._v(" "), _c('i', [_vm._v("Theological Dictionary of the NT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TDOT"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TDOT")]), _vm._v(" "), _c('i', [_vm._v("Theological Dictionary of the OT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TEV"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TEV")]), _vm._v(" Today’s English Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("T. 12 Patriarchs")]), _vm._v(" "), _c('i', [_vm._v("Testaments of the Twelve Patriarchs")]), _vm._v(" (listed individually)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.T.JOB"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("T. Job")]), _vm._v(" "), _c('i', [_vm._v("Testament of Job")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("T. Mos.")]), _vm._v(" "), _c('i', [_vm._v("Testament of Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TG.KET"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Tg. Ket.")]), _vm._v(" "), _c('i', [_vm._v("Targum of the Writings")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TG.NEOF"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Tg. Neof.")]), _vm._v(" "), _c('i', [_vm._v("Targum Neofiti")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.THKNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("THKNT")]), _vm._v(" Theologischer Handkommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TLZ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TLZ")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Theologische Literaturzeitung")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TNTC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TNTC")]), _vm._v(" Tyndale NT Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TOTC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TOTC")]), _vm._v(" Tyndale OT Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TP"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TP")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Theologie und Philosophie")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Tob.")]), _vm._v(" Tobit")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TRANS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("trans.")]), _vm._v(" translated by")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TRINJ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TrinJ")]), _vm._v(" "), _c('i', [_vm._v("Trinity Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TTODAY"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TToday")]), _vm._v(" "), _c('i', [_vm._v("Theology Today")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TYNBUL"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xvii"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TynBul")]), _vm._v(" "), _c('i', [_vm._v("Tyndale Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.TZ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TZ")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Theologische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.UBS"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("UBS")]), _vm._v(" United Bible Societies "), _c('i', [_vm._v("Greek New Testament,")]), _vm._v(" 4th ed.")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.UNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("UNT")]), _vm._v(" Unterschungen zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.USQR"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("USQR")]), _vm._v(" "), _c('i', [_vm._v("Union Seminary Quarterly Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.V.L"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("v.l.")]), _vm._v(" varia lectio (variant reading)")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("vol.")]), _vm._v(" volume")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("v(v.)")]), _vm._v(" verse(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WBC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WBC")]), _vm._v(" Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WEC"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WEC")]), _vm._v(" Wycliffe Exegetical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WH"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WH")]), _vm._v(" Westcott and Hort, "), _c('i', [_vm._v("Greek New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Wis.")]), _vm._v(" Wisdom of Solomon")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WMANT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WMANT")]), _vm._v(" Wissenschaftliche Monographien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WTJ"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("WTJ")]), _vm._v(" "), _c('i', [_vm._v("Westminster Theological Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WUNT"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WUNT")]), _vm._v(" Wissenschaftliche Untersuchungen zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.WW"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("WW")]), _vm._v(" "), _c('i', [_vm._v("Word and World")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.YAD"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Yad.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Yadayim")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.YEBAM"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Yebam.")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Yebamot")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ZG"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Z-G")]), _vm._v(" M. Zerwick and M. Grosvenor, "), _c('i', [_vm._v("A Grammatical Analysis of the Greek NT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ZNW"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZNW")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.ZTK"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZTK")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "BIBLIO"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xviii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rBIBLIO"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "ahaft",
    attrs: {
      "id": "BIBLIO.1"
    }
  }, [_vm._v("I. A NOTE ON THE USE OF PRIMARY SOURCES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Unless otherwise noted, I have used "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum Graece")]), _vm._v(" (ed. Kurt Aland, Johannes Karavidopoulos, Carlo M. Martini, and Bruce M. Metzger; 27th ed., 1993) for the text of Romans and other NT literature, "), _c('i', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(" (ed. K. Elliger and W. Rudolf, 1977) for the Hebrew OT, "), _c('i', [_vm._v("Septuaginta")]), _vm._v(" (ed. A. Rahlfs, 1971) for the Septuagint, "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die Texte aus Qumran")]), _vm._v(" (ed. E. Lohse, 1964) for the Dead Sea Scrolls, the Loeb Classical Library editions for the works of Josephus and Philo, "), _c('i', [_vm._v("The Oxford Annotated Apocrypha")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RSV"
    }
  }, [_vm._v("RSV")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TRANS"
    }
  }, [_vm._v("trans.")]), _vm._v(", 1957) for English translations of the Apocrypha, and "), _c('i', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(" (ed. J. Charlesworth; 2 vols., 1983, 1985) for English translations of the Pseudepigrapha.")]), _vm._v(" "), _c('p', [_vm._v("I have cited texts from the OT according to the versification of the English translations, even when the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(" or "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" verse number differs.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BIBLIO.2"
    }
  }, [_vm._v("II. A NOTE ON THE USE OF SECONDARY SOURCES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The interpreter of Romans is faced with the danger that the text of what Paul himself wrote will become obscured by the reams and reams of material that other people have written about the text. Thomas Hobbes is reputed to have said, “If I read as many books as most men do, I would be as dull-witted as they are.” Certainly it is easy for the interpreter of Scripture to substitute broad reading in books about the text for deep reading in the text itself. In no book of the Bible is this more of a temptation than in Romans, and I hope I have not succumbed to it.")]), _vm._v(" "), _c('p', [_vm._v("In any case, I have tried to keep the focus on the text while, at the same time, interacting with as much of the secondary literature as possible. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xix"
    }
  }), _vm._v("Even here, however, I have been quite selective, citing scholars who are representative of a particular view or who have argued a view particularly well. With respect to this point, the reader should note the difference between a simple reference to a work and a reference preceded by “see especially.” The former indicates nothing more than that the work in question is representative of those who argue the particular position mentioned, but the latter means that the work in question provides a particularly good argument for the point in question.")]), _vm._v(" "), _c('p', [_vm._v("I have cited commentaries by the last name of the commentator only; the reader may assume, unless noted, that the reference is to the commentator’s notes on the relevant verse. I have cited several other frequently used volumes in the same way; these are listed under “Other Significant Works” below.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BIBLIO.3"
    }
  }, [_vm._v("III. COMMENTARIES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The following list of commentaries is far from exhaustive: Romans, by virtue of its theological importance, has attracted uncountable numbers of commentators (Cranfield [1.30–44] has a particularly good survey of commentaries up to 1973). These range from technical, scholarly tomes, replete with Latin and Greek and extensive interaction with other scholars, to homilies designed to apply, rather than analyze, the message of the letter.")]), _vm._v(" "), _c('p', [_vm._v("The reader will find few references to the second type because such books, by their very nature, say little new about the meaning of the text. A noted exception, however—if indeed they belong in this category at all—are the edited sermons of D. M. Lloyd-Jones. His very relevant homiletical applications grow out of insightful, theologically informed exegesis, and the reader can see from the notes how much his exegesis has informed my own thinking about the text.")]), _vm._v(" "), _c('p', [_vm._v("On the other hand, I have consulted as many of those works on Romans that might be accurately termed “commentary” as I could lay my hands on. Realizing early on in my work that it was both impractical and unnecessary to cite all these works consistently—for there is much repetition of argument and conclusion—I selected twelve commentators for particularly careful study. Three factors informed my selection: exegetical excellence, theological sophistication, and representative significance. These commentaries may be called—to borrow a phrase from textual criticism—the “constant witnesses” in my commentary, and they are preceded in the list that follows with and asterisk (*). I regard these scholars as my exegetical “sparring partners,” and I refer the reader to them consistently.")]), _vm._v(" "), _c('div', {
    staticClass: "references"
  }, [_c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xx"
    }
  }), _vm._v("Achtemeier, Paul J. "), _c('i', [_vm._v("Romans.")]), _vm._v(" Interpretation: A Bible Commentary for Teaching and Preaching. Atlanta: John Knox, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Alford, Henry. "), _c('i', [_vm._v("The Greek Testament.")]), _vm._v(" 4 vols. 1845–60. Reprint. Chicago: Moody, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Althaus, Paul. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an der Römer übersetzt und erklärt.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NTD"
    }
  }, [_vm._v("NTD")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ambrosiaster, in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.PL"
    }
  }, [_c('i', [_vm._v("PL")])]), _vm._v(" 17.45–184.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Augustine. "), _c('i', [_vm._v("Augustine on Romans: Propositions from the Epistle to the Romans and Unfinished Commentary on the Epistle to the Romans.")]), _vm._v(" Chico, CA: Scholars, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Barclay, William. "), _c('i', [_vm._v("The Letter to the Romans.")]), _vm._v(" The Daily Study Bible. Edinburgh: St. Andrew, 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Barrett, C. K. "), _c('i', [_vm._v("A Commentary on the Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HNTC"
    }
  }, [_vm._v("HNTC")]), _vm._v(". San Francisco: Harper & Row, 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Barth, Karl. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" London: Oxford University, 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("A Shorter Commentary on Romans.")]), _vm._v(" Richmond: John Knox, 1959. (Cited as "), _c('i', [_vm._v("Shorter.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Baulès, R. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("L’Evangile puissance de Dieu.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LD"
    }
  }, [_vm._v("LD")]), _vm._v(" 53. Paris: Cerf, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bengel, J. A. "), _c('i', [_vm._v("Gnomon of the New Testament.")]), _vm._v(" 5 vols. 1742. Reprint. Edinburgh: T & T Clark, 1860.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Best, Ernest. "), _c('i', [_vm._v("The Letter of Paul to the Romans.")]), _vm._v(" Cambridge Bible Commentary. Cambridge: Cambridge University, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Black, Matthew. "), _c('i', [_vm._v("Romans.")]), _vm._v(" NCB. London: Oliphants, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Boylon, Patrick. "), _c('i', [_vm._v("St. Paul’s Epistle to the Romans.")]), _vm._v(" Dublin: M. H. Gill, 1934.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bruce, F. F. "), _c('i', [_vm._v("The Letter of Paul to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TNTC"
    }
  }, [_vm._v("TNTC")]), _vm._v(". Grand Rapids: Eerdmans, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brunner, Emil. "), _c('i', [_vm._v("The Letter to the Romans: A Commentary.")]), _vm._v(" Philadelphia: Westminster, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Calvin, John. "), _c('i', [_vm._v("Commentaries on the Epistle of Paul the Apostle to the Romans.")]), _vm._v(" 1540. Reprint. Grand Rapids: Eerdmans, 1947.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Chrysostom, John. "), _c('i', [_vm._v("Homilies on Romans. PG")]), _vm._v(" 60.391–682; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NPNF"
    }
  }, [_c('i', [_vm._v("NPNF")])]), _vm._v(" 11.335–564.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Cranfield, C. E. B. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ICC"
    }
  }, [_vm._v("ICC")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.N.S"
    }
  }, [_vm._v("n.s.")]), _vm._v(" 2 vols. Edinburgh: T & T Clark, 1975, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Denney, James. “St. Paul’s Epistle to the Romans.” In "), _c('i', [_vm._v("The Expositor’s Greek New Testament,")]), _vm._v(" vol. 2. 1904. Reprint. Grand Rapids: Eerdmans, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dodd, C. H. "), _c('i', [_vm._v("The Epistle of Paul to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MNTC"
    }
  }, [_vm._v("MNTC")]), _vm._v(". New York: Harper and Bros., 1932.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Dunn, James D. G. "), _c('i', [_vm._v("Romans 1–8, Romans 9–16.")]), _vm._v(" Word Biblical Commentary. Waco, TX: Word, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxi"
    }
  }), _vm._v("*Fitzmyer, Joseph. "), _c('i', [_vm._v("Romans: A New Translation with Introduction and Commentary.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.AB"
    }
  }, [_vm._v("AB")]), _vm._v(". New York: Doubleday, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Letter to the Romans.” In "), _c('i', [_vm._v("The Jerome Biblical Commentary.")]), _vm._v(" Ed. Raymond E. Brown, Joseph A. Fitzmyer, and Roland E. Murphy. Englewood Cliffs, NJ: Prentice-Hall, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Garvie, Alfred E. "), _c('i', [_vm._v("Romans.")]), _vm._v(" The Century Bible. London: Caxton, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.N.D"
    }
  }, [_vm._v("n.d.")])]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gaugler, E. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief.")]), _vm._v(" Prophezei. 2 vols. Zurich: Zwingli, 1945, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gifford, E. H. "), _c('i', [_vm._v("The Epistle of St. Paul to the Romans.")]), _vm._v(" London: John Murray, 1886.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Godet, Frederic Louis. "), _c('i', [_vm._v("Commentary on Romans.")]), _vm._v(" 1879. Reprint. Grand Rapids: Kregel, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gore, Charles. "), _c('i', [_vm._v("St. Paul’s Epistle to the Romans. A Practical Exposition.")]), _vm._v(" 2 vols. London: John Murray, 1899.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Haldane, Robert. "), _c('i', [_vm._v("Exposition of the Epistle to the Romans.")]), _vm._v(" 1839. Reprint. London: Banner of Truth, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrison, Everett F. “Romans.” In "), _c('i', [_vm._v("The Expositor’s Bible Commentary,")]), _vm._v(" vol. 10. Grand Rapids: Zondervan, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrisville, Roy A. "), _c('i', [_vm._v("Romans.")]), _vm._v(" Augsburg Commentary on the New Testament. Minneapolis: Augsburg, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hendriksen, William. "), _c('i', [_vm._v("Exposition of Paul’s Epistle to the Romans.")]), _vm._v(" 2 vols. Grand Rapids: Baker, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hodge, Charles. "), _c('i', [_vm._v("Commentary on the Epistle to the Romans.")]), _vm._v(" 1886. Reprint. Grand Rapids: Eerdmans, 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Huby, J. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Saint Paul: Epître aux Romains.")]), _vm._v(" Ed. Stanilas Lyonnet. Paris: Beauchesne, 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Johnson, Alan F. "), _c('i', [_vm._v("Romans: The Freedom Letter.")]), _vm._v(" Everyman’s Bible Commentary. Rev. ed. 2 vols. Chicago: Moody, 1984, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Käsemann, Ernst. "), _c('i', [_vm._v("Commentary on Romans.")]), _vm._v(" Grand Rapids: Eerdmans, 1980 ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ET"
    }
  }, [_vm._v("ET")]), _vm._v(" of "), _c('i', [_vm._v("An die Römer")]), _vm._v(" [Tübingen: Mohr, 1980]).")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kirk, K. E. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" Clarendon Bible. Oxford: Clarendon, 1937.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Knox, John. “The Epistle to the Romans.” "), _c('i', [_vm._v("IB,")]), _vm._v(" vol. 9. New York: Abingdon, 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Kuss, Otto. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief.")]), _vm._v(" 3 vols. Regensburg: Pustet, 1963–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lagrange, M.-J. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Saint Paul: Epître aux Romains.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.EBIB"
    }
  }, [_vm._v("Ebib")]), _vm._v(". Paris: Gabalda, 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lapide, Cornelius à. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Commentaria in Epistolarum ad Romanos Commentarii. Sacram Scriptorum,")]), _vm._v(" vol. 9. 1614. Reprint. Paris, 1859.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Leenhardt, Franz J. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" 1957. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ET"
    }
  }, [_vm._v("ET")]), _vm._v(", London: Lutterworth, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxii"
    }
  }), _vm._v("Lenski, R. C. H. "), _c('i', [_vm._v("The Interpretation of St. Paul’s Epistle to the Romans.")]), _vm._v(" Minneapolis: Augsburg, 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Liddon, H. P. "), _c('i', [_vm._v("Explanatory Analysis of St. Paul’s Epistle to the Romans.")]), _vm._v(" London: Longmans, Green, 1893.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lietzmann, Hans. "), _c('i', [_vm._v("An die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HNT"
    }
  }, [_vm._v("HNT")]), _vm._v(". Tübingen: Mohr, 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lightfoot, J. B. "), _c('i', [_vm._v("Notes on Epistles of St. Paul.")]), _vm._v(" 1895. Reprint. Grand Rapids: Baker, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lipsius, R. A. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Briefe an die Galater, Römer, Philipper.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HKNT"
    }
  }, [_vm._v("HKNT")]), _vm._v(". Freiburg: Mohr, 1892.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lloyd-Jones, D. M. "), _c('i', [_vm._v("Romans.")]), _vm._v(" 7 vols., variously titled, on chaps. 1 and 3:20–8:39. Grand Rapids: Zondervan, 1970–88.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Luther, Martin. "), _c('i', [_vm._v("Lectures on Romans: Glosses and Scholia.")]), _vm._v(" Luther’s Works 25. St. Louis: Concordia, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meyer, H. A. W. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MEYERK"
    }
  }, [_vm._v("MeyerK")]), _vm._v(". 2 vols. 1872. Reprint. Edinburgh: T & T Clark, 1881, 1884.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Michel, Otto. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MEYERK"
    }
  }, [_vm._v("MeyerK")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Morris, Leon. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" Pillar New Testament Commentary. Grand Rapids: Eerdmans, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Moule, H. C. G. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" The Cambridge Bible for Schools and Colleges. Cambridge: Cambridge University, 1887.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Murray, John. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NICNT"
    }
  }, [_vm._v("NICNT")]), _vm._v(". 2 vols. Grand Rapids: Eerdmans, 1959, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Nygren, Anders. "), _c('i', [_vm._v("Commentary on Romans.")]), _vm._v(" 1944. Reprint. Philadelphia: Fortress, 1949.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("O’Neill, J. C. "), _c('i', [_vm._v("Paul’s Letter to the Romans.")]), _vm._v(" Pelican New Testament Commentaries. Baltimore: Penguin, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Pesch, R. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Römerbrief.")]), _vm._v(" Die neue Echter Bibel. Wurzburg: Echter, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ridderbos, Herman N. "), _c('i', [_vm._v("Aan de Romeinen.")]), _vm._v(" Commentaar op het Nieuwe Testament. Kampen: Kok, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Robinson, John A. T. "), _c('i', [_vm._v("Wrestling with Romans.")]), _vm._v(" Philadelphia: Westminster, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Sanday, William, and Arthur C. Headlam. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ICC"
    }
  }, [_vm._v("ICC")]), _vm._v(". Edinburgh: T & T Clark, 1902.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schelkle, Karl Hermann. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Paulus, Lehrer der Väter. Die altkirchliche Auslegung von Römer 1–11.")]), _vm._v(" Düsseldorf: Patmos, 1956.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schlatter, Adolf. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Gottes Gerechtigkeit.")]), _vm._v(" Stuttgart: Calwer, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schlier, H. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief Kommentar.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HTKNT"
    }
  }, [_vm._v("HTKNT")]), _vm._v(". Freiburg: Herder, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmidt, Hans Wilhelm. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief des Paulus an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.THKNT"
    }
  }, [_vm._v("THKNT")]), _vm._v(". Berlin: Evangelische, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmithals, W. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief. Ein Kommentar.")]), _vm._v(" Gütersloh: Mohn, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxiii"
    }
  }), _vm._v("Shedd, William G. T. "), _c('i', [_vm._v("A Critical and Doctrinal Commentary upon the Epistle of St. Paul to the Romans.")]), _vm._v(" New York: Scribner’s, 1879.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sickenberger, Joseph. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die beiden Briefe des heiligen Paulus an die Korinther und sein Brief an die Römer.")]), _vm._v(" Die Heiligen Schriften des Neuen Testaments. Bonn: Peter Hanstein, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Smart, James. "), _c('i', [_vm._v("Doorway to a New Age: A Study of Paul’s Letter to the Romans.")]), _vm._v(" Philadelphia: Westminster, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stuart, Moses. "), _c('i', [_vm._v("A Commentary on the Epistle to the Romans.")]), _vm._v(" Ed. and rev. by R. D. C. Robbins. Andover, MA: Warren F. Draper, 1862.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stuhlmacher, P. "), _c('i', [_vm._v("Paul’s Letter to the Romans. A Commentary.")]), _vm._v(" Louisville: Westminster/John Knox, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Theodoret, in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.PG"
    }
  }, [_c('i', [_vm._v("PG")])]), _vm._v(" 82.43–226.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thomas, W. H. Griffith. "), _c('i', [_vm._v("St. Paul’s Epistle to the Romans.")]), _vm._v(" 1946. Reprint. Grand Rapids: Eerdmans, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tholuck, F. A. G. "), _c('i', [_vm._v("Exposition of St. Paul’s Epistle to the Romans.")]), _vm._v(" Philadelphia: Sorin and Ball, 1844.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Viard, A. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Saint Paul: Epître aux Romains.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SB"
    }
  }, [_vm._v("SB")]), _vm._v(". Paris: Gabalda, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wesley, John. "), _c('i', [_vm._v("Explanatory Notes upon the New Testament.")]), _vm._v(" 1754. Reprint. London: Epworth, 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Westcott, Frederick Brooke. "), _c('i', [_vm._v("St. Paul and Justification, being an Exposition of the Teaching in the Epistles to Rome and Galatia.")]), _vm._v(" London: Macmillan, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Wilckens, Ulrich. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.EKKNT"
    }
  }, [_vm._v("EKKNT")]), _vm._v(". 3 vols. Neukirchen/Vluyn: Neukirchener and Zürich: Benziger, 1978–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zahn, Theodor. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief des Paulus an die Römer.")]), _vm._v(" Leipzig: A. Deichertsche, 1910.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zeller, Dieter. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RNT"
    }
  }, [_vm._v("RNT")]), _vm._v(". Regensburg: Pustet, 1985.")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BIBLIO.4"
    }
  }, [_vm._v("IV. OTHER SIGNIFICANT WORKS")]), _vm._v(" "), _c('div', {
    staticClass: "references"
  }, [_c('p', {
    staticClass: "rf"
  }, [_vm._v("Beker, J. C. "), _c('i', [_vm._v("Paul the Apostle: The Triumph of God in Life and Thought.")]), _vm._v(" Philadelphia: Fortress, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bultmann, Rudolf. "), _c('i', [_vm._v("Theology of the New Testament.")]), _vm._v(" 2 vols. New York: Scribner’s, 1951, 1955.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Burton, E. de W. "), _c('i', [_vm._v("Syntax of the Moods and Tenses in New Testament Greek.")]), _vm._v(" 3d ed. Edinburgh: T & T Clark, 1898.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Byrne, Brendan. "), _c('i', [_vm._v("‘Sons of God’—‘Seed of Abraham.’ A Study of the Idea of Sonship of God of All Christians in Paul against the Jewish Background.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ANBIB"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 83. Rome: Pontifical Biblical Institute, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cambier, J. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("L’Evangile de Dieu selon L’épître aux Romains. Exégèse et "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxiv"
    }
  }), _vm._v("théologie biblique. Vol. I: L’Evangile de la justice et de la grace.")]), _vm._v(" Brussels/Louvain: Desclée de Brouwer, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dahl, Nils Alstrup. "), _c('i', [_vm._v("Studies in Paul: Theology for the Early Christian Mission.")]), _vm._v(" Minneapolis: Augsburg, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davies, W. D. "), _c('i', [_vm._v("Paul and Rabbinic Judaism.")]), _vm._v(" London: SPCK, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Deidun, T. J. "), _c('i', [_vm._v("New Covenant Morality in Paul.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ANBIB"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 89. Rome: Pontifical Biblical Institute, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Donfried, Karl P., ed. "), _c('i', [_vm._v("The Romans Debate.")]), _vm._v(" 2d ed. Peabody, MA: Hendrickson, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gamble, Harry, Jr. "), _c('i', [_vm._v("The Textual History of the Letter to the Romans: A Study in Textual and Literary Criticism.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SD"
    }
  }, [_vm._v("SD")]), _vm._v(" 42. Grand Rapids: Eerdmans, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gundry, R. H. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Sōma")]), _vm._v(" "), _c('i', [_vm._v("in Biblical Theology with Emphasis on Pauline Anthropology.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SNTSMS"
    }
  }, [_vm._v("SNTSMS")]), _vm._v(" 29. Cambridge: Cambridge University, 1976. Reprint. Grand Rapids: Zondervan, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hagner, Donald A., and Harris, Murray J., eds. "), _c('i', [_vm._v("Pauline Studies: Essays Presented to Professor F. F. Bruce on His 70th Birthday.")]), _vm._v(" Grand Rapids: Eerdmans, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hays, Richard B. "), _c('i', [_vm._v("Echoes of Scripture in the Letters of Paul.")]), _vm._v(" New Haven: Yale University, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hübner, Hans. "), _c('i', [_vm._v("Law in Paul’s Thought.")]), _vm._v(" Edinburgh: T & T Clark, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Koch, D.-A. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die Schrift als Zeuge des Evangeliums: Untersuchungen zur Verwendung und zum Verständnis der Schrift bei Paulus.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.BZHT"
    }
  }, [_vm._v("BZHT")]), _vm._v(" 69. Tübingen: Mohr, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kühl, E. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief des Paulus an die Römer.")]), _vm._v(" Leipzig: Quelle & Meyer, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Longenecker, Richard N. "), _c('i', [_vm._v("Paul, Apostle of Liberty.")]), _vm._v(" 1964. Reprint. Grand Rapids: Baker, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lorenzi, Lorenzo de, ed. "), _c('i', [_vm._v("Battesimo e Giustizia in Rom 6 e 8.")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 2. Rome: St. Paul’s Abbey, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, ed. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die Israelfrage nach Röm 9–11.")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 3. Rome: St. Paul’s Abbey, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, ed. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Dimensions de la vie chrétienne (Rm 12–13).")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 4. Rome: St. Paul’s Abbey, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, ed. "), _c('i', [_vm._v("The Law of the Spirit in Rom 7 and 8.")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 1. Rome: St. Paul’s Abbey, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Luz, U. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Das Geschichtsverständnis bei Paulus.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.BEVT"
    }
  }, [_vm._v("BEvT")]), _vm._v(" 49. Munich: Kaiser, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxv"
    }
  }), _vm._v("Metzger, Bruce M. "), _c('i', [_vm._v("A Textual Commentary on the Greek New Testament.")]), _vm._v(" New York: United Bible Societies, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Minear, Paul S. "), _c('i', [_vm._v("The Obedience of Faith: The Purposes of Paul in the Epistle to the Romans.")]), _vm._v(" London: SCM, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Moulton, James Hope. "), _c('i', [_vm._v("Prolegomena.")]), _vm._v(" Vol. 1 of "), _c('i', [_vm._v("A Grammar of New Testament Greek.")]), _vm._v(" Edinburgh: T & T Clark, 1908.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Munck, Johannes. "), _c('i', [_vm._v("Paul and the Salvation of Mankind.")]), _vm._v(" 1954. London: SCM, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ortkemper, F.-J. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Leben aus dem Glauben: Christliche Grundhaltungen nach Römer 12–13.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NTABH"
    }
  }, [_vm._v("NTAbh")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.N.S"
    }
  }, [_vm._v("n.s.")]), _vm._v(" 14. Münster: Aschendorff, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Piper, John. "), _c('i', [_vm._v("The Justification of God: An Exegetical and Theological Study of Romans 9:1–23.")]), _vm._v(" Grand Rapids: Baker, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Räisänen, Heikki. "), _c('i', [_vm._v("Paul and the Law.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.WUNT"
    }
  }, [_vm._v("WUNT")]), _vm._v(" 29. Tübingen: Mohr, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Robertson, A. T. "), _c('i', [_vm._v("A Grammar of the Greek New Testament in the Light of Historical Research.")]), _vm._v(" New York: George H. Doran, 1915.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schoeps, H.-J. "), _c('i', [_vm._v("Paul. The Theology of the Apostle in the Light of Jewish Religious History.")]), _vm._v(" 1959. Philadelphia: Westminster, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Turner, Nigel. "), _c('i', [_vm._v("Syntax.")]), _vm._v(" Vol. 3 of "), _c('i', [_vm._v("A Grammar of New Testament Greek,")]), _vm._v(" by J. H. Moulton. Edinburgh: T & T Clark, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Watson, Francis. "), _c('i', [_vm._v("Paul, Judaism and the Gentiles: A Sociological Approach.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SNTSMS"
    }
  }, [_vm._v("SNTSMS")]), _vm._v(" 56. Cambridge: Cambridge University, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Westerholm, Stephen. "), _c('i', [_vm._v("Israel’s Law and the Church’s Faith: Paul and His Recent Interpreters.")]), _vm._v(" Grand Rapids: Eerdmans, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zerwick, Maximilian. "), _c('i', [_vm._v("Biblical Greek.")]), _vm._v(" Rome: Pontifical Biblical Institute, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, and Grosvenor, Mary. "), _c('i', [_vm._v("A Grammatical Analysis of the Greek New Testament.")]), _vm._v(" Rome: Biblical Institute Press, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zuntz, G. "), _c('i', [_vm._v("The Text of the Epistles: A Disquisition upon the Corpus Paulinum.")]), _vm._v(" The Schweich Lectures, 1946. London: British Academy, 1953.")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "INTRO"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.1"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("“The quintessence and perfection of saving doctrine.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.1.1",
      "id": "FN.1.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" This description of Romans by Thomas Draxe, a seventeenth-century English Puritan, has been echoed by theologians, commentators, and laypeople throughout the centuries. When we think of Romans, we think of doctrine. Moreover, this response is both understandable and appropriate. As we will see, Paul’s letter to the Romans is thoroughly doctrinal: the “purest Gospel,” as Luther put it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.1.2",
      "id": "FN.1.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" But, like every book in the NT, Romans is rooted in history. It is not a systematic theology but a letter, written in specific circumstances and with specific purposes. The message of Romans is, indeed, timeless; but to understand its message aright, we must appreciate the specific context out of which Romans was written. In the pages that follow, I want to fill out this context as a basis for my interpretation and application of the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.1"
    }
  }, [_vm._v("I. GENERAL CIRCUMSTANCES")])]), _vm._v(" "), _c('p', {
    staticClass: "bhaft",
    attrs: {
      "id": "INTRO.1.1"
    }
  }, [_vm._v("A. PAUL")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Romans claims to be written by Paul (1:1), and there has been no serious challenge to this claim. In keeping with regular ancient custom, Paul used an amanuensis, or scribe, to write the letter, identified in 16:22 as Tertius. Ancient authors gave to their amanuenses varying degrees of responsibility in the composition of their works—from word-for-word recording of what they "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.2"
    }
  }), _vm._v("dictated to quite sweeping responsibility for putting ideas into words. Paul’s method in Romans is certainly far toward the “dictation” end of this spectrum. For the style of Romans is very close to that of Galatians and 1 Corinthians—and we have no evidence that Tertius was involved in the composition of either of these letters (indeed, see Gal. 6:11).")]), _vm._v(" "), _c('p', [_vm._v("If the authorship of Romans is not in doubt, neither is the general situation in which it was written. Paul tells us in 15:22–29 that three localities figure in his immediate plans: Jerusalem, Rome, and Spain. Jerusalem is his immediate destination. Paul has completed his collection of money from his largely Gentile churches and is now on his way to Jerusalem to deliver the money to the Jewish saints there. This collection was an important project for Paul, as may be gauged from the fact that he talks about it in every letter written on the third missionary journey (cf. also 1 Cor. 16:1–4; 2 Cor. 8–9). Its importance goes beyond meeting the material needs of the poor Christians in Judea; Paul views it as a practical way to cement the fractured relationship between the Gentile churches of the mission field and the Jewish churches in the “home” country. In chap. 15 Paul demonstrates his concern about how this collection will be received by the “saints” in Jerusalem. Will they accept the gift and so acknowledge the links that bind Jewish and Gentile believers together in one people of God? Or will they reject it, out of suspicion of Paul and the “law-free” churches he has planted?")]), _vm._v(" "), _c('p', [_vm._v("Rome is the second stage in Paul’s itinerary (15:24, 28). But, while sincere in his desire to visit the Christians in Rome, Paul views Rome as little more than a stopping-off point in his projected journey to Spain. This is not to minimize the importance of the Christian community in Rome but reflects Paul’s understanding of his call: “to preach the gospel in regions where Christ has not yet been named” (15:20). This task of initial church-planting is one that Paul has completed in the eastern Mediterranean: “from Jerusalem and as far around as Illyricum [modern-day Albania and the former Yugoslavia] I have ‘fulfilled’ the gospel of Christ” (15:19). As a result of the first three missionary journeys, churches have been planted in major metropolitan centers throughout southern and western Asia Minor (Tarsus, Pisidian Antioch, Lystra, Iconium, Derbe, and Ephesus), Macedonia (Philippi and Thessalonica), and Greece (Corinth). These churches can now take responsibility for evangelism in their own areas, while Paul sets his sights on virgin gospel territory in the far western end of the Mediterranean.")]), _vm._v(" "), _c('p', [_vm._v("When we compare these indications with Luke’s narrative in Acts, it is clear that Romans must have been written toward the end of the third missionary journey, when Paul, accompanied by representatives from the churches he had founded, prepared to return to Jerusalem (Acts 20:3–6). Since Luke tells us that Paul spent three months in Greece before beginning his homeward journey, we can also surmise that while staying here, with the next "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.3"
    }
  }), _vm._v("stage of his missionary career about to unfold, Paul wrote his letter to the Romans. It was probably in Corinth that Paul stayed while in Greece (see 2 Cor. 13:1, 10); and that Romans was written from here is suggested by the fact that Paul commends to the Romans a woman, Phoebe, from Cenchrea, a seaport adjacent to Corinth (16:1–2). Moreover, the Gaius with whom Paul is apparently staying (16:23) is probably the same Gaius whom Paul baptized at Corinth (1 Cor. 1:14). (And is the city-treasurer Erastus who sends greetings to the Romans [16:23] the same Erastus who is identified in an inscription as an "), _c('i', [_vm._v("aedile")]), _vm._v(" [city commissioner] at Corinth?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.3.3",
      "id": "FN.3.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(") The date at which Romans was written will depend, accordingly, on the dating of Paul’s three-month stay in Greece; and this dating, in turn, is dependent on the hazardous process of constructing an absolute chronology of the life of Paul. The best alternative is probably "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 57,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.3.4",
      "id": "FN.3.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")]), _vm._v(" though leeway of a year or two either way must be allowed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.3.5",
      "id": "FN.3.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("What emerges as especially significant from this sketch of Paul’s own situation is that he writes his letter to the Romans at an important transition point in his missionary career. For almost twenty-five years, Paul has planted churches in the eastern Mediterranean. Now he prepares to bring to Jerusalem a practical fruit of that work, one that he hopes will heal the most serious social-theological rift in the early church—the relationship between Jew and Gentile in the people of God. Beyond Jerusalem, Spain, with its “fields ripe for the harvesting,” beckons. On the way is Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.1.2"
    }
  }, [_vm._v("B. THE CHRISTIAN COMMUNITY IN ROME")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In reconstructing Paul’s situation when he wrote Romans, we can build on his own statements in Romans, as well as on the evidence from his other letters and from the book of Acts. We have no such direct evidence to use in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.4"
    }
  }), _vm._v("reconstructing the situation of the Christian community in Rome at the time of Paul’s letter. Its origin is obscure and its composition and nature in Paul’s day unclear.")]), _vm._v(" "), _c('p', [_vm._v("The tradition that the church in Rome was founded by Peter (or Peter and Paul together) cannot be right."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.6",
      "id": "FN.4.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" It is in this very letter that Paul enunciates the principle that he will “not build on another person’s foundation” (15:20). This makes it impossible to think that he would have written this letter, or planned the kind of visit he describes in 1:8–15, to a church that was founded by Peter. Nor is it likely that Peter could have been at Rome early enough to have founded the church there. Since the traditions we possess associate no other apostle with the church at Rome, the assessment of the fourth-century church father Ambrosiaster is probably correct: the Romans “have embraced the faith of Christ, albeit according to the Jewish rite, without seeing any sign of mighty works or any of the apostles.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.7",
      "id": "FN.4.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" The most likely scenario is that Roman Jews, who were converted on the day of Pentecost in Jerusalem (see Acts 2:10), brought their faith in Jesus as the Messiah back with them to their home synagogues. In this way the Christian movement in Rome was initiated.")]), _vm._v(" "), _c('p', [_vm._v("Ambrosiaster is probably also right, then, when he identifies the synagogue as the starting point for Christianity in Rome. Enough Jews had emigrated to Rome by the end of the first century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.C.")]), _vm._v(" to make up a significant portion of the population."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.8",
      "id": "FN.4.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" They were not bound together in any single organizational structure. Their many synagogues apparently were independent of one another."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.9",
      "id": "FN.4.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" An important event in the history of the Jews in Rome is mentioned by the Roman historian Suetonius. In his "), _c('i', [_vm._v("Life of Claudius,")]), _vm._v(" he says that Claudius “expelled the Jews from Rome because they were constantly rioting at the instigation of Chrestus” (25.2). Most scholars agree that “Chrestus” is a corruption of the Greek "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Christos")]), _vm._v(" and that the reference is probably to disputes within the Jewish community over the claims of Jesus to be the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.5"
    }
  }), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Christos,")]), _vm._v(" the Messiah. There is less agreement over whether the fifth-century writer Orosius is right in dating this incident in "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 49. But the date is probably correct"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.10",
      "id": "FN.5.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" and receives incidental confirmation from Acts 18:2, where Luke says that Aquila and Priscilla had recently come to Corinth from Italy “because Claudius had commanded all the Jews to leave Rome.” As with similar expulsions of specific groups from Rome, this one did not stay in force for long. Jews, like Aquila and Priscilla (cf. Rom. 16:3), were able to return to Rome within a short period of time, certainly soon after Claudius’s death in "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 54.")]), _vm._v(" "), _c('p', [_vm._v("Nevertheless, since the Roman authorities would not have distinguished between Jews and Jewish Christians, this expulsion, however temporary, must have had a significant impact on the development of the church at Rome. Specifically, the Gentile element in the churches, undoubtedly present before the expulsion, would have come into greater prominence as a result of the absence for a time of all (or virtually all) the Jewish Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.11",
      "id": "FN.5.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" Theologically this would also have meant an acceleration in the movement of the Christian community away from its Jewish origins. The decentralized nature of the Jewish community from which the Christian community sprang would also make it likely that the Christians in Rome were grouped into several house churches. Confirmation that this was the case comes from Rom. 16, where Paul seems to greet several different house churches."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.12",
      "id": "FN.5.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" It is also possible, though more speculative, that these different house churches were divided theologically."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.13",
      "id": "FN.5.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.2"
    }
  }, [_vm._v("II. INTEGRITY, LITERARY HISTORY, AND TEXT")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Is the letter to the Romans as it is now printed in our Bibles identical to the letter that Paul sent to the Christians in Rome? Many scholars answer no. Of these a few base their conclusions on internal literary considerations alone. Two scholars, for instance, conclude that internal inconsistencies within Romans can be explained only if our present letter is composed of two or more "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.6"
    }
  }), _vm._v("separate letters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.6.14",
      "id": "FN.6.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Others have identified interpolations in the text: single verses, or more, that have been added to the letter after the time of Paul."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.6.15",
      "id": "FN.6.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" But none of these theories can be accepted. They have no textual basis, and Romans has none of those somewhat awkward transitions that have led scholars to question the integrity of other Pauline letters.")]), _vm._v(" "), _c('p', [_vm._v("But a more serious question is raised by the textual evidence. This evidence has led a significant number of scholars to think that the 16-chapter form of the letter we have in our Bibles was not the form of the letter that Paul sent to the Roman Christians. We can begin by listing the several forms of the text as it appears in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" tradition:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_vm._v("1. 1:1–14:23, 15:1–16:23, 16:25–27: P"), _c('sup', [_vm._v("61")]), _vm._v("?, "), _c('span', {
    staticClass: "heb"
  }, [_vm._v("א")]), _vm._v(", B, C, D, 1739, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("2. 1:1–14:23, 16:25–27, 15:1–16:23, 16:25–27: A, P, 5, 33, 104")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("3. 1:1–14:23, 16:25–27, 15:1–16:24: "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("Ψ")]), _vm._v(", the “majority” text, sy"), _c('sup', [_vm._v("h")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("4. 1:1–14:23, 15:1–16:24: F, G [archetype of D?], 629")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("5. 1:1–14:23, 16:24–27: vg"), _c('sup', [_vm._v("1648,1792,2089")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("6. 1:1–15:33, 16:25–27, 16:1–23: P"), _c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', [_vm._v("Ostensibly, the major problem is whether the doxology (16:25–27) should be included, and if so, where—at the end of chap. 14, chap. 15, or chap. 16? If this were the extent of the problem, we would be faced with a relatively minor textual question. But the different placements of the doxology combine with other textual and literary issues to raise serious questions about the origin and literary history of this letter as a whole. As can be seen above, for instance, several "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" of the Latin Vulgate omit 15:1–16:23 entirely, an omission for which evidence is also found in another Vulgate codex"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.6.16",
      "id": "FN.6.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")]), _vm._v(" and in the absence of reference to chaps. 15 and 16 in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.7"
    }
  }), _vm._v("Tertullian,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.17",
      "id": "FN.7.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Irenaeus, and Cyprian. All this raises the possibility that the 16-chapter form of the letter we now have in our Bibles is secondary to an original 14- or 15-chapter form. When we add to this the fact that a few "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" (G and the Old Latin g) omit the only references to Rome that occur in the letter (1:7, 15), we can understand why various theories of a shortened and more “universal” form of the letter have arisen.")]), _vm._v(" "), _c('p', [_vm._v("Lake, for instance, argues that Paul’s original letter was made up of chaps. 1–14 and that he added chap. 15 when he sent it to Rome."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.18",
      "id": "FN.7.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But a more popular theory is that the original letter, addressed to Rome, consisted of 1:1–15:33. In both reconstructions, however, chap. 16 is considered to be no part of Paul’s letter to the Romans. This conclusion, which is quite widespread, is based on both textual and literary considerations. The placement of the doxology after chap. 15 in P"), _c('sup', [_vm._v("46")]), _vm._v(" can be accounted for, it is argued, only if the letter had at one time ended there.")]), _vm._v(" "), _c('p', [_vm._v("But more important is the internal evidence of chap. 16 itself. The warning about people causing dissensions in 16:17–20 seems out of place with chaps. 1–15. Particularly striking are the extensive greetings in vv. 3–15. In addition to Phoebe, Paul greets twenty-five individuals, two families, one “church,” and an unspecified number of “fellow believers” and “saints”—all these in a community that he had never visited. Surely chap. 16, it is argued, must be addressed to a church that Paul knows well—Ephesus being the best candidate because Paul singles out for a greeting “the first convert in Asia” (16:5; Ephesus was in the Roman province of Asia) and because we last meet Aquila and Priscilla there (Acts 18:19). According to one variation of this interpretation, chap. 16 was a separate letter of commendation for Phoebe."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.19",
      "id": "FN.7.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" According to another view, associated particularly with T. W. Manson, the chapter was added when Paul sent a copy of his original letter to Rome (chaps. 1–15) to Ephesus."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.20",
      "id": "FN.7.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.8"
    }
  }), _vm._v("These theories, however, are almost certainly wrong."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.21",
      "id": "FN.8.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" Although there is definite evidence of a 14-chapter form of Romans in the early church,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.22",
      "id": "FN.8.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" the intimate connection between chaps. 14 and 15 makes it impossible to think that Paul’s original letter was without chap. 15."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.23",
      "id": "FN.8.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" How, then, did the 14-chapter form of the letter originate? Lightfoot thought that Paul himself may have abbreviated his letter to the Romans, omitting the references to Rome in 1:7 and 1:15 at the same time, in order to universalize the epistle."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.24",
      "id": "FN.8.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" But it is unlikely that, had this been Paul’s purpose, he would have cut off his epistle in the middle of his argument."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.25",
      "id": "FN.8.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" The same objection applies to Gamble’s theory that the text of Romans was shortened after Paul’s time in order to make the letter more universally applicable."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.26",
      "id": "FN.8.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" The earliest explanation for the shortened form is given by Origen, who claims that Marcion cut off "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dissecuit)")]), _vm._v(" the last two chapters. Since this explanation offers the best rationale for breaking off the letter at 15:1 (for there is much from 15:1 onward that would have offended Marcion’s anti-Jewish sentiments), I tentatively adopt it as the most likely explanation for the 14-chapter form of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.27",
      "id": "FN.8.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', [_vm._v("What, then, of the alleged 15-chapter form? Textually, this theory is on shaky ground from the outset, for there is no single "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(" of Romans that contains only 15 chapters. Its only textual evidence is the placement of the doxology in P"), _c('sup', [_vm._v("46")]), _vm._v(" after chap. 15; but P"), _c('sup', [_vm._v("46")]), _vm._v(" does not omit chap. 16. Furthermore, the internal arguments for omitting the chapter are not strong. The last-minute warning about false teachers in vv. 17–20 has some parallel with Paul’s procedure in other letters; and the special circumstances of Romans explain why it occurs only here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.28",
      "id": "FN.8.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The number of people greeted poses a greater problem. But the expulsion of the Jews and Jewish Christians from Rome would have given Paul opportunity to meet a number of these people (like "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.9"
    }
  }), _vm._v("Priscilla and Aquila) during the time of their exile in the east. It has even been argued that Paul would be more likely to greet individuals by name in an unfamiliar church where he knew only those whom he greeted than to risk offending the majority by greeting only selected members in a church he knew well."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.9.29",
      "id": "FN.9.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" At any rate, the problem posed by the number of greetings is not great enough to overcome the external evidence in favor of including chap. 16 in Paul’s original letter to the Romans.")]), _vm._v(" "), _c('p', [_vm._v("We conclude that the letter Paul wrote to Rome contained all sixteen chapters found in modern texts and translations."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.9.30",
      "id": "FN.9.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.3"
    }
  }, [_vm._v("III. AUDIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As we have seen, Christianity in Rome began among Jews (see “General Circumstances”). And, although the expulsion under Claudius eliminated the Jewish element in the church for a time, we can be certain that by the date of Romans at least some Jewish Christians (like Priscilla and Aquila) would have returned. We have no direct knowledge of the origins of Gentile Christianity in Rome; but, if the pattern of the Pauline mission was followed, we can surmise that “God fearers,” Gentiles who were interested in Judaism and attended synagogue without becoming Jews,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.9.31",
      "id": "FN.9.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" were the first to be attracted to the new faith. Certainly by the date of Romans Gentiles made up a significant portion of the church in Rome (cf. 11:13–32 and 15:7–12). We may, then, be fairly certain that when Paul wrote Romans the Christian community in Rome was made up of both Jewish and Gentile Christians. This does not necessarily mean, however, that Paul had both groups in mind as he wrote his letter. It is to the evidence of the letter that we must turn to determine the audience.")]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, the letter appears to send out mixed signals on this issue. On the one hand, there is evidence to suggest that Paul had Jewish Christians in mind as he wrote: (1) he greets the Jewish-Christians Priscilla and Aquila and his “kinfolk” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(syngeneis)")]), _vm._v(" Andronicus, Junia, and Herodion in chap. 16 (vv. 3, 7, 11); (2) he directly addresses “the Jew” in chap. 2 (cf. v. 17); (3) he "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.10"
    }
  }), _vm._v("associates his readers closely with the Mosaic law (6:14: “you are no longer under the law”; 7:1: “I am speaking to those who know the law”; 7:4: “you have died to the law”); (4) he calls Abraham “"), _c('i', [_vm._v("our")]), _vm._v(" forefather according to the flesh” (4:1); and (5) he spends much of the letter on issues of special interest to the Jewish people: their sin and presumption of divine favor (2:1–3:8), the failure of their law (3:19–20, 27–31; 4:12–15; 5:13–14, 20; 6:14; 7; 8:2–4; 9:30–10:8), the significance of Abraham their “forefather” (chap. 4), and their place in the unfolding plan of God (chaps. 9–11).")]), _vm._v(" "), _c('p', [_vm._v("Indications of a Gentile-Christian audience are also, however, evident: (1) in his address for the letter as a whole, Paul includes the Roman Christians among the Gentiles to whom he has been called to minister (1:5–6; cf. also 1:13 and 15:14–21); (2) Paul claims that his argument about the place of Jews in God’s plan (11:11–24) is directed “to you Gentiles” (v. 13; and note the second person plurals throughout vv. 14–24); (3) Paul’s plea to “receive one another” in 15:7 appears to be directed especially to Gentile Christians (cf. vv. 8–9).")]), _vm._v(" "), _c('p', [_vm._v("We appear to be faced with a paradox. As Kümmel puts it, “Romans manifests a double character: it is essentially a debate between the Pauline gospel and Judaism, so that the conclusion seems obvious that the readers were Jewish Christians. Yet the letter contains statements which indicate specifically that the community was Gentile-Christian.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.10.32",
      "id": "FN.10.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" Several options are open to us.")]), _vm._v(" "), _c('p', [_vm._v("First, we may dismiss or downplay the evidence of a Gentile-Christian readership and conclude that the letter is addressed solely, or at least mainly, to Jewish Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.10.33",
      "id": "FN.10.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" But this will not do. Rom. 11:13 may suggest that Gentiles are only one part of the church, but 1:5–6 cannot be evaded (by, for instance, translating “among whom [Gentiles] you [Roman Christians] are located”—see the exegesis). This verse, standing in the introduction to the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.11"
    }
  }), _vm._v("letter, suggests strongly that Paul regarded his addressees as Gentile Christians.")]), _vm._v(" "), _c('p', [_vm._v("A much better case can be made, then, for the view that Paul’s readers were Gentile Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.11.34",
      "id": "FN.11.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Not only does 1:5–6 appear to be decisive, but the evidence for a Jewish-Christian readership is not particularly strong. The greetings in chap. 16 show that there were Jewish Christians in the Roman community, but they do not require that the letter be addressed to them. The second singular address in Rom. 2 is a literary device and reveals nothing about the actual readers of the letter (see the introduction to 2:1–3:8). When Paul calls Abraham “our” forefather (4:1), he may be including with himself other Jews or Jewish Christians rather than his readers. That Paul associates his readers with the law is clear; but, as we argue (see the notes on 6:14 and 7:4), Paul thinks that Gentiles are “under the law” in some sense. And, even in 14:1–15:13, where reference to Jewish Christians can probably not be excluded, Paul’s argument is directed mainly to the “strong in faith.”")]), _vm._v(" "), _c('p', [_vm._v("Finally, while some of the letter is, indeed, a debate, or dialogue, with Judaism (e.g., 1:18–4:25), it is not necessary that Jews or Jewish Christians be the intended audience for the debate. Paul’s purpose may be to rehearse the basic issues separating Jews and Christians and to show what his gospel has to say about them, with the purpose of helping Gentile Christians understand the roots of their faith and their own situation vis-à-vis both Jews and Jewish Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.11.35",
      "id": "FN.11.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" This purpose certainly becomes evident in chaps. 9–11, where Paul sketches the place of Israel in salvation history to stifle the arrogance of the Gentiles. Galatians, too, demonstrates clearly enough that teaching about the failure of the law and the inadequacy of circumcision was necessary for Gentile Christians to hear."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.11.36",
      "id": "FN.11.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" Moreover, the Gentiles themselves would have had a more personal interest in these matters than we have sometimes realized. For, as we have suggested, Christianity in Rome began in the synagogue, and the first Gentiles converted were almost certainly “God-fearing” synagogue attenders. This Jewish matrix for Christianity in Rome meant that even Gentile Christians would have “known the law” (7:1) "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.12"
    }
  }), _vm._v("and that many of them would likely have been curious about how the gospel related to their previous understanding of circumcision and the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.12.37",
      "id": "FN.12.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', [_vm._v("Although this interpretation of the data is generally satisfactory, it must be questioned whether we can eliminate Jewish Christians entirely from Paul’s audience. Paul claims in 1:7 that he is addressing “"), _c('i', [_vm._v("all")]), _vm._v(" those beloved of God in Rome,” and it is clear that there were Jewish Christians in Rome. Moreover, Paul’s exhortation to the “strong” and the “weak” makes best sense if both groups—roughly equivalent to Gentile and Jewish Christians respectively—were in his audience. And, while Paul’s “dialogue with Judaism” in 1:18–4:25 and his sketch of the inadequacy of the law in chap. 7 can be accounted for on the basis of a solely Gentile audience, we must wonder whether these texts are not more adequately explained if there were at least some Jewish Christians in Paul’s audience. These considerations make it likely that the audience to which Paul writes was composed of both Jewish and Gentile Christians.")]), _vm._v(" "), _c('p', [_vm._v("Granted such a mixed audience, it is possible to suppose that Paul directs different parts of his letter to different groups within the Roman church. The most elaborate and best-defended version of this viewpoint is that of Paul Minear. He distinguishes five separate groups in the community, attributing each section of the letter to one or another of these groups."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.12.38",
      "id": "FN.12.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" While providing a salutary reminder that the community in Rome should not be simplistically divided into two groups according to ethnic origin, Minear’s thesis goes beyond the evidence. The existence of several of his groups is unclear, and the progressive flow of Paul’s argument in the letter renders a constant shifting in audience unlikely. This means that, with certain exceptions (e.g., 11:13–24), we must assume that Paul has the whole community, a mixed group of Jewish and Gentile Christians, in mind as he writes.")]), _vm._v(" "), _c('p', [_vm._v("Along with the majority of commentators, then, we think that Paul addresses a mixed group of Jewish and Gentile Christians in Romans. Some "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.13"
    }
  }), _vm._v("decline to estimate the relative proportion of the two groups,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.39",
      "id": "FN.13.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" but the considerations advanced above show that Gentile Christians were in the majority, perhaps an overwhelming majority."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.40",
      "id": "FN.13.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" There is, however, one major problem with this reconstruction: Why, if there were Jewish Christians in the community, and especially if they were being slighted by the Gentile-Christian majority (cf. 11:13–24), would Paul have addressed the community as a "), _c('i', [_vm._v("Gentile")]), _vm._v(" one (1:5–6)?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.41",
      "id": "FN.13.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" The answer is probably that the community as a whole had by this date taken on the complexion of Gentile Christianity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.42",
      "id": "FN.13.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" Indeed, it is perhaps just this shift from the earlier Jewish matrix of Roman Christianity to a more purely “Gentile” framework (a process accelerated by the enforced exile of Jewish Christians under Claudius) that has given rise to a sense of inferiority on the part of the Jewish segment. Moreover, the purpose of Paul in 1:5–6 (and 1:13) is not so much to identify the national complexion of the community as to locate it within the scope of his commission to the Gentiles. These texts, then, do not stand in the way of the conclusion that the audience Paul addresses in Romans is made up of a Gentile-Christian majority and a Jewish-Christian minority.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.4"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.4"
    }
  }, [_vm._v("IV. NATURE AND GENRE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Romans is, of course, an epistle, but what kind? Many types of letters were written in the ancient world, ranging from brief, intimate, and informal notes to friends and family members to carefully crafted treatises designed for a large audience. Where within this range we should situate the Pauline letters has been much debated, but they clearly fall somewhere between these extremes."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.43",
      "id": "FN.13.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" Even the Pauline letters addressed to individuals—1 and 2 Timothy, Titus, and Philemon (though cf. v. 2)—have broadly pastoral purposes. And the most general of his letters—Ephesians and Romans—are not only addressed to specific communities (at least in their present form) but also include material, like greetings to individuals, that would be of limited interest.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.14"
    }
  }), _vm._v("Nevertheless, while Romans displays clear evidence of its “occasional” nature in its epistolary opening (1:1–15 [–17]) and closing (15:14–16:27), the really striking feature of the letter is the general and sustained argument of 1:16–11:36. Unlike, for instance, 1 Corinthians, where Paul’s agenda is set by questions and issues raised by his readers, these chapters in Romans develop according to the inner logic of Paul’s own teaching. Even the questions and objections that periodically interrupt the argument arise naturally from the flow of Paul’s presentation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.14.44",
      "id": "FN.14.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" Not once in these chapters does Paul allude to a circumstance peculiar to the community at Rome, and even the direct addresses of his audience are so general as to be applicable to almost any church: “fellow believers” (7:4; 8:12; 10:1; 11:25), “those who know the law” (7:1), “you Gentiles” (11:13). Nor does the situation change much in 12:1–15:13. None of the issues addressed is clearly local or particular in scope. Some even argue that the section about the “strong” and the “weak” (14:1–15:13) has no specific local situation in view."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.14.45",
      "id": "FN.14.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', [_vm._v("These features show that the main body of Romans is what we may call a “treatise,” or “tractate.” It addresses key theological issues against the backdrop of middle first-century Christianity rather than within the context of specific local problems. Nevertheless, Romans is no timeless treatise. We must not forget that Romans as a whole is a "), _c('i', [_vm._v("letter,")]), _vm._v(" written on a specific occasion, to a specific community. As we have seen, these specifics have not played a large role in Paul’s presentation, but they have undoubtedly determined the agenda of theological and practical issues with which Paul deals. In this regard, we must note that Romans is far from being a comprehensive summary of Paul’s theology. Many issues near and dear to him are absent, or only allusively mentioned: the church as the “body of Christ,” the parousia, and Christology (in the “formal” sense). Moreover, the issues that Paul does treat are oriented to a specific, though broad, theological topic: the relationship between Jew and Gentile, law and gospel (see, further, the section on “Theme” below).")]), _vm._v(" "), _c('p', [_vm._v("Romans, then, is a tractate letter and has at its heart a general theological argument, or series of arguments."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.14.46",
      "id": "FN.14.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" More specific genre identification is perilous. R. Bultmann compared Romans to the “diatribe,” an argumentative "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.15"
    }
  }), _vm._v("genre particularly popular with Cynic-Stoic philosophers (the best example is probably the "), _c('i', [_vm._v("Discourses")]), _vm._v(" of Epictetus, 1st-2d "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.CENT"
    }
  }, [_vm._v("cent.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.47",
      "id": "FN.15.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Features of the diatribe include “fictional” conversations and debates, rhetorical questions, and the use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mē genoito")]), _vm._v(" (“may it never be!”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.48",
      "id": "FN.15.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" to reject a line of argument. Bultmann thought that the diatribe had a polemical purpose and read Romans accordingly. But S. Stowers argues that instruction and clarification rather than polemics were the purposes of the diatribe."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.49",
      "id": "FN.15.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Recent research also suggests that “diatribe” was not so much a genre as a style."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.50",
      "id": "FN.15.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" In any case, while parts of Romans use this diatribe style (e.g., 2:1–3:8), the letter as a whole cannot be classified as a diatribe.")]), _vm._v(" "), _c('p', [_vm._v("Scholars have suggested many other genre classifications for Romans: “memorandum,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.51",
      "id": "FN.15.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" “epideictic” letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.52",
      "id": "FN.15.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" ambassadorial letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.53",
      "id": "FN.15.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" “protreptic letter,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.54",
      "id": "FN.15.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" and “letter essay,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.55",
      "id": "FN.15.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" to name only a few. None quite fits. Certainly Romans has similarities to these genres and to a large number of other ancient Hellenistic and Jewish genres and styles. But these resemblances mean nothing more than that Paul has effectively utilized various literary conventions of his culture to get his message across. Romans cannot finally be put into any single genre; as Dunn says, “the distinctiveness of the letter far outweighs the significance of its conformity with current literary or rhetorical custom.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.56",
      "id": "FN.15.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.5"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.16"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.5"
    }
  }, [_vm._v("V. PURPOSE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The interesting mixture of the general and the occasional outlined in the last section gives rise to one of the most debated questions about Romans: Why has Paul written "), _c('i', [_vm._v("this")]), _vm._v(" letter to "), _c('i', [_vm._v("this")]), _vm._v(" particular church?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.16.57",
      "id": "FN.16.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" This question can, of course, be bypassed by those who view Romans as a timeless theological treatise, a “compendium of Christian doctrine” (Melanchthon). But, however general and systematic its presentation may be, Romans is a letter, and the question of why Paul has written it cannot be evaded.")]), _vm._v(" "), _c('p', [_vm._v("The question of the purpose of Romans has been given so many different answers because Paul says almost nothing on the subject. In the introduction (1:1–15), Paul talks about his plans to visit Rome and preach the gospel there, but he says nothing about the purpose of the letter. The conclusion of the letter elaborates these plans to come to Rome. Having “completed” his mission in the eastern Mediterranean, Paul is going next to Jerusalem to deliver the collection, and from there he plans to visit Rome on his way to Spain. But about the purpose of the letter he says only that he “has written on some points by way of reminder” (15:15). This statement is so general and stereotyped that little can be gleaned from it.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s purpose in writing, then, can be determined only by fitting the contents of the letter with its occasion. We have sketched the general occasion for the letter earlier in the introduction and, briefly, in the last paragraph. But it is the specific occasion, in the sense of Paul’s motivation for writing, that will give us the clue to the purpose of the letter. Opinions on this matter may be divided into two basic types: (1) those that stress Paul’s own situation and circumstances as the occasion for Romans; and (2) those that focus on problems within the Roman community as the occasion for the letter. Few scholars completely ignore either of these occasions; but their reconstructions differ in the degree of importance accorded to each one.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.5.1"
    }
  }, [_vm._v("A. FOCUSING ON PAUL’S CIRCUMSTANCES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Alternatives that focus on circumstances within Paul’s own situation as his motivation for writing to the Romans may be conveniently, if somewhat simplistically, categorized by reference to the "), _c('i', [_vm._v("location")]), _vm._v(" that is Paul’s focus.")]), _vm._v(" "), _c('p', {
    staticClass: "ch"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.17"
    }
  }), _vm._v("1. Spain")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Most scholars, whatever weight they give to other circumstances, think that one of Paul’s purposes in writing to the Romans was to prepare for his mission to Spain. A church-planting enterprise so far from Paul’s home base in Antioch would create all kinds of logistical problems. It would be natural for Paul to try to enlist the help of the vital and centrally located Roman community for this mission. In fact, Paul alludes to his hopes for such support in 15:24, using the verb "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("propempō,")]), _vm._v(" which connotes “help on the way with material support.” We may, then, view Romans as Paul’s “letter of introduction” to a church that he hopes to add to his list of “sponsors.” This would explain the general theological focus of the letter, for Paul would want to assure the Romans that they would be sponsoring a missionary whose orthodoxy was without question."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.17.58",
      "id": "FN.17.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', [_vm._v("Preparation for the mission to Spain was certainly one of Paul’s purposes in writing, probably even a major purpose. But it cannot stand alone as an explanation for the epistle. For one thing, had this been Paul’s sole concern, we would have expected him to mention the visit to Spain more prominently—in the introduction, not just in the conclusion of the letter. For another, it is difficult on this interpretation to account for Paul’s focus on questions of Jew and Gentile within salvation history.")]), _vm._v(" "), _c('p', {
    staticClass: "ch"
  }, [_vm._v("2. Corinth/Galatia")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One way of accounting for this emphasis on Jewish issues is to regard Romans as Paul’s summary of the position he had hammered out in the course of his struggle with Judaizers in Galatia and Corinth. Paul’s three-month stay in Greece came after the resolution of intense battles for the gospel in these churches; before he enters a new stage of missionary work, with fresh challenges and problems, Paul may well have decided to put in writing his settled views on these issues. Supporting this way of viewing the matter is the neutral and balanced stance that Paul in Romans takes on issues such as the law and circumcision—a balance that suggests no particular viewpoint was forcing Paul into a polemical position on these matters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.17.59",
      "id": "FN.17.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.18"
    }
  }), _vm._v("Again, there is probably much to this suggestion. But it leaves too much unexplained. Most important, why send this “last will and testament” (as Bornkamm calls it) to Rome?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.60",
      "id": "FN.18.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('p', {
    staticClass: "ch"
  }, [_vm._v("3. Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The same objection applies to the suggestion that Romans contains the “speech” that Paul is preparing to deliver in Jerusalem when he arrives with the collection. As we have seen, Paul viewed this collection as a practical means to cement the fractured and sometimes bitter relationships between Jews and Gentiles in the early church. And, since Paul expressly requests the Romans to pray for the success of this mission (15:30–33), what is more natural than that he would outline his own theological position on the issue to the church?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.61",
      "id": "FN.18.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Paul’s impending visit to Jerusalem clearly loomed large in his mind as he wrote Romans. But there is no evidence that it was his overriding concern. Moreover, both this suggestion and the last fail to come to grips with Paul’s stress on his desire to visit the community in Rome—an emphasis in both the introduction and conclusion to the letter. Surely this suggests that the letter had something specific to do with this planned visit.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.5.2"
    }
  }, [_vm._v("B. FOCUSING ON PROBLEMS IN ROME")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("F. C. Baur inaugurated a new approach to Romans by insisting, against the prevalent tendency to consider Romans as a timeless theological manifesto, that this letter, like all the other letters of Paul, must be directed to specific issues in the church addressed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.62",
      "id": "FN.18.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" To be sure, Paul had never visited the church in Rome. But there is sufficient evidence that he was acquainted with the situation there (see 1:8; 7:1; 11:13; 14–15; Prisca and Aquila would have been good sources of information)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.63",
      "id": "FN.18.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" Baur’s general approach has enjoyed a resurgence in the last three decades. However, though Baur thought Romans had "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.19"
    }
  }), _vm._v("a polemical purpose, contesting the claims of Jewish Christians, modern scholars have focused on other concerns as primary.")]), _vm._v(" "), _c('p', [_vm._v("G. Klein thinks that Paul wrote with the purpose of providing the necessary apostolic foundation for the creation of a “church” in Rome. Significant, according to Klein, is the absence of the word “church” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(ekklēsia)")]), _vm._v(" from the address of the letter (1:7). The Christians in Rome lacked the apostolic “imprimatur” that was necessary to constitute a church. In Romans, Paul provides this apostolic stamp of approval by rehearsing the “fundamental kerygma” that would turn a Christian community into a Christian church."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.64",
      "id": "FN.19.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" Klein’s thesis does not stand up to scrutiny. Paul’s failure to address the Romans as a church proves nothing; Philippians, Colossians, and Ephesians share the same omission."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.65",
      "id": "FN.19.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" More fundamentally, however, Klein’s supposition that a church could not exist without a "), _c('i', [_vm._v("personal")]), _vm._v(" “apostolic foundation” is baseless.")]), _vm._v(" "), _c('p', [_vm._v("Most of those who think that Paul writes with the needs of the Roman church uppermost in his mind seize on the implications of 14:1–15:13 as the key to the purpose of the letter. This passage reveals a split in the Roman community between Jewish and Gentile Christians. Here it is, many scholars think, that we find the central concern of the letter. The treatise in chaps. 1–11 supplies the theological basis for Paul’s appeal for unity in chaps. 14–15, while chaps. 12–13 provide its general parenetic basis. According to F. Watson, Paul writes specifically to convert the Jewish Christians in the community to his view of a “law-free” gospel so that they will separate completely from Judaism and join the Gentile Christians in forming one Pauline congregation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.66",
      "id": "FN.19.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" It is more popular, though, to view Romans as addressed to both Jewish and Gentile Christians, with the emphasis, if anything, on the latter group. This fits better with both the focus on Gentiles in the letter (1:5–6, 13; 11:13—see above) and the probably increasingly dominant position of Gentiles in the church. Paul would then be writing to correct the Gentiles’ indifference, even arrogance, toward the Jewish minority at the same time that he tries to show the Jews that they must not insist on the law as a normative factor in the church."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.67",
      "id": "FN.19.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.20"
    }
  }), _vm._v("We think that Paul does, indeed, write with an eye on specific problems in the community at Rome. What he says in 14:1–15:13 is too specific to allow us to consider it as general “paraenesis,” with no direct application to the Roman community."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.68",
      "id": "FN.20.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" And his direct address of Gentiles in 11:13–24 shows that Paul intends the theology he is developing to have direct practical relevance to his audience. But we also think that the divisions in the Roman church mirrored the tensions of the church at large in Paul’s day. It would be going too far to say that the specific problem in Rome gave Paul a good excuse to write about this widespread tension. But it is the case that Romans is far less tied to issues bound up with a particular church than is any other Pauline letter (with the possible exception of Ephesians). We have noted that the major part of the body of Romans, chaps. 1–11, develops by its own internal logic: Paul’s focus is on the gospel and its meaning rather than on the Romans and their needs."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.69",
      "id": "FN.20.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" The complete omission of any direct reference to the Romans until 11:13 makes it very difficult to think that the problems of the Roman church were foremost in Paul’s mind. Then, too, there is much in this treatise that does not relate to the situation implied in chaps. 14 and 15. Nor is it fair to argue that Romans must be directed to the needs of the congregation in the same way that Paul’s other letters are. For one thing, Romans stands apart, by definition, as being the only letter Paul wrote to a church for which he did not have established “pastoral” responsibility."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.70",
      "id": "FN.20.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" For another, we have too few letters of Paul to make black-and-white judgments about the kind of letter he could or could not have written.")]), _vm._v(" "), _c('p', [_vm._v("The purpose of Paul in Romans, then, cannot be confined to any one of these suggestions; Romans has several purposes."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.71",
      "id": "FN.20.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" But the various purposes share a common denominator: Paul’s missionary situation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.72",
      "id": "FN.20.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" The past battles in Galatia and Corinth; the coming crisis in Jerusalem; the desire to secure a missionary base for his work in Spain; the need to unify the Romans around “his” gospel to support his work in Spain—all these forced Paul to write a letter in which he carefully rehearsed his understanding of the gospel, especially "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.21"
    }
  }), _vm._v("as it related to the salvation-historical questions of Jew and Gentile and the continuity of the plan of salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.21.73",
      "id": "FN.21.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', [_vm._v("There may have been another reason for Paul to give such prominence to these particular issues. Paul’s battle against Judaizers (cf. Galatians; 2 Corinthians) had gained for him a reputation as being “anti-law” and perhaps even “anti-Jewish.” Rumors of Paul’s stance on these matters had probably reached Rome, as 3:8 might suggest (Paul mentions people who are “blasphemously” charging him with saying, “Let us do evil that good may come”). As Paul introduces his gospel to the Roman community, he is aware that he must defuse these rumors and perhaps even win over some who were already hostile toward him."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.21.74",
      "id": "FN.21.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(" But, unlike the situations he faced in Galatia and elsewhere, at Rome these doubts about Paul and his gospel did not, apparently, come from only one side."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.21.75",
      "id": "FN.21.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" As 14:1–15:13 suggests, he was contending both with Jewish Christians who were still tied to the law and with Gentile Christians who scorned everything Jewish—and very likely with a number of intermediate positions. Hence Paul fights on two fronts: criticizing Judaism for its overemphasis on the law and its presumption of “most favored nation” status, while affirming Israel as the “root” of the church and emphasizing its continuing place within the plan of God.")]), _vm._v(" "), _c('p', [_vm._v("One more thing about the occasion and purpose of Romans should be mentioned. The legitimate desire to pin down as precisely as possible the historical background and purpose of the letter should not obscure the degree to which Romans deals with theological issues raised by the nature "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.22"
    }
  }), _vm._v("of God’s revelation itself. Perhaps the earliest comment on the purpose of Romans comes in the Muratorian Canon ("), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 200?): “to the Romans he [Paul] wrote at greater length [than in Corinthians or Galatians], concerning the plan of the Scriptures, showing at the same time that their foundation is Christ.”")]), _vm._v(" "), _c('p', [_vm._v("We moderns must beware the tendency to overhistoricize: to focus so much on specific local and personal situations that we miss the larger theological and philosophical concerns of the biblical authors."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.76",
      "id": "FN.22.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" That Paul was dealing in Romans with immediate concerns in the early church we do not doubt. But, especially in Romans, these issues are ultimately those of the church—and the world—of all ages: the continuity of God’s plan of salvation, the sin and need of human beings, God’s provision for our sin problem in Christ, the means to a life of holiness, and security in the face of suffering and death."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.77",
      "id": "FN.22.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" Augustine, Luther, Calvin, and Wesley, whatever their failings as exegetes, saw this; and perhaps they understood more clearly than many of their latter-day critics."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.78",
      "id": "FN.22.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" We need to recognize that Romans is God’s word to "), _c('i', [_vm._v("us")]), _vm._v(" and read it seeking to discover the message that God has for us in it. As Luther said, “[Romans] is worthy not only that every Christian should know it word for word, by heart, but occupy himself with it every day, as the daily bread of the soul. It can never be read or pondered too much, and the more it is dealt with the more precious it becomes, and the better it tastes.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.79",
      "id": "FN.22.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.6"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.6"
    }
  }, [_vm._v("VI. THEME")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("At the risk of oversimplification, we can chart the history of the discussion of the theme of Romans as a movement from a focus on the beginning of the epistle to its end. The Reformers and their followers, following the lead of Luther, almost universally gave pride of place to chaps. 1–5, with their "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.23"
    }
  }), _vm._v("theme, justification by faith, as the center of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.80",
      "id": "FN.23.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" At the beginning of this century, however, Schweitzer and others argued that justification by faith was no more than a “battle doctrine” "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("(Kampflehre),")]), _vm._v(" a theological concept that Paul used simply to oppose Judaizers. The real center of Paul’s thinking is to be found in chaps. 5–8, in his doctrine of union with Christ and the work of God’s Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.81",
      "id": "FN.23.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" Others objected to the traditional focus on justification by faith because they thought that it illegitimately read back into Paul’s day a modern and Western preoccupation with the individual and his conscience. “How can a sinful person be made right with God?” was Luther’s problem, but it was not Paul’s. Rather, the question Paul sought to answer was: “How can Gentiles be incorporated with Jews into God’s people without jeopardizing the continuity of salvation history?” For these scholars, Rom. 9–11, far from being a detour from the real theme of the letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.82",
      "id": "FN.23.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v(" was the heart of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.83",
      "id": "FN.23.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" Finally, as we have seen, the last thirty years have witnessed an emphasis on Romans as an occasional letter, directed to the needs of the Roman church. For many of those who advocate this approach to the letter, Paul’s exhortation to unity in 14:1–15:13 expresses the major purpose of the letter (see above on Purpose).")]), _vm._v(" "), _c('p', [_vm._v("Forms of each of these positions are argued in the current literature on Romans. H. Hübner and others have vigorously reasserted, against its critics, the centrality of justification in Romans and in Paul generally."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.84",
      "id": "FN.23.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" In the approach associated especially with E. Käsemann, justification language is subsumed under the category of “the righteousness of God,” interpreted broadly to mean God’s intervention to reclaim his creation for himself and to bring salvation to his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.85",
      "id": "FN.23.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" Indeed, he claims that this interpretation is the theme "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.24"
    }
  }), _vm._v("of Romans. E. P. Sanders has reemphasized the importance of the “participationist” categories of Rom. 5–8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.86",
      "id": "FN.24.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿86")]), _vm._v(" Perhaps the most popular recent viewpoint is that Romans is about the role of Jews in salvation history."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.87",
      "id": "FN.24.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" Many other focal points for the letter have also been advocated: “God,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.88",
      "id": "FN.24.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" “hope,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.89",
      "id": "FN.24.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" and “salvation,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.90",
      "id": "FN.24.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" to name only a few.")]), _vm._v(" "), _c('p', [_vm._v("Before commenting on these proposals, two cautions are in order. First, we must be careful not to impose on Romans a single theme when Paul may never have thought in those terms. It is true that the tractate nature of the letter encourages the supposition that Paul may have had a single overarching theme in view. But such a supposition is not necessary, particularly when we recognize that the tractate style recedes into the background after chap. 11. In other words, a theme that fits 1:16–11:36 may not fit the letter as a whole. Romans may, then, have several themes without having any single, unifying topic. Second, we must define what we mean when we talk about "), _c('i', [_vm._v("the")]), _vm._v(" “theme,” or “center,” of the letter. Do we mean the doctrine that serves to ground and unify the various topics of the letter, the theological framework of Paul’s thinking, or the most important, or critical, topic in the letter—or something else? Some of the debate on this issue is no more than shadow-boxing, because scholars are confusing categories and are not arguing about the same thing.")]), _vm._v(" "), _c('p', [_vm._v("To avoid confusion, we will define “theme” as the overarching topic that is able to stand as the heading of Romans as a whole. Before further exploring the issue of theme per se, we need to comment on some of the related issues that we raised above.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.6.1"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.25"
    }
  }), _vm._v("A. THE THEOLOGICAL STARTING POINT")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Christology is the theological ground and starting point of the letter. Paul’s understanding of Christ is the only topic broad enough to unify his various emphases. And, though no paragraph is devoted to Christology per se in the doctrinal portion of the letter, we must not neglect the importance of Rom. 1:3–4, where Paul describes the content of his gospel in terms of Christology."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.25.91",
      "id": "FN.25.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" Other passages make God’s act in Christ the center of God’s eschatological revelation (3:21–26; 5:12–21), and all the topics in the letter are grounded in Christ (note the constant refrain in chaps. 5–8: “through Jesus Christ our Lord”). God’s act in Christ is the starting point of all Paul’s thinking and is so basic to the early church that he could assume that the Roman Christians shared this conviction with him. In this sense, while Christology is nowhere in Romans the expressed "), _c('i', [_vm._v("topic,")]), _vm._v(" it is everywhere the underlying point of departure.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.6.2"
    }
  }, [_vm._v("B. THE CONCEPTUAL FRAMEWORK")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Second, the theological framework within which Paul expresses his key ideas in Romans can be called salvation history. The phrase “salvation history,” or “redemptive history” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.GERM"
    }
  }, [_vm._v("Germ.")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Heilsgeschichte")]), _vm._v("), is used to designate several different and sometimes contradictory concepts. We are using the phrase in a rather untechnical fashion to denote a conceptual framework that Paul uses to describe what has taken place in Christ. In focusing on Paul, we do not intend to confine the conception exclusively to him; on the contrary, it is basic to the NT and perhaps the OT as well."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.25.92",
      "id": "FN.25.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.26"
    }
  }), _vm._v("Justification for the salvation-historical approach begins with due appreciation for the fact that God has accomplished redemption as part of a historical process. God’s work in Christ is the center of history, the point from which both past and future must be understood. The cross and resurrection of Christ are both the fulfillment of the OT and the basis and anticipation of final glory. With Christ as the climax of history, then, history can be divided into two “eras,” or “aeons,” each with its own founder—Adam and Christ, respectively—and each with its own ruling powers—sin, the law, flesh, and death on the one hand; righteousness, grace, the Spirit, and life on the other. All people start out in the “old era” by virtue of participation in the act by which it was founded—the sin of Adam (cf. Rom. 5:12, 18–19). But one can be transferred into the “new era” by becoming joined to Christ, the founder of that era, thereby participating in the acts through which that era came into being—Christ’s death, burial, and resurrection (cf. 6:1–6). This "), _c('i', [_vm._v("corporate")]), _vm._v(" element in Paul’s thinking is vital to understanding his argument at a number of points in Romans.")]), _vm._v(" "), _c('p', [_vm._v("The division of history into two ages was popular in Jewish apocalyptic, and Paul probably drew his conception from that background. But his understanding of God’s work in Christ introduces a key qualification in the scheme. Although Jewish apocalyptic conceived of the transition from old age to new as taking place in the field of actual history, Paul’s conception is necessarily more nuanced. For, contrary to Jewish expectation, the Messiah has accomplished the work of redemption, the Spirit has been poured out, yet evil has not been eradicated, the general resurrection is still future, and the final state of God’s kingdom has not been established. In other words, the new era has begun—has been inaugurated—but it has not yet replaced the old era. Both ages exist simultaneously; and this means that “history,” in the sense of temporal sequence, is not ultimately determinative in Paul’s salvation-historical scheme."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.26.93",
      "id": "FN.26.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(" Thus, the “change of aeons,” while occurring historically at the cross (cf. 3:21), becomes real for the individual only at the point of faith. The “change of aeons” that took place in Christ is experienced only “in Christ.” Therefore, the person who lives "), _c('i', [_vm._v("after")]), _vm._v(" Christ’s death and resurrection and who has not appropriated the benefits of those events by faith lives in the old era yet: enslaved to sin, in the flesh, doomed to eternal death. On the other hand, Abraham, for example, though living many centuries "), _c('i', [_vm._v("before")]), _vm._v(" Christ, must, in light of Rom. 4, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.27"
    }
  }), _vm._v("be considered to belong, in some sense at least, to the new era. This circumstance introduces a confusing factor, making it difficult to come up with an overall system that is capable of integrating all of Paul’s applications of salvation history. At this point, however, it is important to recall that, while rooted in the nature of God’s redemptive work, the salvation-historical scheme we have delineated is largely a useful conceptual tool for Paul, a tool that he uses to make different points in different places."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.27.94",
      "id": "FN.27.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" But it serves Paul well in Romans, where it perfectly serves his purpose to make clear the finality and uniqueness of the gospel as well as its connections with the revelation of God in the OT."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.27.95",
      "id": "FN.27.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.6.3"
    }
  }, [_vm._v("C. THE THEME")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The trend in recent scholarship to make the relationship of Jews and Gentiles within the new covenant people of God central to Romans is understandable and, to a considerable extent, justified. For Romans is permeated with concern for the Jews, their law, and their relationship to the revelation of the righteousness of God and to the increasingly Gentile-oriented church. The word “law,” usually referring to the Mosaic law, occurs more times in Romans (74) than in all the other letters of Paul combined (47); Paul devotes an entire chapter to it (7), and it recurs in relationship to almost every topic Paul treats (cf., e.g., 2:12–16; 4:13–15; 5:13–14, 20; 6:14, 15; 8:2–4; 9:31–10:5; 13:8–10)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.27.96",
      "id": "FN.27.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" Because the law is central to the Mosaic covenant, Paul’s discussion of law becomes a discussion of the Mosaic covenant and its relationship to the New Covenant initiated in Christ. Rom. 9–11 is no excursus then, but brings to a climax a theme that has been present in the letter since its opening verses: “the gospel of God which he promised beforehand through his prophets in the holy scriptures” (1:1b-2). For the issue of the Jew is, finally, the issue of continuity in God’s salvation plan and, consequently, of God’s faithfulness to his promises (cf. 3:1–8; 9:6). In Romans, Paul teaches both the newness of God’s intervention in Christ—which means a “no” to the law and the Mosaic covenant as permanent features of salvation history—and the connections between the new act and the OT—which means a “yes” to the Abrahamic promise and to the future of Israel. Paul, then, both denies to the Jew "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.28"
    }
  }), _vm._v("an “advantage” (3:9) and affirms that Israel has certain inalienable rights (3:1–2; 11:11–32); affirms the universality of God’s righteousness—“to "), _c('i', [_vm._v("all")]), _vm._v(" who believe”—and its particular relevance to the Jew—“to the Jew first”; and claims that the righteousness of God has been revealed “apart from the law” (3:21) and that the gospel first provides for the true fulfillment of the law (3:31; 8:4). These are not contradictions but the two sides of the relationship of continuity and discontinuity between the testaments that Paul sets forth in Romans. We can understand, then, why many scholars call Romans a “dialogue with Judaism.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.28.97",
      "id": "FN.28.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('p', [_vm._v("But to make the relationship between the two peoples—Jews and Gentiles—the theme of Romans, with the transformation of the individual a subordinate, supporting concept, is to reverse their relationship in the letter, to confuse background with foreground. The scholars who have put “people” questions at the center of Romans have overreacted to the neglect of these matters among some earlier interpreters. The bulk of Romans focuses on how God has acted in Christ to bring the "), _c('i', [_vm._v("individual")]), _vm._v(" sinner into a new relationship with himself (chaps. 1–4), to provide for that "), _c('i', [_vm._v("individual’s")]), _vm._v(" eternal life in glory (chaps. 5–8), and to transform that "), _c('i', [_vm._v("individual’s")]), _vm._v(" life on earth now (12:1–15:13). Since it is essential to Paul’s message that God acts, in a way that he has not previously, to include on an equal basis both Jew and Gentile in this transforming operation, Paul must pay constant attention to the implications of this new equality of treatment. He must explain how his message of individual transformation relates to God’s focus on Israel in the OT. This explanation thus becomes a constant motif in the letter and occupies an important section of the letter (chaps. 9–11) in its own right. But it remains the background, as Paul presents in the foreground the way in which God has acted to transform rebellious sinners into obedient saints.")]), _vm._v(" "), _c('p', [_vm._v("Is, then, justification by faith the theme of the letter? Certainly a good case can be made for it. But I do not finally think that it can stand as the overarching theme. This is not because I would thereby be foisting an anachronism on Paul. The individual and his relationship to God are important in Romans; and there is not as much difference between the thought world of Paul and that of Luther or ourselves as Stendahl and others think."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.28.98",
      "id": "FN.28.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" On the other hand, there is too much in Romans that cannot, without distortion, be subsumed under the heading of justification: the assurance "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.29"
    }
  }), _vm._v("and hope of the believer (chaps. 5 and 8); freedom from sin and the law (chaps. 6 and 7); God’s purpose for Israel (chaps. 9–11); and the life of obedience (chaps. 12–15). To be sure, we can relate all of these to justification, as its fruits, or implications, or requirements; and Paul makes this connection himself at several points (cf. 5:1, 9; 8:33; cf. 9:30–10:8). But he does not do so often enough to make us think that justification, or “the righteousness of God,” is his constant reference point. In fact, as we have implied above, it is only in 1:18–4:25 that justification is highlighted in Romans.")]), _vm._v(" "), _c('p', [_vm._v("But while it is not the theme of Romans, justification by faith is nevertheless of critical importance in the letter. For, as we will argue below, the theme of the letter is the gospel. And the message of the gospel is that God brings guilty sinners into relationship with himself and destines them to eternal life when they believe in his son, Jesus the Messiah. Moreover, this message is nothing more than what we call justification by faith. And justification by faith is central to Romans and to Paul’s theology also because it expresses, in the sphere of anthropology, a crucial element in Paul’s understanding of God’s work in Christ: its entirely gracious character. Justification by faith is the necessary implicate of the grace of God (e.g., 4:5, 16). Not only, then, does justification by faith guard against the Jewish attempt to make works of the law basic for salvation in Paul’s day; it expresses the resolute resistance of Paul, and the NT authors, to the constant human tendency to make what people do decisive for salvation. It is in this sense, then, that we uphold justification as a doctrine of critical importance in Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.29.99",
      "id": "FN.29.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("What, then, is the theme of the letter? The gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.29.100",
      "id": "FN.29.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")]), _vm._v(" The word “gospel” and the cognate verb “evangelize” are particularly prominent in the introduction (cf. 1:1, 2, 9, 15) and conclusion (15:16, 19) of Romans—its epistolary “frame.” And this is the word that has pride of place in Paul’s statement of the theme of the letter: 1:16–17. “For I am not ashamed of the gospel.…” True, Paul goes on to speak of the interplay of salvation, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.30"
    }
  }), _vm._v("the interplay of Jew and Gentile, and justification by faith; and each has been advanced as the theme of the letter. But they are all elaborations of the main topic of these verses, the gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.30.101",
      "id": "FN.30.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" And we require a theme as broad as “the gospel” to encompass the diverse topics in Romans. Moreover, as we have seen, Romans grows out of Paul’s own missionary situation; and the gospel Paul preaches would naturally be the focus of attention in any letter that arises from such a situation. Romans is Paul’s summary of the gospel that he preaches. But because he writes this summary in a context charged with uncertainty and controversy over the gospel’s relationship to the OT—especially the torah—and its embrace of both Jew and Gentile, he nuances his summary with constant reference to these issues.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.7"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.7"
    }
  }, [_vm._v("VII. TEXT AND TRANSLATION")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The textual basis for the commentary is the United Bible Societies’ "), _c('i', [_vm._v("The Greek New Testament,")]), _vm._v(" fourth edition (which prints the same text as the Nestle-Aland "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum Graece,")]), _vm._v(" twenty-seventh edition). Readers may find discussion of every variant cited in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(" in the footnotes to the translations; I have also discussed a number of significant variants that do not appear in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("The Greek "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" witnesses to the text of Romans are:")]), _vm._v(" "), _c('p', {
    staticClass: "dh"
  }, [_vm._v("Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("P"), _c('sup', [_vm._v("46")]), _vm._v(", “Chester Beatty II.” This very early ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.C"
    }
  }, [_vm._v("c.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 200) papyrus codex exhibits what Aland and Aland call a “free” text,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.30.102",
      "id": "FN.30.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" one that does not clearly line up consistently with any of the “families” that developed at a later period."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.30.103",
      "id": "FN.30.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" It unfortunately includes only parts of Romans: 5:17–6:14; 8:15–15:9; 15:11–16:27.")]), _vm._v(" "), _c('p', [_vm._v("The other papryi witnesses to the text of Romans (P"), _c('sup', [_vm._v("10, 26, 27, 31, 40, 61, 94")]), _vm._v(") include only small parts of the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "dh"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.31"
    }
  }), _vm._v("Uncials")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("א")]), _vm._v(" (01), “Sinaiticus.” This is one of the great fourth-century uncials, containing the entire NT (as well as most of the OT and Apocrypha). It is a primary witness to the Alexandrian text.")]), _vm._v(" "), _c('p', [_vm._v("A (02), “Alexandrinus.” This fifth-century "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(" contains most of the NT, including all of Romans, and is a slightly less valuable witness to the Alexandrian text (Aland and Aland’s category II).")]), _vm._v(" "), _c('p', [_vm._v("B (03), “Vaticanus.” With Sinaiticus, Vaticanus is the most important witness to the Alexandrian textual tradition. It contains most of the NT, including all of Romans.")]), _vm._v(" "), _c('p', [_vm._v("C (04), “Ephraemi Rescriptus.” A fifth-century palimpsest, it contains most of Romans and is a secondary witness to the Alexandrian text.")]), _vm._v(" "), _c('p', [_vm._v("D (06), “Claromontanus.” To be distinguished from the “D” uncial of the Gospels and Acts (Bezae), this sixth-century uncial is one of the most important witnesses to the western text in Romans. It lacks only a few verses of Rom. 1.")]), _vm._v(" "), _c('p', [_vm._v("F (010), “Augiensis.” A ninth-century witness to the western text, it contains all of Romans except chaps. 1–2 and parts of chap. 3.")]), _vm._v(" "), _c('p', [_vm._v("G (012), “Boernerianus.” This ninth-century "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(", containing all of Romans except parts of chaps. 1 and 2, has a text very close to that of “F.” They might well be “sister” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(", copied from the same (now lost) "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("P (025), “Porphyrianus.” Containing most of Romans, this ninth-century codex displays a text that does not line up consistently with any of the major textual families (Aland and Aland’s category III).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "grc"
  }, [_vm._v("Ψ")]), _vm._v(" (044), “Athous Lavrensis.” This eighth- or ninth-century uncial, like P, is not a consistent witness to any text family. It includes all of Romans.")]), _vm._v(" "), _c('p', [_vm._v("Several other uncials contain all or most of Romans: K (018), L (020), 049, 056, 0142, and 0151. But they are late (ninth century or later) and are part of what textual critics call the “majority text.”")]), _vm._v(" "), _c('p', {
    staticClass: "dh"
  }, [_vm._v("Minuscules")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Twenty-nine minuscules contain all or part of the text of Romans. The three most important are 33 (ninth century), 81 (eleventh century), and 1739 (tenth century), all of which are important secondary witnesses to the Alexandrian text."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.31.104",
      "id": "FN.31.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.32"
    }
  }), _vm._v("All the important witnesses identified above will be cited (where extant and relevant) as we deal with variants in the text of Romans. Following the practice of "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NA"
    }
  }, [_vm._v("NA")]), _c('sup', [_vm._v("27")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(", I will cite the majority of late "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" that belong to the Byzantine text by reference to the “majority text” (= “Byz” in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The translation printed at the heading of each section is my own. It is very literal, my purpose being to give the non-Greek-speaking reader as much sense as possible of the structure and ambiguity of the underlying Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.8"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.8"
    }
  }, [_vm._v("VIII. STRUCTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Because the main body of Romans is a “theological tractate,” outlines of the structure of the letter tend to resemble the headings in systematic theologies. Beker has objected to this procedure, arguing that the pursuit of a “systematic thought structure” imposes an “architectonic rigor” on what is, after all, an occasional letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.32.105",
      "id": "FN.32.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" To the extent that scholars subsume everything in the letter under a single theological doctrine (e.g., justification by faith), or attach the labels of later dogmatic structures to the letter (e.g., dividing Rom. 1–8 into the topics of justification and sanctification, or making predestination the topic of chaps. 9–11), or ignore the occasional and practical elements in the letter (especially chaps. 12–16), this objection is warranted. But this should not deter us from searching for logical movement in the letter, especially in chaps. 1–11, where, as we have seen, the course of Paul’s argument owes more to the “inner logic” of the gospel than to occasional matters. In these chapters, I am convinced, Paul is arguing—and arguing theologically. We should not impose our own theological categories on Paul, but neither should we ignore those that he may be using.")]), _vm._v(" "), _c('p', [_vm._v("My own outline reflects what I think is the theme of the letter: the gospel. There is general agreement over the major sections of the letter, with one significant exception: the place of chap. 5. Many interpreters, especially in the Reformed Protestant tradition, made this chapter the conclusion to Paul’s argument about justification by faith in chaps. 1–4. But gaining in popularity has been the decision to take chap. 5 with chaps. 6–8, a part of Paul’s “two-age” presentation of Christian existence and hope. As I argue in the introduction to chaps. 5–8, I am are convinced that the latter alternative is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.9"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.33"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.9"
    }
  }, [_vm._v("IX. ANALYSIS OF ROMANS")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1"
    }
  }, [_vm._v("I. THE LETTER OPENING (1:1–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1.1"
    }
  }, [_vm._v("A. PRESCRIPT (1:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1.2"
    }
  }, [_vm._v("B. THANKSGIVING AND OCCASION: PAUL AND THE ROMANS (1:8–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1.3"
    }
  }, [_vm._v("C. THE THEME OF THE LETTER (1:16–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY2"
    }
  }, [_vm._v("EXCURSUS: RIGHTEOUSNESS LANGUAGE IN ROMANS")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3"
    }
  }, [_vm._v("II. THE HEART OF THE GOSPEL: JUSTIFICATION BY FAITH (1:18–4:25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1"
    }
  }, [_vm._v("A. THE UNIVERSAL REIGN OF SIN (1:18–3:20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.1"
    }
  }, [_vm._v("1. All Persons Are Accountable to God for Sin (1:18–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2"
    }
  }, [_vm._v("2. Jews Are Accountable to God for Sin (2:1–3:8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2.1"
    }
  }, [_vm._v("a. The Jews and the Judgment of God (2:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2.1.1"
    }
  }, [_vm._v("i. Critique of Jewish Presumption (2:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2.1.2"
    }
  }, [_vm._v("ii. The Impartiality of Judgment (2:6–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.1.3"
    }
  }, [_vm._v("iii. Judgment and the Law (2:12–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.2"
    }
  }, [_vm._v("b. The Limitations of the Covenant (2:17–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.2.1"
    }
  }, [_vm._v("i. The Law (2:17–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.2.2"
    }
  }, [_vm._v("ii. Circumcision (2:25–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.3"
    }
  }, [_vm._v("c. God’s Faithfulness and the Judgment of Jews (3:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.3"
    }
  }, [_vm._v("3. The Guilt of All Humanity (3:9–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY4"
    }
  }, [_vm._v("Excursus: Paul, “Works of the Law,” and First-Century Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY4.1"
    }
  }, [_vm._v("B. JUSTIFICATION BY FAITH (3:21–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.1"
    }
  }, [_vm._v("1. Justification and the Righteousness of God (3:21–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2"
    }
  }, [_vm._v("2. “By Faith Alone” (3:27–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.1"
    }
  }, [_vm._v("a. “By Faith Alone”: Initial Statement (3:27–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2"
    }
  }, [_vm._v("b. “By Faith Alone”: Elaboration with Respect to Abraham (4:1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.1"
    }
  }, [_vm._v("i. Faith and Works (4:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.2"
    }
  }, [_vm._v("ii. Faith and Circumcision (4:9–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.3"
    }
  }, [_vm._v("iii. Faith, Promise, and the Law (4:13–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.4"
    }
  }, [_vm._v("iv. The Faith of Abraham and the Faith of the Christian (4:23–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5"
    }
  }, [_vm._v("III. THE ASSURANCE PROVIDED BY THE GOSPEL: THE HOPE OF SALVATION (5:1–8:39)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5.1"
    }
  }, [_vm._v("A. THE HOPE OF GLORY (5:1–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5.1.1"
    }
  }, [_vm._v("1. From Justification to Salvation (5:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY5.1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Reign of Grace and Life (5:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. FREEDOM FROM BONDAGE TO SIN (6:1–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY5.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. “Dead to Sin” through Union with Christ (6:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "page.34"
    }
  }), _vm._v("Excursus: Paul’s “With Christ” Conception")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Freed from Sin’s Power to Serve Righteousness (6:15–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. FREEDOM FROM BONDAGE TO THE LAW (7:1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Released from the Law, Joined to Christ (7:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The History and Experience of Jews under the Law (7:7–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.2.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Coming of the Law (7:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.2.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Life under the Law (7:13–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. ASSURANCE OF ETERNAL LIFE IN THE SPIRIT (8:1–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Spirit of Life (8:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Spirit of Adoption (8:14–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY6.3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Spirit of Glory (8:18–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY6.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. THE BELIEVER’S SECURITY CELEBRATED (8:31–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. THE DEFENSE OF THE GOSPEL: THE PROBLEM OF ISRAEL (9:1–11:36)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. INTRODUCTION: THE TENSION BETWEEN GOD’S PROMISES AND ISRAEL’S PLIGHT (9:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. DEFINING THE PROMISE (1): GOD’S SOVEREIGN ELECTION (9:6–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Israel within Israel (9:6–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Objections Answered: The Freedom and Purpose of God (9:14–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. God’s Calling of a New People: Israel and the Gentiles (9:24–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. UNDERSTANDING ISRAEL’S PLIGHT: CHRIST AS THE CLIMAX OF SALVATION HISTORY (9:30–10:21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Israel, the Gentiles, and the Righteousness of God (9:30–10:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Righteousness of God and the “Law of Righteousness” (9:30–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Righteousness of God and “Their Own Righteousness” (10:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Gospel and Law (10:5–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Israel’s Accountability (10:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. SUMMARY: ISRAEL, THE “ELECT,” AND THE “HARDENED” (11:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. DEFINING THE PROMISE (2): THE FUTURE OF ISRAEL (11:11–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. God’s Purpose in Israel’s Rejection (11:11–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Interrelationship of Jews and Gentiles: A Warning to Gentile Believers (11:16–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY7.5.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Salvation of “All Israel” (11:25–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY7.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "page.35"
    }
  }), _vm._v("F. CONCLUSION: PRAISE TO GOD IN LIGHT OF HIS AWESOME PLAN (11:33–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. THE TRANSFORMING POWER OF THE GOSPEL: CHRISTIAN CONDUCT (12:1–15:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. THE HEART OF THE MATTER: TOTAL TRANSFORMATION (12:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. HUMILITY AND MUTUAL SERVICE (12:3–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. LOVE AND ITS MANIFESTATIONS (12:9–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. THE CHRISTIAN AND SECULAR RULERS (13:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. LOVE AND THE LAW (13:8–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. LIVING IN LIGHT OF THE DAY (13:11–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. A PLEA FOR UNITY (14:1–15:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Do Not Condemn One Another! (14:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Do Not Cause Your Brother to Stumble! (14:13–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Put Other People First! (15:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Receive One Another! (15:7–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. THE LETTER CLOSING (15:14–16:27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY9.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. PAUL’S MINISTRY AND TRAVEL PLANS (15:14–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Looking Back: Paul’s Ministry in the East (15:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Looking Ahead: Jerusalem, Rome, and Spain (15:22–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Request for Prayer (15:30–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. GREETINGS (16:1–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Commendation of Phoebe (16:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Greetings to Roman Christians (16:3–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Warning, a Promise, and a Prayer for Grace (16:17–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Greetings from Paul’s Companions (16:21–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. CONCLUDING DOXOLOGY (16:25–27)")])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "pt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.36"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.37"
    }
  }), _vm._v("The Epistle to the"), _c('br'), _vm._v("ROMANS")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pt01"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.38"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.39"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rpt01"
    }
  }, [_vm._v("Text, Exposition, and Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BODY1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rBODY1"
    }
  }, [_vm._v("I. THE LETTER OPENING (1:1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The main body of Romans is a treatise on Paul’s gospel, bracketed by an epistolary opening (1:1–17) and conclusion (15:14–16:27). These opening and concluding statements have many similarities, not the least of which is the emphasis on the "), _c('i', [_vm._v("gospel.")]), _vm._v(" (Eight of the 11 occurrences in Romans of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("euangelion")]), _vm._v(" [“gospel”] and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("euangelizomai")]), _vm._v(" [“to evangelize”] are in these passages.) Paul’s special relationship to this gospel, a relationship that encompasses the Roman Christians, both opens and closes the strictly “epistolary” introductory material in this section (vv. 1–5, 13–15)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.39.1",
      "id": "FN.39.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY1.1"
    }
  }, [_vm._v("A. PRESCRIPT (1:1–7)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("Paul, a slave of Christ Jesus,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.39.2",
      "id": "FN.39.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" called to be an apostle, set apart for the gospel of God, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("which was promised beforehand through his prophets in the holy Scriptures, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("concerning his son, who came from the seed of David according to the flesh, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("who was designated Son of God in power according to the Spirit of holiness on the basis of the resurrection of the dead, Jesus Christ our Lord, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("through whom we received grace and apostleship for the obedience of faith among all the Gentiles for the sake of his name, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("among whom you also are called "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.40"
    }
  }), _vm._v("of Jesus Christ, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("to all of you in Rome,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.40.3",
      "id": "FN.40.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" beloved by God, called to be saints. Grace to you, and peace from God our Father and the Lord Jesus Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The letters of Paul must have been greeted with considerable perplexity by their first-century recipients. To the extent that this perplexity was due to the theological complexity of the letters, contemporary readers can share the reaction of their first-century counterparts. But the very form of the letters would have been further grounds for puzzlement to the early Christians. Paul’s letters are far longer than most first-century letters—so long that they make exact literary classification difficult. And Romans, with 7,114 words, is the longest of Paul’s letters. Fittingly, Romans also has the longest prescript. The typical Greek letter began simply with a one-sentence identification of the sender and recipients, and a greeting: A to B, “greetings” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("chairein;")]), _vm._v(" Acts 15:23; 23:26; Jas. 1:1). Paul expands this form considerably in all his letters but nowhere more than in Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.40.4",
      "id": "FN.40.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" The superscription, or identification of the sender, is particularly long, occupying the first six verses.")]), _vm._v(" "), _c('p', [_vm._v("Paul introduces himself by stating his divine call (v. 1), the message that he has been called to proclaim (vv. 2–4), and the specific task with which he is occupied (vv. 5–6). Finally comes the address in v. 7a, followed by the usual Pauline salutation in v. 7b. The length and theological orientation of this prescript are due mainly to the fact that Paul was introducing himself to a church that he had neither founded nor visited. He wanted to establish his credentials as an apostle with a worldwide commission to proclaim the good news of Jesus Christ. Whether this elaborate prescript had a polemical motive (as, e.g., Murray thinks) is not clear.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" Paul"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.40.5",
      "id": "FN.40.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿5")]), _vm._v(" introduces himself to the Roman church with three parallel designations that, respectively, identify his master, his office, and his purpose. All three lack articles, a style typical of the introductions of letters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.40.6",
      "id": "FN.40.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" “Slave "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.41"
    }
  }), _vm._v("of Christ Jesus” is patterned on the familiar OT phrase “slave,” or “servant,” of Yahweh."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.41.7",
      "id": "FN.41.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" The phrase connotes total devotion, suggesting that the servant is completely at the disposal of his or her Lord. That great honor attaches to the service of so exalted a master is of course true, and many commentators stress this side of the title in Paul’s application of it to himself."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.41.8",
      "id": "FN.41.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" But the connotations of humility, devotion, and obedience are never absent from the OT phrase and are surely primary here also. Indicative of Paul’s high Christology is the fact that he replaces the “Lord” of the OT phrase with “Christ Jesus.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.41.9",
      "id": "FN.41.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" The sequence “Christ Jesus” draws particular attention to the "), _c('i', [_vm._v("Messiah")]), _vm._v(" Jesus and may also suggest the corporate and universal significance of this Messiahship.")]), _vm._v(" "), _c('p', [_vm._v("Only in the prescripts of Titus and Philippians (where Timothy is also mentioned) does Paul call himself a “slave.” But the second designation in Rom. 1:1, “apostle,” is used in every Pauline prescript except those in Philippians, 1 and 2 Thessalonians, and Philemon. Paul occasionally uses “apostle” in a general way to mean simply “messenger” (Phil. 2:25; 2 Cor. 8:23), and more often to refer to accredited missionaries (e.g., Rom. 16:7). But here the title carries a stronger sense, marking Paul as one among that unique group appointed by Christ himself to have the salvation-historical role as the “foundation” of the church (Eph. 2:20)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.41.10",
      "id": "FN.41.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" For the risen Christ appeared to him "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.42"
    }
  }), _vm._v("(1 Cor. 15:8) and chose him for his special mission to the Gentiles (Rom. 11:13; cf. 1 Tim. 2:7; 2 Tim. 1:11). This divine initiative in Paul’s apostleship is made evident here by the verbal adjective “called.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.42.11",
      "id": "FN.42.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" What Paul intends by this is spelled out in the polemically oriented opening of Galatians: “Paul, an apostle—sent not from men nor by man, but by Jesus Christ and God the Father, who raised him from the dead …” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v("). As is Paul’s custom, then, he specifies at the very beginning of his letter that he writes not as a private individual, nor even as a gifted teacher, but as a “called apostle” whose words bear the authority of God himself. Any reading of this great theological treatise that ignores this claim to authority will fail to come to grips with the ultimate purpose of its writing.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s final description of himself in v. 1, “set apart for the gospel of God,” may allude to his being set aside for his great apostolic task even from “the womb of his mother” (cf. Gal. 1:15)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.42.12",
      "id": "FN.42.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" But the word order here makes it more likely that the “set apart” clause is simply a further definition of “called.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.42.13",
      "id": "FN.42.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" The verb is used in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of God’s “separating” and calling of Israel from among other nations (Lev. 20:26) and in Acts 13:2 of the “setting apart” of Barnabas and Saul for missionary service. Similarly, Paul, as a “called apostle,” has been set aside by God for a special purpose in God’s plan for history. Paul here specifies this purpose with the words “for"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.42.14",
      "id": "FN.42.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿14")]), _vm._v(" the gospel of God.” “Gospel” here might denote the activity of preaching the gospel (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TEV"
    }
  }, [_vm._v("TEV")]), _vm._v(": “called by God to preach the Good News”),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.42.15",
      "id": "FN.42.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" or it might "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.43"
    }
  }), _vm._v("simply refer to the message of the gospel itself."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.43.16",
      "id": "FN.43.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" What makes a decision difficult is that the dynamic sense fits well with v. 1 but badly with vv. 2–3, while the more static connotation suffers from just the reverse problem. Cranfield suggests that the word contains both connotations here. This is certainly on the right track, but perhaps we can refine this suggestion further. Paul uses “gospel” so generally in some contexts (cf. Rom. 1:9; Phil. 1:27; Eph. 3:6; 6:19) that it becomes functionally equivalent to “Christ” or God’s intervention in Christ. In other words, Paul can sometimes expand the scope of “gospel” to include the very events of which the message speaks. God’s sending his Son for the salvation of the world is itself “good news.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.43.17",
      "id": "FN.43.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Since the context makes it difficult to choose either the active or the static sense alone, there is good reason to adopt this broad meaning of the word here. In saying that he has been “set apart for the gospel of God,” then, Paul is claiming that his life is totally dedicated to God’s act of salvation in Christ—a dedication that involves both his own belief in, and obedience to, that message as well as his apostolic proclamation of it. With this meaning, “of God” probably can be paraphrased “sent by God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.43.18",
      "id": "FN.43.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" This genitive addition should not be overlooked. As L. Morris has reminded us, Romans is ultimately a book about "), _c('i', [_vm._v("God:")]), _vm._v(" how "), _c('i', [_vm._v("he")]), _vm._v(" acted to bring salvation, how "), _c('i', [_vm._v("his")]), _vm._v(" justice is preserved, how "), _c('i', [_vm._v("his")]), _vm._v(" purposes are worked out in history, how "), _c('i', [_vm._v("he")]), _vm._v(" can be served by his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.43.19",
      "id": "FN.43.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" In a relative clause dependent on “gospel” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(euangelion),")]), _vm._v(" Paul further defines the gospel as something promised in the OT. In a manner typical of Paul’s emphasis throughout Romans, he draws a line of continuity "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.44"
    }
  }), _vm._v("between the new work of God in his Son, the content of the gospel (vv. 3–4), and the OT. By adding the redundant “ahead of time” to the verb “promise,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.20",
      "id": "FN.44.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Paul emphasizes the temporal sequence of promise and fulfillment. He therefore touches on what will become two key themes in Romans: the promise (cf. Rom. 4), and the grounding of God’s salvific revelation in his previous purposes and work."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.21",
      "id": "FN.44.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" The “prophets” through whom God promised the gospel include men like Moses (cf. Acts 3:21–22) and David (cf. Acts 2:30), in addition to those we would ordinarily classify as “prophets” per se. In Paul’s perspective, as Luther puts it, “Scripture is completely prophetical.” The phrase “holy Scriptures”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.22",
      "id": "FN.44.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" occurs only here in Paul."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.23",
      "id": "FN.44.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" It is doubtful whether Paul has any particular OT passages in mind here; his purpose is general and principial, to allay possible suspicion about “his” gospel as new and innovative by asserting its organic relationship to the OT.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3")]), _vm._v(" Whether the prepositional phrase that introduces v. 3, “concerning his Son,” depends on “promise ahead of time” in v. 2"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.24",
      "id": "FN.44.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" or on “gospel” in v. 1,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.25",
      "id": "FN.44.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿25")]), _vm._v(" the meaning is much the same: the focus of the gospel is a person, God’s Son. “Son of God” is a title not used often by Paul, but as M. Hengel notes, it is used in key places and assumes thereby an importance disproportionate to its frequency."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.26",
      "id": "FN.44.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" As we would expect, the title focuses on Jesus’ uniquely intimate relationship to God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.44.27",
      "id": "FN.44.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" “His Son” is further defined in vv. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.45"
    }
  }), _vm._v("3b–4 with two parallel participial clauses. Their close parallelism is evident when they are set side by side:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“who has come”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“who was appointed”")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“from the seed of David”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“Son of God in power”")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“according to the flesh”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“according to the Spirit of holiness”")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "sl"
  }, [_vm._v("“from the resurrection of the dead”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.45.28",
      "id": "FN.45.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This parallelism, coupled with the presence of several words and phrases unique or unusual in Paul,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.45.29",
      "id": "FN.45.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" raises the possibility that Paul is here quoting from, or adapting, an earlier tradition. Such use of traditional material is unobjectionable in itself, paralleled in other Pauline texts, and entirely appropriate as a means to establish some common ground with the unfamiliar Roman church."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.45.30",
      "id": "FN.45.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" Nevertheless, we should be cautious about drawing exegetical conclusions from this necessarily uncertain hypothesis. The meaning of these verses, then, is to be determined against the background of Paul and his letters, not against a necessarily hypothetical traditions-history."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.45.31",
      "id": "FN.45.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.46"
    }
  }), _vm._v("The first participial clause (v. 3b) focuses on the Son of God coming into human existence. This clause assumes the preexistence of the Son."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.46.32",
      "id": "FN.46.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" How specifically Paul may allude to the incarnation depends on the meaning to be given the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("genomenon,")]), _vm._v(" “has come.” Although it is not the usual word for “give birth,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.46.33",
      "id": "FN.46.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" it can sometimes take this meaning, and some argue for it here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.46.34",
      "id": "FN.46.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" But this probably reads too much into the verb. Perhaps Paul uses the more general term to suggest that more than a simple “birth” was entailed in the “becoming” of the Son; a change in existence also took place. This appearance of the Son on the human scene is qualified as being “from the seed of David,” a clear allusion to the messianic stature of the Son."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.46.35",
      "id": "FN.46.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Finally, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.47"
    }
  }), _vm._v("this “coming” of the Son is qualified as being “according to the flesh.” “Flesh” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(sarx)")]), _vm._v(" is a key Pauline theological term. It refers essentially to human existence, with emphasis on the transitory, weak, frail nature of that existence."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.47.36",
      "id": "FN.47.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" “According to the flesh,” used 21 times in Paul, denotes being or living according to the “merely human.” Neutral in itself, the phrase nevertheless suggests that only one perspective is being considered and that other aspects must be taken into account to get the whole picture."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.47.37",
      "id": "FN.47.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" The phrase here, then, while obviously far toward the neutral end of the spectrum, also suggests that we have not arrived at a full understanding of Jesus if we look at him only from the standpoint of “the flesh.” Verse 4 goes on to fill out this picture of Jesus by looking at him from another perspective.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("4")]), _vm._v(" Although the claim that v. 4 sets forth “the whole message of the epistle in a nutshell” (Nygren) may be exaggerated, the verse is theologically important. But its meaning is debated and can be determined only after answering three basic exegetical questions. First, what is the meaning of the word we have translated “designated”? Some think it should be translated “declared”: the resurrection declared that Jesus was “Son of God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.47.38",
      "id": "FN.47.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" But the verb does not appear to have this meaning in first-century Greek."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.47.39",
      "id": "FN.47.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" In its seven other NT occurrences, the verb means “determine, appoint, fix,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.47.40",
      "id": "FN.47.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" and we "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.48"
    }
  }), _vm._v("must assume that the word has this meaning here also: the Son (the subject of the participle; cf. v. 3a) has been “appointed” Son of God by God the Father"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.48.41",
      "id": "FN.48.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿41")]), _vm._v(" by virtue of his resurrection.")]), _vm._v(" "), _c('p', [_vm._v("This notion appears at first sight to be theologically troublesome (is the eternal sonship of Christ being denied?), but several considerations remove any difficulty. The idea that the resurrection caused Jesus to be, in some sense, appointed Son has parallels elsewhere in the NT. See, particularly, Paul’s proclamation to the synagogue worshipers in Pisidian Antioch: “this [‘what God promised to the fathers’] he has fulfilled to us their children by raising Jesus; as also it is written in the second psalm, ‘Thou art my Son, today I have begotten Thee’ ” (Acts 13:33). Rom. 1:4 probably alludes to this Psalm verse (2:7), which speaks of the coronation of the Davidic messianic King (cf. also Heb. 1:5)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.48.42",
      "id": "FN.48.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" In speaking this way, Paul and the other NT authors do not mean to suggest that Jesus becomes the Son only at the time of his resurrection. In this passage, we must remember that the Son is the subject of the entire statement in vv. 3–4: It is the "), _c('i', [_vm._v("Son")]), _vm._v(" who is “appointed” Son. The tautologous nature of this statement reveals that being appointed Son has to do not with a change in essence—as if a person or human messiah becomes Son of God for the first time—but with a change in status or function.")]), _vm._v(" "), _c('p', [_vm._v("At this point we must consider the second key exegetical issue in this verse: the function of the phrase “in power.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.48.43",
      "id": "FN.48.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" The phrase could modify either “declared”—“declared with power to be the Son of God” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(")"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.48.44",
      "id": "FN.48.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v("—or “Son of God”—“declared Son-of-God-in-power.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.48.45",
      "id": "FN.48.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" But the need to demarcate the second occurrence of “Son of God” from the first—“his Son” in v. 3—strongly favors the latter connection."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.48.46",
      "id": "FN.48.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" What Paul is claiming, then, is that the preexistent Son, who entered into human experience as the promised Messiah, was appointed on the basis of (or, perhaps, at the time "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.49"
    }
  }), _vm._v("of"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.49.47",
      "id": "FN.49.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿47")]), _vm._v(") the resurrection to a new and more powerful position in relation to the world. By virtue of his obedience to the will of the Father (cf. Phil. 2:6–11) and because of the eschatological revelation of God’s saving power in the gospel (1:1, 16), the Son attains a new, exalted status as “Lord” (cf. v. 4b). Son of God from eternity, he becomes Son of God “in power,” “able ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dynatai")]), _vm._v("] for all time to save those who draw near to God through him” (Heb. 7:25, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RSV"
    }
  }, [_vm._v("RSV")]), _vm._v("). The transition from v. 3 to v. 4, then, is not a transition from a human messiah to a divine Son of God (adoptionism) but from the Son as Messiah to the Son as both Messiah "), _c('i', [_vm._v("and")]), _vm._v(" powerful, reigning Lord.")]), _vm._v(" "), _c('p', [_vm._v("This brings us to the third and most difficult question: What is the meaning of “according to the Spirit of holiness”? This phrase is the antithetical parallel to “according the flesh” in v. 3. We may then explore this question by assessing the meaning of the contrast. Although a bewildering variety of views are found,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.49.48",
      "id": "FN.49.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" they fall into three basic categories.")]), _vm._v(" "), _c('p', [_vm._v("The first understands “flesh/spirit” to suggest a contrast between Jesus’ human and divine natures. It is because of Jesus’ human descent that he is “seed of David”; and because of “the divine nature, or Godhead, that dwelt in Jesus Christ” he is the Son of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.49.49",
      "id": "FN.49.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" While having a respectable pedigree, this interpretation suffers from fatal objections. Not only must it take "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("horizō")]), _vm._v(" to mean “demonstrate” or “manifest,” which we have seen to be unlikely, but it also gives to “spirit” a connotation unexampled elsewhere in Paul.")]), _vm._v(" "), _c('p', [_vm._v("The second interpretation avoids the latter problem by understanding “spirit of holiness” as the obedient, consecrated spirit that Jesus manifested throughout his earthly life. The contrast in vv. 3–4 is that between the outward and physical, by virtue of which Jesus is qualified as “seed of David,” and the inward, spiritual perfection, which qualifies Jesus to be the Son of God in power."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.49.50",
      "id": "FN.49.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" While suffering from fewer difficulties than the first, this interpretation is open to the objection that it does not give to the “flesh/spirit” antithesis the meaning it most often has in Paul.")]), _vm._v(" "), _c('p', [_vm._v("The contrast of “flesh” and “Spirit” is part of Paul’s larger salvation-historical "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.50"
    }
  }), _vm._v("framework, in which two “aeons” or eras are set over against one another: the old era, dominated by sin, death, and the flesh, and the new era, characterized by righteousness, life, and the eschatological gift of the Holy Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.50.51",
      "id": "FN.50.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" The third interpretation of the contrast takes its starting point from this framework and is thereby to be preferred."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.50.52",
      "id": "FN.50.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" In Jesus’ earthly life (his life in “the realm of the flesh”), he was the Davidic seed, the Messiah. But while true and valuable, this does not tell the whole story. For Christians, Jesus is also, in “the realm of the Spirit,” the powerful, life-giving Son of God. In Christ the “new era” of redemptive history has begun, and in this new stage of God’s plan Jesus reigns as Son of God, powerfully active to bring salvation to all who believe (cf. 1:16)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.50.53",
      "id": "FN.50.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" The major objection to this interpretation is that “spirit of holiness” is never used of the Holy Spirit in the NT; indeed, the phrase is found only here in biblical Greek."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.50.54",
      "id": "FN.50.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" However, the Semitic-flavored expression may reflect traditional language."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.50.55",
      "id": "FN.50.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" As is usual in Paul, the inauguration of this new age is attributed to Christ’s resurrection."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.50.56",
      "id": "FN.50.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', [_vm._v("With “Jesus Christ our Lord,” Paul returns to the beginning of v. 3: “his Son,” the inner content of the gospel, is now finally and climactically identified. This identification builds on the christological formula of vv. 3b–4, since Jesus’ lordship is linked to his investiture in power after and because of his resurrection (Phil. 2:6–11; Acts 2:31–36). For Paul, “Lord,” expressing both Jesus’ cosmic majesty and his status as master of the believer, is the single best title to express the true significance of Jesus. Verses 3–4 leave the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.51"
    }
  }), _vm._v("reader, then, with an impressive accumulation of christological titles: Son of God, Seed of David, Messiah, and Lord. Here, Paul makes clear, is the heart of the gospel that he will be setting forth in great detail for the Romans. Since Christology does not, apparently, figure in the issues with which Paul and the Romans are concerned, Paul provides no detailed attention to Christology per se in the rest of the letter. But these verses remind us that the gospel cannot be understood without reference to the person of Christ, whose resurrection ushers in the new age of redemption.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" Paul’s description of himself, interrupted by the theologically loaded excursus about the gospel to which he has been dedicated (vv. 2–4), continues in this verse with an indication of the purpose of his apostolic call. “Jesus Christ our Lord” (v. 4b) is the mediator"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.57",
      "id": "FN.51.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿57")]), _vm._v(" of this apostleship. Paul may use the plural “we received”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.58",
      "id": "FN.51.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" because he includes other Christians as recipients of grace"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.59",
      "id": "FN.51.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿59")]), _vm._v(" or because he includes his fellow apostles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.60",
      "id": "FN.51.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" But it is better, since the description of mission in the rest of the verse is so typical of Paul’s conception of his own call, to view the plural as editorial."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.61",
      "id": "FN.51.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" What Paul has received is “grace and apostleship.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.62",
      "id": "FN.51.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" Paul may have in view two separate things,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.63",
      "id": "FN.51.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" but it is more likely that the second term explains the first: Paul has received the special gift of being an apostle."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.64",
      "id": "FN.51.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', [_vm._v("Paul then draws attention to three aspects of his apostleship in prepositional phrases."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.65",
      "id": "FN.51.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" First, Paul’s purpose in his apostolic ministry is to bring about"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.66",
      "id": "FN.51.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿66")]), _vm._v(" “obedience"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.51.67",
      "id": "FN.51.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿67")]), _vm._v(" of faith.” Scholars debate the exact relationship of these two words. Many think that Paul intends to present faith as the basis for, or motivating force of, obedience: “obedience that springs from "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.52"
    }
  }), _vm._v("faith.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.52.68",
      "id": "FN.52.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" This rendering places the emphasis on postconversion commitment: the obedience of the Christian that is to follow and be the fruit of faith. The other major option"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.52.69",
      "id": "FN.52.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿69")]), _vm._v(" is to take “faith” as a definition of “obedience”: “the obedience which is faith.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.52.70",
      "id": "FN.52.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" In support of this last interpretation can be mentioned the numerous places where obedience and faith occur in parallel statements,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.52.71",
      "id": "FN.52.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" as well as those instances where Paul speaks of “obeying” the gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.52.72",
      "id": "FN.52.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" However, this view, by evaporating “obedience” into faith, gives insufficient emphasis to this part of Paul’s ministry. But by effectively putting faith into a subordinate position, the first option illegitimately downplays the priority of evangelism in Paul’s apostleship. Paul saw his task as calling men and women to submission to the lordship of Christ (cf. vv. 4b and 7b), a submission that began with conversion but which was to continue in a deepening, lifelong commitment. This obedience to Christ as Lord is always closely related to faith, both as an initial, decisive step of faith and as a continuing “faith” relationship with Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.52.73",
      "id": "FN.52.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" In light of this, we understand the words “obedience” and “faith” to be mutually interpreting: obedience always involves faith, and faith always involves obedience. They should not be equated, compartmentalized, or made into separate stages of Christian experience. Paul called men and women to a faith that was always inseparable from obedience—for the Savior in whom we believe is nothing less than our Lord—and to an obedience that could "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.53"
    }
  }), _vm._v("never be divorced from faith—for we can obey Jesus as Lord only when we have given ourselves to him in faith. Viewed in this light, the phrase captures the full dimension of Paul’s apostolic task, a task that was not confined to initial evangelization but that included also the building up and firm establishment of churches.")]), _vm._v(" "), _c('p', [_vm._v("The second prepositional phrase specifies the arena of Paul’s apostolic labors: “among"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.53.74",
      "id": "FN.53.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿74")]), _vm._v(" all the Gentiles ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ethnesin")]), _vm._v("].” The word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ethnē")]), _vm._v(" could mean “nations” in a strictly geographical sense,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.53.75",
      "id": "FN.53.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" but this would run contrary to the semantic focus of the term in Paul when it is used of the sphere of his apostolic work."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.53.76",
      "id": "FN.53.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" Paul’s call was not so much to minister in many different nations as it was to minister to Gentiles in distinction from Jews.")]), _vm._v(" "), _c('p', [_vm._v("The third modifier of “grace and apostleship” is “for the sake of his name.” The phrase expresses the ultimate focus of Paul’s ministry: the "), _c('i', [_vm._v("name")]), _vm._v(" of Jesus his Lord."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.53.77",
      "id": "FN.53.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" As generally in Scripture, “name” connotes the person in his or her true character and significance. Ultimately, Paul ministers not for personal gain or even the benefit of his converts, but for the glory and benefit of Jesus Christ his Lord.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" This verse, inasmuch as it characterizes the readers before Paul actually addresses them in v. 7, is somewhat parenthetical. It is connected grammatically to “Gentiles” in v. 5 by the relative pronoun “whom” and is most naturally punctuated, as Godet shows, with a comma after “you”: “among whom also are you, [you] who are called of Jesus Christ” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _vm._v(", as opposed to "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v("). We may also follow Godet in identifying the purpose of this remark: to show the Roman Christians that they belong within the sphere of Paul’s apostolic commission. Paul is sent to “"), _c('i', [_vm._v("all")]), _vm._v(" the Gentiles”; and the Romans are “among” the Gentiles. They are thereby subject to his authority, as mediated in the letter that follows and in his personal presence "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.54"
    }
  }), _vm._v("when he visits them. Greater difficulty attaches to the exact meaning of the phrase “among the Gentiles.” Cranfield argues that Paul is simply identifying the Romans as living in the midst of Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.78",
      "id": "FN.54.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" On this view, the verse would imply nothing about the Roman Christians’ national origin. This interpretation has the advantage of leaving open the vexing question of the makeup of the Roman church (see the Introduction), but it must be rejected."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.79",
      "id": "FN.54.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" We take it, then, that Paul designates the Roman Christians to whom he is writing as (at least mainly) Gentile."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.80",
      "id": "FN.54.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" This interpretation also agrees with the most natural reading of v. 13 (see below).")]), _vm._v(" "), _c('p', [_vm._v("More important than the Roman Christians’ ethnic origin is their spiritual destination. They have been “called to belong to Jesus Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.81",
      "id": "FN.54.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" As Paul has been “called” to be an apostle (v. 1), so the Roman Christians have been “called” to be people who name Jesus as Christ and Lord. “Call” and its cognates are used by Paul to express an “effectual” calling. What is meant is not an “invitation” but the powerful and irresistible reaching out of God in grace to bring people into his kingdom."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.82",
      "id": "FN.54.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("7")]), _vm._v(" With v. 7 Paul finally returns to the standard letter opening begun in v. 1 and identifies those to whom the letter is being written: “to all in Rome.” Not much should be made of Paul’s failure to address himself to the “church” in Rome, since Paul does not consistently use the word in his letter openings."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.83",
      "id": "FN.54.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" But its absence may reflect the fact that the Roman Christians met in several house churches.")]), _vm._v(" "), _c('p', [_vm._v("In designating the Roman Christians as “beloved by God” and “called to be saints,” Paul implies that they are God’s chosen people; for both phrases echo OT designations of Israel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.54.84",
      "id": "FN.54.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" In so transferring language used of Israel "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.55"
    }
  }), _vm._v("in the OT to Christians, Paul initiates an important theme of the first eight chapters of the letter. In addition, these two descriptions remind the readers that who they are depends on "), _c('i', [_vm._v("God’s")]), _vm._v(" love and call. Paul uses “saints” at least 38 times to designate Christians (four other times in salutations), the focus being not on behavior but on status: Christians are those who "), _c('i', [_vm._v("have been")]), _vm._v(" sanctified “in the name of the Lord Jesus Christ and in the Spirit of our God” (1 Cor. 6:11).")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("As we noted in commenting on v. 4, the importance of Christology in this opening paragraph should not be missed. Paul shares with his Roman audience the conviction that Jesus is the heart of the gospel. He is the promised Messiah of Israel (“seed of David”), the Son of God, the Lord. Confessing the gospel in our own day requires that we subscribe to Paul’s exalted view of Jesus; it is failure to do so that spawns many heresies. But Paul’s attention, as we have also seen, is especially on the activity of this Jesus: his coming to earth as the Messiah; his exaltation through resurrection to Lord of all; his dispensing power as the Son of God. It is what Jesus has done, not just who he is, that makes the gospel the “good news” that it is. But make no mistake: what Jesus has done cannot be severed from who he is. Ours is an age not too much interested in theology; but correct theology—in this case, the person of Jesus—is vital to salvation and to Christian living.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY1.2"
    }
  }, [_vm._v("B. THANKSGIVING AND OCCASION: PAUL AND THE ROMANS (1:8–15)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("First, I am thanking my God through Jesus Christ for all of you, because your faith is being proclaimed in all the world. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("For God is my witness, whom I serve in my spirit in the gospel of his Son, that without ceasing I remember you, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("always in my prayers praying if somehow, now at last, in the will of God, I might succeed in coming to you. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("For I long to see you, so that I might share with you some spiritual gift to strengthen you. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("That is, to be mutually encouraged among you through the faith that is in one another, both yours and mine.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("Now I do not wish"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.55.1",
      "id": "FN.55.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" you to be ignorant, brothers and sisters, for I have often wanted to come to you (but I have been hindered until now) so that I might have a harvest also among you, even as I have had among the rest of the Gentiles. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("To both Greeks and barbarians, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.56"
    }
  }), _vm._v("to both the wise and the unlearned, I am a debtor. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("And so my desire is to preach the gospel also to you in Rome."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.56.2",
      "id": "FN.56.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Greek letters often had an expression of thanks or petition to the gods in the “proem,” the second main part of the letter. Paul adapts this form for his own purposes, generally including a thanksgiving and, often, a prayer for his readers at an early point in his letters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.56.3",
      "id": "FN.56.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" After thanking God for the widespread knowledge of the Romans’ faith (v. 8), Paul mentions his frequent prayer that he might visit them (vv. 9–10). The reason for this desire is given in vv. 11–13: that Paul and the Romans might strengthen and comfort one another in their faith. Finally, as both an explanation of his wish to visit Rome and a transition to the statement of the letter’s theme, Paul expresses his strong sense of obligation to preach the gospel to all sorts of people (vv. 14–15)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.56.4",
      "id": "FN.56.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', [_vm._v("What is remarkable about this section is a certain awkwardness on Paul’s part in stating his reasons for wanting to come to Rome. After mentioning his wish to strengthen the Romans’ faith (v. 11), Paul almost corrects himself, acknowledging that he anticipates a "), _c('i', [_vm._v("mutual")]), _vm._v(" benefit (v. 12). This note should not be seen as mere rhetorical flourish—as if Paul did not really believe that the Romans could contribute anything to his own Christian walk. Nevertheless, it is unparalleled in Paul’s other letters. Such hesitation to assert his authority (cf. also 15:14–17) may reflect his desire to tread warily in light of doubts among the Roman Christians about his message and ministry."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.56.5",
      "id": "FN.56.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" But it is mainly attributable to his caution about “building on another’s foundation” (15:20)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.56.6",
      "id": "FN.56.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.57"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("8")]), _vm._v(" The opening word, “first,” implies a series, but Paul never comes to a “second” or “next.” It is hard to know whether Paul simply forgets to maintain the sequence he begins or whether the phrase functions here simply to highlight what Paul considers of primary importance (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NEB"
    }
  }, [_vm._v("NEB")]), _vm._v(", “Let me begin …”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.7",
      "id": "FN.57.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" In either case, Paul draws special attention to his thanksgiving, a feature typical of Paul’s letters. He offers his thanks to “my God,” a note of personal piety that may reflect the language of the Psalms."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.8",
      "id": "FN.57.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Only in Romans, however, does Paul offer his thanks “through Jesus Christ.” Although this might mean that Christ, as High Priest, is the mediator of his thanks before God,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.9",
      "id": "FN.57.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" it is better taken as an indication that Christ is the one who has created the access to God for such thanks to be offered."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.10",
      "id": "FN.57.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', [_vm._v("Corresponding to his apostolic commission (1:5, 14–15) and the universality of the gospel (1:16"), _c('i', [_vm._v("b")]), _vm._v("), Paul includes all the Christians in Rome in his thanksgiving. Paul’s reason"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.11",
      "id": "FN.57.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" for giving thanks is that “your faith is being proclaimed in the whole world.” Nothing is implied in this about their faith being particularly strong; the very fact of their faith is sufficient reason for giving thanks to God, the author of faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.12",
      "id": "FN.57.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" A measure of hyperbole is undoubtedly present in the phrase “in all the world”; but it must be remembered that Paul is thinking of fellow Christians"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.13",
      "id": "FN.57.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" and thus of places where the gospel had already been preached. That people in the Roman capital had bowed the knee to the Lord Jesus is something that would be widely known, and perhaps highlighted, by the early missionaries."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.14",
      "id": "FN.57.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9–10")]), _vm._v(" “For”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.57.15",
      "id": "FN.57.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" introduces further remarks about Paul’s prayers for the Romans. Paul often follows his thanksgivings with assertions about the constancy "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.58"
    }
  }), _vm._v("of his prayer and concern for his readers"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.16",
      "id": "FN.58.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")]), _vm._v(" as well as petitions for their spiritual growth."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.17",
      "id": "FN.58.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Here Paul’s unceasing prayer for the Romans (v. 9b) has a more personal focus: his own desire to minister personally to them (v. 10). Since the “witness formula” that introduces the verse is used by Paul when he is particularly concerned to attest to the truth of what he is saying,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.18",
      "id": "FN.58.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" it would seem that Paul is eager that the Romans know of his heartfelt concern for them and desire to see them. Perhaps there were some in the church who felt slighted that the “Apostle to the Gentiles” had not yet deigned to visit the capital of the Gentile world.")]), _vm._v(" "), _c('p', [_vm._v("Before stating what it is that he calls God to witness, Paul digresses in a relative clause that affirms the sincerity of his service of God. The word Paul uses for “serve” focuses attention on his service in its vertical aspect as an offering of worship to God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.19",
      "id": "FN.58.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Paul qualifies his worshipful service of God as being “in my spirit” and “in the gospel of his Son.” The former phrase is particularly unclear. A few take "), _c('i', [_vm._v("pneuma")]), _vm._v(" as a reference to the Holy Spirit,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.20",
      "id": "FN.58.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" but Paul’s use of "), _c('i', [_vm._v("pneuma")]), _vm._v(" qualified by a first or second person pronoun is against it. Others suggest that the phrase may denote prayer, the inward or “spiritual” aspect of Paul’s ministry,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.21",
      "id": "FN.58.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" but this, too, is unlikely. What fits Pauline usage and makes sense in the context is an emphasis on the engagement of Paul’s “deepest” person in the ministry to which he has been called."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.22",
      "id": "FN.58.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" As this inward part of Paul’s person is the instrument of his service, the gospel of God’s Son is the sphere of that ministry. “Gospel” has an active sense here: Paul’s service consists particularly in preaching the good news about God’s Son (cf. 15:16–21 for many of these same emphases)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.58.23",
      "id": "FN.58.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.59"
    }
  }), _vm._v("The end of v. 9—“that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.24",
      "id": "FN.59.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" without ceasing I remember you”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.25",
      "id": "FN.59.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v("—resumes the main thought from the beginning of the verse—“God is my witness.” In a context like this, the word “unceasingly,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.26",
      "id": "FN.59.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" as well as “always” in v. 10a, does not refer to “unceasing petition, or the like, but to prayer offered at frequent and regular intervals.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.27",
      "id": "FN.59.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" Paul’s reticence to claim any authority over the Romans is again evident in his unusual failure to spell out any specific petitions for the Christians there. Rather, in v. 10 Paul shares with the Romans a petition he often brings before God, which, though related to the Romans, has more to do with his own plans: he regularly"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.28",
      "id": "FN.59.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿28")]), _vm._v(" prays that he might “somehow, now at last,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.29",
      "id": "FN.59.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" “succeed”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.30",
      "id": "FN.59.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" in coming to them.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11")]), _vm._v(" With “for,” Paul introduces several verses (11–15) in which he explains why he wants to come to Rome. Paul really advances only one reason, which he delineates in three roughly parallel purpose statements: “to share some spiritual gift” (v. 11); “to have a harvest” (v. 13); “to preach the gospel” (v. 15). “Spiritual gift” is a literal translation of the Greek"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.31",
      "id": "FN.59.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" and may refer to that kind of spiritual gift which Paul elsewhere denotes simply with “gift” ("), _c('i', [_vm._v("charisma;")]), _vm._v(" cf., e.g., Rom. 12:6; 1 Cor. 12, passim)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.32",
      "id": "FN.59.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" But Paul never elsewhere uses the combination “spiritual” and “gift” with this meaning, and the indefinite focus here—“some”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.33",
      "id": "FN.59.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v("—makes it difficult to think that Paul has in mind his special ministerial gift(s)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.34",
      "id": "FN.59.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Others think that Paul refers to “spiritual blessings” that he hopes will result from his ministry in Rome."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.59.35",
      "id": "FN.59.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" But we "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.60"
    }
  }), _vm._v("should think rather of an insight or ability, given Paul by the Spirit, that Paul hopes to “share” with the Romans. What gift Paul may want to share with the Romans cannot be specified until he sees what their needs may be. Whatever it is, its purpose will be to “strengthen”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.36",
      "id": "FN.60.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" their faith.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("12")]), _vm._v(" “But that is,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.37",
      "id": "FN.60.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" used only here in the NT, implies that what follows in some sense “corrects” what has just been said."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.38",
      "id": "FN.60.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" What is being corrected is probably the last phrase of v. 11, “in order to strengthen you.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.39",
      "id": "FN.60.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" It is not that Paul wants to withdraw this statement but that he wants to expand it by recognizing the "), _c('i', [_vm._v("mutual")]), _vm._v(" gain that will accrue from his visit. The verb Paul uses"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.40",
      "id": "FN.60.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿40")]), _vm._v(" could refer to mutual exhortation, but probably here refers to mutual “comfort” or “encouragement.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.41",
      "id": "FN.60.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" This mutual encouragement"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.42",
      "id": "FN.60.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿42")]), _vm._v(" will be accomplished through faith—“both yours and mine.” This rather cumbersome expression suggests both commonality—Paul and the Romans share the same faith—and distinction—the faith they share brings with it different perspectives and gifts, which, when shared, bring mutual edification. Paul’s wish that his visit would bring spiritual encouragement to him as well as to the Roman Christians is no mere literary convention or “pious fraud” (as Erasmus called it) but is sincerely meant (and he returns to it in the letter closing: see 15:32). But the fact that he mentions it here—in contrast to his habit elsewhere—signals Paul’s diplomacy. For he is dealing with a church that, while certainly within the scope of his authority (cf. 1:5–6; 15:15), is built on another person’s foundation (cf. 15:20). If Paul is to gain a sympathetic ear for “his” gospel from the Roman Christians and enlist their support for his Spanish mission (15:24), he must exercise tact in asserting his authority.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("13")]), _vm._v(" Conveying a degree of solemnity by the use of a disclosure formula, “I do not wish you to be ignorant, brothers and sisters,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.60.43",
      "id": "FN.60.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" Paul reaffirms his concern for the Roman Christians and his desire to minister with them. Not only has he longed to see them (v. 11a) and prayed that he might be able to make the trip (v. 10), but he has often made specific plans to that "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.61"
    }
  }), _vm._v("end."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.61.44",
      "id": "FN.61.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" In a parenthetical clause,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.61.45",
      "id": "FN.61.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Paul mentions that these plans have been hindered—probably by the demands on Paul of his ministry in the eastern Mediterranean (“from Jerusalem all the way around to Illyricum,” 15:19)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.61.46",
      "id": "FN.61.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" With the last clause of v. 13, Paul expresses the purpose of coming to the Romans—to “have a harvest” among the Romans. “Harvest” refers to the product of his apostolic labors (cf. Phil. 1:22), including here probably both an increase in the number of Christians through evangelization “among” the Romans and a strengthening of the faith of the Roman Christians themselves (cf. v. 11b)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.61.47",
      "id": "FN.61.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" By adding the phrase “as among the rest of the Gentiles,” Paul makes clear again that he views the Roman Christians as belonging to a “Gentile” church."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.61.48",
      "id": "FN.61.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" Paul’s forthright reaffirmation of his intention to bring spiritual benefit to the Roman Christians demonstrates that the mutuality of v. 12, while genuine, takes nothing from Paul’s view of the importance of his apostolic labors in Rome.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("14")]), _vm._v(" The lack of a connecting particle between vv. 13 and 14 lends a certain emphasis to what follows, but the logical connection between the verses is clear. Paul’s plan to have a harvest among the Roman Christians has its source not in a desire for personal aggrandizement but in his sense of missionary “obligation.” Paul is deeply conscious of his calling, of his being “set apart for the gospel” (1:1), and it is this "), _c('i', [_vm._v("divine")]), _vm._v(" obligation to use his gift (Eph. 3:8) that motivates Paul—“Woe to me if I do not preach the gospel!” (1 Cor. 9:16b). The two pairs of peoples mentioned in this verse—“Greeks and barbarians,” “wise and foolish”—have been variously understood. Each pair may include all of humanity, one being essentially synonymous with the other or each classifying humanity according to different criteria. However, while Paul frequently uses “Greeks” to designate Greeks-as-opposed-to-Jews (1:16; 2:9, 10; 3:9; 10:12 in Romans), his pairing the word here with “barbarians” suggests a different meaning. “Barbarian” is an onomatopoeic word (a word that sounds like what it means), mocking the way “uncouth” foreign languages would sound "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.62"
    }
  }), _vm._v("to Greek ears. Accordingly, it is widely used in Greek literature of all non-Greek-speaking peoples and, by derivation, often connotes the supposedly inferior culture of such peoples. Paul applies the word in its general linguistic sense to the incomprehension attendant on exercising the gift of tongues without an interpretation (1 Cor. 14:11) and uses it in a list embracing all humanity (Col. 3:11). Greeks would, of course, include Jews among the “barbarians,” but it is more than probable that Paul followed the general practice of Philo and Josephus in excluding them from such an “inferior” grouping."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.49",
      "id": "FN.62.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', [_vm._v("Probably, then, Paul intends in the first pair to designate all of "), _c('i', [_vm._v("Gentile")]), _vm._v(" humanity, divided according to linguistic/cultural criteria."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.50",
      "id": "FN.62.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" Many of the Romans would undoubtedly place themselves in the first class. But, recognizing the appeal of Christianity to the lower classes and the influx of foreigners into Rome, there would also be some who would count themselves “barbarians” (and perhaps Paul thinks also of those people in Spain to whom he hopes to preach the gospel"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.51",
      "id": "FN.62.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿51")]), _vm._v("). Whether the terms in the second pair are simply explanatory equivalents to the first pair,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.52",
      "id": "FN.62.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" embrace the same people as the first pair but from a different perspective,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.53",
      "id": "FN.62.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" or designate a wider group beyond but including the first pair"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.54",
      "id": "FN.62.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿54")]), _vm._v(" is difficult to decide. But the reference to “Gentiles” in v. 13b makes it probable that Paul has in mind only Gentiles in v. 14. Perhaps Paul’s use of “wise” in 1 Cor. 1 (19, 20, 26, 27) to designate those who prided themselves on their knowledge of God and the world, and his reference in Rom. 1:22 to people who thought they were “wise” by virtue of their own thoughts, suggests that the contrast is between those who claimed some intellectual attainment and those who did not.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("15")]), _vm._v(" Paul now relates what he has said generally in v. 14 to the specific situation of his desire to come to Rome: “and so"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.55",
      "id": "FN.62.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿55")]), _vm._v(" my desire"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.62.56",
      "id": "FN.62.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿56")]), _vm._v(" is to preach the gospel also to you in Rome.” That Paul includes the Roman Christians among those to whom he wants to preach the gospel is, at first sight, strange. Some commentators therefore think that Paul is talking here about what he had planned "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.63"
    }
  }), _vm._v("to do in the past when he had hoped to come to Rome."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.57",
      "id": "FN.63.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" But v. 15 is tied to v. 14, which uses a present tense."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.58",
      "id": "FN.63.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" Others think that he is indicating his desire to preach the gospel in Spain, on behalf of the Roman Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.59",
      "id": "FN.63.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" But this requires us to import too much from the end of the letter. Another possibility is that “you” refers generally to Romans and that Paul is speaking of his desire to evangelize in Rome."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.60",
      "id": "FN.63.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" But it is more natural to take “you” to refer to the Roman Christians; in this case, “preach the gospel” will refer to the ongoing work of teaching and discipleship that builds on initial evangelization."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.61",
      "id": "FN.63.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" As P. Bowers has pointed out, “the gospel” in Paul includes “not simply an initial preaching mission but the full sequence of activities resulting in settled churches.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.62",
      "id": "FN.63.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY1.3"
    }
  }, [_vm._v("C. THE THEME OF THE LETTER (1:16–17)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("For I am not ashamed of the gospel,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.63.1",
      "id": "FN.63.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" for it is the power of God for salvation to everyone who believes, to the Jew first and then to the Greek. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("For in it the righteousness of God is being revealed, from faith for faith, even as it is written, “The one who is righteous by faith will live.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.1.A",
      "id": "FN.1.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("These theologically dense verses are made up of four subordinate clauses, each supporting or illuminating the one before it. Paul’s pride in the gospel (v. 16a) is the reason why he is so eager to preach the gospel in Rome (v. 15). This pride, in turn, stems from the fact that the gospel contains, or mediates, God’s saving power for everyone who believes (v. 16b). Why the gospel brings salvation is explained in v. 17a: it manifests God’s righteousness, a righteousness "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.64"
    }
  }), _vm._v("based on faith. Verse 17b, finally, provides scriptural confirmation for this connection between righteousness and faith.")]), _vm._v(" "), _c('p', [_vm._v("This chain of subordinate clauses is tied both to what comes before it and to what comes after it (note the “for” in both v. 16 and v. 18); from the standpoint of syntax alone, this means that the main statement of the sequence is Paul’s assertion of desire to preach the gospel in Rome (v. 15). Some interpreters accordingly question the common opinion that vv. 16–17 state the theme of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.64.2",
      "id": "FN.64.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Isolating these verses as the theme of the letter, it is argued, betrays a preoccupation with theology at the expense of the argumentative and syntactical flow of the text.")]), _vm._v(" "), _c('p', [_vm._v("But the syntax does not tell the whole story. Grammatically subordinate clauses frequently stand out in importance by virtue of their content—especially in Greek, with its love of subordinate clauses (hypotaxis)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.64.3",
      "id": "FN.64.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" In the present case, the language of v. 16a implies a shift in focus. Up to this point, Paul has been telling the Romans about his call to ministry and how that ministry relates to the Romans. Since the gospel is the very essence of his ministry (vv. 1, 9) and is also the message that Paul wants to bring to Rome (v. 15), it has naturally figured prominently in these verses. Now, however, using v. 16a to make the transition, Paul turns his attention away from his own ministry and focuses it on the gospel as such. After this, nothing more is said of Paul’s mission plans or the Romans (except for brief interjections—7:1, 4; 8:12; 10:1; 11:13, 25; 12:1) until the “strong and the weak” section in 14:1–15:13 and the final summing up of Paul’s plans and prospects in 15:14–33. In other words, the epistolary material of 1:1–15 and 15:14ff. “frames” what appears to be a theological treatise.")]), _vm._v(" "), _c('p', [_vm._v("Therefore, while vv. 16–17 are technically part of the proem of the letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.64.4",
      "id": "FN.64.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" they serve as the transition into the body by stating Paul’s theme. Most scholars would agree with this conclusion;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.64.5",
      "id": "FN.64.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" but they would not agree "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.65"
    }
  }), _vm._v("about just where within vv. 16–17 this theme is to be found. Protestant exegetes have traditionally focused on either “the righteousness of God is being revealed” or “the one who is righteous by faith will live,” understanding them as assertions of the theological theme of “justification by faith.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.65.6",
      "id": "FN.65.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" E. Käsemann and his many followers also see in “the righteousness of God” the theme of the letter, but they give the phrase a much broader meaning than it has in traditional Protestantism (see the excursus below). A few interpreters place the concept of “salvation” in v. 16b at the center."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.65.7",
      "id": "FN.65.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Still others are impressed by the way in which the phrase “to the Jew first and then to the Greek” (v. 16b) encapsulates two of the letter’s key themes: the incorporation of Gentiles within the people of God and the continuing significance of Israel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.65.8",
      "id": "FN.65.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" It is also possible to view the individual elements of vv. 16–17 as each summing up different parts of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.65.9",
      "id": "FN.65.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" However, as we argued in the Introduction, the breadth of the letter’s contents requires a correspondingly broad theme. And standing out by virtue of its importance in vv. 1–15 as well as by its leading position in the structure of vv. 16–17 is the term “gospel” (for further exploration of the theme of the letter, see the Introduction).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("16")]), _vm._v(" As we have noted, v. 16a explains (cf. the “for”) why Paul is eager to preach the gospel in Rome (v. 15). But it also picks up the various descriptions of Paul’s commitment to the ministry of the gospel in vv. 1–15 (cf. vv. 1, 5, 9, 14). The negative form of Paul’s assertion, “I am not ashamed of the gospel,” may be a literary convention (litotes), justifying our rendering it as a straightforward positive statement (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TEV"
    }
  }, [_vm._v("TEV")]), _vm._v(": “I have complete confidence”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.65.10",
      "id": "FN.65.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" However, “the foolishness of the word of the cross” (1 Cor. 1:18) would make some degree of embarrassment about the gospel natural—particularly "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.66"
    }
  }), _vm._v("in the capital of the Gentile world."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.66.11",
      "id": "FN.66.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" It may also be that accusations to the effect that Paul’s gospel was antinomian or anti-Jewish lie behind this denial (cf. 3:8; 9:1–5)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.66.12",
      "id": "FN.66.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_vm._v("The second clause in v. 16 explains (“for”) why Paul is not ashamed of the gospel. For this gospel, whose content is Jesus Christ, “appointed Son-of-God-in-power” (v. 4), mediates “the power of God leading to salvation.” The term “power,” as one might expect, is used widely in Greek philosophy and religion,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.66.13",
      "id": "FN.66.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" but its NT background is undoubtedly to be sought in the OT teaching about a personal God who uniquely possesses power and who manifests that power in delivering (Exod. 9:16; Ps. 77:14–15) and judging (Jer. 16:21) his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.66.14",
      "id": "FN.66.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("“Salvation” and its cognates are widely used in both the Greek world and the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" to depict deliverance from a broad range of evils."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.66.15",
      "id": "FN.66.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" The NT as a whole uses “salvation” and its cognates with much of the same broad range of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.67"
    }
  }), _vm._v("meaning as the OT, whereas Paul uses the words only of spiritual deliverance. Moreover, his focus is eschatological: “salvation” is usually the deliverance from eschatological judgment that is finalized only at the last day."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.16",
      "id": "FN.67.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Characteristic, however, of Paul’s (and the NT’s) outlook is the conviction that these eschatological blessings are, to some extent, enjoyed by anyone the moment he or she trusts Jesus Christ as Savior and Lord. It is because of this “already” focus in Paul’s salvation-historical perspective that he can speak of Christians as “saved” in this life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.17",
      "id": "FN.67.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" “Salvation” often has a negative meaning—deliverance "), _c('i', [_vm._v("from")]), _vm._v(" something—but positive nuances are present at times also, so that the term can denote generally God’s provision for a person’s spiritual need. Particularly, in light of Rom. 3:23 and the use of “save” in 8:24 (cf. vv. 18–23), “salvation” here must include the restoration of the sinner to a share of the “glory of God.”")]), _vm._v(" "), _c('p', [_vm._v("The last part of v. 16 introduces themes that recur as key motifs throughout Romans. First, God’s salvific power is available “to everyone who believes.” “Believe”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.18",
      "id": "FN.67.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" and “faith”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.19",
      "id": "FN.67.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" are key words in Romans; they are particularly prominent in 3:21–4:25."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.20",
      "id": "FN.67.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿20")]), _vm._v(" The lack of an explicit object after “believe” is also characteristic of Romans. This does not mean that Paul depreciates the centrality of Christ as the object of faith, but that the language of faith has become so tied to what God has done in Christ that further specification is not needed. To “believe” is to put full trust in the God who “justifies the ungodly” (4:5) by means of the cross and resurrection of Christ. Though intellectual assent cannot be excluded from faith, the Pauline emphasis is on surrender to God as an act of the will (cf., e.g., 4:18; 10:9). Pauline (and NT) faith is not (primarily) agreement with a set of doctrines but trust in a person. Though not explicit here, another focus of Romans is the insistence that faith is in no sense a “work.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.21",
      "id": "FN.67.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" Therefore, although we must never go to the extreme of making the person a totally passive instrument through whom “believing” occurs—for Paul makes clear that people are responsible to believe—we must also insist that believing is not something we "), _c('i', [_vm._v("do")]), _vm._v(" (in the sense of “works”) but is always a response, an accepting of the gift God holds out to us in his grace (see especially 4:1–8). As Calvin puts it, faith is “a kind of vessel” with which we “come empty and with the mouth of our soul open to seek God’s grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.67.22",
      "id": "FN.67.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.68"
    }
  }), _vm._v("“Believing,” then, while a genuinely human activity, possesses no “merit” or worth for which God is somehow bound to reward us; for salvation is, from first to last, "), _c('i', [_vm._v("God’s")]), _vm._v(" work."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.68.23",
      "id": "FN.68.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', [_vm._v("But this same phrase introduces another recurring motif of Romans: the availability of God’s “power for salvation” for “"), _c('i', [_vm._v("all")]), _vm._v(" who believe.” This phrase occurs four other times in Romans (3:22; 4:11; 10:4, 11), in each case with particular reference to the breaking down of barriers between Jew and Gentile. Paul’s ministry to Gentiles derives from his understanding of the gospel itself as eschatological revelation that fulfills the OT promises about the universal reign of Yahweh."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.68.24",
      "id": "FN.68.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" This required the elimination of those barriers between Jew and Gentile laboriously erected by the oral (and written—cf. Eph. 2:15) law. Nowhere does this principle receive more emphasis than in Romans, as Paul seeks to validate his gospel before a skeptical audience.")]), _vm._v(" "), _c('p', [_vm._v("Yet it is typical also of Romans that Paul does not rest content with a reminder of the universalism of the gospel but immediately introduces a note of particularism: “to the Jew first and then to the Greek.” It is only a slight exaggeration to say that the key to understanding Romans lies in successfully untangling the two connected strands of universalism—“to "), _c('i', [_vm._v("all")]), _vm._v(" who believe”—and particularism—“to the Jew "), _c('i', [_vm._v("first.")]), _vm._v("” The attempted resolution of this apparent paradox must await our comments on Rom. 9–11, but we must say something here about this particular phrase. In opposition to “Jew,” “Greek” must indicate, broadly, any non-Jew."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.68.25",
      "id": "FN.68.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" What is the nature of the Jew’s priority (“first”) over the Gentile? Some scholars, indeed, have sought to remove any sense of priority from the phrase,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.68.26",
      "id": "FN.68.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" but without success. Paul clearly accords some kind of priority to the Jew. Some suggest that no more is involved than "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.69"
    }
  }), _vm._v("the historical circumstance of the apostolic preaching, which, according to Acts, began with the Jews and moved to the Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.69.27",
      "id": "FN.69.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" But Paul must intend more than simple historical fact in light of the theological context here. If we ask what precedence Paul accords Israel elsewhere in Romans, we find that his emphasis is on the special applicability of the promise of God to that people whom he chose (3:2; 9–11). However much the church may seem to be dominated by Gentiles, Paul insists that the promises of God realized in the gospel are “first of all” for the Jew. To Israel the promises were first given, and to the Jews they still particularly apply. Without in any way subtracting from the equal access that all people now have to the gospel, then, Paul insists that the gospel, “promised beforehand … in the holy Scriptures” (1:2), has a special relevance to the Jew.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("17")]), _vm._v(" Verse 17 shows why (see again the “for”) the gospel is God’s saving power to everyone who believes (v. 16b): “in it [the gospel], the righteousness of God is being revealed.” The verb translated “is being revealed”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.69.28",
      "id": "FN.69.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" is an important biblical term. Meaning originally “uncover,” this verb and its cognate noun, “revelation,” are typically used by Paul to refer to the eschatological disclosure of various aspects and elements of God’s redemptive plan. Sometimes this disclosure is an “uncovering” to the intellect of various truths relating to God’s purposes."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.69.29",
      "id": "FN.69.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" But in other places, picking up the language and concepts of Jewish apocalyptic, Paul uses the word to denote the “uncovering” of God’s redemptive plan as it unfolds on the plane of human history."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.69.30",
      "id": "FN.69.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" If the former, “cognitive,” meaning is adopted here, then Paul is speaking about the way in which the gospel makes known to us, or informs us, of “the righteousness of God.” If we accept the more “historical” meaning of “reveal,” however, Paul’s point will be that the gospel in some way actually makes manifest, or brings into existence, “the righteousness of God.” This latter, “historical” meaning is to be preferred in 1:17. This is the most frequent meaning of the verb in Paul, and it matches both the most likely meaning of “reveal” in 1:18 (“the wrath of God is being revealed [e.g., is being inflicted] from heaven”) and the related statement in 3:21: “the righteousness of God has been made manifest.” One key difference between 3:21 and 1:17, however, is the tense of the verb. The perfect tense in 3:21 focuses "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.70"
    }
  }), _vm._v("attention on the cross as the time of God’s decisive intervention to establish his righteousness. In 1:17, on the other hand, the present tense suggests that Paul is thinking of an ongoing process, or series of actions, connected with the preaching of the gospel. Wherever the gospel is being proclaimed, the “righteousness of God” in its eschatological fullness is being disclosed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.70.31",
      "id": "FN.70.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', [_vm._v("But what is this “righteousness of God” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē theou)?")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.70.32",
      "id": "FN.70.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" Occurring only eight times in Romans (1:17; 3:5, 21, 22, 25, 26; 10:3 [twice]), the phrase bears an importance out of proportion to its frequency, and for three reasons. First, with the exception of 2 Cor. 5:21, Paul uses the phrase “righteousness of God” only in Romans, so that the phrase might give us a clue to the distinctive message of the letter. Second, the phrase is prominent in precisely those texts that are often considered to state the central theme of the letter: 1:16–17 and 3:21–26. And, third, the meaning of “the righteousness of God” has played a significant role in the interpretation of Paul and of the gospel generally—from Augustine to Luther to E. Käsemann. There are three main options for the meaning of the phrase.")]), _vm._v(" "), _c('p', [_vm._v("(1) The expression might refer to "), _c('i', [_vm._v("an attribute of God.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.70.33",
      "id": "FN.70.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" Under this general heading are to be included two distinct possibilities. According to the first, “righteousness” is God’s justice, or rectitude ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("iustitia distributiva,")]), _vm._v(" “distributive justice”). This interpretation was widespread in the early church, where it owed its popularity somewhat to the meaning of the Greek term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" and its Latin equivalent."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.70.34",
      "id": "FN.70.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Contemporary scholars, while often giving this meaning to the phrase in 3:5 and 3:25–26, rarely do so in 1:17; for the context requires a positive meaning for the phrase. The second possibility takes its point of departure from the alleged OT meaning of “God’s righteousness”: God’s faithfulness, especially to his covenant with Israel. This interpretation also has an ancient pedigree,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.70.35",
      "id": "FN.70.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" but it is particularly popular in recent studies. While again the occurrences in 3:5 and 3:25–26 are most often interpreted in this way, a few scholars think that 1:17 could be understood in the same way: for example, the gospel reveals “the faithfulness of God [to his promises of salvation].”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.70.36",
      "id": "FN.70.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.71"
    }
  }), _vm._v("(2) “Righteousness of God” in 1:17 might refer to a "), _c('i', [_vm._v("status given by God.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.71.37",
      "id": "FN.71.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Luther’s personal spiritual struggle ended with his realization that God’s righteousness meant not “the righteousness by which he is righteous in himself but the righteousness by which we are made righteous by God.” Not the strict “distributive justice” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(iustitia distributiva)")]), _vm._v(" by which God impartially rules and governs the world, but a righteousness that is not one’s own "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(iustitia aliena),")]), _vm._v(" a new standing imparted to the sinner who believes—this was what made Paul’s message “good news” to Luther. In contrast to both Augustine and most medieval theologians, Luther viewed this righteousness as purely forensic—a matter of judicial standing, or status, and not of internal renewal or moral transformation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.71.38",
      "id": "FN.71.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" This understanding of “righteousness of God” stands at the heart of Luther’s theology and has been a hallmark of Protestant interpretation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.71.39",
      "id": "FN.71.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" On this view, Paul is asserting that the gospel reveals “the righteous status that is from God.”")]), _vm._v(" "), _c('p', [_vm._v("(3) “Righteousness of God” might denote "), _c('i', [_vm._v("an activity of God.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.71.40",
      "id": "FN.71.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" The English word “righteousness” naturally designates an abstract quality, but the use of the equivalent Greek term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē)")]), _vm._v(" in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" has a much broader range of meaning—including the dynamic sense of “establishing right.” Especially significant are the many places in the Psalms and Isaiah where God’s “righteousness” refers to his salvific intervention on behalf of his people (see section "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY2.1.2"
    }
  }, [_vm._v("A.2")]), _vm._v(" in the Excursus). If Paul is using this “biblical” meaning of the word, then his point here would be that the gospel manifests “the saving action of God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.71.41",
      "id": "FN.71.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.72"
    }
  }), _vm._v("These options are neither exhaustive nor mutually exclusive, and two or more of them are often combined in the interpretation of 1:17. In fact, every possible combination of the three basic interpretations is found in the literature: God’s action in making people right and the status of people so made right;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.72.42",
      "id": "FN.72.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" God’s attribute of “being in the right” and his making sinners right before him;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.72.43",
      "id": "FN.72.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" both his being in the right and his gift of righteousness;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.72.44",
      "id": "FN.72.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" and, combining all three, God’s being in the right, his action of making people right before him, "), _c('i', [_vm._v("and")]), _vm._v(" the resultant status of those made right."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.72.45",
      "id": "FN.72.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" A particularly attractive and popular combination is that found in the interpretation of Käsemann. He argues that “God’s righteousness” is “God’s salvation-creating power,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.72.46",
      "id": "FN.72.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" a concept that incorporates the ideas of status given by God and activity exercised by God—with the emphasis on the latter—and the addition of nuances such as God’s reclaiming of creation for his lordship (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY2.2.4"
    }
  }, [_vm._v("B.4")]), _vm._v(" in the Excursus for details).")]), _vm._v(" "), _c('p', [_vm._v("Three factors influence the decision we reach on this issue: the OT background; the use of “righteousness” words generally in Romans"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.72.47",
      "id": "FN.72.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿47")]), _vm._v("; and the immediate context. The difficulty is that they do not all point in the same direction. Whereas the OT provides warrant for each of the main alternatives, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.73"
    }
  }), _vm._v("there is no doubt that the third—God’s saving activity—receives strongest support. When “righteousness” is attributed to God, it has this meaning more than any other; and it is God’s “righteousness” in this sense—a saving, vindicating intervention of God—that the prophets say will characterize the eschatological deliverance of God’s people (cf. Mic. 7:9; Isa. 46:13; 50:5–8; and see section "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY2.1.2"
    }
  }, [_vm._v("A.2")]), _vm._v(" in the Excursus for detailed substantiation). Granted the OT roots of Paul’s conception of “righteousness” (cf. 3:21), we would expect this notion of saving activity to be included when he announces the revelation of “the righteousness of God.”")]), _vm._v(" "), _c('p', [_vm._v("Paul uses “righteousness” words in Romans in several different ways (see, again, the survey in section "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY2.1.2"
    }
  }, [_vm._v("A.2")]), _vm._v(" in the Excursus). But one thing emerges as characteristic: the connection between righteousness and faith. It is no exaggeration to call this a leitmotif of the letter. The references to “righteousness of God” evidence a definite pattern at this point: those in 3:5 and 3:25–26 are not tied directly to faith, and—as our exposition will show—they refer to God’s attribute of “faithfulness to his person and promises.” On the other hand, Paul links “righteousness of God” closely with the response of faith in 1:17, in 3:21–22, and (cf. 10:6) in 10:3. This ties the idea of “righteousness” in the phrase “righteousness of God” to Paul’s use of the word generally in Romans, where it is typically linked to faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.73.48",
      "id": "FN.73.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" And “righteousness” is used most often in Romans to denote the “gift of righteousness” (5:17)—a righteous status that God bestows on the one who believes (chap. 4, passim; note also the parallel between “righteousness of God” and “righteousness based on faith” in 10:3–6, and the reference to “righteousness "), _c('i', [_vm._v("from")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.73.49",
      "id": "FN.73.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿49")]), _vm._v(" God” in Phil. 3:9). Paul’s use of “righteousness” language in Romans, then, strongly suggests that “righteousness of God” in 1:17; 3:21, 22; and 10:3 includes reference to the status of righteousness “given” to the believer by God.")]), _vm._v(" "), _c('p', [_vm._v("If these first two factors point in two different directions, the consideration of the context only confuses matters further by giving some support to "), _c('i', [_vm._v("each")]), _vm._v(" possibility. On the one hand, Paul’s use of “reveal”—particularly if it has the dynamic meaning we have suggested—makes better sense if “righteousness of God” denotes a divine activity than if it refers to a divine gift. Furthermore, the “revelation of God’s wrath” in v. 18 appears to parallel v. 17, and “wrath” in v. 18 is clearly a divine activity. On the other hand, the “gift” character of “righteousness” receives support from the prepositional addition “on the basis of faith” and from the quotation of Hab. 2:4 at the end of the verse, where the cognate word “righteous” designates human status. And this "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.74"
    }
  }), _vm._v("stress on faith as the means by which the righteousness of God is received binds this verse closely to those many others in Romans in which righteousness is clearly a status given to the one who believes (see above). The contexts in which the related occurrences of “righteousness of God” are found evidence the same ambiguity: God’s righteousness is “manifested” (3:21), and people are to “submit” to it (10:3)—suggesting activity; and yet it is also “based on” faith—suggesting gift or status.")]), _vm._v(" "), _c('p', [_vm._v("Most interpreters make a decision at this point, choosing either activity or status and offering more or less convincing explanations of the data that appear to conflict with the view they have chosen. But must we make this choice? Do we have to choose between theology ("), _c('i', [_vm._v("God")]), _vm._v(" acting) and anthropology (the "), _c('i', [_vm._v("human being")]), _vm._v(" who receives)—as some have stated the dilemma? Could we not take “righteousness of God” here to include "), _c('i', [_vm._v("both")]), _vm._v(" God’s activity of “making right”—saving, vindicating—"), _c('i', [_vm._v("and")]), _vm._v(" the status of those who are so made right, in a relational sense that bridges the divine and the human? The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" usage, out of which Paul’s use of the phrase grows, makes it likely that “the righteousness of God” is first of all the saving intervention of God in history, predicted by the prophets, manifested on the cross, and constantly made effective in the preaching of the gospel. But God’s righteousness never operates in a vacuum, and the OT occurrences often allude also to the situation or status of those who experience God’s saving intervention (see section "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY2.1.2"
    }
  }, [_vm._v("A.2")]), _vm._v(" in the Excursus). Partly because he needs to distance his interpretation of God’s righteousness from the prevalent Jewish view, in which works and the law play so prominent a role (cf. 3:21; 10:3), Paul insists that God’s righteousness can be experienced only through faith: “For Paul the righteousness of God is essentially a righteousness that comes by faith.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.74.50",
      "id": "FN.74.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" His theology also leads him to develop the idea of righteousness as an enduring, judicial status far beyond anything found in the OT. This emphasis shifts the focus of the phrase a bit with respect to its OT usage, although, as we have said, the dual aspect of God’s righteousness as both divine activity and human status does have its antecedents in the OT.")]), _vm._v(" "), _c('p', [_vm._v("For Paul, as in the OT, “righteousness of God” is a relational concept. Bringing together the aspects of activity and status, we can define it as "), _c('i', [_vm._v("the act by which God brings people into right relationship with himself.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.74.51",
      "id": "FN.74.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" With Luther, we stress that what is meant is a status "), _c('i', [_vm._v("before")]), _vm._v(" God and not internal moral transformation—God’s activity of “making right” is a purely forensic activity, an acquitting, and not an “infusing” of righteousness or a “making "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.75"
    }
  }), _vm._v("right” in a moral sense (see the Excursus). To be sure, the person who experiences God’s righteousness does, necessarily, give evidence of that in the moral realm, as Paul makes clear in Rom. 6. But, while “sanctification” and “justification” are inseparable, they are distinct; and Paul is badly misread if they are confused or combined. To use the imagery of the law court, from which righteousness language is derived, we can picture God’s righteousness as the act or decision by which the judge declares innocent a defendant: an activity of the judge, but an activity that is a declaration of status—an act that results in, and indeed includes within it, a gift. In this sense, the noun “righteousness” in this phrase can be understood to be the substantival equivalent of the verb “justify.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.75.52",
      "id": "FN.75.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', [_vm._v("This more comprehensive interpretation of “righteousness of God” in 1:17 has several advantages. First, it is built on the most frequent meaning of the phrase in the OT, so that Paul’s readers in Rome would have an immediate starting point for their understanding of Paul’s language. Second, it does justice to the nuances of both divine activity and human receptivity that occur in the text. Third, it enables us to relate the phrase to Paul’s broader use of “righteousness,” where he frequently highlights the end result of the process of justification in the believer’s status of righteousness.")]), _vm._v(" "), _c('p', [_vm._v("Verse 16 has already indicated that God’s salvation comes only to those (though to all) who believe. The same point is underscored in the present verse with the phrase “from faith to faith” and the quotation from Hab. 2:4. Just what the prepositional phrase modifies is not clear. Coming immediately after, the phrase could modify the verb “is being revealed.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.75.53",
      "id": "FN.75.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" But the Habakkuk quotation that follows—where “on the basis of faith” probably modifies “the one who is righteous”—and Paul’s persistent linking of righteousness words with faith throughout Rom. 1–4 point toward a connection with “righteousness of God.” Both concerns can be met if we construe the double prepositional phrase as an almost independent phrase that resumes Paul’s discussion of righteousness."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.75.54",
      "id": "FN.75.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.76"
    }
  }), _vm._v("Thus, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(": “For in the gospel a righteousness from God is revealed, a righteousness that is by faith …” (v. 17).")]), _vm._v(" "), _c('p', [_vm._v("Paul’s addition of “for faith”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.55",
      "id": "FN.76.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" to “on the basis of faith” has been the subject of endless discussion. Many of the Fathers explained the double reference as meaning that God’s righteousness was “from the faith in the law to the faith in the gospel.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.56",
      "id": "FN.76.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" Augustine gave several explanations, among them that Paul wished to include both the faith of the preacher and the faith of the hearer."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.57",
      "id": "FN.76.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" Calvin and others see a reference to the growth of faith in the individual, enabling the Christian to appreciate and enjoy more and more the righteousness of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.58",
      "id": "FN.76.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" Barth argues that the first “faith” refers to God’s faithfulness, and the second the faith of the individual person."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.59",
      "id": "FN.76.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" Some commentators compare Rom. 3:22, concluding that Paul wants to stress both that righteousness is received by faith and is for all who believe,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.60",
      "id": "FN.76.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" or (on another reading of Rom. 3:22) that Paul attributes our righteousness both to Christ’s faithfulness (“on the basis of faith”) and to our own believing."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.61",
      "id": "FN.76.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Others find a thrust against Judaism: righteousness is both received by faith and has faith, not works, as its goal."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.62",
      "id": "FN.76.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" Probably, however, in light of the only clear NT parallel to the construction,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.63",
      "id": "FN.76.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" the combination is rhetorical and is intended to emphasize that faith and “nothing but faith” can put us into right relationship with God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.64",
      "id": "FN.76.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', [_vm._v("The quotation from Hab. 2:4 confirms (cf. “even as”) the truth that righteousness is to be attained only on the basis of faith. There are textual differences between Paul’s wording and the original text of Habakkuk,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.76.65",
      "id": "FN.76.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" but "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.77"
    }
  }), _vm._v("the main problem is that Paul appears to give the words a different meaning. Hab. 2:4 is God’s response to the prophet’s complaint about God’s inaction and injustice. It instructs the person who is already righteous how to face the difficulties of life and, especially, the apparent contradictions between God’s promises and what takes place in history. In Paul, the quotation functions to characterize how it is that one can attain right standing with God and so live eternally. Another key difference is found if we take “on the basis of faith” "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.78"
    }
  }), _vm._v("with “the righteous one” rather than with “will live.” Indeed, a large number of scholars deny that we should do this. They argue that Paul, like Habakkuk, connects “by faith” with “live” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v(": “The just shall live by faith”; also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v("; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.78.66",
      "id": "FN.78.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" But a better case can be made for connecting “the one who is righteous” with “on the basis of faith” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RSV"
    }
  }, [_vm._v("RSV")]), _vm._v(": “He who through faith is righteous will live”; also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TEV"
    }
  }, [_vm._v("TEV")]), _vm._v("; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NEB"
    }
  }, [_vm._v("NEB")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.78.67",
      "id": "FN.78.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" Of greatest significance is the way Paul in Rom. 1–8 consistently links faith with righteousness (cf. the summary in 5:1) and shows how “life” is the product of that righteousness (cf. 5:18 and 8:10). These connections favor the translation “the one who is righteous by faith will live.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.78.68",
      "id": "FN.78.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', [_vm._v("In both the meaning of the terms and their connections, then, Paul’s quotation differs from the meaning of the original. But the differences should not be magnified. The point in Habakkuk is that faith"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.78.69",
      "id": "FN.78.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿69")]), _vm._v(" is the key to one’s relationship to God. The meaning of faith in the NT is deepened through its intimate relationship to Christ as the object of faith,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.78.70",
      "id": "FN.78.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" but the OT concept, in verses like Gen. 15:6 and Hab. 2:4 especially, shares with NT “faith” the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.79"
    }
  }), _vm._v("quality of absolute reliance on God and his Word rather than on human abilities, activities, or assurances."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.79.71",
      "id": "FN.79.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" Rom. 4 will bring out more fully how Christians are to exhibit this “faith of Abraham.”")]), _vm._v(" "), _c('p', {
    staticClass: "sh",
    attrs: {
      "id": "BODY2"
    }
  }, [_vm._v("EXCURSUS: “RIGHTEOUSNESS” LANGUAGE IN PAUL")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("No set of words is more important for a correct understanding of Paul’s message to the Romans than those that share the root "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-,")]), _vm._v(" especially "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" (“justify”), "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" (“righteousness”), and, to a lesser extent, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaios")]), _vm._v(" (“righteous”). Although individual occurrences must be treated in context in the commentary proper, a discussion of the general background and meaning of the word group as a whole is necessary as a foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY2.1"
    }
  }, [_vm._v("A. THE OT AND JEWISH BACKGROUND")]), _vm._v(" "), _c('p', {
    staticClass: "chaft",
    attrs: {
      "id": "BODY2.1.1"
    }
  }, [_vm._v("1. Words from the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dik-")]), _vm._v(" Root Generally")]), _vm._v(" "), _c('p', {
    staticClass: "dhaft",
    attrs: {
      "id": "BODY2.1.1.1"
    }
  }, [_vm._v("a. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dikaioō")]), _vm._v(" (“Justify”)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dikaioō")]), _vm._v(" and its cognates were used in secular Greek,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.79.1",
      "id": "FN.79.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" but the widespread and theologically significant use of the terminology in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", along with Paul’s frequent appeal to the OT in discussing the words (e.g., Rom. 3:22; 4:1–25), shows that the OT/Jewish background is decisive. In the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" normally translates two Hebrew words, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣedeq")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣ"), _c('sup', [_vm._v("e")]), _vm._v("dāqâ,")]), _vm._v(" which are generally interchangeable."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.79.2",
      "id": "FN.79.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Likewise, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" usually translates "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣādaq,")]), _vm._v(" whereas "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaios")]), _vm._v(" renders "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣaddîq.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.79.3",
      "id": "FN.79.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" By the same token, words from the Hebrew root "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sdq")]), _vm._v(" are translated by Greek words from the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-")]), _vm._v(" root in the large majority of cases. This considerable linguistic overlap suggests that the meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-")]), _vm._v(" words for Greek-speaking Jews like Paul was decisively influenced by the meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣdq")]), _vm._v(" words. The long-standing debate over whether the basic meaning of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.80"
    }
  }), _vm._v("the root "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣdq")]), _vm._v(" is “conformity to a norm”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.80.4",
      "id": "FN.80.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" or “mutual fulfillment of claims arising from a particular relationship”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.80.5",
      "id": "FN.80.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" may be bypassed if we agree with Ziesler that the “norm” in question is the demands that stem from God’s relationship with his people in the covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.80.6",
      "id": "FN.80.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dikaioō")]), _vm._v(" occurs 44 times in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", and in all but six occurrences where there is a Hebrew original it translates a form of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣādaq.")]), _vm._v(" In the qal this verb means “to be righteous,” in the piel “to be demonstrated as righteous,” and in the hiphil “to declare righteous.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.80.7",
      "id": "FN.80.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" The nine times "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" translates the hiphil of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣādaq")]), _vm._v(" are particularly significant for Paul’s usage. The verb is used almost always with a judicial or forensic flavor. Sometimes the “judge” who “pronounces righteous,” or acquits, is human (Deut. 25:1; Isa. 5:23), and at other times divine (Exod. 23:7; 1 Kings 8:32; 2 Chron. 6:23; Ps. 82:3; Isa. 50:8). Even when the term is not used with explicit reference to the law court, the forensic connotations remain (cf. Gen. 38:26; 44:16; Jer. 3:11; Ezek. 16:51–52). The high degree of translation correspondence between "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣedeq/ṣ"), _c('sup', [_vm._v("e")]), _vm._v("dāqâ")]), _vm._v(" means that these can be considered together.")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY2.1.1.2"
    }
  }, [_vm._v("b. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dikaiosynē")]), _vm._v(" (“Righteousness”)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dikaiosynē,")]), _vm._v(" which occurs more than 300 times in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", is applied both to God and to human beings. Leaving the former for consideration below in conjunction with "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē theou")]), _vm._v(" (“righteousness of God”), we note that the forensic flavor is much less obvious in the case of the human being’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(". The word becomes a general way of describing what is “well pleasing” to God and takes on definitely ethical connotations."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.80.8",
      "id": "FN.80.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Nevertheless, the notion of right relationship is not completely lost. As most scholars emphasize, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" language has its context in the covenant and designates most often that form of life which is the Israelite’s appropriate response to the covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.80.9",
      "id": "FN.80.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.81"
    }
  }), _vm._v("In intertestamental Judaism, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" usually has this more “ethical” flavor, a usage reflected in Matthew’s Gospel especially."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.81.10",
      "id": "FN.81.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Dikaios,")]), _vm._v(" the most common "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-")]), _vm._v(" word in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" (almost 400 occurrences), is used of the person who is characterized by "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē.")]), _vm._v(" It is the standard way by which the godly, or pious, person is denoted (cf., e.g., Prov. 10–13).")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY2.1.2"
    }
  }, [_vm._v("2. “The Righteousness of God” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē theou)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The complexity of the issues surrounding this phrase makes it necessary to consider it on its own. The actual phrase "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē theou")]), _vm._v(" never occurs in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v("; "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē kyriou")]), _vm._v(" (“righteousness of the Lord”) occurs twice (1 Sam. 12:7; Mic. 6:5). But 48 times, mainly in the Psalms and Isaiah, we find "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" modified by a personal pronoun whose antecedent is “God” or “the Lord.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.81.11",
      "id": "FN.81.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" In all but six of these occurrences, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" translates "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣedeq")]), _vm._v(" (12 times) or "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣ"), _c('sup', [_vm._v("e")]), _vm._v("dāqâ")]), _vm._v(" (32 times)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.81.12",
      "id": "FN.81.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" In addition to these specific references to “God’s righteousness” are more than 50 places where "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" is ascribed to God or where God is said to do or speak "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē,")]), _vm._v(" or the like. The high degree of translation equivalence between the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣdq")]), _vm._v(" roots means that a study of the one is virtually a study of the other also. Since our concern is to explain the Greek phrase in Romans, we will take the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" occurrences as our basic material.")]), _vm._v(" "), _c('p', [_vm._v("God’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" in secular Greek usually designates an attribute of God, although most of the biblical occurrences possess a more active or relational meaning. For instance, in Ps. 51:14 David prays, “Deliver me from those who seek my blood, O God, the God of my salvation; my tongue will rejoice in your righteousness ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("tēn dikaiosynēn sou")]), _vm._v("]” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" 50:16). Similarly, God promises through the prophet Isaiah: “I bring near my righteousness ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("tēn dikaiosynēn mou")]), _vm._v("], and my salvation will not delay” (Isa. 46:13). As the parallel with “salvation” shows, “God’s righteousness” in these verses is his saving intervention on behalf of his people. Probably 16 other occurrences of the phrase have this same general sense."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.81.13",
      "id": "FN.81.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', [_vm._v("What is sometimes overlooked at this point is that this saving activity can also be considered from the standpoint of the human being who receives "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.82"
    }
  }), _vm._v("“God’s righteousness.” In these contexts, God’s righteousness clearly includes the aspect of gift or status enjoyed by the recipient. The clearest instance is Ps. 35:27–28: “Let those who desire "), _c('i', [_vm._v("my")]), _vm._v(" righteousness shout and be glad.… And my tongue will declare "), _c('i', [_vm._v("your")]), _vm._v(" righteousness.” Cf. also 51:14, where the psalmist speaks of the “God of "), _c('i', [_vm._v("my")]), _vm._v(" salvation” and of “"), _c('i', [_vm._v("your")]), _vm._v(" [God’s] righteousness,” and the references to the psalmist’s righteousness in 4:1 and 37:6, and to Israel’s righteousness in Isa. 62:2. The important occurrences of the phrase in Isa. 46:13 and 50:5–8 may also include reference to the continuing enjoyment of God’s righteousness, since this righteousness meets the need brought by Israel’s being “far from righteousness” (Isa. 46:12) and is said to be eternal (50:8).")]), _vm._v(" "), _c('p', [_vm._v("Recognizing that these texts constitute the largest single category among those that we are considering, and that both Micah and Isaiah predict the arrival of this righteousness at the time of God’s eschatological deliverance (Mic. 7:9; Isa. 46:13; 54:5–8), we are justified in thinking that this meaning of the phrase must have considerable influence on Paul’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē theou")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("A second meaning is closely related to this first, and, indeed, is not always easy to distinguish from it. In a number of texts, God’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" is not his saving activity but the basis, or the motivation, for that saving activity. Psalm 31:1 is characteristic: “in your righteousness ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("en tē dikaiosynē sou")]), _vm._v("] deliver me and lead me out.” At least 14 other occurrences probably fit here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.82.14",
      "id": "FN.82.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" In these passages, God’s “righteousness” is his faithfulness, his commitment to fulfill the promises he has made to his people. Since it is generally thought that OT righteousness language has to do with meeting commitments imposed by the covenant relationship, this dimension of God’s righteousness is often said to be his covenant faithfulness."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.82.15",
      "id": "FN.82.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" In a number of verses where righteousness is attributed to God (e.g., Ps. 88:12; 145:7), it is difficult to know whether God’s commitment to help his people or the help itself is meant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.82.16",
      "id": "FN.82.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" In some cases, at least, we may surmise that elements of both are present.")]), _vm._v(" "), _c('p', [_vm._v("Thus far, it would appear that God’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" is exclusively beneficial in its operation; and, indeed, scholars such as von Rad conclude just that."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.82.17",
      "id": "FN.82.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.83"
    }
  }), _vm._v("But a number of texts show how shortsighted such a conclusion would be. First, several of the passages that highlight the salvific benefits of God’s righteousness also refer to the judgment that it brings on the wicked. In Ps. 50, for instance, God summons the heavens and the earth as witnesses as he sits in judgment over his people (v. 4). Verse 6 then reads: “And the heavens declare his righteousness, for God himself is judge.” There follows in the rest of the psalm an indictment of Israel, with a call for repentance. Here God’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" is virtually his justice, in a neutral sense—his commitment to deliver those who have met the standards of the covenant and reject those who have not (similar to this are Ps. 7:17; 9:4, 8; 97:2; Isa. 59:17). It is God’s righteousness in this sense that is given to the king, so that he will be able to “vindicate the afflicted, save the children of the needy, and crush the oppressor” (Ps. 72:1). God’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" bears this meaning also in the expression that occurs five times in Ps. 119—"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ta krimata tou dikaiosynēs sou,")]), _vm._v(" “the judgments of your righteousness” (vv. 7, 62, 106, 160, 164)—and in those places where God is said to judge “in righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.83.18",
      "id": "FN.83.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" God’s covenant commitment, these passages suggest, is a commitment to do what is “right” with reference to that covenant. When Israel’s enemies are in view, or when Israel breaks the terms of the covenant, God’s righteousness naturally takes on a negative, judgmental aspect (cf. Isa. 5:16; 10:22).")]), _vm._v(" "), _c('p', [_vm._v("This more neutral meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" colors even those texts where God’s righteousness is salvific. In many of those passages, the saving righteousness of God is pictured as God’s vindicating his people—his granting to them a deliverance to which they can lay claim, either because of their own “righteousness” (Ps. 7:8; 9:8; 18:20, 24; 35:24; 37:6) or because of God’s promises. The righteousness of God, then, while having the same positive connotation as salvation in these instances, stresses that the deliverance in view has the character of vindication, an establishing of what is “right.” The phrase is used positively so often because God’s promises to his people in the covenant mean that the pious Israelite can expect God’s “doing what is right” to bring deliverance from his or her enemies.")]), _vm._v(" "), _c('p', [_vm._v("That such a conception creates tensions even with the OT is clear. In Ps. 143:1, for instance, the psalmist pleads for deliverance on the basis of God’s righteousness, while acknowledging that no one can claim God’s help on the basis of one’s own righteousness (v. 2). Similarly, in Dan. 9, God is acknowledged to be righteous in the disasters he has brought on his unfaithful people (vv. 7, 14), while at the same time the prophet can appeal to God’s righteousness as the motivation for turning his wrath away from his people (v. 16). Here God’s establishing of what is right does not take place within "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.84"
    }
  }), _vm._v("the terms of the covenant as such but with reference to something more basic. Piper argues that it is God’s determination to act for the glory of his name that is this more basic element (see Dan. 9:17–19)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.84.19",
      "id": "FN.84.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Piper is certainly on the right track but perhaps narrows the conception more than is justified. More broadly, in view of the clearly forensic focus of righteousness language in the OT,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.84.20",
      "id": "FN.84.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" the “more basic element” is God’s always acting in accordance with the norm of his own person and promises."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.84.21",
      "id": "FN.84.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', [_vm._v("A frequent objection to any such view of God’s righteousness as an “attribute” is that it “intrudes conceptions quite foreign to the Hebrew mind, and for which there is no basis in the naïvely realistic thinking of the Israelite.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.84.22",
      "id": "FN.84.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" But such objections, while understandable as a reaction against the tendency of some scholars (particularly in the past) to read European medieval legal norms into the OT, surely have gone too far. What the “Hebrew mind” could or could not conceive can be known only from the pages of the OT. Nor are we seeking to revive the notion that God’s righteousness in the OT is a conformity to an ideal ethical norm, as if God were being forced to conform to something outside himself. Nor are we arguing that righteousness is attributed to God as a result of ontological speculation. It is, as we may put it, an experienced attribute, stating the conviction of the Israelites that God can always be depended upon to act in accordance with what is right, as defined by God’s person and promises."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.84.23",
      "id": "FN.84.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', [_vm._v("To summarize, then, we find that God’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" in the OT can denote God’s character as that of a God who will always do what is right, God’s activity of establishing right, and even, as a product of this activity, the state of those who have been, or hope to be, put right."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.84.24",
      "id": "FN.84.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" While the expectation that God would act to put his people in the right is usually founded on the covenant commitment, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.85"
    }
  }), _vm._v("some texts, such as Ps. 143, Dan. 9, and probably Isa. 46 and 50, anticipate an irruption of God’s righteousness that cannot be tied to the covenant as such.")]), _vm._v(" "), _c('p', [_vm._v("Further evidence pertaining to Paul’s use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē theou")]), _vm._v(" is found in intertestamental Jewish texts. Particularly significant, because singled out by the “Käsemann school” as the clearest evidence for the pre-Christian technical, apocalyptic use of the phrase, is chap. 11 in the Dead Sea Scroll “The Manual of Discipline” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NUM1QS"
    }
  }, [_vm._v("1QS")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.25",
      "id": "FN.85.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" “God’s/his righteousness” occurs five times in the chapter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.26",
      "id": "FN.85.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" Moreover, in what some claim to be a striking anticipation of Paul’s theology, this righteousness of God is in four of these verses said to be the basis for human justification."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.27",
      "id": "FN.85.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" This last point, however, is questionable. The translation “justification” for the Hebrew "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišpāṭ")]), _vm._v(" is problematic, and the stress on the law throughout the scrolls creates a wholly different atmosphere from that of Paul’s teaching."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.28",
      "id": "FN.85.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" Nor does the use of the phrase “God’s righteousness” signal an advance on the OT teaching. It probably means “mercy” or “saving faithfulness” in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NUM1QS"
    }
  }, [_vm._v("1QS")]), _vm._v(" 11 and is used with other meanings elsewhere in the scrolls, showing that the phrase has not taken on a fixed meaning."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.29",
      "id": "FN.85.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" The situation is the same in other possibly pre-Christian texts where the phrase occurs ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NUM1QM"
    }
  }, [_vm._v("1QM")]), _vm._v(" 4:6; "), _c('i', [_vm._v("T. Dan")]), _vm._v(" 6:10"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.30",
      "id": "FN.85.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿30")]), _vm._v("; "), _c('i', [_vm._v("1 Enoch")]), _vm._v(" 71:14; 99:10; 101:3). In "), _c('i', [_vm._v("1 Enoch,")]), _vm._v(" for instance, “God’s righteousness” refers to his faithfulness (71:14) and is parallel to the simple “righteousness” (cf. 71:16), his moral strictures (99:10), and his merciful works (101:3). In all this, there is little that substantiates a key supposition of the “Käsemann” approach: that “righteousness of God” is a fixed, apocalyptic "), _c('i', [_vm._v("terminus technicus.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.85.31",
      "id": "FN.85.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" Nor does "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.86"
    }
  }), _vm._v("the NT give any basis for interpreting "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē theou")]), _vm._v(" as a "), _c('i', [_vm._v("terminus technicus.")]), _vm._v(" It occurs only twice outside Paul’s letters, and then with a meaning different from Paul’s (Matt. 6:33; Jas. 1:20).")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY2.2"
    }
  }, [_vm._v("B. “JUSTIFY,” “RIGHTEOUSNESS,” AND “RIGHTEOUS” IN PAUL")]), _vm._v(" "), _c('p', {
    staticClass: "chaft",
    attrs: {
      "id": "BODY2.2.1"
    }
  }, [_vm._v("1. “Justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(Dikaioō)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In Paul, it is always God who justifies and the human being who is justified (except in the probably traditional 1 Tim. 3:16). Particularly characteristic of Paul’s usage is his insistence that justification takes place by faith"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.86.32",
      "id": "FN.86.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" and not by “works” (Rom. 4:2), or “works of the law” (Rom. 3:20, 28; Gal. 2:16). That Paul preserves the thoroughly forensic flavor of the word is clear from his addition of the phrase “before God” to the verb (Rom. 2:13; 3:20) and from the contrast between "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("katakrinō")]), _vm._v(" (“condemn”) in Rom. 8:33. It is now generally agreed, then, that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" in Paul means not “make righteous” but “declare righteous,” or “acquit,” on the analogy of the verdict pronounced by a judge."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.86.33",
      "id": "FN.86.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" To justify signifies, according to forensic usage, to acquit a guilty one and declare him or her righteous."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.86.34",
      "id": "FN.86.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', [_vm._v("Roman Catholic scholars who agree that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" means “declare righteous” nevertheless often insist that this declaration, being God’s powerful word, must be effectual, and include thereby moral transformation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.86.35",
      "id": "FN.86.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" It is indeed the case that God’s declaration is effectual, but there is nothing about the act that suggests this effect must extend beyond its forensic sphere. So also the criticism that a strictly forensic meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" makes the action "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.87"
    }
  }), _vm._v("a “legal fiction” is wide of the mark: legal it is, but it is no more fiction than is the release from imprisonment experienced by the pardoned criminal.")]), _vm._v(" "), _c('p', [_vm._v("Despite his debt to the OT and Judaism in his use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō,")]), _vm._v(" Paul differs from the normal OT/Jewish usage in three important respects. First, the verdict pronounced by a judge, according to the OT, was required to be in accordance with the facts (cf. especially Exod. 23:7; 1 Kings 8:32). It is a keystone of Paul’s doctrine, however, that “God justifies the ungodly” (Rom. 4:5). His realization of the seriousness of sin and concern to maintain the absolute grace of God manifested in Christ led him to see that God’s justifying verdict could never be forthcoming if the human being were regarded in himself. It is not that God acts “unjustly,” against the facts; but his justifying takes into account a larger set of facts, including the atoning character of Jesus’ death and the righteousness he thereby acquired."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.87.36",
      "id": "FN.87.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_vm._v("Second, the Jewish view was that the verdict of “justification” would be pronounced only at the judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.87.37",
      "id": "FN.87.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Indeed, Sanders disputes this, noting the frequency with which Jewish writings speak of people as “righteous” in this life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.87.38",
      "id": "FN.87.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" But what is meant by “righteous” in these writings is something different from what Paul means. Moreover, Sanders’s own argument, which stresses the importance of obedience to the law as a condition for remaining in the covenant, shows implicitly that the final verdict according to Jewish theology cannot be pronounced until the judgment. Paul, however, transfers the final verdict into the present."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.87.39",
      "id": "FN.87.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" (For a discussion of the difficulties caused in this regard by Rom. 2:13, see the discussion there.) The moment a sinner places his or her faith in Christ, he or she is justified—the final verdict is read back into his or her present experience in a characteristic example of NT “inaugurated eschatology.”")]), _vm._v(" "), _c('p', [_vm._v("Third, the justification offered the sinner in the gospel goes beyond “acquittal,” by putting the sinner into a relationship with God in which "), _c('i', [_vm._v("all")]), _vm._v(" sins—future as well as past—are accounted for.")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY2.2.2"
    }
  }, [_vm._v("2. “Righteousness” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(Dikaiosynē)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Ziesler contends that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaioō")]), _vm._v(" in Paul is always forensic, but that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" usually has both ethical and forensic dimensions. But Ziesler has been justly criticized for too often finding two meanings in "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" that are not clearly "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.88"
    }
  }), _vm._v("supported from the context."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.88.40",
      "id": "FN.88.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" Some of Paul’s uses of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" are difficult to categorize (particularly those in Rom. 6), but most fall clearly into one category or the other."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.88.41",
      "id": "FN.88.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY2.2.3"
    }
  }, [_vm._v("3. “Righteous” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(Dikaios)")]), _vm._v(" and Other Terms")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In comparison with the frequency of the word in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", Paul’s 17 uses of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaios")]), _vm._v(" seem paltry. As in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", Paul can use the word to mean “what is right” (Eph. 6:1; Phil. 1:7; 4:8; Col. 4:1), but he rarely uses it as is customary in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", to denote the person who is “right” with God. When Paul does so use it, forensic connotations are again to the fore (cf. Rom. 1:17; 2:13; 3:10; 5:19; Gal. 3:11). One is “right” not because of behavior that is pleasing to God but because of faith in Jesus Christ. God is called “just” several times (2 Thess. 1:5, 6; 2 Tim. 4:8), as is the law (Rom. 7:12). Paul uses several other words with a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-")]), _vm._v(" root in Romans, and these are also generally forensic in nature: "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiōma")]), _vm._v(" (“just decree”; cf. 1:32; 2:26; 5:16, 18; 8:4); "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiōsis")]), _vm._v(" (“justifying”; cf. 4:25; 5:18); "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiokrisia")]), _vm._v(" (“righteous judgment”; cf. 2:5); "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("endikos")]), _vm._v(" (“just”; cf. 3:8). The antonyms "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("adikia")]), _vm._v(" (“unrighteousness”) and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("adikos")]), _vm._v(" (“unrighteous”) are generally used of humans, with moral force (although cf. 3:5; 9:14).")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY2.2.4"
    }
  }, [_vm._v("4. A Note on E. Käsemann’s Interpretation of “The Righteousness of God”")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("We allude to E. Käsemann’s influential interpretation of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē theou")]), _vm._v(" in the exposition above; here we want to describe it in more detail. Käsemann argues that “righteousness of God” is a technical phrase in Jewish apocalyptic, where it denotes God’s saving power and activity as it is exercised in commitment to the covenant. Paul picks up the phrase from this apocalyptic context but modifies its meaning by expanding the sphere of God’s saving activity from the covenant people to all of creation. God in Jesus acts to reclaim his sovereignty over the world. Particularly important to Käsemann, who is reacting to what he perceives to be an excessive concern with anthropology in Bultmann, is that God’s righteousness always remains God’s. Even when Paul portrays this righteousness as a gift, it is a gift that is never separate from the giver. We are taken up "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.89"
    }
  }), _vm._v("into righteousness as a sphere of power and are called to its service (Rom. 6). Käsemann’s interpretation, therefore, includes the ideas of status given by God and activity exercised by God, with the emphasis on the latter and the addition of nuances such as power and the reclaiming of creation that shift the focus of these ideas. It is a powerful and coherent interpretation and is the lifeblood of his impassioned interpretation of Romans and of Paul.")]), _vm._v(" "), _c('p', [_vm._v("Since there are some similarities between our own interpretation and that of Käsemann, the differences should be noted: (1) our explanation is not dependent on the background of a fixed apocalyptic term but on the broad OT usage; (2) faithfulness or activity directed to the creation as a whole is not included—in fact, Paul’s righteousness language appears to be concentrated solely on the relationship of God to people;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.89.42",
      "id": "FN.89.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" (3) the idea of “power” is not clearly present; (4) it is not so clear that the occurrences of “righteousness” in texts such as Rom. 6 have to be merged with this conception—they may reflect a relatively independent conception, based on the OT, Jewish, and NT (see Matthew) use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dikaiosynē")]), _vm._v(" to designate what is ethically right; (5) the phrase “righteousness of God” cannot be made the center, or starting point, of Paul’s theology.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY2.3"
    }
  }, [_vm._v("C. JUSTIFICATION BY FAITH IN ROMANS AND IN PAUL’S THEOLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("For Luther, and many Protestant interpreters who have followed him, “justification by faith” is the center of Romans, of Paul’s theology, and indeed of the Bible. This view of the matter has, however, been subjected to severe criticism, most notably by W. Wrede and A. Schweitzer at the beginning of this century, and by K. Stendahl, E. P. Sanders, and others more recently. Wrede considered “justification by faith” to be a doctrine with only polemical import, devised to counter the claims of Judaism,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.89.43",
      "id": "FN.89.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" whereas Schweitzer, noting the relative absence of justification language in Rom. 5–8, labeled justification by faith a “subsidiary crater” in Paul’s thinking, much less important than his “Christ-mysticism.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.89.44",
      "id": "FN.89.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" Stendahl is representative of many contemporary exegetes who insist that questions of “people”—Jew and Gentile; who belongs to the people of God—rather than questions of an individual’s being right with God dominate Romans and Paul’s thinking."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.89.45",
      "id": "FN.89.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Sanders, wanting to integrate Paul’s justification language into his central concerns more than Schweitzer did, nevertheless agrees "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.90"
    }
  }), _vm._v("with Schweitzer that “participationist,” not forensic, justification categories are central to Paul."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.90.46",
      "id": "FN.90.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" These views have, naturally, sparked considerable response from those who want to defend the traditional position that justification by faith is central to Paul’s thought, especially in Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.90.47",
      "id": "FN.90.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', [_vm._v("A decision on this question depends greatly on what is meant by “center.” If by this one means the organizing focus of Paul’s thinking, then Christology should probably be put at the center. If one means, however, the basic theological framework within which Paul expresses his theology, then salvation history should be made central. But there is something to be said for the centrality of justification by faith in another sense. Though it is true, as opponents of the traditional view tirelessly point out, that “justification by faith” occurs mainly in passages where Paul is countering Jewish tendencies and that the doctrine has, for that reason, a distinctly polemical thrust, it is also true that the doctrine guards Paul’s theology at an absolutely vital point. Justification by faith is the anthropological reflex of Paul’s basic conviction that what God has done in Christ for sinful human beings is entirely a matter of grace (see especially 3:24; 4:1–8, 16). If, then, justification by faith is not the center of Romans or of Paul’s thought in the logical sense, in another sense it expresses a central, driving force in Paul’s thought (see, further, the Introduction, under “Theme”). In this respect, the Reformers were not far wrong in giving to justification by faith the attention they did.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BODY3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rBODY3"
    }
  }, [_vm._v("II. THE HEART OF THE GOSPEL: JUSTIFICATION BY FAITH (1:18–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In his statement of the theme of the letter (vv. 16–17), Paul moves quickly from the gospel to the salvation mediated by the gospel to the “righteousness of God” revealed in the gospel. It is now this righteousness, God acting to bring people into a right relationship with himself, that occupies Paul’s attention in the first major section of the body of Romans, 1:18–4:25."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.90.1",
      "id": "FN.90.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" “Righteousness” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("("), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.91"
    }
  }), _vm._v("dikaiosynē)")]), _vm._v(" and its cognates “justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaioō)")]), _vm._v(" and “righteous” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaios)")]), _vm._v(" occur 24 times in these verses, being particularly prominent (6 occurrences) in the passage that is the heart of this section, 3:21–26. But even more prominent is another word group: “faith” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(pistis)")]), _vm._v(" and its (in Greek) cognate verb, “believe” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(pisteuō),")]), _vm._v(" occur 27 times, and usually in close conjunction with “righteousness” or “justify.” Word frequency does not, of course, tell the whole story, but in this case the statistics are indeed indicative of the theme of these chapters: God’s righteousness as the righteousness of faith.")]), _vm._v(" "), _c('p', [_vm._v("OT prophets and psalmists predicted that God’s righteousness, his intervention in history to establish Israel’s “right,” would be revealed in the last days. And Jews in Paul’s day continued to look for this act of God on their behalf. Paul announces the coming of this righteousness in the gospel of Christ. But he also emphasizes two aspects of this righteousness that were not widely accepted in his day. First, being an entirely gracious act on God’s part, God’s righteousness could be experienced only by faith. Second, "), _c('i', [_vm._v("anyone—")]), _vm._v("Jew or Gentile—could, and "), _c('i', [_vm._v("needed")]), _vm._v(" to, experience it on exactly the same terms. These points, which for Paul are intertwined (for, as he argues, in 3:28–30, if God is to be God of all people, his righteousness must be offered to all on the same basis), are what he wants to get across to the Romans in this part of his letter. The argument takes the form of a “dialogue with Judaism.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.91.2",
      "id": "FN.91.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Not only does Paul address “the Jew” directly (2:17–29; cf. 2:1–5), but the issues of the law and circumcision dominate much of the discussion. The language of “righteousness” itself is OT-Jewish. Even Paul’s indictment of humanity (1:18–3:20) focuses on the Jew (2:1–3:20). As we argue in the Introduction, the fact that Paul dialogues with Judaism here does not mean that the dialogue is itself directed to Jews, or even to Jewish Christians. Paul wants the Christian community in Rome to listen in to this dialogue so that they may understand his gospel. The points he argues in this section are those points for which Paul had to contend throughout his missionary career. It is therefore no wonder that “the Apostle to the Gentiles,” when setting forth his gospel to Christians with whom he had had no contact, would emphasize just these points.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY3.1"
    }
  }, [_vm._v("A. THE UNIVERSAL REIGN OF SIN (1:18–3:20)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Our claim that righteousness, or justification, by faith is the focus of 1:18–4:25 might seem odd in light of the statistics that emerge from 1:18–3:20: “righteousness” words occur only six times and references to faith or believing "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.92"
    }
  }), _vm._v("only twice—and then without reference to human faith. It is, in fact, only beginning with 3:21 that “righteousness by faith” becomes central; in 1:18–3:20, sin, wrath, and judgment occupy center stage. Paul implicitly acknowledges that 1:18–3:20 is an interruption in his exposition of the righteousness of God by reprising 1:17 in 3:21: “But now the righteousness of God has been manifested.…” Why this interruption? What is the purpose of this step-by-step indictment of humanity? Some think that the “revelation of God’s wrath” is a product of the preaching of the gospel, so that 1:18–3:20 is as much “gospel” as is 3:21–4:25 (see below, on v. 18). But, although Paul clearly considers warning about judgment to come to be related to his preaching of the gospel (2:16),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.92.3",
      "id": "FN.92.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" his generally positive use of “gospel” language forbids us from considering God’s wrath and judgment to be "), _c('i', [_vm._v("part of")]), _vm._v(" the gospel.")]), _vm._v(" "), _c('p', [_vm._v("We must consider 1:18–3:20 as a preparation for, rather than as part of, Paul’s exposition of the gospel of God’s righteousness. But it is a necessary preparation if what Paul wants to emphasize about this righteousness is to be accepted by the Romans. For only if sin is seen to be the dominating, ruling force that Paul presents it to be in this section (cf. 3:9) will it become clear why God’s righteousness can be experienced only by humbly receiving it as a gift—in a word, by faith. “Only those who are prepared to acknowledge that they are unworthy can put faith in the Giver of grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.92.4",
      "id": "FN.92.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" And only if Jews as much as Gentiles are understood to be subject to this imprisoning effect of sin will it become clear that all people need to experience this righteousness of God.")]), _vm._v(" "), _c('p', [_vm._v("This dual focus of 1:18–3:20 is succinctly stated in 3:9: “all people, both Jews and Gentiles, are under the power of sin.” So absolute is sin’s power over people that only God’s power, available in the gospel, can rescue them. And so universal is sin’s power that it has gained sway even over God’s chosen people, the Jews. As we argue below (see the introduction to 1:18–32), Paul’s indictment of humanity in 1:18–3:8 proceeds as if it were moving inward through a series of concentric circles: from the whole of humanity (1:18), to humanity apart from special revelation—mainly, then, Gentiles (1:19–32), to the “righteous” person—but mainly the Jew (2:1–16), to the Jew explicitly (2:17–3:8)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.92.5",
      "id": "FN.92.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.93"
    }
  }), _vm._v("This section, then, may practically be divided into two main parts: 1:18–32, which targets Gentiles mainly; and 2:1–3:8, which is preoccupied with the Jews. It is obvious that Paul has carefully formulated an argument in each of the first two sections that will meet the needs of the different people addressed. To counter Paul’s indictment of them, the Gentiles might well claim to have had no chance to make things right with God; thus Paul insists that all people have some knowledge of God and of his will for them. Moreover, Jews might well claim exemption from judgment by virtue of their covenant privileges; so Paul shows that these privileges, though real, do not help them in the judgment because they have broken that covenant through disobedience."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.93.6",
      "id": "FN.93.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_vm._v("While, then, 1:18–3:20 brings charges against all humanity, the structure and relative weight of Paul’s indictment reveal that the Jew is his main “target.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.93.7",
      "id": "FN.93.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" After all, few people would have to be convinced that Gentiles were in need of God’s righteousness. Except for “God-fearers,” few Gentiles would have ever had any pretense of a relationship to the God of the Bible. But the case was different with the Jews. Were they not God’s people? Had not God already "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.94"
    }
  }), _vm._v("promised them his righteousness through the terms of the Old Covenant? Can it be said that Jews stand in the same hopeless condition as do godless Gentiles? So might the questions run, questions that Paul had to confront often in the course of his missionary work. And so Paul must argue that Jews are as much subject to sin’s power as are Gentiles and that the old system of the law, in itself, is quite insufficient to provide for release from sin’s power (cf. 3:20). As Beker puts it, “What is argued is the equal status of Jew and Gentile under sin; what is presupposed is the self-evident character of the Gentile under sin.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.94.8",
      "id": "FN.94.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_vm._v("But why this preoccupation with unbelieving Jews in a letter that is written to Christians, and mainly Gentile Christians at that? Although Paul is undoubtedly rehearsing themes from his missionary preaching,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.94.9",
      "id": "FN.94.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" it is not unconverted Jews but the Roman Christians who are the real audience of what he says in this letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.94.10",
      "id": "FN.94.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" To a considerable extent, of course, Paul’s focus is due to his desire to set before the Romans, in preparation for his visit and request for support, the gospel he preaches—and the need for God’s righteousness on the part of both Jews and Gentiles is an important component of that gospel. Add to this Paul’s concern about his upcoming visit to Jerusalem (cf. 15:30–33), and it is no wonder he says as much about the situation of Jews as he does.")]), _vm._v(" "), _c('p', [_vm._v("But there were factors within the Roman church that made the discussion quite relevant to the Christians there. We must assume that Paul already had his eye on the tensions between the Gentile-Christian majority and the Jewish-Christian minority that he attacks in 14:1–15:13. In this regard, we should not overlook the fact that Paul balances his attack on the Jewish presumption of superiority with affirmations of the Jews’ salvation-historical prerogatives (3:1–2), the legitimate demand of the law (3:31), and the OT roots of the gospel (3:21, 31; 4:1–25). Paul is also aware that perverted information about his teaching on these matters was circulating in the community at Rome (cf. 3:8). If the Christians in Rome were to be united in support of Paul’s ministry, they would have to be convinced of the logical coherence of Paul’s gospel on this central, early Christian issue. Throughout Romans, then, Paul preaches the equality of Jew and Gentile in both sin and righteousness, at the same time as he insists that Israel retains inalienable salvation-historical privileges. In the present section, Paul’s overriding concern is to show that, like Gentiles, Jews are locked up under sin and can receive the righteousness available in the gospel only by faith in Jesus."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.94.11",
      "id": "FN.94.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY3.1.1"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.95"
    }
  }), _vm._v("1. All Persons Are Accountable to God for Sin (1:18–32)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("For the wrath of God is being revealed from heaven against all ungodliness and unrighteousness of human beings, who suppress the truth in unrighteousness, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("for what can be known about God is manifest among them—for God has made it manifest to them. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("For since the creation of the world his invisible attributes—his eternal power and his deity—have been seen, being understood through the things he has made, so that they are without excuse.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("Because, having known God, they did not glorify him as God or give thanks but became foolish in their reasonings, and their hearts, lacking understanding, were darkened. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("Supposing themselves to be wise, they became fools, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("and exchanged the glory of the immortal God for the likeness of the image of mortal man, and birds, and animals, and reptiles. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("Therefore, God handed them over in the passions of their hearts to uncleanness, to the dishonoring of their bodies among themselves. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("They exchanged the truth of God for a lie, worshiping and serving the creature rather than the Creator, who is blessed forever. Amen. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("Because of this, God handed them over to dishonorable passions, for women exchanged the natural use of their bodies for that use which is against nature. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("Likewise, men, leaving natural use of the woman, burned in their desire for one another, men with men doing that which is shameful and receiving in themselves the just penalty that was necessary for their error. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("And even as they did not see fit to retain God in knowledge, God handed them over to a worthless mind, so that they do what is not right, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("being filled with all manner of unrighteousness, evil, greed, wickedness;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.95.12",
      "id": "FN.95.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" full of envy, murder, strife, deceit, malice; gossips, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("maligners, haters of God, proud, arrogant, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.96"
    }
  }), _vm._v("overbearing, devisers of evil, disobedient to parents, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("without understanding, without faithfulness, without affection,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.96.13",
      "id": "FN.96.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" without mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("32")]), _vm._v("These people, knowing the righteous decree of God, that those who do such things are worthy of death, not only do these things themselves, but commend those who do them.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This passage divides into three main parts. In the first (vv. 18–20), Paul announces the “revelation” of God’s wrath and explains why that wrath is justified: people commit ungodly and unrighteous acts, “suppressing” the truth (v. 18). Paul can accuse people of "), _c('i', [_vm._v("suppressing")]), _vm._v(" the truth because God has given people a knowledge of himself (vv. 19–20a); therefore, when they sin, they are “without excuse” (v. 20b). The second section, vv. 21–31, describes in more detail the ways in which people have suppressed the truth of God and draws out some of their consequences. Paul uses three generally parallel “retribution” sequences to make his point:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.96.14",
      "id": "FN.96.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("Vv. 21–24: People "), _c('i', [_vm._v("“exchange”")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.96.15",
      "id": "FN.96.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" the truth of God for idols—God "), _c('i', [_vm._v("“hands them over”")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.96.16",
      "id": "FN.96.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Vv. 25–26a: People "), _c('i', [_vm._v("“exchange”")]), _vm._v(" the truth of God for a lie—God "), _c('i', [_vm._v("“hands them over”")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Vv. 26b–31: People "), _c('i', [_vm._v("“exchange”")]), _vm._v(" natural sexual practices for the unnatural—God "), _c('i', [_vm._v("“hands them over”")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Verse 32 makes up the third section. Though related to vv. 28–31, it stands somewhat independently as a concluding indictment and transition to 2:1ff.")]), _vm._v(" "), _c('p', [_vm._v("Whose experience does Paul describe in these verses? Traditionally, it has been assumed almost without argument that Paul is depicting the situation of Gentiles. However, the tendency of recent scholarship is to reject, or at least qualify, this conclusion. It is pointed out that the objects of God’s wrath are called “people,” not “Gentiles”; indeed, the word “Gentiles” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(ethnē)")]), _vm._v(" never occurs in the passage. Moreover, their turn to idolatry is described in language reminiscent of OT descriptions of the Fall, suggesting that all humanity is in view, and of the golden calf incident, suggesting that Jews must be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.97"
    }
  }), _vm._v("included in Paul’s purview. Finally, the transition from 1:32 to 2:1 would make better sense if the people indicted in 2:1–4 were already included in 1:18–32; but those depicted in 2:1–4 cannot be confined to Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.97.17",
      "id": "FN.97.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', [_vm._v("Despite the force of some of these points, two considerations, in particular, favor a reference mainly to Gentiles. First, the passage is reminiscent of Jewish apologetic arguments in which Gentile idolatry was derided and the moral sins of the Gentile world were traced to that idolatry."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.97.18",
      "id": "FN.97.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" Second, the knowledge of God rejected by those depicted in 1:18–32 comes solely through “natural revelation”—the evidences of God in creation and, perhaps, the conscience. The situation with Jews is, of course, wholly different, for Paul holds them responsible for the special revelation they have been given in the law (cf. 2:12–13, 17–29).")]), _vm._v(" "), _c('p', [_vm._v("This last point, especially, makes it improbable that Paul is thinking specifically of Jews in 1:19–32. It may not be, however, that Jews are entirely excluded either. The argument of 1:18–2:29 is best viewed as a series of concentric circles, proceeding from the general to the particular. Verse 18, the outermost circle, begins with a universal indictment: "), _c('i', [_vm._v("all")]), _vm._v(" people stand condemned under the wrath of God. It is the “heading” of 1:18–3:20 as a whole."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.97.19",
      "id": "FN.97.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Romans 1:19–32, likewise, includes in its scope all people, but it looks at them from the standpoint of their responsibility to God apart from special revelation. This qualification, even though not removing Jews in principle from the focus, means that Paul is not speaking directly about them. He is still speaking "), _c('i', [_vm._v("to")]), _vm._v(" them, however, since he uses this section to set up the indictment of the Jews that follows. The focus in 2:1–11 becomes more specific as Paul indicts the “moral person,” but implicitly, as we will see, the Jew. Romans 2:17–29 finally targets Jews explicitly, accusing them on the basis of the clearest revelation of God available: the law of Moses.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.98"
    }
  }), _vm._v("Can we isolate more specifically the experience(s) depicted in 1:19–32? The sequence of tenses is relevant to this question. In vv. 18–19a and 32, Paul uses the present tense, suggesting that the revealing of God’s wrath, the suppression of the knowledge of God available in creation, and the recognition that certain sins deserve God’s judgment are constant aspects of human experience. Throughout vv. 19b–31, however (except in v. 20, which asserts a universal truth), Paul uses a tense (the aorist) normally rendered in English with a past tense: people "), _c('i', [_vm._v("turned")]), _vm._v(" from God; he "), _c('i', [_vm._v("handed")]), _vm._v(" them over. This may suggest that vv. 19b-31 have in view a specific event: either the original fall of humanity into sin (Gen. 3), or a kind of mythical “Ur-fall” of the Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.98.20",
      "id": "FN.98.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" This view has certain undeniable strengths but cannot finally be accepted. The tense Paul uses in vv. 19–31 need not indicate a single past experience;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.98.21",
      "id": "FN.98.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" and, more important, this view fails to explain the heart of this passage: the characterization of all those upon whom the wrath of God falls as those who possessed the truth of God but turned from it.")]), _vm._v(" "), _c('p', [_vm._v("Paul says more than that all people experienced the consequences of an original turning away from God, or even that all people shared such an original turning away. He insists that those who turned were also those who knew better, and who are consequently deserving of God’s wrath. This, coupled with the obviously universal thrust of vv. 18 and 32, makes clear that this foolish and culpable rejection of the knowledge of God is repeated in every generation, by every individual. "), _c('i', [_vm._v("Every person")]), _vm._v(" is “without excuse” because every person—whether a first-century pagan or a twentieth-century materialist—has been given a knowledge of God and has spurned that knowledge in favor of idolatry, in all its varied manifestations. All therefore stand under the awful reality of the wrath of God, and all are in desperate need of the justifying power of the gospel of Christ. We will never come to grips with the importance of the gospel, or be motivated as we should be to proclaim it, until this sad truth has been fully integrated into our worldview."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.98.22",
      "id": "FN.98.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.99"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("18")]), _vm._v(" In light of the stark contrast between the “revelation of the righteousness of God” (v. 17) and “the revelation of the wrath of God,” we would expect v. 18 to begin with a strong adversative—“but” or “however.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.23",
      "id": "FN.99.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" Instead, v. 18 is linked to the preceding verses with the word “for,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.24",
      "id": "FN.99.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" which normally introduces a reason or explanation for a previous statement. It may be that the word here has lost its normal causal meaning and that we should simply ignore it (note that it is untranslated in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TEV"
    }
  }, [_vm._v("TEV")]), _vm._v(", and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NJB"
    }
  }, [_vm._v("NJB")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.25",
      "id": "FN.99.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" Some scholars, however, think that the close biblical connection between righteousness and wrath allows Paul to claim the reality of God’s righteousness "), _c('i', [_vm._v("because")]), _vm._v(" the wrath of God is present."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.26",
      "id": "FN.99.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" But Paul is not using the word “righteousness” in v. 17 in a way that would make this connection likely. It is best, then, to retain the usual force of “for,” but to view it as introducing the answer to a question implicit in what Paul has just said: Why has God manifested his righteousness and why can it be appropriated only through faith?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.27",
      "id": "FN.99.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" Viewed in this light, this conjunction introduces the entire argument of 1:18–3:20—which, indeed, is encapsulated in v. 18.")]), _vm._v(" "), _c('p', [_vm._v("Since the time of certain Greek philosophers, the idea that God would inflict wrath on people has been rejected as incompatible with an enlightened understanding of the deity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.28",
      "id": "FN.99.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The second-century Christian heretic Marcion omitted “of God” in v. 18,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.29",
      "id": "FN.99.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" and many others since would like to omit the verse altogether. In our day, C. H. Dodd is representative of those who have rejected or drastically modified the traditional conception of God’s wrath. Criticizing the conception of a God who personally exercises wrath as “archaic,” he argues that Paul’s “wrath of God” is no more than “an inevitable process of cause and effect in a moral universe.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.99.30",
      "id": "FN.99.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" But such a conception of God has more in common with the Greek philosophical abstraction of God than the biblical presentation of a personal, active God.")]), _vm._v(" "), _c('p', [_vm._v("In the Bible wrath is an aspect of God’s person, as is clear from the many OT texts that make the “kindling” of God’s wrath the basis for his judgment. God’s wrath is necessary to the biblical conception of God: “As "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.100"
    }
  }), _vm._v("long as God is God, He cannot behold with indifference that His creation is destroyed and His holy will trodden underfoot. Therefore He meets sin with His mighty and annihilating reaction.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.31",
      "id": "FN.100.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" The OT regularly pictures God as responding to sin with wrath;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.32",
      "id": "FN.100.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" but, particularly in the prophets, the wrath of God is associated with the Day of the Lord as a cosmic, climactic outbreak of judgment. Although Paul works with this same conception of God’s wrath, he stresses the working and effects of God’s wrath. Paul speaks of wrath as a present reality under which people outside Christ stand,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.33",
      "id": "FN.100.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" and often, following the OT prophets, predicts the outpouring of God’s wrath on the future day of judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.34",
      "id": "FN.100.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" If the main verb in v. 18 is a “futuristic present,” Paul could here also be predicting this climactic outbreak of wrath at the end of history, as in 2:5."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.35",
      "id": "FN.100.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿35")]), _vm._v(" But the verb is most likely depicting a present-time situation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.36",
      "id": "FN.100.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_vm._v("If, then, Paul presents God’s wrath as a present reality, how are we to understand that that wrath is now being manifested? And what is the relationship between the two “revelations”—of the righteousness of God in v. 17 and of the wrath of God in v. 18?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.100.37",
      "id": "FN.100.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Taking the last question first, a determinative issue is whether the verb “reveal” means “reveal [a truth] to the mind” or “manifest [an action] in history.” One provocative interpretation that takes the verb in the first sense is associated with Karl Barth. He argues that the revelation of both God’s righteousness and wrath takes place in the preaching of the gospel. For the gospel proclaims the cross, and Jesus’ death on the cross "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.101"
    }
  }), _vm._v("reveals both the possibility for a new righteousness "), _c('i', [_vm._v("and")]), _vm._v(" the seriousness of God’s wrath against human sin."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.101.38",
      "id": "FN.101.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" Although this view does justice to the parallelism between vv. 17 and 18, it suffers from some fatal objections."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.101.39",
      "id": "FN.101.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" Barth’s interpretation also requires that “reveal” have a cognitive sense: “make known, disclose.” But as we have seen, this same verb in v. 17 has a “historical” sense: “come into historical reality” (from the “hiddenness” of God’s purpose). It is probable that this is the meaning of the verb in v. 18 also, especially since the object of this “revealing” is not people but the sins of people, or people as sinners: God’s wrath is revealed “upon all godlessness and unrighteousness of human beings.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.101.40",
      "id": "FN.101.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', [_vm._v("If, then, “reveal” indicates the actual inflicting of God’s wrath, when, and how, does it take place? Although God will inflict his wrath on sin finally and irrevocably at the end of time (2:5), there is an anticipatory working of God’s wrath in the events of history. Particularly, as vv. 24–28 suggest, the wrath of God is now visible in his “handing over” of human beings to their chosen way of sin and all its consequences. As Schiller’s famous aphorism puts it, “The history of the world is the judgment of the world.” It is this judgment of the world that the present infliction of God’s wrath is intended to reveal. For the present experience of God’s wrath is merely a foretaste of what will come on the day of judgment. Furthermore, what both the warning of “wrath to come” and the present experience of wrath demonstrate is the sentence of condemnation under which all people outside Christ stand. It is this reality that Paul wants to get across to this readers here.")]), _vm._v(" "), _c('p', [_vm._v("What, then, of the parallel between vv. 17 and 18? Some would go so far as to make this exercise of wrath a part of the righteousness of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.101.41",
      "id": "FN.101.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" But only if righteousness is taken broadly as an attribute of God is this possible, and we have seen good reason to reject this interpretation. On the other hand, the parallel with v. 17 may suggest that this condemning activity is particularly bound up with the eschatological breaking in of the new age "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.102"
    }
  }), _vm._v("in Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.42",
      "id": "FN.102.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" Though it is clear that God has inflicted his wrath in the past,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.43",
      "id": "FN.102.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" the inauguration of “the last days” means that the final, climactic wrath of God is already making itself felt."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.44",
      "id": "FN.102.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" The wrath of God falls more deservedly than ever before on people now that God’s righteousness in Christ is being publicly proclaimed.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s mention of the fact that God’s wrath is being revealed “from heaven” adds weight to what Paul is saying: it “significantly implies the majesty of an angry God, and His all-seeing eye, and the wide extent of His wrath: whatever is under heaven, and yet not under the Gospel, is under this wrath.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.45",
      "id": "FN.102.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Paul specifies two objects of God’s wrath: “ungodliness” and “unrighteousness.” Some distinguish the two words, arguing that the former refers to sins of a religious nature and the latter to sins of a moral nature."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.46",
      "id": "FN.102.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" Paul would then be following a sequence similar to that of the Decalogue, which focuses on a person’s duty to God in the first four commandments and on one’s duty to others in the second six."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.47",
      "id": "FN.102.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Moreover, it is claimed that 1:19–32 picks up this same sequence, as Paul concentrates first on people’s rejection of God (vv. 19–27) and then on the disruption of human relations that flows from this rejection."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.48",
      "id": "FN.102.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" The point would be, as S. L. Johnson puts it, “immorality in life proceeds from apostasy in doctrine.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.49",
      "id": "FN.102.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Although this interpretation is attractive and theologically sound, it does not have sufficient basis in the meaning of the words Paul uses."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.102.50",
      "id": "FN.102.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', [_vm._v("Paul further characterizes the people who are guilty of “ungodliness” "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.103"
    }
  }), _vm._v("and “unrighteousness” as those who “suppress the truth of God in unrighteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.103.51",
      "id": "FN.103.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" “Truth” in the NT is not simply something to which one must give mental assent; it is something to be done, to be obeyed. When people act sinfully, rebelling against God’s just rule, they fail to embrace the truth and so suppress it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.103.52",
      "id": "FN.103.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" In this case, as Meyer says, they “do not let it develop itself into power and influence on their religious knowledge and moral condition.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("19")]), _vm._v(" Verses 19–20 have two purposes. On the one hand, Paul justifies his assertion that people “suppress” the truth (v. 18b)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.103.53",
      "id": "FN.103.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" On the other hand, he wants to show that people who sin and are correspondingly subject to God’s wrath are responsible for their situation. They are “without excuse” (v. 20b). He accomplishes both purposes by asserting that people have been given a knowledge of God: “for"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.103.54",
      "id": "FN.103.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿54")]), _vm._v(" what can be known"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.103.55",
      "id": "FN.103.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿55")]), _vm._v(" about God is manifest among"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.103.56",
      "id": "FN.103.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿56")]), _vm._v(" them.” For Jews, as Paul will acknowledge later (2:18, 20), this "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.104"
    }
  }), _vm._v("knowledge of God comes above all through the law of Moses. Here, however, he is interested in the knowledge of God available to all people through the nature of the world itself. Therefore, what Paul says in the following verses, though not limited to Gentiles (since Jews, too, have knowledge of God through nature), has particular relevance to them.")]), _vm._v(" "), _c('p', [_vm._v("The last clause of v. 19 explains “is manifest”: what can be known of God has been made visible "), _c('i', [_vm._v("because")]), _vm._v(" God has “made it known.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.57",
      "id": "FN.104.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" Only by an act of revelation from above—God “making it known”—can people understand God as he is.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("20")]), _vm._v(" The “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.58",
      "id": "FN.104.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" introducing this verse shows that Paul continues the close chain of reasoning about the knowledge of God that he began in v. 19. He has asserted that what can be known of God is visible among people generally and that this is so only because God has acted to disclose himself. Now he explains how it is that God has made this disclosure. Two different connections among the main elements in the verse are possible: (1) “his invisible attributes … have been seen through the things he has made, being understood”;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.59",
      "id": "FN.104.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" (2) “his invisible attributes … have been seen, being understood through the things he has made.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.60",
      "id": "FN.104.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" Probably the latter makes better sense because, on the former rendering, the word “being understood” is somewhat redundant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.61",
      "id": "FN.104.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" The subject of this complex clause, “his invisible attributes,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.62",
      "id": "FN.104.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" is further defined in the appositional addition, “his eternal power and his deity.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.104.63",
      "id": "FN.104.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" What is denoted is that God is powerful and that he possesses those properties normally associated with deity. These properties of God that "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.105"
    }
  }), _vm._v("cannot be “seen” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(aorata)")]), _vm._v(" are “seen” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(kathoratai)—")]), _vm._v("an example of the literary device called oxymoron, in which a rhetorical effect is achieved by asserting something that is apparently contradictory. God in his essence is hidden from human sight, yet much of him and much about him can be seen through the things he has made. Paul is thinking primarily of the world as the product of God’s creation (see, e.g., Ps. 8), though the acts of God in history may also be included."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.105.64",
      "id": "FN.105.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', [_vm._v("But just what does Paul mean when he claims that human beings “see” and “understand” from creation and history that a powerful God exists? Some think that Paul is asserting only that people have around them the evidence of God’s existence and basic qualities; whether people actually perceive it or become personally conscious of it is not clear. But Paul’s wording suggests more than this. He asserts that people actually come to “understand” something about God’s existence and nature."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.105.65",
      "id": "FN.105.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" How universal is this perception? The flow of Paul’s argument makes any limitation impossible. Those who perceive the attributes of God in creation must be the same as those who suppress the truth in unrighteousness and are therefore liable to the wrath of God. Paul makes clear that this includes all people (see 3:9, 19–20).")]), _vm._v(" "), _c('p', [_vm._v("The last clause of v. 20, “so that they are without excuse,” states a key element in our interpretation of vv. 19–20."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.105.66",
      "id": "FN.105.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿66")]), _vm._v(" For Paul here makes clear "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.106"
    }
  }), _vm._v("that “natural revelation,” in and of itself, leads to a negative result. That Paul teaches the reality of a revelation of God in nature to all people, this text makes clear. But it is equally obvious that this revelation is universally rejected, as people turn from knowledge of God to gods of their own making (cf. vv. 22ff.). Why this is so, Paul will explain elsewhere (cf. Rom. 5:12–21). But it is vital if we are to understand Paul’s gospel and his urgency in preaching it to realize that natural revelation leads not to salvation but to the demonstration that God’s condemnation is just: people are “without excuse.” That verdict stands over the people we meet every day just as much as over the people Paul rubbed shoulders with in the first century, and our urgency in communicating the gospel should be as great as Paul’s.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("21")]), _vm._v(" This verse provides the missing link in the argument of v. 20. The refusal of people to acknowledge and worship God (v. 21) explains why the revelation of God in nature (v. 20a) leads to their being “without excuse” (v. 20b)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.106.67",
      "id": "FN.106.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" Paul accentuates the accountability of people by claiming that their failure to “glorify” and “give thanks to” God took place “even though they knew God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.106.68",
      "id": "FN.106.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" Paul’s claim that people through natural revelation “know” God is unexpected. Such language is normally confined to the intimate, personal relationship to God and Christ that is possible only for the believer."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.106.69",
      "id": "FN.106.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" In light of the use to which this knowledge is put, this is plainly not the case here. “Knowing God” must therefore be given a strictly limited sense compatible with Paul’s argument in this passage. But how limited? Cranfield suggests a greatly weakened sense: “in their awareness of the created world it is of him that all along, though unwittingly, they have been—objectively—aware.” But the elimination of any subjective perception from the meaning of the verb has no basis in Paul’s usage."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.106.70",
      "id": "FN.106.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" People do have some knowledge of God. But this knowledge, Paul also makes clear, is limited, involving the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.107"
    }
  }), _vm._v("narrow range of understanding of God available in nature: they “knew of God” (Phillips: “They knew all the time that there is a God”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.107.71",
      "id": "FN.107.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" The outward manifestation of God in his created works was met with a real, though severely limited, knowledge of him among those who observed those works.")]), _vm._v(" "), _c('p', [_vm._v("This limited knowledge of God falls far short of what is necessary to establish a relationship with him. Knowledge must lead to reverence and gratitude. This it has failed to do. Instead of acknowledging God “as God,” by glorifying him and thanking him, human beings perverted their knowledge and sank into idolatry. That idolatry, explicitly discussed in v. 23, might already be in Paul’s mind in this verse is suggested by his claim that people “became futile.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.107.72",
      "id": "FN.107.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" It is in the “reasonings”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.107.73",
      "id": "FN.107.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" of people that this futility has taken place, showing that, whatever their initial knowledge of God might be, their natural capacity to reason accurately about God is quickly and permanently harmed. Parallel to, and descriptive of, this futility in thinking is the darkening of the “un-understanding heart.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.107.74",
      "id": "FN.107.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(" In the NT, “heart” is broad in its meaning, denoting “the thinking, feeling, willing ego of man, with particular regard to his responsibility to God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.107.75",
      "id": "FN.107.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" We can understand, then, how Paul can describe the heart as being “without understanding” and recognize also how comprehensive is this description of fallen humanity. At the very center of every person, where the knowledge of God, if it is to have any positive effects, must be embraced, there has settled a darkness—a darkness that only the light of the gospel can penetrate.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("22")]), _vm._v(" This verse initiates three parallel descriptions of people’s rejection of God and the corresponding punitive response of God (vv. 22–24, 25–27, 28–31; see the introduction to the section)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.107.76",
      "id": "FN.107.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" The degeneration in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.108"
    }
  }), _vm._v("people’s understanding of God, asserted in v. 21, is characterized further in v. 22 by a contrast between illusion and reality. In refusing to pay homage to God when his works are recognized, people claim to be acquiring wisdom."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.108.77",
      "id": "FN.108.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" In reality, however, it is the opposite: they are “becoming foolish.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.108.78",
      "id": "FN.108.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" From v. 23, it is clear that this foolishness involves not only refusing to worship the true God but also embracing false gods."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.108.79",
      "id": "FN.108.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" This contrast, in which what people think is wisdom God considers foolishness, and vice versa, is elaborated in 1 Cor. 1–4. In that this “becoming foolish” involves the various idolatrous religions that people invent for themselves (v. 23), Paul’s estimation of non-Christian religions also becomes clear in this verse. Far from being a preparatory stage in the human quest for God, these religions represent a descent from the truth and are “evidence of man’s deepest corruption.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.108.80",
      "id": "FN.108.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("23")]), _vm._v(" Continuing the sentence begun in v. 22, this verse graphically portrays the folly of idolatry that lies at the heart of all religions that are not based on a reverent response to the revelation of the one true God. Paul pictures the fall into idolatry as an “exchange” of the glory of God for the images of human beings and beasts. “Glory” signifies the splendor and majesty that belong intrinsically to the one true God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.108.81",
      "id": "FN.108.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" Given the opportunity to bask in the glory of the immortal"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.108.82",
      "id": "FN.108.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" God, people have rather chosen, in their folly, to worship the images of mortal human beings and beasts. Paul’s description of the fall into idolatry is reminiscent of several OT texts, particularly Ps. 106:20, “and they exchanged their glory for the likeness of a bull that eats grass”; cf. also Jer. 2:11, “has a nation exchanged its gods? … yet my people have "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.109"
    }
  }), _vm._v("exchanged its glory.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.109.83",
      "id": "FN.109.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" Paul wishes his readers to see how foolish it is to substitute for direct contact with God’s awesome presence the indirect, shadowy relationship found in idolatry.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s description of the fall into idolatry in this verse draws from a variety of sources and traditions. There are allusions to the creation story in the threefold division of the animal kingdom. Ps. 106:20, which, as we have seen, Paul uses, comments on the “fall” of Israel into idolatry when she constructed the golden calf (Exod. 32). But Paul is not describing either the fall of Israel"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.109.84",
      "id": "FN.109.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿84")]), _vm._v(" or the fall of humankind in Adam."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.109.85",
      "id": "FN.109.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" Rather, in a somewhat "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.110"
    }
  }), _vm._v("idealized, paradigmatic fashion, he describes the terrible proclivity of all people to corrupt the knowledge of God they possess by making gods of their own. This tragic process of human “god-making” continues apace in our own day, and Paul’s words have as much relevance for people who have made money or sex or fame their gods as for those who carved idols out of wood and stone. Thus, as vv. 24–31 show, the whole dreadful panoply of sins that plague humanity has its roots in the soil of this idolatry."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.110.86",
      "id": "FN.110.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("24")]), _vm._v(" The “therefore”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.110.87",
      "id": "FN.110.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" at the beginning of this verse shows that God’s “handing over” of human beings is his response to their culpable rejection of the knowledge of himself that he has made generally available (vv. 21–23). Paul’s use of the verb “hand over” to describe this retribution has its roots in the OT, where it is regularly used in the stereotyped formula according to which God “hands over” Israel’s enemies so that they may be defeated in battle."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.110.88",
      "id": "FN.110.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" And, in an ironic role reversal, the same formula is used when God hands his own people over to another nation as punishment for their sins."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.110.89",
      "id": "FN.110.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" Somewhat similarly, Paul here alleges that God has “handed over” people to “uncleanness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.110.90",
      "id": "FN.110.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" What does Paul mean by this? Clearly he cannot be saying that God impelled people to sin. Not only would this contradict the biblical depiction of God (cf. Jas. 1:13), but the phrase that qualifies this “handing over to uncleanness,” “in the passions of their hearts,” shows that those who were handed over were already immersed in sin. Paul’s purpose in this verse is to highlight the divine side of the cycle of sin; but it must be balanced with "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.111"
    }
  }), _vm._v("the human side, presented in Eph. 4:19, where Paul says that Gentiles “gave themselves up”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.91",
      "id": "FN.111.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" to licentiousness, leading to all kinds of “uncleanness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.92",
      "id": "FN.111.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")]), _vm._v(" Dodd, in keeping with his interpretation of God’s wrath, thinks the “handing over” is no more than the outworking of the natural processes of history. But so impersonal a procedure does justice neither to the biblical teaching about God’s sovereign activity in history nor to Paul’s active language. Chrysostom interprets this handing over in a passive sense: by withdrawing his influence over these disobedient idolaters, God permits them to continue in, and indeed to plunge more deeply into, the sin they had already chosen. As Godet puts it: “He [God] ceased to hold the boat as it was dragged by the current of the river.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.93",
      "id": "FN.111.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('p', [_vm._v("No doubt such a withdrawal of divine influence would produce this result. But the meaning of “hand over” demands that we give God a more active role as the initiator of the process."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.94",
      "id": "FN.111.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" God does not simply let the boat go—he gives it a push downstream. Like a judge who hands over a prisoner to the punishment his crime has earned, God hands over the sinner to the terrible cycle of ever-increasing sin."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.95",
      "id": "FN.111.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" Is this punishment reformatory in purpose? Chrysostom thought so; the depths of sin in which the idolater is plunged are designed to awaken the sinner to the awful seriousness of his or her situation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.96",
      "id": "FN.111.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" In that God’s handing over of his people in the OT was not the final word, and in light of the possible parallel to this action in the temporary confining of Israel under sin through the law (Gal. 3:21–25), this might be the case. But it must be added that both biblical and secular history afford us many examples in which such punishment has not led to spiritual reformation.")]), _vm._v(" "), _c('p', [_vm._v("The sexual nuance present in the term “uncleanness” is elaborated in the last clause of the verse: “to the dishonoring of their bodies among themselves.” The significance of this clause is not clear. Does it indicate the purpose for which God handed people over?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.97",
      "id": "FN.111.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(" Its result?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.111.98",
      "id": "FN.111.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" Or does it simply give a "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.112"
    }
  }), _vm._v("fuller definition of the word “uncleanness”?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.99",
      "id": "FN.112.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")]), _vm._v(" Certainty is impossible, but the last is probably the best option."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.100",
      "id": "FN.112.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("25")]), _vm._v(" The first clause of this verse might continue the sentence begun in v. 24 and have a causal meaning: “God handed them over [v. 24] … "), _c('i', [_vm._v("because")]), _vm._v(" they exchanged the truth of God for a lie.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.101",
      "id": "FN.112.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" But since v. 23 has already expressed the reason for this handing over, it is preferable to see v. 25 as initiating a new sentence."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.102",
      "id": "FN.112.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" Rather than looking backward, then, v. 25 looks ahead, providing, as does v. 23 in relation to v. 24, the basis for God’s judicial “handing over” of sinners to the consequences of their choices. Moreover, the bases are very similar. If in v. 23 Paul accuses people of exchanging “the glory of the immortal God for the likeness of the image of mortal man, and birds, and animals, and reptiles,” so here he claims that they have “exchanged"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.103",
      "id": "FN.112.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿103")]), _vm._v(" the truth of God for a lie.” “The truth of God” is not “the truth God has made known and belongs to him,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.104",
      "id": "FN.112.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")]), _vm._v(" but the reality, the fact of God as he has revealed himself."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.112.105",
      "id": "FN.112.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" The Thessalonian Christians, Paul "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.113"
    }
  }), _vm._v("writes, have reversed this exchange; they “turned to God from idols, to serve a living and true God” (1 Thess. 1:9).")]), _vm._v(" "), _c('p', [_vm._v("In the second clause of v. 25, Paul concisely defines the “lie” of idolatry: “worshiping and serving the creature rather than"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.106",
      "id": "FN.113.106r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿106")]), _vm._v(" the Creator.” The two verbs are mutually interpreting and together sum up all that is involved in the veneration of idols."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.107",
      "id": "FN.113.107r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")]), _vm._v(" It is this putting some aspect of God’s creation—whether it be an animal, a human, or a material object—in place of God that is the essence of idolatry. Perhaps it is to underline the folly of this exchange that Paul adds a blessing formula, “who is blessed forever. Amen.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.108",
      "id": "FN.113.108r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("26")]), _vm._v(" In many Jewish polemical works, the gross sexual immorality that the Jews found rampant among the Gentiles was traced directly to idolatry. Thus, to cite Wisdom of Solomon: “the idea of making idols was the beginning of fornication, and the invention of them was the corruption of life” (14:12). Paul follows this genre by making the same connection but differs from it by attributing the connection to the act of God. As in vv. 23–24, people’s “exchange” of the true God for idols (v. 25) is the cause"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.109",
      "id": "FN.113.109r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿109")]), _vm._v(" of God’s retributive “handing them over.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.110",
      "id": "FN.113.110r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")]), _vm._v(" And that to which they are handed over, “dishonorable passions,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.111",
      "id": "FN.113.111r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")]), _vm._v(" here corresponds to the “uncleanness” of v. 24. Paul’s use of the word “passions,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.113.112",
      "id": "FN.113.112r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")]), _vm._v(" combined with what he says in vv. 26b–27, makes clear that he refers to illicit sexual "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.114"
    }
  }), _vm._v("passions. For the last clause of the verse illustrates these “dishonorable passions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.114.113",
      "id": "FN.114.113r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")]), _vm._v(" In yet another similarity to Jewish criticisms of the Gentile world, the sexual sin that Paul singles out is homosexuality: “women"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.114.114",
      "id": "FN.114.114r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿114")]), _vm._v(" exchanged the natural use of their bodies for that use which is against nature.” The verb “exchange,” which has been used twice to depict the fall into idolatry (vv. 23, 25), is now used to characterize this tragic reversal in sexual practice. The “natural use” has been replaced with one that is “against nature.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.114.115",
      "id": "FN.114.115r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('p', [_vm._v("The extent to which Paul characterizes this exchange as a violation of God’s created order depends on the significance of the words “natural” and “nature” in this verse. Paul generally uses the word “nature” to describe the way things are by reason of their intrinsic state or birth, and in these cases there is no clear reference to divine intention."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.114.116",
      "id": "FN.114.116r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")]), _vm._v(" Some scholars in recent years especially, noting this, have argued that Paul does not here brand homosexuality as a violation of God’s will. He is only, they argue, following his own cultural prejudices by characterizing homosexual relations as being against what is “usually” the case."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.114.117",
      "id": "FN.114.117r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")]), _vm._v(" But Paul’s use of the word “nature” in this verse probably owes much to Jewish authors, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.115"
    }
  }), _vm._v("particularly Philo, who included sexual morality as part of “natural law” and therefore as a divine mandate applicable to all people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.115.118",
      "id": "FN.115.118r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")]), _vm._v(" Violations of this law, as in the case of Sodom, are therefore considered transgressions of God’s will."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.115.119",
      "id": "FN.115.119r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")]), _vm._v(" In keeping with the biblical and Jewish worldview, the heterosexual desires observed normally in nature are traced to God’s creative intent. Sexual sins that are “against nature” are also, then, against God, and it is this close association that makes it probable that Paul’s appeal to “nature” in this verse includes appeal to God’s created order."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.115.120",
      "id": "FN.115.120r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")]), _vm._v(" Confirmation can be found in the context. In labeling the turning from “the natural use” to “that [use] which is against nature” an “exchange,” Paul associates homosexuality with the perversion of true knowledge of God already depicted in vv. 23 and 25. In addition, we must remember that the clause in question is a description of “sinful passions,” a phrase plainly connoting activities that are contrary to God’s will. When these factors are considered, it is clear that Paul depicts homosexual activity as a violation of God’s created order, another indication of the departure from true knowledge and worship of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.115.121",
      "id": "FN.115.121r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("27")]), _vm._v(" This verse is connected to the last part of v. 26 with “likewise,” as Paul shows that the same “sinful passions” that lead women to engage in unnatural homosexual acts are also operative among men, with similar effect."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.115.122",
      "id": "FN.115.122r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.116"
    }
  }), _vm._v("Homosexuality among “males,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.123",
      "id": "FN.116.123r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")]), _vm._v(" like that among “females,” is characterized as a departure from nature."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.124",
      "id": "FN.116.124r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")]), _vm._v(" As in the previous verse, “nature” denotes the natural order, but as reflective of God’s purposes. Paul uses strong language to characterize male homosexuality: “they burned"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.125",
      "id": "FN.116.125r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿125")]), _vm._v(" in their desire"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.126",
      "id": "FN.116.126r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿126")]), _vm._v(" for one another, men with men"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.127",
      "id": "FN.116.127r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿127")]), _vm._v(" doing"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.128",
      "id": "FN.116.128r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿128")]), _vm._v(" that which is shameful"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.129",
      "id": "FN.116.129r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿129")]), _vm._v(" and receiving in themselves the just penalty"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.130",
      "id": "FN.116.130r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿130")]), _vm._v(" that was necessary for their error.” In calling the homosexual activity that brings about this penalty an “error,” Paul does not diminish the seriousness of the offense, for this word often denotes sins of unbelievers in the NT."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.131",
      "id": "FN.116.131r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")]), _vm._v(" In claiming that this penalty for homosexual practice is received “in themselves,” Paul may suggest that the sexual perversion itself is the punishment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.132",
      "id": "FN.116.132r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")]), _vm._v(" On the other hand, this could be a vivid way of saying that those who engage in such activities will suffer eternal punishment; they will receive “in their own persons” God’s penalty for violation of his will."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.116.133",
      "id": "FN.116.133r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")]), _vm._v(" This punishment, Paul says, was “necessary,” by "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.117"
    }
  }), _vm._v("which he probably means that God could not allow his created order to be so violated without there being a just punishment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.134",
      "id": "FN.117.134r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("28")]), _vm._v(" In vv. 22–24 and 25–27 Paul has shown how the sexual immorality that pervades humanity has its roots in the rejection of the true God in favor of gods of their own making. In the third and final portrayal of this sin-retribution sequence (vv. 28–32), he traces sins of inhumanity, of man’s hatred of his fellow man in all its terrible manifestations, to this same root sin of idolatry.")]), _vm._v(" "), _c('p', [_vm._v("In keeping with the relation between human sin and divine retribution in the previous two sections, the first clause in this verse might have a causal force: “"), _c('i', [_vm._v("because")]), _vm._v(" they did not see fit to retain God in knowledge, God handed them over” (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v("; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.135",
      "id": "FN.117.135r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")]), _vm._v(" But the lack of clear evidence for a causal meaning of the word Paul uses here"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.136",
      "id": "FN.117.136r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿136")]), _vm._v(" leads us to prefer the normal correlative sense of the word: “Even as people did not retain knowledge of God, God handed them over to a worthless mind.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.137",
      "id": "FN.117.137r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")]), _vm._v(" This correlative relationship underlines the close correspondence in this verse between sin and retribution, a relationship Paul enhances with a wordplay in Greek between “see fit” and “worthless.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.138",
      "id": "FN.117.138r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")]), _vm._v(" “To have God in knowledge” means to acknowledge God, to retain and respond to the knowledge of himself that God has given in his creation. The Greek word for “knowledge” that Paul uses here sometimes connotes “practical” or “applied” (as opposed to theoretical) knowledge."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.139",
      "id": "FN.117.139r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")]), _vm._v(" Perhaps, then, we could distinguish the “theoretical” knowledge of God that Gentiles were given (vv. 19, 21) from the practical, experiential knowledge of God that would have been involved in glorifying and thanking God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.117.140",
      "id": "FN.117.140r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.118"
    }
  }), _vm._v("For the third time Paul describes God’s response to people’s spurning of him with the words “God handed them over” (cf. also vv. 24, 26). Whereas in the previous instances it was to immoral acts that God consigned people, in this case it is to a “worthless mind.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.118.141",
      "id": "FN.118.141r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")]), _vm._v(" People who have refused to acknowledge God end up with minds that are “disqualified” from being able to understand and acknowledge the will of God. The result, of course, is that they do things that are “not proper.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.118.142",
      "id": "FN.118.142r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")]), _vm._v(" As in 1:21, Paul stresses that people who have turned from God are fundamentally unable to think and decide correctly about God and his will. This tragic incapacity is the explanation for the apparently inexplicable failure of people to comprehend, let alone practice, biblical ethical principles. Only the work of the Spirit in “renewing the mind ["), _c('i', [_vm._v("nous")]), _vm._v("]” (Rom. 12:2) can overcome this deep-seated blindness and perversity.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("29–31")]), _vm._v(" Paul includes a long list of immoral activities in “things that are not proper” in vv. 29–31. Such a listing of sins is called a “vice list,” a literary form widespread in secular moral writings as well as in the NT."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.118.143",
      "id": "FN.118.143r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")]), _vm._v(" As is typical of such lists, this one exhibits no rigid logical arrangement, since rhetorical concerns play a role in the ordering of the list. Nor is it possible to give each term in the list a meaning distinct from every other term—some are virtually synonymous, and a considerable degree of overlap in meaning occurs. Nevertheless, we can note some structural as well as logical order. Structurally, the list falls into three parts:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("“filled with"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.118.144",
      "id": "FN.118.144r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿144")]), _vm._v(" all manner"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.118.145",
      "id": "FN.118.145r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿145")]), _vm._v(" of unrighteousness, evil, greed, wickedness;")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.119"
    }
  }), _vm._v("“full of envy, murder, strife, deceit, malice;")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("“gossips, maligners, haters of God, proud, arrogant, overbearing, devisers of evil, disobedient to parents, without understanding, without faithfulness, without affection, without mercy.”")])]), _vm._v(" "), _c('p', [_vm._v("A general logical sequence matches this structure. The first four nouns are rather general in their focus, the next five revolve around envy and its consequences, while the last twelve begin with two words depicting slander, move on to four that focus on arrogance, and conclude with six less closely related. Throughout the list, Paul focuses on social ills, leaving out sins relating to sexual conduct and, for the most part, sins against God directly. The purpose of this recital, which is the longest of its kind in the NT, is to show the general scope of social evils produced by the “unqualified mind” to which God has handed sinners over. The harm done by people to other people is thus added to idolatry and sexual perversion to complete Paul’s sketch of the world outside Christ.")]), _vm._v(" "), _c('p', [_vm._v("On “unrighteousness,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.146",
      "id": "FN.119.146r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")]), _vm._v(" see 1:18.")]), _vm._v(" "), _c('p', [_vm._v("“Evil” cannot easily be delimited to anything specific."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.147",
      "id": "FN.119.147r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('p', [_vm._v("“Greed” is more specific than the other three words in this first group but is perhaps included because greed is basic to so many other sins."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.148",
      "id": "FN.119.148r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('p', [_vm._v("The first two words of the second part of the list are probably put together because of the assonance they create—"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("phthonou")]), _vm._v(" (“envy”)/"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("phonou")]), _vm._v(" (“murder”)—but the two have a logical relation as well. “Envy” was the subject of many moral treatises both in the secular Greek world and in Hellenistic Judaism,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.149",
      "id": "FN.119.149r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")]), _vm._v(" and to it were frequently ascribed acts of violence such as “murder.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.150",
      "id": "FN.119.150r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('p', [_vm._v("Perhaps the other three sins in this section, “strife,” “deceit,” and “malice,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.151",
      "id": "FN.119.151r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")]), _vm._v(" are also to be subsumed under envy,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.119.152",
      "id": "FN.119.152r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")]), _vm._v(" although the logical relationship is not so clear for the last two.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.120"
    }
  }), _vm._v("The final part of the vice list begins with two terms that denote slander. The first"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.153",
      "id": "FN.120.153r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿153")]), _vm._v(" is the more specific, suggesting the “whispering” of the person who spreads “confidential” rumors about others.")]), _vm._v(" "), _c('p', [_vm._v("The word translated “maligners” could more clumsily be paraphrased “one who speaks against.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.154",
      "id": "FN.120.154r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")]), _vm._v(" The next word is the most difficult in the list to define. It is composed of words that mean “hate” and “God,” but it is not clear whether God is the hater or the one hated. In classical Greek it is invariably passive, “hated by the gods,” and some give it this meaning here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.155",
      "id": "FN.120.155r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")]), _vm._v(" But it is more likely that the word has an active sense, “haters of God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.156",
      "id": "FN.120.156r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('p', [_vm._v("The sin of human self-exaltation before both God and other people is conveyed in the next three words, “proud,” “arrogant,” and “overbearing.” Trench distinguishes them, arguing that the first focuses on activities, the second on thoughts, and the third on words."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.157",
      "id": "FN.120.157r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")]), _vm._v(" Without making these distinctions absolute, they capture accurately enough the nuances of the words."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.158",
      "id": "FN.120.158r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('p', [_vm._v("Rhetoric rather than logic dictates the sequence of the next two vices, each denoted by a phrase rather than by a single word: “devisers of evil”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.159",
      "id": "FN.120.159r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")]), _vm._v(" and “disobedient to parents.” Because “disobedient to parents” occurs in 2 Tim. 3:2 along with “overbearing” and “proud,” we may conclude that its presence here continues the theme of arrogance found earlier in v. 30.")]), _vm._v(" "), _c('p', [_vm._v("The last four items are listed together to create assonance."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.120.160",
      "id": "FN.120.160r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")]), _vm._v(" “Without understanding” describes those who, because of their rejection of God (cf. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.121"
    }
  }), _vm._v("1:21, 28), can no longer comprehend the will of God. They are like the “fool” of Proverbs who ignores wisdom and pursues activities harmful both to herself and to others. “Without faithfulness” means literally one who refuses to abide by covenants and treaties."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.161",
      "id": "FN.121.161r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")]), _vm._v(" “Without affection” may have reference particularly to the lack of affection for family members."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.162",
      "id": "FN.121.162r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")]), _vm._v(" The failure of people to exhibit even the affection natural to family relationships shows how deep is the corruption of morals.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("32")]), _vm._v(" As in v. 25, Paul reverts to the subject of the earlier verses—human beings generally—by using a pronoun that focuses attention on their character."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.163",
      "id": "FN.121.163r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")]), _vm._v(" Even though those in view are the people Paul has been describing throughout vv. 19–31,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.164",
      "id": "FN.121.164r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿164")]), _vm._v(" this verse is linked particularly closely with vv. 28–31, since “such things” has its antecedent in the vices listed in vv. 29–31. The function of this concluding verse is to bring out even more fully the willful rebellion against God that pervades humanity. Toward this end, Paul notes that those who engage in the activities he has listed know that what they are doing is wrong. They act “knowing"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.165",
      "id": "FN.121.165r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿165")]), _vm._v(" the righteous decree of God, that those who do such things are worthy of death.” “Righteous decree” translates a word that Paul uses several other times in Romans, the closest parallel being 8:4, where Paul speaks of the “righteous decree of the law” that believers fulfill by the Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.166",
      "id": "FN.121.166r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")]), _vm._v(" The lack of reference here to “the law” is significant: Paul speaks of what all people, whether blessed with special revelation or not, can know of God’s just judgment. “Death” denotes here a divinely imposed punishment and reminds us, as does the earlier part of this passage, of Gen. 3."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.121.167",
      "id": "FN.121.167r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿167")]), _vm._v(" As Michel rightly emphasizes, the present tenses in this verse show that Paul is speaking not only of what has been true in the past or of what will be true in the future. People generally, Paul claims, have some degree of awareness "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.122"
    }
  }), _vm._v("that the moral outrages they commit are wrong and hence deserve to be punished by God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.122.168",
      "id": "FN.122.168r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('p', [_vm._v("The last part of the verse poses a certain difficulty. For by characterizing people as those “who not only do these things themselves, but commend those who do"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.122.169",
      "id": "FN.122.169r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿169")]), _vm._v(" them,” Paul appears to suggest that “commending” evil is worse than doing it. Some have attempted to avoid the difficulty by rearranging the text or translating it differently, but these solutions are not convincing."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.122.170",
      "id": "FN.122.170r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")]), _vm._v(" After all, is the traditional interpretation so large a problem? Granted that commending evil is not, in the ultimate sense, worse than doing it, it is also true that in a certain respect the person who commits a sin under the influence of strong temptation is less reprehensible than the one who dispassionately agrees with and encourages a sin for which he or she feels no strong attraction him- or herself. As Murray says, “we are not only bent on damning ourselves but we congratulate others in the doing of those things that we know have their issue in damnation.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.122.171",
      "id": "FN.122.171r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")]), _vm._v(" Although it does not feature the same ascensive emphasis, "), _c('i', [_vm._v("T. Asher")]), _vm._v(" 6:2 is both verbally and conceptually close to Paul’s statement: “The two-faced are doubly punished because they both practice evil and approve of others who practice it; they imitate the spirits of error and join in the struggle against mankind.”")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("In Paul’s concern to demonstrate the responsibility of all human beings for their sin and fallen state, he says some important things about what theologians call the doctrine of “natural revelation”—the knowledge of God that he has made available in the very creation and working of the world. Yet theologians disagree quite dramatically on the extent and significance of this revelation in nature. Roman Catholic theologians have traditionally been very open to the possibility of persons coming to know God through the evidence of nature and the conscience."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.122.172",
      "id": "FN.122.172r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")]), _vm._v(" Against any such notion, Barth has reacted vigorously. For him all knowledge of God must come through Christ; Rom. 1:19–21 speaks not of Gentiles knowing God through nature, but of Gentiles who, confronted with the gospel, have revealed the objective condition that has been theirs all "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.123"
    }
  }), _vm._v("along."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.123.173",
      "id": "FN.123.173r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")]), _vm._v(" Others, noting that Paul elsewhere accuses the Gentiles of his day of being ignorant of God (cf. 1 Thess. 4:5; 2 Thess. 2:8; Gal. 4:8), suggest that the knowledge of God possessed by Gentiles was a stage in the past, before a collective fall into idolatry."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.123.174",
      "id": "FN.123.174r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")]), _vm._v(" Support for this view is found in the aorist tenses of vv. 19b–28. Still others insist that the knowledge of God that Paul speaks of in these verses is a matter only of “objective” reality, but not of “subjective” awareness."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.123.175",
      "id": "FN.123.175r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('p', [_vm._v("What can we conclude from the text? First, against Barth, Rom. 1:19–21 teaches that true knowledge of God is available in nature and that people apart from God’s revelation in Christ come to know this truth about God. Moreover, the emphasis on the “mind” in v. 19 strongly implies that the inner reason contributes to this knowledge "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(sensus divinitatis).")]), _vm._v(" Second, the aorist tenses of vv. 19b–28 do not allow us to conclude that only a past generation is in view. For the argument of these verses supports the contention of v. 18b that people in Paul’s day are suppressing the truth. For this argument to work, the people who have some kind of access to knowledge of God must be the same ones who suppress that knowledge. Thus, while the possibility that Paul describes a collective fall of humankind into idolatry in vv. 19–21 cannot be completely discounted, it does not, by itself, explain adequately the way the passage functions in Rom. 1. It can be concluded, then, that the text teaches that all people have, by reason of God’s revelation in creation, access to some degree of knowledge about God (v. 19) and that, to however limited an extent, they subjectively perceive this knowledge (v. 20). “(M)an becomes guilty because something essential does reach him.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.123.176",
      "id": "FN.123.176r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('p', [_vm._v("But this knowledge is both limited and impure; it is confined to those basic attributes of God that may be discerned in nature (v. 20) and is so mixed with false perceptions that it is almost immediately perverted. Further, it is vitally important, if the passion of Paul’s gospel is to be correctly appreciated and the argument of this section correctly understood, to see that the knowledge of God that people possess outside special revelation is woefully inadequate, of itself, to save. Paul makes clear that, rather than being a help to people in their search for God, the evidence of nature and conscience (cf. 2:14–16) serves only to render them “without excuse” before the wrathful God. That this is the result of natural revelation follows from the sinfulness of human beings, who without grace are unable to respond appropriately to whatever knowledge of God they "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.124"
    }
  }), _vm._v("may possess. Paul, then, teaches a natural revelation, but, at least in this passage, the purpose and effect of that revelation are wholly negative."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.124.177",
      "id": "FN.124.177r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('p', [_vm._v("Another question is how long this knowledge remains with a person. When a person refuses to respond properly to the knowledge of God, is that knowledge immediately effaced or does it remain in some form, whether perverted or not? This question is more difficult to answer on the basis of the discussion in Rom. 1. But v. 32 strongly implies that some knowledge of God remains even after a person has fallen into the degenerate state that Paul depicts in these verses. For the present tenses of that verse, along with the fact that Paul is trying to establish the seriousness of the sinning he has depicted, make it probable that “knowing the righteous ordinance of God” is contemporaneous with the panoply of sinning outlined in vv. 29–31."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.124.178",
      "id": "FN.124.178r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿178")])]), _vm._v(" "), _c('p', [_vm._v("Calvin, whose treatment of this topic in the "), _c('i', [_vm._v("Institutes")]), _vm._v(" (1.3–5) can hardly be improved on, may be quoted briefly on these points:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("It is therefore in vain that so many burning lamps shine for us in the workmanship of the universe to show forth the glory of its Author. Although they bathe us wholly in their radiance, yet they can of themselves in no way lead us into the right path. Surely they strike some sparks, but before their fuller light shines forth these are smothered.… But although we lack the natural ability to mount up unto the pure and clear knowledge of God, all excuse is cut off because the fault of dullness is within us."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.124.179",
      "id": "FN.124.179r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])])]), _vm._v(" "), _c('p', [_vm._v("Paul’s teaching about natural revelation in these verses has some parallels with Greek Stoicism and Hellenistic Judaism. The Greek traditions have "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.125"
    }
  }), _vm._v("mainly a positive purpose, however, encouraging people to pursue the knowledge of God through their reason. This is far from Paul’s exclusively negative use of the language."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.125.180",
      "id": "FN.125.180r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")]), _vm._v(" As Bornkamm puts it, “the intention of the Apostle is not to infer God’s being from the world, but to uncover the being of the world from God’s revelation.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.125.181",
      "id": "FN.125.181r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")]), _vm._v(" The Hellenistic Jewish teachings differ widely, but some, at least, are much closer to Paul. Wisdom 13–14, for instance, criticizes Gentiles for not recognizing “the craftsman while paying heed to his works” (13:1) and for falling into the foolish worship of “homemade” gods. The author can even say that those who failed to recognize God are “not to be excused” (13:8). Paul has undoubtedly been influenced by this tradition and shares with it the generally negative verdict about the knowledge of God among the Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.125.182",
      "id": "FN.125.182r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")]), _vm._v(" At one crucial point, however, Paul dissents from the Jewish view: he criticizes Jews as well as Gentiles for failing to respond appropriately to God’s self-revelation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.125.183",
      "id": "FN.125.183r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY3.1.2"
    }
  }, [_vm._v("2. Jews Are Accountable to God for Sin (2:1–3:8)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 1:18–32, Paul describes those people whom he accuses of perverting their knowledge of God (Gentiles, primarily) in the third person: “they” turned away from God; God handed “them” over. In chap. 2, however, it is the second person singular, “you,” that Paul uses in making his accusation (2:1–5, 17–29). This does not mean that Paul is now accusing his readers of these things; were he to do that, the second person plural would have been needed. Rather, Paul utilizes here, and sporadically throughout the letter, a literary style called "), _c('i', [_vm._v("diatribe.")]), _vm._v(" Diatribe style, which is attested in several ancient authors as well as elsewhere in the NT (e.g., James), uses the literary device of an imaginary dialogue with a student or opponent. Elements of this style include frequent questions, posed by the author to his conversation partner or by the conversation partner, emphatic rejections of possible objections to a line of argument using "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mē genoito")]), _vm._v(" (“May it never be!”), and the direct address of one’s conversation partner or opponent."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.125.1",
      "id": "FN.125.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.126"
    }
  }), _vm._v("Romans 3:1–8 is a particularly clear example of this dialogical style; and chap. 2, while not containing any true dialogue, is similar to those parts of the diatribe in which the “teacher” rebukes his or her conversation partner by exposing his or her presumption and inconsistency (cf. 2:1: “you are without excuse, O person”; 2:3: “Do you reckon this, O person”; 2:17: “If you call yourself a Jew,” etc.). However, the dialogue that Paul records in this part of the letter, while imaginary, undoubtedly reflects accurately many actual debates and conversations with those to whom he was preaching the gospel. The “conversations” and indictments that we find in this section are not verbatim reports of actual dialogues, but they reflect real-life situations."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.126.2",
      "id": "FN.126.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("Who, then, is the person that Paul addresses in this section? Although some application to self-righteous Gentiles cannot be entirely removed from what Paul says in 2:1–11, it is clear that Paul’s main target is the Jew (see the introduction to 2:1–16). His indictment of the Jew proceeds in two stages (2:1–16; 2:17–29), with 3:1–8 being a parenthetical response to possible misconceptions of what Paul has said. Both parts of Paul’s indictment accuse the Jews of committing sins (2:1–5; 2:17–24) and then show that those sins are not excused by God simply by virtue of the Jews’ belonging to the people of Israel, e.g., by possessing the law (2:12–16) or by being circumcised (2:25–29). Just as people in general have turned away from the revelation that God has given in nature (1:20–32), so the Jews have turned away, through their disobedience, from the revelation that God has given them specially (2:17–24).")]), _vm._v(" "), _c('p', [_vm._v("Contrary to popular Jewish belief, the sins of the Jews will not be treated by God significantly differently from those of the Gentiles. For God is impartial and judges every person “according to his works” (2:6–11). Like John the Baptist (Matt. 3:7–10) and Jesus (cf. Matt. 21:28–32) before him, Paul denies that belonging to the covenant people per se ensures acceptance with God. Neither possession of the law nor circumcision marks a person as truly belonging to God. Only repentance (2:4) and an inner, heartfelt commitment to God (2:28–29)—in a word, faith—ultimately count before the Lord. Like the bark of the dog in the Sherlock Holmes story “Silver Blaze,” the word “faith,” introduced in 1:17 as the way in which God’s righteousness can be appropriated, is conspicuous in 2:1–3:8 by its absence. Yet, as Paul shows in chap. 4, it has always been faith—and only faith—that enables "), _c('i', [_vm._v("anyone")]), _vm._v(" to belong to the people of God and so escape his wrath. Scholars have introduced the phrase “covenantal nomism” to describe the Jews’ conviction that their corporate election, combined with sincere intention to obey the law, sufficed for salvation. This belief Paul implicitly denies in chap. 2. He then goes on to claim that the OT itself teaches not “covenantal nomism” but “promissory pistism”—that a "), _c('i', [_vm._v("saving")]), _vm._v(" relationship with God comes, as it did for Abraham, through human "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.127"
    }
  }), _vm._v("response to God’s grace expressed in his promise and not through the Mosaic covenant. (See, in more detail, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY4"
    }
  }, [_vm._v("Excursus")]), _vm._v(" after 3:20.)")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY3.1.2.1"
    }
  }, [_vm._v("a. The Jews and the Judgment of God (2:1–16)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Paul develops his critique of the Jews in these verses in three paragraphs. The first, vv. 1–5, uses the second person singular to accuse the Jews of earning for themselves the same wrath that is already falling on Gentile sinners. This accusation is the main point of 2:1–16. God’s judgment is “according to truth,” and he must fairly assess the works of every person (v. 2). And this criterion of impartial “fairness” applies even to the Jew who is proud of being a member of God’s people (vv. 3–5).")]), _vm._v(" "), _c('p', [_vm._v("The second two paragraphs (vv. 6–11 and 12–16) interrupt the second person “accusation” style (it is resumed in v. 17) with explanation (in the third person plural) of the indictment in vv. 1–5. Both paragraphs serve to validate the inclusion of Jews along with Gentiles under sentence of God’s wrath by showing that Jews stand on the same basic ground as Gentiles when it comes to God’s judgment. For, in the first place, God’s impartiality demands that he treat all people the same, judging every person according to what he has done (vv. 6–11). To this, the Jews may object that they possess, in the Mosaic law, a distinct advantage over the Gentiles. So, in the second place, Paul shows that possession of the Mosaic law will make no difference in this judgment (v. 12)—for (1) it is not the possession but the doing of the law that matters (v. 13); and (2) the Gentiles also have “law” in some sense (vv. 14–16).")]), _vm._v(" "), _c('p', [_vm._v("Paul therefore “levels the playing field” between Jew and Gentile. Both stand condemned before God because of their transgressions of God’s Word. It is because Jews "), _c('i', [_vm._v("do")]), _vm._v(" “the same things” as Gentiles that God will judge them (2:1–3); because they disobey the law in which they boast that they “dishonor God” (2:17–24); because they transgress the law that they lose any value in their circumcision (2:25; see also 3:10–18). Factual transgressions are the reason Jews stand condemned and need the righteousness of God available in the gospel; the lack of security in their “covenant status” is the reason, in turn, why these transgressions will “count” before God.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY3.1.2.1.1"
    }
  }, [_vm._v("i. Critique of Jewish Presumption (2:1–5)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("Therefore, you are without excuse, O person, each one of you who is judging. For in what you are condemning the other person, you are condemning yourself, for you who are judging are doing the very same things. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("Now we know that the judgment of God upon those who do such things is according to truth. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("Or do you reckon this, O person "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.128"
    }
  }), _vm._v("who is judging those doing such things and doing the same things, that you will escape the judgment of God? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("Or are you showing contempt for the riches of his goodness and forbearance and patience, being ignorant that the goodness of God is leading you to repentance? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("Because of your hard and unrepentant heart you are storing up for yourself wrath on the day of wrath and the revelation"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.128.3",
      "id": "FN.128.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" of the righteous judgment of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Paul begins by turning his attention to a person who is standing in judgment over the people whom he has described in chap. 1. Cheering Paul on in his indictment of Gentiles, this person, although he thinks himself superior to the “heathen” idolater of 1:18–32, is nevertheless just as much in danger of the wrath of God, for he is doing “the same things” as those whom he condemns (2:1–2). Who is this “superior” person? A few interpreters, noting that Paul calls this person a “judge” (v. 1), have thought that Paul might be addressing an actual civil judge."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.128.4",
      "id": "FN.128.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" But this misses the import of Paul’s accusation and is too narrow an application. Much more popular is the identification of this person with any self-consciously “moral” person, whether Jew or Gentile."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.128.5",
      "id": "FN.128.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" But this identification is a bit too broad. Without necessarily excluding application to the moral person generally, we think it is clear that it is the Jew who is the real target of Paul’s indictment in these verses."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.128.6",
      "id": "FN.128.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_vm._v("Paul’s accusation in vv. 1–3 could apply to anyone, but v. 4 draws on language from Wis. 12–15 that makes best sense if the passage is directed against the Jew. This same conclusion emerges from the fact that vv. 6–11 and 12–16, in which Paul lays the basis for the charge he has made in vv. 1–5, have the purpose of relativizing the position of the Jew vis-à-vis the Gentile. But this makes sense only if vv. 1–5 have been directed primarily against the Jew."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.128.7",
      "id": "FN.128.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Therefore, although Paul does not explicitly identify his target until 2:17, it is clear that already in 2:1–11 the Jew is his “hidden target.” By beginning his indictment in such general terms—“O person, each one of you” (v. 1)—Paul enables his readers in Rome to share in the “discovery” process that he probably used when he "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.129"
    }
  }), _vm._v("preached his gospel to mixed audiences. We can imagine many self-professed “moral” people adding their “Amen” to the kind of denunciation of “heathen” sins that we find in 1:18–32. Suddenly, however, Paul turns on these people and accuses them of doing “the very same things.” Only as he moves on in his denunciation will it emerge that it is the Jew whom Paul has really in mind. Such a technique would have enabled Paul to gain the sympathy of the Jews in his audience and keep them interested in his message.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" The “therefore”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.129.8",
      "id": "FN.129.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" that connects the opening of Rom. 2 with Rom. 1 creates a problem for our conclusion that 1:18–32 is directed mainly against Gentiles and 2:1–16 mainly against Jews. For if Paul has shifted targets in this manner, we would expect the transition to be made with something like “in the same manner also.” But how can the sin and guilt of Gentiles establish the conclusion (“therefore”) that Jews who judge them are also “without excuse”? Several scholars seize on this problem as another reason for thinking that 1:18–32 must depict humanity generally; for if all people have been condemned there, the sin of those from among them who judge can follow as a logical conclusion."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.129.9",
      "id": "FN.129.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" But Paul’s assertion that those who judge others do “the very same things” shows that he is distinguishing between those he described at the end of chap. 1 and those he now condemns. Others, then, argue that the word Paul uses at the beginning of this chapter has no inferential force here,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.129.10",
      "id": "FN.129.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" or that it states the conclusion of an argument that follows in vv. 1b–2,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.129.11",
      "id": "FN.129.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" or even that v. 1 should be removed from the text as a later gloss."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.129.12",
      "id": "FN.129.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" But none of these suggestions can muster convincing lexical or textual support. There is more to be said for the possibility that the word connects 2:1ff. with 1:32."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.129.13",
      "id": "FN.129.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" But the change of subject between 1:32 and 2:1 renders this connection logically questionable.")]), _vm._v(" "), _c('p', [_vm._v("The best solution is to understand the “therefore” to relate, not to the description of (mainly) Gentile sin in 1:21–32, but to the announcement of God’s wrath and the reality of the knowledge of God in 1:18–19. For 1:18–19, which functions as a kind of heading for all of 1:18–3:20, includes reference to all humanity. On this reading, Paul would be saying in 2:1 that "), _c('i', [_vm._v("because")]), _vm._v(" God’s wrath is revealed against "), _c('i', [_vm._v("all")]), _vm._v(" people, and "), _c('i', [_vm._v("because all")]), _vm._v(" people have been given knowledge of God, "), _c('i', [_vm._v("therefore")]), _vm._v(" even the person who judges is “without "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.130"
    }
  }), _vm._v("excuse” before God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.14",
      "id": "FN.130.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Although it might be objected that connecting 2:1 with 1:18–19 skips over too much intervening material, it can be said in response that 1:18–19 establishes what is Paul’s main point in 1:18–32, so that the “therefore” in 2:1 resumes the main sequence of Paul’s argument.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s accusation that the person who judges another is “without excuse” gives further support for this conclusion. In 1:20, Paul directed this accusation against those who spurned the knowledge of God available in nature. Paul now brings the same accusation against those who reveal by their act of judging that they also have access to the knowledge of God. The person whom Paul so accuses, addressed with the second person singular in diatribe style, is “O person,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.15",
      "id": "FN.130.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" each one of you who is judging.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.16",
      "id": "FN.130.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Paul invites anyone who might judge another to include himself or herself in the scope of his accusation. But he particularly wants Jews to realize that they cannot be excused from this category. It is "), _c('i', [_vm._v("anyone—")]), _vm._v("including the Jew—who “condemns”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.17",
      "id": "FN.130.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" another that is “without excuse.”")]), _vm._v(" "), _c('p', [_vm._v("In the second part of the verse, Paul tells why"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.18",
      "id": "FN.130.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿18")]), _vm._v(" one who judges is without excuse before God: in the very act"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.19",
      "id": "FN.130.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿19")]), _vm._v(" of judging another, a person is “condemning” himself because he does the same things as the other. It is not clear what Paul means in accusing the judgmental person of doing “the very same things” as “the other.” If “the other” is to be identified with the Gentile of 1:21–32, as seems clear, how can it be said that highly moral people like the Jews are doing “the very same things”? Barrett suggests that this takes place in the act of judging itself, for to judge another is to seize God’s prerogative and thus to be guilty of idolatry (cf. 1:23, 25). But this interpretation does not adequately explain the plural “these things.” Minear suggests that failing to glorify and thank God and making a false claim to wisdom, which he views as the key sins in 1:18–32, are intended by Paul."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.130.20",
      "id": "FN.130.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Another possibility is that Paul thinks in terms of sins “according to their essential "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.131"
    }
  }), _vm._v("moral categories,” perhaps in dependence on Jesus’ manner of interpreting the commandments (Matt. 5:21–48)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.21",
      "id": "FN.131.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" In this sense, the Jews’ reverence for their traditions is not essentially different from the idolatry of the Gentiles, nor is the lust in the hearts of Jews any less culpable than the perverse sexual practices of the Gentiles. There is some truth to this observation; but the similarity of “you are doing the very same things” and “those who are doing these things” in 1:32 suggests that we should look to 1:29–31 rather than to 1:20–28 for the sins Paul has in mind here in 2:1."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.22",
      "id": "FN.131.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" Many of these sins—for example, pride, arrogance, gossiping, maligning others, and lack of affection—are as prevalent in the Jewish as in the Gentile world. In fact, Paul will accuse the Jews of some of these same sins in vv. 17–24.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" Having accused the self-righteous person of doing the same things as the “wicked” Gentiles, Paul now affirms"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.23",
      "id": "FN.131.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" as a general principle the fact and fairness of God’s judgment of such practices: “Now"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.24",
      "id": "FN.131.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" we know that the judgment"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.25",
      "id": "FN.131.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿25")]), _vm._v(" of God upon those who do such things is according to truth.” In claiming that God’s judgment is “according to truth,” Paul is affirming that God’s judgment against sin is fully in accord with the facts, that it is just."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.26",
      "id": "FN.131.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" This tenet was one on which both Paul and his dialogue partner could agree, it being a standard Jewish teaching."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.131.27",
      "id": "FN.131.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" Where the disagreement between Paul and the Jew comes is in Paul’s application of the principle to the Jews on the same basis as to the Gentiles. In other words, the Jews would want to include as part of the “truth” on the basis of which God judges the special relationship that they enjoy with God. Paul does not deny this relationship (cf. 3:1–8), but claims that it does not shield the Jews from the consequences of their sins (cf. the generally parallel vv. 6, 11, 13, and 16).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3")]), _vm._v(" Having established common ground with his discussion partner (cf. “we know” in v. 2), Paul now uses the doctrine of God’s “truthfulness” in judging to criticize the person who proudly stands in judgment over others (v. 1). And since he is moving again to the attack, Paul shifts back to the second person "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.132"
    }
  }), _vm._v("singular form of address: “Or do you"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.28",
      "id": "FN.132.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿28")]), _vm._v(" reckon this, O person who is judging those doing such things and doing the same things, that you will escape the judgment of God?” The sense of the verse shows that Paul is questioning this person’s belief that he or she will be able to escape this judgment of God. Such a question is legitimately put to the Gentile moralist or philosopher who thinks he or she can please God by his or her good life, but it is particularly the Jew who would be likely to make such an assumption. This is just the attitude revealed in the intertestamental Jewish writing "), _c('i', [_vm._v("The Psalms of Solomon,")]), _vm._v(" where the author asserts that “those who do lawlessness will not escape the judgment of the Lord”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.29",
      "id": "FN.132.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" (15:8) but then goes on to exempt the “righteous” from that same judgment. What Paul is calling into question is precisely whether anyone can claim that exemption, at least as traditionally defined in terms of the Mosaic covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.30",
      "id": "FN.132.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', [_vm._v("The logic of the first three verses of the chapter may then be set forth as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("God’s judgment falls on those who do “these things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Even the self-righteous judge does “these things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Therefore: even the self-righteous judge stands under God’s judgment.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("4")]), _vm._v(" The “or”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.31",
      "id": "FN.132.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" at the beginning of this verse does not set forth an alternative to v. 3 but introduces a rhetorical question that brings to light the false assumptions of the person who is addressed in v. 3."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.32",
      "id": "FN.132.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" Paul wants to show the person who thinks she can sin and yet avoid judgment that she is, in fact, “showing contempt for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.33",
      "id": "FN.132.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" God’s mercy. Three terms, all dependent on “riches,” describe this mercy of God. “Goodness”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.34",
      "id": "FN.132.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" is attributed to God by Paul in Rom. 11:11a and c (where its opposite is “severity”) and in Eph. 2:7; Tit. 3:4. It is used several times in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of the Psalms to designate God’s goodness toward his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.35",
      "id": "FN.132.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" “Forbearance”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.36",
      "id": "FN.132.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" and “patience”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.132.37",
      "id": "FN.132.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" denote the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.133"
    }
  }), _vm._v("expression of God’s goodness in his patient withholding of the judgment that is rightfully due the sinner."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.133.38",
      "id": "FN.133.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', [_vm._v("As we have noted, several of the words Paul uses in v. 4"), _c('i', [_vm._v("a")]), _vm._v(" are found in OT and Jewish descriptions of God’s goodness and mercy toward Israel. But the text that stands out as particularly significant, in the light of parallels between Wis. 11–15 and 1:18–32, is Wis. 15:1–2. After a long exposé of Gentile idolatry and sin (chaps. 11–14), the author says in these verses: “But thou, our God, art kind"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.133.39",
      "id": "FN.133.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿39")]), _vm._v(" and true, patient,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.133.40",
      "id": "FN.133.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" and ruling all things in mercy. For even if we sin we are thine, knowing thy power.” That Paul has this text in mind is probable; but even if he does not, it is the attitude expressed in the passage, and by no means confined to Wisdom of Solomon, that Paul rebukes in these verses. Certainly the OT encourages God’s people to regard God as merciful and forgiving (e.g., Ps. 145). But the assumption of God’s special favor toward his people had already in the OT period become a source of false security for those within Israel who were not living faithfully within the covenant, as the preaching of the prophets abundantly indicates. The literature of intertestamental Judaism, while consistently stressing the need for Jews to repent of sin, also tended to highlight Israel’s favored position to the extent that its security in God’s judgment was virtually unassailable."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.133.41",
      "id": "FN.133.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" It is this assumption that Paul, in agreement with the prophets, calls into question. As the passage unfolds, however, we will find Paul going beyond the prophets in asserting that Jews are no better off than Gentiles in the judgment. This is a radical departure from all Jewish tradition and implies not only a critique of the prevailing understanding of God’s covenant with Israel but also that a new era in salvation history had dawned.")]), _vm._v(" "), _c('p', [_vm._v("The participial clause in the last part of the verse—“being ignorant that the goodness of God is leading"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.133.42",
      "id": "FN.133.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿42")]), _vm._v(" you to repentance”—shows that God’s purpose in his kindness is not to excuse sin but to stimulate repentance. This notion, too, has parallels in Jewish teaching (cf. Wis. 11:23), and Paul criticizes his rhetorical partner for willfully ignoring this truth. Repentance plays a "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.134"
    }
  }), _vm._v("surprisingly small part in Paul’s teaching, considering its importance in contemporary Judaism. Probably this is because the coming of Christ had revealed to Paul that acceptance with God requires a stronger action than the word “repentance” often connoted at the time.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" God’s patience with sin must not be taken as a sign that he is weak"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.43",
      "id": "FN.134.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿43")]), _vm._v(" or that he will withhold his judgment forever. In this verse, Paul warns his complacent addressee that a time of judgment is indeed coming, and that instead of mercy, it is wrath that the person who presumes on God’s kindness is accumulating in advance of that judgment. It serves, then, as a solemn confirmation of the answer implied by the rhetorical question in v. 3. Such a person will certainly not “escape the judgment of God.” Specifically, Paul claims that “because of"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.44",
      "id": "FN.134.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿44")]), _vm._v(" your hard"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.45",
      "id": "FN.134.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿45")]), _vm._v(" and unrepentant heart you are storing up for yourself"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.46",
      "id": "FN.134.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿46")]), _vm._v(" wrath.” The metaphorical application of “store up” was well established."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.47",
      "id": "FN.134.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" But since what is “stored up” is almost always something good, the verb possesses an ironical flavor here: the recalcitrant sinner is storing up for himself not blessing or life"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.48",
      "id": "FN.134.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿48")]), _vm._v(" but wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.49",
      "id": "FN.134.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', [_vm._v("When will this situation become evident? Noting that Paul speaks in this context (1:18) of a present infliction of the wrath of God, some commentators think that the last phrase in the verse, “on the day of wrath and the revelation of the righteous judgment of God,” modifies “storing up.” In this case, Paul would be qualifying the current period of salvation history as the “day of wrath.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.50",
      "id": "FN.134.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" But “day of wrath” is quasi-technical biblical language for the time of final judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.134.51",
      "id": "FN.134.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" This strongly suggests that Paul is looking here at the climactic outpouring of wrath at the end of history; and the Jew who "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.135"
    }
  }), _vm._v("refuses to repent is even now accumulating the wrath that on that day will be revealed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.135.52",
      "id": "FN.135.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" Also to be revealed on that day, claims Paul, is “the righteous judgment of God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.135.53",
      "id": "FN.135.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" This word also continues a central theme of this section of Romans: the reality of God’s judgment and the fact that this judgment will be absolutely just (cf. v. 2). Paul thus calls into question the Jewish tendency to confine God’s “righteous judgment” to Gentile sinners."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.135.54",
      "id": "FN.135.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY3.1.2.1.2"
    }
  }, [_vm._v("ii. The Impartiality of Judgment (2:6–11)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("For he will render to each person according to that person’s works. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("On the one hand, to those who by their persistence in a good work are seeking glory and honor and immortality [he will render] eternal life; "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("but, on the other hand, for those who are characterized by selfishness and who disobey the truth while obeying unrighteousness, there will be wrath and fury. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("There will be tribulation and distress for every soul of a person who does evil, for the Jew first and then for the Greek; "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("but there will be glory and honor and peace for everyone who does good, for the Jew first and then for the Greek. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("For there is no partiality with God.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("These verses form a self-contained thought unit, as their chiastic arrangement demonstrates:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A. God will judge everyone equitably")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl1"
  }, [_vm._v("B. Those who do good will attain eternal life")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 7")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl2"
  }, [_vm._v("C. Those who do evil will suffer wrath")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 8")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl2"
  }, [_vm._v("C′. Wrath for those who do evil")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 9")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl1"
  }, [_vm._v("B′. Glory for those who do good")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 10")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A′. God judges impartially")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 11"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.135.1",
      "id": "FN.135.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.136"
    }
  }), _vm._v("Unlike some chiastically structured paragraphs, the main point of vv. 6–11 occurs not at the center but at the beginning and the end (vv. 6, 11): God will judge every person impartially, assessing each according to the same standard—works. The paragraph therefore elaborates “the righteous judgment of God” in v. 5b. The verses that are sandwiched between the main assertions in vv. 6 and 11 illustrate the two possible outcomes of this judgment. In applying “the Jew first, then the Greek” sequence of salvation (1:16) to judgment (vv. 9, 10), Paul brings into the light the Jew as the hidden target of his polemic. On the other hand, the style of direct address is dropped—to be resumed in 2:17—in favor of a more dispassionate expositional style.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" Paul signals that he is continuing the general discussion of vv. 1–5 by connecting this verse grammatically with v. 5."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.136.2",
      "id": "FN.136.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" Paul’s assertion that God “will render” or “recompense” every person according to what that person has done"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.136.3",
      "id": "FN.136.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" reflects common OT and Jewish teaching."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.136.4",
      "id": "FN.136.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" And this teaching, though set in a new context as a result of the revelation of God’s grace in Christ, is not retracted (cf. Matt. 16:27; 2 Cor. 11:15; 2 Tim. 4:14).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("7–8")]), _vm._v(" Verses 7 and 8 outline the two possible outcomes of God’s rendering to “each” according to works."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.136.5",
      "id": "FN.136.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" On the one hand, to “those who by their persistence in a good work are seeking"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.136.6",
      "id": "FN.136.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿6")]), _vm._v(" glory and honor and immortality”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.136.7",
      "id": "FN.136.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.137"
    }
  }), _vm._v("he will “render”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.137.8",
      "id": "FN.137.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" eternal life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.137.9",
      "id": "FN.137.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" Paul’s suggestion that a person’s “good work” might lead to eternal life seems strange in light of his teaching elsewhere; and we will deal with this question below in conjunction with v. 10. It might be noted, however, that Paul goes out of his way to stress that the work that God so rewards is a persistent lifestyle of godliness."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.137.10",
      "id": "FN.137.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" In contrast to these people are “those who are characterized by selfishness, and who disobey the truth while obeying"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.137.11",
      "id": "FN.137.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" unrighteousness, there will be wrath and fury.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.137.12",
      "id": "FN.137.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" As the contrast in these verses makes clear, there are two, and only two, fates in store for “every person” at the time of God’s “righteous judgment.” Those who do not receive eternal life receive the punishment of God’s wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.137.13",
      "id": "FN.137.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Paul describes these latter people from the standpoint of their basic "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.138"
    }
  }), _vm._v("motivating principle—selfishness"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.138.14",
      "id": "FN.138.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿14")]), _vm._v("—and from the standpoint of their allegiance: they give themselves in obedience to unrighteousness rather than to the truth. Paul here describes opposite sides of the same coin. These people are refusing to subject themselves to the truth as God has revealed it and prefer rather to give themselves over to “unrighteousness” (cf. 1:18). As often in Romans, Paul singles out obedience as indicative of one’s true spiritual state (cf. 1:5; 2:25–27; 6:15–23).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9–10")]), _vm._v(" Paul now reiterates these two contrasting outcomes of judgment, taking them in reverse order."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.138.15",
      "id": "FN.138.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" And within this larger chiasm (vv. 7–8/9–10), we have a smaller chiasm linking vv. 8–9:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 8")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“there will be for those …")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("wrath and fury”")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("v. 9")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“tribulation and distress")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("for those who …”")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Paul generally uses “tribulation” of the trials and suffering experienced by Christians in this life,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.138.16",
      "id": "FN.138.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" but here it clearly designates the suffering of eschatological "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.139"
    }
  }), _vm._v("condemnation (cf. 2 Thess. 1:6). “Distress,” though close in meaning to “tribulation,” may focus on the (subjective) suffering caused by the (objective) tribulation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.139.17",
      "id": "FN.139.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" As eternal life was the reward for those who persisted in “good work” (v. 7), so this distress of divine judgment will"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.139.18",
      "id": "FN.139.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿18")]), _vm._v(" come “upon every soul of a person who does"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.139.19",
      "id": "FN.139.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿19")]), _vm._v(" evil.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.139.20",
      "id": "FN.139.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" In using the phrase “every soul of a person,” Paul apparently wants to emphasize again the utter impartiality of God’s judgment. And, once again, this point is directed particularly to the Jew, as the last phrase of the verse—“for the Jew first and then for the Greek”—indicates. In an ironic twist, Paul uses the same phrase that maintained the priority of the Jew as the recipient of the good news of salvation (1:16) to assert the same priority in judgment. As the word of the promise has gone “first” to the Jew, so does punishment for failure to respond to that word go “first” to the Jew. In contrast to the Jews’ tendency to regard their election as a guarantee that they would be “first” in salvation and “last” in judgment, Paul insists that their priority be applied equally to both.")]), _vm._v(" "), _c('p', [_vm._v("Verse 10 repeats the substance of v. 7, with only minor changes. “Glory and honor,” which in v. 7 denoted the goal pursued by the righteous, now denote the blessing of God’s salvation. And Paul adds a further term to describe this blessing, “peace,” the state of perfect well-being created by God’s eschatological intervention and enjoyed by the righteous."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.139.21",
      "id": "FN.139.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" And, more simply than in v. 7, Paul describes those who inherit these blessings as “everyone who does"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.139.22",
      "id": "FN.139.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" good.” But he also continues the theme of v. 9 with his addition of the phrase “for the Jew first and then for the Greek.”")]), _vm._v(" "), _c('p', [_vm._v("We now must ask who it is that Paul has in mind in vv. 7 and 10, where he promises salvation to those who engage in persistent “doing good.” The question is an important one because these promises would seem at first sight to conflict with Paul’s insistence elsewhere that “no one will be justified by works of the law” (cf. 3:20). Answers to this question can be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.140"
    }
  }), _vm._v("divided into three categories, according to the identification of those who are doing good.")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_vm._v("(1) Quite popular in the patristic period was the identification of these people with "), _c('i', [_vm._v("faithful Jews and “moral” Gentiles")]), _vm._v(" before the coming of Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.140.23",
      "id": "FN.140.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("(2) The majority of commentators have argued that Paul refers to "), _c('i', [_vm._v("any non-Christian.")]), _vm._v(" But within this interpretation, five approaches, differing in vital respects, are to be distinguished.")]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_vm._v("(a) Some think that Paul sets out as a possibility the salvation of some people through their works apart from faith in Christ and that this principle stands in irreconcilable tension with his teaching of justification by faith alone."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.140.24",
      "id": "FN.140.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_vm._v("(b) Others argue, similarly, that God rewards with eternal life those who respond obediently to “the light they have received” and that as long as the works are regarded as produced with the aid of God’s grace no contradiction with Paul’s teaching elsewhere is created."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.140.25",
      "id": "FN.140.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_vm._v("(c) Another variation holds that those who earnestly seek eternal peace are granted the faith that brings justification and that this faith—the missing “middle term” in Paul’s argument—is what brings eternal life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.140.26",
      "id": "FN.140.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_vm._v("(d) A few have viewed the principle as purely hypothetical, a statement of the way things would be if Christ had not come and the law could be fulfilled."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.140.27",
      "id": "FN.140.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_vm._v("(e) Finally, others argue that the promise of eternal life for those who do good is fully valid, but that the power of sin prevents anyone from doing that good to the degree necessary to merit salvation. Verses 7 and 10 set out the condition, apart from Christ, for "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.141"
    }
  }), _vm._v("salvation; Paul’s subsequent argument shows that no one is able to fulfill those conditions."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.141.28",
      "id": "FN.141.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("(3) Growing in popularity is the view that Paul is thinking in these verses specifically of "), _c('i', [_vm._v("Christians.")]), _vm._v(" They, and only they, are those who, through union with Christ, are able to produce works acceptable to God in the judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.141.29",
      "id": "FN.141.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', [_vm._v("We think that the choice lies between the last two of these alternatives. That Paul is considering only people before the coming of Christ (view 1) or that he considers them completely apart from the coming of Christ (view 2d) is unlikely because the revelation of God’s wrath of which Paul is speaking is addressed clearly to Jews and Greeks in Paul’s own day. Furthermore, the principle that all people, even Christians, will, in some sense, be judged by works is clearly taught in the NT and cannot be dismissed as a “pre-Christian” viewpoint. To adopt a view that creates a contradiction in Paul’s teaching (view 2a) is a last resort and one that is unnecessary in the present instance. If they are to harmonize Paul, those who claim that Paul teaches a salvation based on obedience to the light each person has received (view 2b) must argue that Paul does not exclude "), _c('i', [_vm._v("all")]), _vm._v(" works from having the power to justify, but only “works of the law,” understood in some sort of restricted sense (cf. 3:20, 28), and that Paul does not regard everyone who has not been justified by faith as condemned. But these positions cannot be maintained. Paul’s denial that “works of the law” can justify is meant to exclude all “works,” "), _c('i', [_vm._v("anything")]), _vm._v(" that a person does, as a basis for salvation (see our comments on 3:20). And the verdicts of 3:19 (“the whole world is held accountable to God”) and 3:23 (“"), _c('i', [_vm._v("all")]), _vm._v(" have sinned and fallen short of God’s glory”), in relationship to 3:21–22, 24–26, show that only by receiving God’s righteousness through faith can a person be saved. The suggestion that we should supply justifying faith as the middle term in the promise of vv. 7 and 10 (view 2c) overcomes this objection "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.142"
    }
  }), _vm._v("but implies more than the context allows. It suggests a relationship between human effort and God’s grace that is at least questionably Pauline (cf. 4:1–8; 9:10–13).")]), _vm._v(" "), _c('p', [_vm._v("Whether we regard these verses as describing Christians (view 3), or view them as setting forth the unrealizable condition for salvation apart from Christ (view 2e), consistency in Paul’s teaching is maintained. For Paul teaches, in agreement with the OT and Judaism, that judgment will be based on works, for Christians as well as for non-Christians (cf. 2 Cor. 5:10 and the Excursus: The Law, Justification, and Judgment in Paul). Moreover, he upholds faithful obedience to God, or the law as a "), _c('i', [_vm._v("theoretical")]), _vm._v(" means of attaining justification (cf. 2:13; 7:10). But the context strongly suggests that Paul is not directly describing Christians in vv. 7 and 10. Paul’s purpose in 2:6–11 is to establish the principle that God will judge every person on the same basis—by works, not by religious heritage or national identity. Paul’s focus is on the standard of judgment.")]), _vm._v(" "), _c('p', [_vm._v("It is a continual seeking after eternal rewards, accompanied by a persistent doing of what is good, that is the condition for a positive verdict at the judgment. Paul never denies the validity of this principle, but he goes on to show that no one meets the conditions necessary for this principle to become a reality. This is the conclusion to which Paul is driving throughout this part of Romans (cf. 3:9, 19–20). It is true, of course, that a person in Christ does meet these conditions as the fruit of faith comes to expression in his life; and, while the principle in its context has the function of condemning all apart from Christ, Paul will show subsequently in Romans that it is, in fact, Christians who fulfill these conditions."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.142.30",
      "id": "FN.142.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" This may be right, but there is reason to be hesitant; the works of the Christian that are valid in the judgment are the “fruit” of union with Christ and manifestations of God’s grace. But the stress in v. 6 on man’s works as "), _c('i', [_vm._v("the")]), _vm._v(" criterion in the determination of a person’s salvation or condemnation makes it difficult to fit grace into the situation at all (see the final paragraph in this section).")]), _vm._v(" "), _c('p', [_vm._v("We think, therefore, that vv. 7 and 10 set forth what is called in traditional theological (especially Lutheran) language “the law.” Paul sets forth the biblical conditions for attaining eternal life apart from Christ. Understood this way, Paul is not speaking hypothetically. But once his doctrine of universal human powerlessness under sin has been developed (cf. 3:9 especially), it becomes clear that the promise can, in fact, never become operative because the condition for its fulfillment—consistent, earnest seeking after good—can never be realized.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11")]), _vm._v(" With this verse, Paul returns to the main theme of the paragraph. The principle that God treats all people equally in the judgment has been "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.143"
    }
  }), _vm._v("made positively, with respect to the criterion of judgment, in v. 6. Now Paul makes the same point negatively, by claiming that “there is no partiality"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.143.31",
      "id": "FN.143.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" with God.”")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("This paragraph raises the question about the relationship between justification and judgment—an intricate theological topic. On the one hand, it is vital that the finality and determinacy of justification not be mitigated"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.143.32",
      "id": "FN.143.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" and that salvation, from first to last, be ascribed to God’s grace."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.143.33",
      "id": "FN.143.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" Paul believed that justification, in this life, was perfectly sufficient for deliverance from wrath at the judgment (cf. 5:9–10; 8:28–39). On the other hand, we cannot ignore the serious warnings addressed "), _c('i', [_vm._v("to Christians")]), _vm._v(" about the importance that their works will have at the final judgment (cf. 1 Cor. 3:10–14; 2 Cor. 5:10; Jas. 2:14–26; cf. Matt. 12:37; 25:31–46). Some seek to reconcile these by attributing different purposes to the initial “judgment” of justification and the final judgment,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.143.34",
      "id": "FN.143.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" others by attributing the two strands of teaching to different audiences or different purposes;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.143.35",
      "id": "FN.143.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" but none of these is completely convincing. Without becoming involved in the intricacies of theological nuance (and they are important here), we would follow those who maintain that the justification by faith granted the believer in this life is the sufficient cause of those works that God takes into account at the time of the judgment. The initial declaration of the believer’s acquittal before the bar of heaven at the time of one’s justification is infallibly confirmed by the judgment according to works at the last assize.")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY3.1.2.1.3"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.144"
    }
  }), _vm._v("iii. Judgment and the Law (2:12–16)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("For as many as sin without the law will also perish without the law. And as many as sin in the law will be judged through the law. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("For it is not the hearers of the law who are just before God, but it is the doers of the law who will be justified. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("For whenever the Gentiles who do not have the law do by nature the things of the law, they are a law to themselves, even though they do not have the law. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("They show that the work of the law is written on their hearts, their conscience bearing witness and their thoughts among themselves both accusing and excusing them; "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("on that day when God, through Christ Jesus,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.144.1",
      "id": "FN.144.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" will judge the secret things of people, according to my gospel.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Some interpreters think that this paragraph belongs with what follows, 2:17–29, rather than with what precedes, 2:1–11. They note that Paul first introduces in this paragraph the topic of the law and that this topic continues to be important in the subsequent verses. Furthermore, Paul’s purpose in vv. 12–16 appears to be similar to his concern in 2:25–29: to deny that the Jews can find refuge from God’s judgment simply by virtue of possessing covenant “markers”—whether it be the law or circumcision."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.144.2",
      "id": "FN.144.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" These points have some force, but the connections with 2:1–11 are also very close. For Paul is continuing in vv. 12–16 to treat the standard of God’s judgment and to defend its impartial application to both Jew and Gentile. Verse 16, indeed, with its reference to the last judgment, forms an inclusio with the focus on judgment in vv. 1–5. While recognizing that the paragraph has connections in both directions, therefore, we prefer to attach it to 2:1–11."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.144.3",
      "id": "FN.144.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")])]), _vm._v(" "), _c('p', [_vm._v("The “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.144.4",
      "id": "FN.144.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" that introduces this paragraph connects it specifically with the principle of God’s impartial judgment stated in v. 11. In these verses Paul defends the equality of all people before God’s judgment seat against the charge that the Jews’ possession of the law gives to them a decisive "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.145"
    }
  }), _vm._v("advantage."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.145.5",
      "id": "FN.145.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" This is not the case, Paul argues, because (1) it is doing, not hearing or possessing, the law that matters (v. 13); and (2) even the Gentiles, who do not have God’s law in written form, are not without “law” (vv. 14–15). The law, then, gives to the Jews no true advantage when it comes to salvation.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("12")]), _vm._v(" The division of the world into those who sin “without the law” and those who sin “in the law”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.145.6",
      "id": "FN.145.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" corresponds to the distinction between Jews and Gentiles (cf. vv. 10, 14). This means that the “law” in question is the law of Moses, the body of commandments given by God through Moses to the people of Israel at Mt. Sinai. Modern scholars often use the transliterated Hebrew word “torah” to denote this law, in an effort to make clear the distinctly Jewish, salvation-historical nature of the law that Paul is talking about. While we will maintain the more traditional term “law” it will be important to keep in mind that, for Paul the converted Jew, “law” refers, unless other qualifications are present, to this specific, historical, body of commandments that functioned, more than anything else, to give Israel its particular identity as a “people apart.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.145.7",
      "id": "FN.145.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Therefore, Paul is not here accusing "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.146"
    }
  }), _vm._v("the Gentiles of being “lawless” (that is, notorious criminals or outlaws)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.8",
      "id": "FN.146.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" but of being “law-less”—by definition, as Gentiles, they do not possess the law of Moses. They are “alienated from the commonwealth of Israel, strangers to the covenants of promise” (Eph. 2:12)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.9",
      "id": "FN.146.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" In contrast, then, Jews live “in the sphere of,” within the boundaries defined by, the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.10",
      "id": "FN.146.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" From the Jewish point of view, of course, this difference in possession of God’s law is absolutely basic. The Gentile, so most Jews maintained, could experience God’s favor only by taking on “the yoke of the law.” Outside Israel, the sphere of the law, there is no salvation. The Jews who live within the domain of law, on the other hand, often considered themselves virtually assured of salvation.")]), _vm._v(" "), _c('p', [_vm._v("Paul relativizes this difference between Jew and Gentile by arguing, in two parallel sentences, that “as many as"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.11",
      "id": "FN.146.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" sin"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.12",
      "id": "FN.146.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿12")]), _vm._v(" without the law will also perish"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.13",
      "id": "FN.146.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" without the law” and “as many as sin in the law will be judged through the law.” The parallelism between the sentences and the contrast with “justify” in v. 13 show that “will be judged” in the second sentence must denote the negative verdict of condemnation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.146.14",
      "id": "FN.146.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Verse 23 of chap. 3—“all have sinned”—shows "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.147"
    }
  }), _vm._v("that Paul would exempt no one from the verdict he here imposes. It is clear from these verses that Paul argues for universal human sinfulness, and a sinfulness of such a nature that condemnation must be the outcome.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("13")]), _vm._v(" Paul explains why"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.15",
      "id": "FN.147.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿15")]), _vm._v(" even those who possess the law will nevertheless be condemned when they sin. It is because the law can justify only when it is obeyed; reading it, hearing it taught and preached, studying it—none of these, nor all of them together, can justify. This is the first time in Romans that Paul uses the verb “justify.” As scholars now generally agree, it connotes the judicial decision of God to regard a sinner as “just” or “right” or “innocent” before him."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.16",
      "id": "FN.147.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" God’s abhorrence of any hearing of the law without doing it is a very customary Jewish teaching: for example, “Not the expounding [of the law] is the chief thing, but the doing [of it].”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.17",
      "id": "FN.147.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" The NT embraces the principle as well (cf. Matt. 7:24–27; 12:50; Jas. 1:22–25). Whereas the principle in these examples has a hortatory purpose—to encourage obedience to the law or to the Word of God—Paul uses the principle to remind Jews of the standard of God’s judgment. Only those who are “"), _c('i', [_vm._v("doers")]), _vm._v(" of the law” will be declared right in the judgment.")]), _vm._v(" "), _c('p', [_vm._v("The question arises here again (as in vv. 7 and 10): Who are those whom Paul views as vindicated in the judgment by their doing of the law? Again, many interpreters think that Paul refers implicitly to Christians in whom, Paul says later in Romans, “the just decree of the law is fulfilled” (8:4)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.18",
      "id": "FN.147.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" The “doing of the law” spoken of here would then have to designate a faith-oriented obedience to God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.19",
      "id": "FN.147.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" But, as we argued in our comments on v. 10, it would be surprising for Paul to connect vindication in the judgment so closely to the doing of the law. “Doers of the law” are no more and no less than those who “do the works of the law”; and “works of the law,” Paul claims, cannot justify (cf. 3:20, 28). To be sure, there is NT precedent for applying the term “justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaioō)")]), _vm._v(" to vindication at the final judgment;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.20",
      "id": "FN.147.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" and Paul might then be thinking here not of the entry into salvation but of the ultimate vindication at the last judgment. However, Paul does not generally use “justify” in this restricted sense;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.147.21",
      "id": "FN.147.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" and the context here suggests that he "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.148"
    }
  }), _vm._v("uses it in his customary manner to denote the decisive salvific event in its broadest sense. As in vv. 7 and 10, therefore, we think it more likely that Paul is here simply setting forth the standard by which God’s justifying verdict will be rendered."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.148.22",
      "id": "FN.148.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" This verse confirms and explains the reason for the Jews’ condemnation in v. 12b; and this suggests that its purpose is not to show how people can be justified but to set forth the standard that must be met if a person is to be justified. As he does throughout this chapter, Paul presses typical Jewish teaching into the service of his “preparation for the gospel.” Jews believed that “doing” the law, or perhaps the intent to do the law, would lead, for the Jew already in covenant relationship with God, to final salvation. Paul affirms the principle that doing the law can lead to salvation; but he denies (1) that anyone can so “do” the law;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.148.23",
      "id": "FN.148.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" and (2) that Jews can depend on their covenant relationship to shield them from the consequences of this failure.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("14")]), _vm._v(" Verses 14–15 are a self-contained unit, linked to the preceding verses with a “for.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.148.24",
      "id": "FN.148.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" The nature of this connection depends on the identity of the “Gentiles” who are the subjects of these verses. From earliest times, three basic alternatives have been proposed:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.148.25",
      "id": "FN.148.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" (1) Gentiles who fulfill the law and are saved apart from explicit faith in Christ;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.148.26",
      "id": "FN.148.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" (2) Gentiles who do some part of the law but who are not saved;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.148.27",
      "id": "FN.148.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" (3) Gentile Christians who fulfill the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.149"
    }
  }), _vm._v("law by virtue of their relationship to Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.149.28",
      "id": "FN.149.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" As in the related vv. 7, 10, and 13, we think the second alternative is best. Our reasons for this conclusion will emerge as we analyze the details of the verses.")]), _vm._v(" "), _c('p', [_vm._v("Those who think that the Gentiles to whom Paul alludes are Christians generally connect vv. 14–15 with v. 13: Paul now explains that Gentiles, like Jews, can be “doers of the law” and hence justified."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.149.29",
      "id": "FN.149.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" If, as we think, the Gentiles are unbelievers, these verses are best taken as an explanation and qualification of the phrase “without the law” that Paul has used in v. 12a. Gentiles are, indeed, “without the law” when one is thinking from the typical Jewish perspective of the law as the law of Moses. But to say that non-Christian Gentiles are “without "), _c('i', [_vm._v("the")]), _vm._v(" law” is one thing; to say they are “without law” is another. For Gentiles certainly have some knowledge of God’s moral demands—“law” in the generic sense. And when God condemns them, he does not do so without their having any understanding of his demands upon them."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.149.30",
      "id": "FN.149.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" On this view, Paul is speaking not of all Gentiles nor of only a very small number of Gentiles, but, generically, of Gentiles "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qua")]), _vm._v(" Gentiles. And some of these Gentiles, Paul alleges, “do by nature the things of the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.149.31",
      "id": "FN.149.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" Some commentators think that “by nature” modifies “Gentiles who do not have the law” and so think that Paul is distinguishing between Gentiles before and after Christ. Before Christ, Gentiles, “by reason of their birth,” do not have the law; but after conversion, through the ministry of the Holy Spirit, they "), _c('i', [_vm._v("do")]), _vm._v(" have the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.149.32",
      "id": "FN.149.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" But taking “by nature” with the verb “do” makes better sense (as do all major English translations)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.149.33",
      "id": "FN.149.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" For "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.150"
    }
  }), _vm._v("Paul is almost certainly pressing into service a widespread Greek tradition to the effect that all human beings possess an “unwritten” or “natural” law—an innate moral sense of “right and wrong.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.150.34",
      "id": "FN.150.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Paul is “baptizing” this popular Greek conception, one that had already been taken over by Hellenistic Jews for the purpose of rendering Gentiles responsible for basic moral standards."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.150.35",
      "id": "FN.150.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" What Paul is then asserting is that certain Gentiles “do the things of the law” through a natural, inborn capacity; cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NJB"
    }
  }, [_vm._v("NJB")]), _vm._v(": “through their own innate sense.” On this view of the text, it is very unlikely that Paul has in view Gentile Christians, for they, of course, do the law not “by nature” but “by grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.150.36",
      "id": "FN.150.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" “The things of the law” is a general way of stating certain of those requirements of the Mosaic law that God has made universally available to human beings in their very constitution."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.150.37",
      "id": "FN.150.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Paul’s point is that Gentiles outside of Christ regularly obey their parents, refrain from murder and robbery, and so on."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.150.38",
      "id": "FN.150.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', [_vm._v("Paul goes on to claim that those who do these things reveal the existence "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.151"
    }
  }), _vm._v("of that law and are “a law to themselves.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.39",
      "id": "FN.151.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" By this, Paul does not mean that these people need nothing to guide them"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.40",
      "id": "FN.151.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿40")]), _vm._v(" but that they attest knowledge of divine moral standards. Here, we think, Paul clearly uses the term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" in an extended sense, to denote the “demand of God” generally."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.41",
      "id": "FN.151.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" These Gentiles, while not possessing "), _c('i', [_vm._v("the")]), _vm._v(" law of Moses, nevertheless have access to knowledge of God’s will for them. By applying to Gentiles a term reserved in this context for Jews (“law”), Paul pursues his policy of putting Jews and Gentiles on the same footing."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.42",
      "id": "FN.151.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" The Jew does not have in the law a decisive advantage when it comes to knowing and doing the will of God, Paul suggests; for Gentiles have some of the same benefits.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("15")]), _vm._v(" Paul continues to speak of those Gentiles who manifest in their behavior an innate awareness of God’s moral demands. In contrast to the often positive use of the “unwritten law” tradition among the Greeks, Paul follows Jewish writers in using the concept negatively: knowledge of God’s moral demands among the Gentiles simply demonstrates their guilt."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.43",
      "id": "FN.151.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" The standpoint of the last judgment in v. 16 is sometimes read into the present tense verb “show,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.44",
      "id": "FN.151.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" so that it, too, refers to a demonstration before the bar of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.45",
      "id": "FN.151.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" But, although the implicit testimony of the works of Gentiles reaches its climax in the judgment, Paul’s focus in this verse is still on the implications of these works in this life. “The work of the law” written on the heart of the Gentiles could refer to love, the basic intention of the law (cf. 13:8–10),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.46",
      "id": "FN.151.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" or to the “effect” that the law produces,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.47",
      "id": "FN.151.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" but it is probably no more than a “collective” variant of “the things of the law” in v. 14: the “work,” the conduct, that the law demands."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.48",
      "id": "FN.151.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', [_vm._v("In saying that this work of the law has been “written on their hearts,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.151.49",
      "id": "FN.151.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Paul might be alluding to the “new covenant” prophecy of Jer. 31:31–34, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.152"
    }
  }), _vm._v("which promises that God will “write his law” on the hearts of his people. Advocates of the view that finds Gentile Christians in these verses naturally use this as support for their interpretation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.152.50",
      "id": "FN.152.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" But Jeremiah speaks about the "), _c('i', [_vm._v("law’s")]), _vm._v(" being written on the heart and the complete knowledge of God that will result from it. Paul, however, makes reference to the “"), _c('i', [_vm._v("work")]), _vm._v(" of the law” being written on the heart and makes clear that this process still leaves the issue of final judgment in doubt (vv. 15b–16)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.152.51",
      "id": "FN.152.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" As Luther puts it, “the knowledge of the work is written, that is, the law that is written in letters concerning the works that have to be done, but not the grace to fulfill this law.”")]), _vm._v(" "), _c('p', [_vm._v("Some of the results of the Gentiles’ knowledge of God’s demand are spelled out in the last part of the verse: “their conscience bearing witness and their thoughts both accusing and excusing them.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.152.52",
      "id": "FN.152.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" The word “conscience” comes from the Greek rather than from the biblical world."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.152.53",
      "id": "FN.152.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" The word had an important technical role in Stoic philosophy, but Paul’s conception does not go beyond the more popular usage."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.152.54",
      "id": "FN.152.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" The conscience could be the source of moral norms (as in our popular use of the term), but it is usually viewed as a reflective mechanism by which people can measure their conformity to a norm."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.152.55",
      "id": "FN.152.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" If, then, the “law” is that norm, the conscience of individual Gentiles reveals within each "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.153"
    }
  }), _vm._v("of them the extent to which that norm is being followed. Paul uses “bear witness”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.153.56",
      "id": "FN.153.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" of this process, and the meaning of “conscience” would imply that this “witness” is first of all to the individuals themselves. In the light of v. 16, however, there may be a secondary reference to a witness before the heavenly judgment seat. The clause “their thoughts among themselves"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.153.57",
      "id": "FN.153.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿57")]), _vm._v(" both accusing and excusing them” might add a second, independent idea to the witness of the conscience,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.153.58",
      "id": "FN.153.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" but it probably expands it: the witness of the conscience consists in the mixed verdict of one’s thoughts."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.153.59",
      "id": "FN.153.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', [_vm._v("This debate among the thoughts goes on constantly, but its ultimate significance will be revealed in the last judgment, as v. 16 shows."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.153.60",
      "id": "FN.153.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" The excusing and accusing testimony of the thoughts within each person’s conscience portends the verdict of the one who will bring every thought to light. Some have seized on the reference to “excusing” as evidence that this final verdict could bring salvation to some Gentiles apart from the gospel. But this misses the connection in which the idea stands. Bengel is on the mark: “The concessive particle, "), _c('i', [_vm._v("even,")]), _vm._v(" shows that the thoughts have far more to accuse, than defend, and the defense itself … does not extend to the whole, but only to a part of the conduct, and this very part in turn proves us to be debtors as to the whole.…”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("16")]), _vm._v(" Some scholars consider the relationship between v. 16 and the preceding context so awkward that they eliminate the verse as a later, post-Pauline addition."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.153.61",
      "id": "FN.153.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Once this unwarranted and textually unsupported expedient "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.154"
    }
  }), _vm._v("is eliminated, several alternatives remain, of which five deserve mention. (1) Verse 16 could depend directly on the verbs in v. 15 if the processes described there are considered to be future."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.62",
      "id": "FN.154.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" But we have seen good reason to attribute these activities to the circumstances of this life. (2) Verse 16 could depend directly on the verbs in v. 15 if v. 16 is taken noneschatologically as a reference to any “time” of judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.63",
      "id": "FN.154.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" But Pauline usage shows that “the day when the secret thoughts are judged” must be the last assize. (3) A popular alternative has been to take v. 16 with v. 13: “doers of the law will be justified … on the day when.…”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.64",
      "id": "FN.154.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" But vv. 14–15 are too important to Paul’s argument to be viewed as a parenthesis, and v. 16 is too far from v. 13 to think that a syntactical relationship exists. (4) Verse 16 could go loosely with the whole paragraph."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.65",
      "id": "FN.154.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" But this sounds too much like a counsel of despair and gives to the opening prepositional phrase an unlikely function. (5) The final possibility, and the one we think is correct, is to take v. 16 with the verbs of v. 15, in the sense that the continual self-criticism of the Gentiles (v. 15) also relates to, and finds its ultimate meaning in, the final judgment (v. 16)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.66",
      "id": "FN.154.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" As Käsemann points out, v. 16 is necessary to Paul’s argument because his purpose, as we saw in v. 12, is to demonstrate the reality of the condemnation under which the Gentiles stand. As degree of conformity to the law is the criterion of judgment for Jews (vv. 12b–13), so the extent to which Gentiles have conformed to the “law” they possess will be the standard by which they are judged. Their conscience and thoughts reveal to them how well they have done, but in the judgment of God even the secret thoughts will be used as evidence.")]), _vm._v(" "), _c('p', [_vm._v("That God’s judgment will take into account not only outward actions but also the “hidden things”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.67",
      "id": "FN.154.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" is a natural inference from his knowledge of the secrets of people’s hearts."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.68",
      "id": "FN.154.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" Jesus reminded his disciples that God’s reward will be based on what is done “in secret.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.154.69",
      "id": "FN.154.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" In the present context, this shows particularly that the inner witness of the conscience and conflicting thoughts (v. 15) are known to God and destined to be revealed on the day of judgment. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.155"
    }
  }), _vm._v("The two prepositional phrases are not clear as to their connections and relationship. Some connect “according to my gospel” to “will judge” and take “through Christ Jesus” with “my gospel”: “God will judge, according to my gospel, which is through Christ Jesus.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.155.70",
      "id": "FN.155.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" Others suggest a similar sequence, only with “according to my gospel” dependent particularly on the fact that God will judge the “secret things.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.155.71",
      "id": "FN.155.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" Finally, it is possible to take “through Christ Jesus” with “will judge,” with “according to my gospel” dependent on the whole statement, and particularly on the reference to the christological element in the judgment: “It is through Christ Jesus that God will judge, as my gospel teaches.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.155.72",
      "id": "FN.155.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" This last alternative does most justice to the somewhat unexpected reference to the gospel. Paul teaches that it is before the “judgment seat of Christ” that we will have to stand (2 Cor. 5:10). When Paul refers to “my gospel,” he does not mean a particular form of teaching peculiar to him, but the gospel, common to all Christians, which has been entrusted by God to Paul for his preservation and proclamation (cf. 1:1)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.155.73",
      "id": "FN.155.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("Paul’s assertion in v. 13 that “the doers of the law will be justified” raises two broad theological issues.")]), _vm._v(" "), _c('p', [_vm._v("First, to what degree and in what sense does Paul regard the law as a means of justification? The view that God gave the law to Israel as a means of justification is now generally discredited, and rightly so. The OT presents the law as a means of regulating the covenant relationship that had already been established through God’s grace. But, granted that the law was not given for the purpose of securing one’s relationship before God, it may still be questioned whether it sets forth in theory a means of justification. We would argue that it does."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.155.74",
      "id": "FN.155.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(" Verses such as Rom. 2:7, 10, 13, and 7:10 suggest that Paul agreed with the Jewish belief that justification could, in theory, be secured through works. Where Paul disagreed with Judaism was in his belief that the power of sin prevents any person, even the Jew who depends on his or her covenant status, from actually achieving justification in that manner."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.155.75",
      "id": "FN.155.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" While, therefore, one could be justified by doing the law in theory, in practice it is impossible (see also the additional note on 3:20). This issue is related in traditional Reformed theology to the debate over the existence and nature of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.156"
    }
  }), _vm._v("the “covenant of works” and the place of the Mosaic law within that covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.156.76",
      "id": "FN.156.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', [_vm._v("Second, how does our suggestion that Paul assumes the impossibility of fulfilling the law square with contemporary Jewish beliefs? Sanders claims that they cannot be reconciled. He argues that Jews in Paul’s day considered it possible, indeed easy, to “do the law.” Perfection was not considered necessary; the "), _c('i', [_vm._v("intention")]), _vm._v(" to obey was what was important, along with repentance and other means of atonement when failures occurred. How, then, could Paul assume that no one can do the law?")]), _vm._v(" "), _c('p', [_vm._v("Sanders’s own answer is to call into question whether Paul indeed teaches that it is impossible to do the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.156.77",
      "id": "FN.156.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" But, contrary to Sanders, Gal. 3:10–13, along with 5:3, seems to imply just this."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.156.78",
      "id": "FN.156.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" It must be said, however, that Paul never makes this clear in Romans. But what he does make clear is that everyone has failed to match up to the standard necessary to secure justification (compare 2:13 with 3:9, 19–20, and see the additional note on 3:20)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.156.79",
      "id": "FN.156.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" Another possible answer is to say that Paul views the law as impossible to do only after the coming of Christ. But Paul’s whole purpose in this part of Romans is to justify the need of “the revelation of the righteousness of God” in Christ (1:17; 3:21). He can hardly establish the need for this revelation by citing the problems people face after it has arrived.")]), _vm._v(" "), _c('p', [_vm._v("The best answer appears to be that Paul takes a more radical viewpoint of what “doing the law” involves. Because he denies any salvific value to the Mosaic law and the covenant of which it is a part, he recognizes that it is not enough—and never has been—to seek to do the law, however sincerely. For, from the first, it has been faith in the promise of God, and only faith, that justifies (cf. chap. 4). This being the case, only a "), _c('i', [_vm._v("perfect")]), _vm._v(" doing of the law would suffice to justify a person before God. True, an insistence on perfect obedience is a departure from the Jewish view. But this is just what Paul has implied by putting Jews and Gentiles on the same footing with respect to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.157"
    }
  }), _vm._v("works and judgment in 2:1–16. What he says here plainly implies that the covenantal structure within which the Jews thought their sins could be taken care of was itself denied by Paul. The enormity of God’s Son being crucified led Paul to take a far more pessimistic view of human sin than was typical of Judaism: sins that, for the Jews, simply needed to be atoned for within the covenant meant for Paul a breaking of the covenantal structure itself.")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY3.1.2.2"
    }
  }, [_vm._v("b. The Limitations of the Covenant (2:17–29)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In this section Paul resumes the diatribe style of 2:1–5, using direct address and a series of rhetorical questions in his polemic. The person he addresses, though easily enough recognized from what Paul has said in 2:1–16, is now for the first time explicitly identified as a Jew. A sharpening of the attack is thereby indicated. This section has similarities to the diatribe in substance as well as in style. For the author of the diatribe would often criticize his “opponent” for not “practicing what he preached.” Just as, then, Epictetus contests the claims of some to be “true Stoics” because they do not live the philosophy they teach, so Paul questions whether one who does not obey the law has any right to claim the title “Jew.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.157.1",
      "id": "FN.157.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("The function of these verses in the argument of chap. 2 is not clear. Murray thinks that this section resumes the indictment of those who sin “in the law” in vv. 12b–13 after the “digression” about the Gentiles and the law in vv. 14–16. Verses 17–29 would, then, demonstrate that Jews cannot claim to be “doers of the law” and that they cannot, therefore, be justified by doing the law. Wilckens, on the other hand, thinks that vv. 17–29 prove the point Paul made in 2:3, that Jews do “the same things” as the Gentiles. While admitting an element of truth in both these suggestions, we prefer to relate vv. 17–29 to the argument of vv. 1–16 more broadly. Paul’s main point in 2:1–16 is that, because Jews will be assessed by God in the judgment on the same basis as Gentiles (works, doing “the law”), they cannot assume, any more than Gentiles, that they will escape God’s wrath (2:4). Paul is, however, well aware that his argument ignores a crucial matter: the Jews’ claim to possess a status by virtue of the covenant that puts them in a position entirely different from that of the Gentiles. In vv. 17–29, Paul takes up this matter.")]), _vm._v(" "), _c('p', [_vm._v("Without dismissing the Jews’ claim entirely (3:1–2), Paul insists that their privileges do not exempt them from God’s judgment. In two paragraphs with roughly parallel arguments (vv. 17–24, 25–29), Paul takes up those two things that, more than any others, pointed to the Jews’ special status: the law and circumcision. In both paragraphs, without dismissing them as worthless, Paul argues that neither knowledge of the law nor physical circumcision has "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.158"
    }
  }), _vm._v("value unless the law is obeyed. Again, it is what is actually "), _c('i', [_vm._v("done")]), _vm._v(" that is critical in determining every person’s destiny—for the Jew as well as for the Gentile (2:13).")]), _vm._v(" "), _c('p', [_vm._v("To be sure, Paul does not prove, or even explicitly assert, in these paragraphs that all Jews are transgressors, or even that they are all serious enough transgressors to invalidate their hope for salvation through the covenant. Paul does assert this later (3:9), but his point in this section is not to demonstrate that Jews commit sins (no Jew would deny that) but that these sins, despite possession of the law and circumcision, make Jews just as liable to God’s judgment as Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.158.2",
      "id": "FN.158.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" In arguing in this manner, Paul is implicitly contesting the traditional Jewish understanding of the covenant. Whereas Jews tended to rely on their election and works of the law, Paul insists that it is faith—only and always—that is the basis for a righteous standing with God. Therefore, the “signs” of election—the law and circumcision—are of no value without this faith. Only if the law is “done,” and, Paul implies, done perfectly, will the election on the basis of the Mosaic covenant be of value to the Jew (see also the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY4"
    }
  }, [_vm._v("Excursus")]), _vm._v(" after 3:20).")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY3.1.2.2.1"
    }
  }, [_vm._v("i. The Law (2:17–24)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("Now if you call yourself a Jew, and take pride in the law, and boast in God, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("and know his will and approve those things that are best, being instructed by the law, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("and being convinced that you are a guide to the blind, a light for those who are in darkness, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("an instructor of the foolish, a teacher of the immature, having the embodiment of knowledge and truth in the law— "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("therefore will you who teach another, not teach yourself? Do you who preach against stealing, steal? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("Do you who say not to commit adultery, commit adultery? Do you who detest idols, rob temples? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("You who are boasting in the law are, through your transgression of the law, dishonoring God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("For “the name of God is being blasphemed among the nations because of you,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.2.A",
      "id": "FN.2.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")]), _vm._v(" even as it is written.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Paul begins the paragraph with an “if,” introducing a protasis of a conditional sentence. But the matching apodosis—the “then” clause—is not immediately evident. Godet thinks that all of vv. 17–24 may form the protasis, with the apodosis left unexpressed: “What value then is the law?” But the “therefore” at the beginning of v. 21 suggests that a break occurs at that point. It is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.159"
    }
  }), _vm._v("still difficult to decide whether Paul simply abandons his conditional sentence at that point (anacolouthon),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.3",
      "id": "FN.159.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" or whether vv. 21–24 are the apodosis."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.4",
      "id": "FN.159.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" In either case, vv. 21–24 expose the failure of the Jew to live up to the privileges that Paul enumerates in vv. 17–20. There is some measure of irony in the way Paul presents these privileges as items in which the Jew boasts. But the irony is not directed against the claim to these privileges as such, for each of them is, according to the OT, a rightful possession of the Jew."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.5",
      "id": "FN.159.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Rather, the irony emerges in the piling up of these distinctives and in the anticipation of the point that will be made in vv. 21–24. Paul here claims for the Jew nothing more than what the Jews of his day were claiming for themselves; every item on the list in vv. 17–20 is paralleled in Jewish literature of the time.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("17")]), _vm._v(" The three privileges in this verse are listed in ascending order: belonging to the chosen people, reliance on the law, and a special relationship with God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.6",
      "id": "FN.159.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Each is presented from the standpoint of the Jew, Paul’s debating partner, who advances them as evidence of his special relationship with God. The name “Jew,” which originally referred to a person from the region occupied by the descendants of Judah, was applied to Israelite people generally after the Exile, when the territory occupied by the Jews encompassed not much more than the original Judah. By Paul’s day, “Jew” had become a common designation of anyone who belonged to the people of Israel. It suggests the special status enjoyed by the people of Israel, in distinction from all other peoples (cf. 1:16; 2:9, 11)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.7",
      "id": "FN.159.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" “To be named a Jew,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.8",
      "id": "FN.159.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" then, refers to the religious status shared by anyone who belonged to the covenant people.")]), _vm._v(" "), _c('p', [_vm._v("Paul phrases the second privilege enjoyed by the Jews in such a way as to suggest the root problem he addresses. Possession of the law was certainly a genuine blessing. But the problem came because the Jews “rely on"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.9",
      "id": "FN.159.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿9")]), _vm._v(" the law.” Paul makes a point very similar to that of the prophet Micah, who, after rebuking the leaders of Israel for their sin, says, “Yet they lean on"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.159.10",
      "id": "FN.159.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(" saying, ‘Is not the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(" in our midst? Calamity will not come "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.160"
    }
  }), _vm._v("upon us’ ” (3:11). So, in Paul’s day, Jews thought their reliance on the law would exempt them from judgment.")]), _vm._v(" "), _c('p', [_vm._v("The final privilege enumerated in v. 17 is that the Jew “boasts"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.160.11",
      "id": "FN.160.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" in God.” “Boasting” is not in itself wrong, as Jer. 9:23–24 (alluded to by Paul in 1 Cor. 1:31 and 2 Cor. 10:17) makes clear: “Thus says the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(", ‘Let not the wise man boast of his wisdom, and let not the mighty man boast of his might, let not the rich man boast of his riches, but let him who boasts boast of this, that he understands and knows me.’ ” Thus, the Jews’ “boasting in God” is not wrong in itself—an instance of human pride and arrogance—but a legitimate pride and joy in the God who had given to Israel so many good things."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.160.12",
      "id": "FN.160.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("18")]), _vm._v(" Paul continues the conditional construction from v. 17, adding two more distinguishing marks of the Jew to his list: the Jew “knows his will”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.160.13",
      "id": "FN.160.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" and “approves those things that are best.” What Paul attributed to all people in 1:19—that knowledge of God was available through his revelation—he attributes to the Jew. The translation “approve those things that are best”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.160.14",
      "id": "FN.160.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" is one of three possible renderings,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.160.15",
      "id": "FN.160.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" the other two being (1) “distinguish "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.161"
    }
  }), _vm._v("the things that differ [from God’s will]” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NEB"
    }
  }, [_vm._v("NEB")]), _vm._v(": “know right from wrong”);"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.16",
      "id": "FN.161.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" (2) “distinguish the things that really matter.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.17",
      "id": "FN.161.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" The former is unlikely here,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.18",
      "id": "FN.161.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" but the second has much to be said for it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.19",
      "id": "FN.161.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" In fact, however, the difference in meaning between this rendering and the one we have adopted is slight.")]), _vm._v(" "), _c('p', [_vm._v("The final clause of the verse explains why the Jew “knows his will” and “approves those things that are best”: he is “instructed"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.20",
      "id": "FN.161.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿20")]), _vm._v(" by the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.21",
      "id": "FN.161.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" The Jews’ knowledge of God’s will and their approval of the things that mattered the most came through their exposure to the instruction of the law in the synagogue and elsewhere.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("19–20")]), _vm._v(" In vv. 17–18 Paul has listed five blessings personally enjoyed by the Jews by virtue of their being God’s covenant people. Now, with a change in construction, he enumerates four prerogatives that Jews enjoy in relation to other people because of these blessings."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.22",
      "id": "FN.161.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" Paul continues his direct address of a representative Jewish person: “being convinced"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.161.23",
      "id": "FN.161.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" that you are a "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.162"
    }
  }), _vm._v("guide to the blind, a light"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.24",
      "id": "FN.162.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" for those who are in darkness, an instructor of the foolish,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.25",
      "id": "FN.162.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" a teacher"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.26",
      "id": "FN.162.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿26")]), _vm._v(" of the immature.” It is their uniquely detailed knowledge of God’s will, revealed in the law, that renders Jews responsible to teach others. Paul’s description of this role uses language drawn particularly from Jewish propaganda directed to the Hellenistic world."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.27",
      "id": "FN.162.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', [_vm._v("The Jews’ sense of mission toward the rest of the world is rooted in the OT. When, therefore, Paul asserts that the Jew was convinced he was a “guide to the blind” and a “light for those in darkness,” we think of the duty of God’s servant—to some degree at least identified with Israel—to be a “light to the nations” and “to open the eyes of the blind.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.28",
      "id": "FN.162.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The Jews, however far short of their responsibility to enlighten the Gentile world they may have fallen, continued to boast in these mandates as a means of highlighting their importance and the value of their law in the eyes of a skeptical and sometimes hostile Gentile world."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.29",
      "id": "FN.162.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', [_vm._v("As he did in v. 18, Paul adds to his list of Jewish prerogatives a participial clause in which he traces the benefits enjoyed by the Jews to the law. Paul highlights the sufficiency of the law by claiming that it contains “the embodiment"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.162.30",
      "id": "FN.162.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿30")]), _vm._v(" of knowledge and truth.” Paul has asserted that all people, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.163"
    }
  }), _vm._v("including especially those without special revelation, have access to “knowledge” and “truth” (1:18–19, 25, 28, 32) and are hence “without excuse” when they turn from it. The Jew has this knowledge and truth embodied in far clearer and more detailed form in the law, a claim he acknowledges, and indeed boasts of. Even more than the Gentile, therefore, the Jewish person is “without excuse” before God (2:1).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("21–22")]), _vm._v(" The four sentences in these verses are best taken as rhetorical questions, in keeping with the diatribe style. They expose the Jew who has made the lofty claims of vv. 17–20 as inconsistent and hypocritical, as failing “to practice what he preaches.” Such a charge was certainly not new. The OT (cf. Ps. 50:16–21), Judaism (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ABOTR.NAT"
    }
  }, [_c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ʾAbot R. Nat.")])]), _vm._v(" 29[8a]), and Jesus (e.g., Matt. 23:3) made similar accusations. Paul’s stress on “doing” as what ultimately counts before God surfaces here again. All the privileges, distinctions, and gifts that the Jew may claim are meaningless if they are not responded to with a sincere and consistent obedience. And it is just this obedience that is lacking.")]), _vm._v(" "), _c('p', [_vm._v("The first charge, that the Jew who teaches others should teach himself, is a heading and is broken down into three specific examples in the questions that follow. Paul cites three flagrant violations of the law as evidence of the Jew’s failure to “teach himself.” The prohibitions of stealing and adultery"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.163.31",
      "id": "FN.163.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" are, of course, included in the Ten Commandments. The third sin is more difficult to identify. Paul’s claim that the Jew “detests"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.163.32",
      "id": "FN.163.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" idols” is clear enough, and captures an important element of Jewish religion in the first century. The threat to Jewish existence posed by the inroads of Hellenism and the dispersion of Jews throughout pagan society had led to increased emphasis on the need to avoid such pagan practices. Idolatry, in the technical sense, was generally unknown among Jews at this time. Indeed, what Paul accuses the Jew of doing is not specifically worshiping idols, but “robbing temples.” What Paul means by this accusation is not clear."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.163.33",
      "id": "FN.163.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.164"
    }
  }), _vm._v("(1) He might use the word in its natural, literal sense. While evidence that Jews engaged in the robbing of temples is scarce, there is some reason to think that the strictures against using the precious metals from idolatrous articles (cf. Deut. 7:26) were being relaxed and disobeyed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.164.34",
      "id": "FN.164.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Paul could, then, be citing the use of such articles stolen from pagan temples as an example of a practice that contradicted the Jews’ avowed abhorrence of idolatry."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.164.35",
      "id": "FN.164.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', [_vm._v("(2) Paul might apply the word to the robbing of the Jerusalem Temple, which would be taking place when Jews failed to pay the “temple tax” that was required of all Jews for the support of the worship of the Lord."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.164.36",
      "id": "FN.164.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_vm._v("(3) Paul might apply the word to sacrilege in a general sense."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.164.37",
      "id": "FN.164.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" For Paul’s accusation to make sense, this sacrilege would have to involve various acts (or attitudes) of impiety toward the God of Israel—as, for instance, elevating the law to such an extent that it infringed on the rights and honor of the Lord himself."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.164.38",
      "id": "FN.164.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" Each of these alternatives has its problems. Both the second and the third suffer from the difficulty that an act committed against the Jewish Temple or God is not a contradiction to the Jews’ abhorrence of idols."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.164.39",
      "id": "FN.164.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" If we adopt the first alternative, on the other hand, Paul would be accusing his Jewish target of an offense that was, at best, rare. Nevertheless, this difficulty is not as great as the one faced by the second and third alternatives. Moreover, this interpretation places this third accusation on the same footing as the first two (see below).")]), _vm._v(" "), _c('p', [_vm._v("Why has Paul chosen examples of such serious and relatively infrequent activities to accuse Jews generally of failing to live out the law they reverence? How could his accusations be convincing to those Jews, surely in the majority, who had never stolen, committed adultery, or robbed a temple? Some interpreters conclude that Paul must view each of these activities in the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.165"
    }
  }), _vm._v("light of the “deepening” of the law taught by Jesus (Matt. 5:21–48). “When theft, adultery, and sacrilege are strictly and radically understood, there is no man who is not guilty of all three.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.40",
      "id": "FN.165.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" But there is nothing in the context to make such an understanding of these activities likely, and much that is against it. Paul’s purpose in Rom. 2 is to convince Jews of the inadequacy of their works, defined according to the standard of the law itself. For him to accuse them of breaches of the law in the radicalized sense in which Jesus taught it would be to leave this intent behind.")]), _vm._v(" "), _c('p', [_vm._v("Another suggestion is made by Watson, who notes that the context especially stresses the teaching activity of Jews. He thinks that Paul may be criticizing leaders of the Jewish community in Rome who had been active in proselytizing, but whose immorality had led to their expulsion from the city."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.41",
      "id": "FN.165.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" Watson’s interpretation grows out of his reconstruction of the social situation addressed by Paul in Romans, a reconstruction that reads more into the text than is justified. Nevertheless, there may be an element of truth in his suggestion, in the sense that Paul’s intention seems to be to cite these breaches of the law as exemplary of the contrast between words and works, possession of the law and obedience of it, that is the "), _c('i', [_vm._v("leitmotif")]), _vm._v(" of Rom. 2."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.42",
      "id": "FN.165.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿42")]), _vm._v(" It is not, then, that all Jews commit these sins, but that these sins are representative of the contradiction between claim and conduct that "), _c('i', [_vm._v("does")]), _vm._v(" pervade Judaism. Paul may, then, have chosen these particular sins in order to make a contrast with the commands of the Decalogue (if “robbing temples” can be construed as a violation of the first commandment)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.43",
      "id": "FN.165.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" or to follow the pattern of other “vice lists,” in which items such as murder, adultery, and sacrilege often appeared,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.44",
      "id": "FN.165.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" or, perhaps most likely, to show the equivalence between the sins of Jews and of Gentiles (cf. 2:3)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.45",
      "id": "FN.165.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("23")]), _vm._v(" This verse, which is probably a statement ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NA"
    }
  }, [_vm._v("NA")]), _c('sup', [_vm._v("27")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NEB"
    }
  }, [_vm._v("NEB")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.JB"
    }
  }, [_vm._v("JB")]), _vm._v(") rather than another rhetorical question ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RSV"
    }
  }, [_vm._v("RSV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TEV"
    }
  }, [_vm._v("TEV")]), _vm._v("), brings home to Paul’s Jewish addressee the accusation developed in vv. 17–22. Whereas v. 17 spoke of the Jew “relying on” the law, this verse heightens the sense by speaking of the Jew as “boasting”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.165.46",
      "id": "FN.165.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" in it. All such pride in the law—"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.166"
    }
  }), _vm._v("claims as to its antiquity and perfection, boasts about Israel as the people entrusted with the law—becomes insignificant and, indeed, damaging when the law is not obeyed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.166.47",
      "id": "FN.166.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" It is not boasting in the law that brings honor to God but obedience to it.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("24")]), _vm._v(" Paul uses an OT quotation to confirm the conclusion he has drawn in v. 23. The quotation is probably from Isa. 52:5."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.166.48",
      "id": "FN.166.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿48")]), _vm._v(" In Isaiah, the blaspheming of God’s name occurs through the oppression of Israel, God’s chosen people, by foreign powers. Paul ascribes the cause of the blasphemy to the disobedient lives of his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.166.49",
      "id": "FN.166.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Perhaps Paul intends the reader to see the irony in having responsibility for dishonoring God’s name transferred from the Gentiles to the people of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY3.1.2.2.2"
    }
  }, [_vm._v("ii. Circumcision (2:25–29)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("For circumcision is of profit if you practice the law. But if you are a transgressor of the law, your circumcision has become uncircumcision. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("If, then, the person who is uncircumcised guards the just decrees of the law, will not that person’s uncircumcision be considered as circumcision? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("And the person who is uncircumcised by nature who completes the law will judge you who, though having the letter and circumcision, are a transgressor of the law. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("For it is not the Jew who is one outwardly who is the Jew, nor is it the outward circumcision, in the flesh, that is circumcision, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("but it is the Jew who is in secret who is the Jew, and who has the circumcision of the heart, in the Spirit, not in letter. That Jew has praise not from human beings, but from God.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("As vv. 12–24 have shown that the Jews’ possession of the law will not shield them from judgment because it is the doing of the law, not simply the possession of the law, that matters, so vv. 25–29 argue that circumcision also is of no benefit unless the law is obeyed. Circumcision, like the law, was a sign of the Jew’s privileged position as a member of the chosen people, participant "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.167"
    }
  }), _vm._v("in the covenant that God established with Abraham (Gen. 17). Later Judaism claimed that “no person who is circumcised will go down to Gehenna,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.167.1",
      "id": "FN.167.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" and the importance of the rite throughout the Second Temple period suggests that this view was prevalent in Paul’s day also. But Paul goes even further. Not only does disobedience of the law endanger the circumcised Jew’s salvation;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.167.2",
      "id": "FN.167.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" obedience of the law can bring salvation to the uncircumcised Gentile. Moreover, while Paul’s central concern is again (as in vv. 7, 10, and 14–15) to set forth the impartial standard of judgment outside of Christ, he here for the first time in the chapter also hints that it is the Christian, circumcised in the heart by God’s Spirit, who is the “true” Jew (v. 29).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("25")]), _vm._v(" The “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.167.3",
      "id": "FN.167.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" at the beginning of v. 25 relates this whole paragraph to an implied Jewish objection: How can we be treated the same as Gentiles (vv. 6–11), even to the point of being in danger of the wrath of God (cf. v. 5), when our circumcision marks us as belonging to God’s chosen people, heirs of the Abrahamic promises? Paul responds: circumcision “is of profit”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.167.4",
      "id": "FN.167.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" only if the law is done; if, on the other hand,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.167.5",
      "id": "FN.167.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" the law is transgressed, one’s circumcision “has become"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.167.6",
      "id": "FN.167.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿6")]), _vm._v(" uncircumcision.” Paul is clearly contesting the value of circumcision per se. But his precise meaning is open to question. First, what specific “profit” of circumcision is Paul contesting? In light of the context, with its focus on judgment and wrath, Paul must have in mind the efficacy of circumcision in shielding the Jew from the wrath of God. This meaning is confirmed by 3:1–2, where the question “Does circumcision have "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.168"
    }
  }), _vm._v("any profit?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.168.7",
      "id": "FN.168.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" makes sense only if Paul has denied its value in some vital respect in vv. 25–29—and denied it for all Jews. In light of 3:9 and 19, this value must have to do with the efficacy of circumcision to rescue the Jew from the tyranny of sin and the judgment of God.")]), _vm._v(" "), _c('p', [_vm._v("This conclusion has important implications for a second question, the meaning of the phrase “if you practice the law.” Two interpretations fit the context: (1) a heartfelt, faith-filled obedience to the stipulations of the covenant;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.168.8",
      "id": "FN.168.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" (2) a perfect conformity to the letter of the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.168.9",
      "id": "FN.168.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" If the former is adopted, then Paul would presumably regard this kind of “doing the law” as possible, and his point would be that it is only when accompanied by this sincere and faithful response to God’s covenant stipulations that circumcision, the sign of the covenant, is of any value. With the second meaning, on the other hand, Paul would be setting forth the standard by which God judges, a standard of perfect conformity to God’s demands that no one can meet. In this case, circumcision would be of no “profit” (in the sense of salvific profit) to anyone. A decision between these two options is very difficult. In favor of the former is the undeniable stress in the OT itself on the heart attitude necessary for a true doing of the law, a stress that Paul in vv. 28–29 appears to reflect. Certainly, first-century Judaism regarded the law as doable; and most Jews would, presumably, read Paul as calling, not for perfect obedience, but for heartfelt, sincere obedience. Moreover, “doing” the law is something that Paul in vv. 26 and 27 appears to set forth as a genuine possibility.")]), _vm._v(" "), _c('p', [_vm._v("These are strong arguments; but I am still inclined to adopt the second interpretation. My main reason for doing so is the crucial distinction between faith on the one hand and “the law,” “works,” or “doing,” on the other, that Paul maintains throughout Romans, as well as in his other letters. Whereas “doing the law” in Judaism could well include faith, “doing the law” in Paul is definitely and emphatically separated from faith (cf. 3:27–28 [and our comments there]; 4:2–5, 13–16; 10:5–8; and perhaps most clearly, Gal. 3:12). True, Paul thereby drives a wedge between two human responses—faith and obedience to the law—that were intertwined in Judaism. But he does this knowingly and on the basis of conviction, for Paul views any mixing, any synergism, of faith and works as damaging to the grace of God (cf. especially 4:1–5). In light of this concern, it is unlikely that Paul would include faith in “doing the law” here. And in light of the inference Paul draws from his argument in this section of the epistle—“no one is justified before God through works of the law” (3:20)—it is equally unlikely that he intends to accord salvific value to circumcision or doing the law. Paul’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.169"
    }
  }), _vm._v("purpose in this section is not to indicate how circumcision is of value with respect to the covenant but to remove circumcision from the list of those things that the Jew might think would afford him an automatic pardon from the wrath of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.10",
      "id": "FN.169.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', [_vm._v("These decisions help us to determine the meaning of Paul’s claim that transgressing the law turns one’s circumcision into “uncircumcision.” If the profit of circumcision consists in protection from divine wrath, this phrase must, as its contrary, signify exposure to that wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.11",
      "id": "FN.169.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" To become uncircumcised means to become like a Gentile and to forfeit any defense that one’s membership in the people of God might provide on the day of judgment. Michel is right to underscore the polemical tone of this assertion."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.12",
      "id": "FN.169.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" For in contrast to Jewish teachers, who held that only a radical decision to renounce the covenant invalidated one’s circumcision,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.13",
      "id": "FN.169.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Paul argues that simple transgressions of the law can have the same effect. Although Paul is more radical, his polemic resembles that of the prophets, who warned the people of Israel that their cavalier disregard of their covenant obligations rendered null and void the security from foreign domination and divine judgment that they hoped to find in covenant signs."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.14",
      "id": "FN.169.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("26")]), _vm._v(" If it is not circumcision but obedience to the law that determines whether one will be saved at the judgment, it follows as a consequence"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.15",
      "id": "FN.169.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿15")]), _vm._v(" that a Gentile, “the uncircumcised person,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.16",
      "id": "FN.169.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" can, if he or she obeys the law, be saved. This uncircumcision, signifying that the Gentile is “alienated from the commonwealth of Israel, [a] stranger[s] to the covenants of promise, having no hope and without God in the world” (Eph. 2:12), “will be considered”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.169.17",
      "id": "FN.169.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" as circumcision if he “guards the just decrees of the law.”")]), _vm._v(" "), _c('p', [_vm._v("Who are these uncircumcised Gentiles who keep the law and are saved on the day of judgment? We have already dismissed the possibility that Paul would describe Gentiles apart from faith in Christ as saved through their "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.170"
    }
  }), _vm._v("obedience to the light they have received (see the notes on 2:11)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.170.18",
      "id": "FN.170.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" However, if one finds a reference to Gentile Christians in earlier verses of the chapter where a similar positive assessment of Gentiles is made (2:7, 10, 14–15), it is natural to make the same identification here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.170.19",
      "id": "FN.170.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" But even some who do not think these earlier verses refer to Gentile Christians are persuaded that they are in view here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.170.20",
      "id": "FN.170.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Partly, this is because of the apparent realism of v. 27 and the fact that v. 29 alludes, however ambiguously, to Christians. But it is also argued that the phrase “guards the just decrees of the law” is a stronger expression than, for instance, “do the things of the law” (v. 14) and signifies a full and complete fulfillment of the law such as is possible only for Christians. This is questionable. Although Paul says that Christians who are walking by the Spirit have fulfilled in them “the just decree of the law” (Rom. 8:4), both the singular noun and the passive verb differentiate that statement from what Paul says here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.170.21",
      "id": "FN.170.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" Yet Paul does not depict the Christian as one who is under obligation to the specific stipulations of the Mosaic law. The Christian is no longer “under the [Mosaic] law” (6:14, 15; see our comments there), "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.171"
    }
  }), _vm._v("but under “the law of Christ” (Gal. 6:2; cf. 1 Cor. 9:20). Finally, the context suggests that as transgression of the law disbars the Jew from salvation (v. 25), so obedience to the law grants the Gentile membership among the saved. But it is impossible that Paul would have described any Christian as having been granted this status as a result of obeying the law.")]), _vm._v(" "), _c('p', [_vm._v("We therefore conclude that Paul is again here citing God’s standard of judgment apart from the gospel as a means of erasing the distinction at this point between Jew and Gentile. Paul is not pointing the way to salvation but is showing Jews that their position, despite their covenant privileges, is essentially no different from that of the Gentiles: disobedience brings condemnation; obedience brings salvation. Paul’s way of putting the matter in this context could, of course, suggest that there actually are people who meet this requirement for salvation; but his later argument quickly disabuses us of any such idea (cf. 3:9, 20)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.171.22",
      "id": "FN.171.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', [_vm._v("Nevertheless, we should not miss the revolutionary implications of what Paul suggests here. Circumcision was, after all, commanded in the law—yet Paul can say that people who are not circumcised can do the law. This assumption looks toward a new understanding of what the covenant is and what God requires of his people, an understanding that arises from the conviction that a new stage in salvation history has begun."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.171.23",
      "id": "FN.171.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" Without directly describing Christians here, then, Paul’s logic anticipates his teaching that it is faith and the indwelling of the Spirit that meet God’s demand and so bring people into relationship with God. We may paraphrase: “if it should be that there were an uncircumcised person who perfectly kept the law (which in this sense there is not, though in another sense, as we will see, there is), that person would be considered a full member of the people of God.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("27")]), _vm._v(" The belief that the righteous would sit in judgment over the unrighteous was widespread."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.171.24",
      "id": "FN.171.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" But the Jewish tradition naturally cast Jews in the role of the righteous and Gentiles in that of the unrighteous. Paul reverses this customary scheme and, continuing his argument from v. 26, asserts that “the uncircumcised person by nature"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.171.25",
      "id": "FN.171.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿25")]), _vm._v(" who completes the law will judge"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.171.26",
      "id": "FN.171.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿26")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.172"
    }
  }), _vm._v("you [e.g., the Jew]"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.27",
      "id": "FN.172.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" who, though having the letter and circumcision, are a transgressor of the law.” Whether Paul suggests that these righteous Gentiles will be appointed as judges by God"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.28",
      "id": "FN.172.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿28")]), _vm._v(" or that their obedience to the law itself will stand as accusatory evidence against the disobedient Jew"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.29",
      "id": "FN.172.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" is difficult to say. But the latter might be more likely in view of the parallel with Jesus’ rebuke of the Jews who rejected him: “The men of Nineveh will arise at the judgment with this generation and condemn it; for they repented at the preaching of Jonah, and behold, something greater than Jonah is here. The queen of the south will arise at the judgment with this generation and condemn it; for she came from the ends of the earth to hear the wisdom of Solomon, and behold, something greater than Solomon is here” (Matt. 12:41–42; cf. Luke 11:31–32).")]), _vm._v(" "), _c('p', [_vm._v("The matter-of-fact nature of this assertion gives support to those who think that Paul is here depicting a real rather than a hypothetical situation. Moreover, Paul’s description of this person as one who “"), _c('i', [_vm._v("completes")]), _vm._v(" the law” might point in the same direction."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.30",
      "id": "FN.172.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" But this phrase is simply another way of describing obedience to the commandments of the law;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.31",
      "id": "FN.172.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" and, for the reasons outlined above, I prefer to see the verse as a vivid reminder of the equality between Jew and Gentile with respect to judgment.")]), _vm._v(" "), _c('p', [_vm._v("A debated point in this verse is the phrase that Paul uses to qualify “a transgressor of the law”: “through letter and circumcision.” Two related issues arise: the meanings of the word “letter” and of the preposition we here translate “through.” The Greek word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("gramma")]), _vm._v(" means “that which is inscribed or written,” and Paul is the only biblical author to use the term with reference to the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.32",
      "id": "FN.172.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" In each case, he contrasts "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("gramma")]), _vm._v(" with "), _c('i', [_vm._v("pneuma,")]), _vm._v(" “spirit” (cf. v. 29 and Rom. 7:6; 2 Cor. 3:6–7). If the preposition Paul uses here "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dia)")]), _vm._v(" has its normal instrumental meaning, then “letter” must have a negative connotation: it is “through the letter” that transgression of the law occurs."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.172.33",
      "id": "FN.172.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" “Letter” will then connote “an understanding of the law which "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.173"
    }
  }), _vm._v("stays at the level of the ritual act and outward deed,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.173.34",
      "id": "FN.173.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" a superficial and therefore incomplete understanding of the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.173.35",
      "id": "FN.173.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" But the wider context points in a different direction. Paul is arguing in Rom. 2 that Jews cannot depend on their covenant status, symbolized by the law and circumcision, for salvation. And the reason they cannot, he argues, is that they have transgressed the law by disobeying its precepts. Of course, a wrong heart attitude is one aspect of this problem (cf. vv. 28–29). But nothing Paul has said in this chapter suggests that a faulty understanding of the law is part of the problem. Indeed, vv. 17–24, with their contrast between “knowing God’s will, being instructed through the law,” and “breaking the law,” show that it is not at the level of understanding but at the level of "), _c('i', [_vm._v("doing")]), _vm._v(" that the problem lies. This is typical of Paul’s teaching throughout Romans, where the solution to the problem of sin is not a new or deeper understanding of the law, but faith in Christ, leading to the indwelling of the Spirit and the breaking of sin’s stranglehold over human beings.")]), _vm._v(" "), _c('p', [_vm._v("The context therefore makes it more likely that “letter” will have a neutral meaning, referring simply to the law as that which had been written down in letters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.173.36",
      "id": "FN.173.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" And confirming this conclusion is the likelihood that “letter” has this same neutral meaning in Paul’s other uses of it with reference to the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.173.37",
      "id": "FN.173.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" “Letter” and circumcision mark off the Jew from the Gentile, and Paul’s point is that disobedience of the law cancels out these undeniable advantages. The preposition here should then be translated not “through,” but “with” or “even though.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.173.38",
      "id": "FN.173.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("28–29")]), _vm._v(" Verses 28–29 explain why (“for”) circumcision does not guarantee salvation and why its lack does not bar one from salvation. Though God’s verdict is based on “works,” these works reveal “the secret things” (cf. 2:16), the inner reality of a person’s heart relationship to God. And it is this heart attitude that ultimately matters—not a rite that affects only the flesh. Paul argues by means of a contrast, with two denials in v. 28 being matched by two assertions in v. 29:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A For it is not the Jew who is one outwardly who is the Jew,")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("B nor is it the outward circumcision, in the flesh, that is circumcision")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("A but the Jew who in secret who is the Jew,")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.174"
    }
  }), _vm._v("B and circumcision of the heart, in the Spirit, not in letter, is circumcision"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.174.39",
      "id": "FN.174.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿39")])])]), _vm._v(" "), _c('p', [_vm._v("The basic contrast in these verses is an “inner”/“outer” contrast; a contrast between what can be seen with the eye (physical circumcision, Jewish birth) and what only God ultimately sees (the changed heart; “true” Jewishness)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.174.40",
      "id": "FN.174.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" The contrast between outward circumcision (done “in the flesh”) and the circumcision “done to the heart”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.174.41",
      "id": "FN.174.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" is well known in the OT and Judaism. From the earliest history of Israel, God called on the people to display the kind of inner transformation that could be called a “circumcision of the heart” (e.g., Deut. 10:16; cf. Jer. 4:4). Significantly, it was also recognized that only God could ultimately bring about this heart transformation (Deut. 30:6). There thus grew up in Judaism the expectation that God would one day circumcise the hearts of his people through the work of the Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.174.42",
      "id": "FN.174.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" Thus Paul’s call for a “circumcision of the heart, in the Spirit,” is not entirely original. But the unprecedented addition of the negative phrase “not in letter” raises the question whether or not he is using the concept with a deeper significance.")]), _vm._v(" "), _c('p', [_vm._v("The “letter/spirit” contrast Paul uses here has played a prominent role in church history, where it was often applied to interpretation: the “letter” denoting the literal, surface meaning of a text and the “spirit” its deeper, allegorical sense. Paul, however, never uses the contrast with this application. As we have seen (see v. 27), Paul uses “letter” to refer to the law of Moses “as written.” In the current context, because of its proximity to “heart” and apparent contrast with “manifest,” some interpreters think that “spirit” might refer to the inner aspect of the human being."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.174.43",
      "id": "FN.174.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" But the immediate contrast here is with “letter”; and this suggests that “spirit,” like “letter,” refers to a God-given entity. Thus, as in the other Pauline “letter/spirit” passages (Rom. 7:6; 2 Cor. 3:6–7), “spirit” should be capitalized: it refers to God’s Holy Spirit. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.175"
    }
  }), _vm._v("Paul’s “letter”/“Spirit” contrast is a salvation-historical one, “letter” describing the past era in which God’s law through Moses played a central role and “Spirit” summing up the new era in which God’s Spirit is poured out in eschatological fullness and power."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.175.44",
      "id": "FN.175.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" It is only the circumcision “in the Spirit”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.175.45",
      "id": "FN.175.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" that ultimately counts.")]), _vm._v(" "), _c('p', [_vm._v("For the first time, then, in Rom. 2, Paul alludes to Christians. But even here it is only an allusion, since Paul is not so much describing a group of people as specifying what it is that qualifies a person to be a “true Jew” and so to be saved. No outward rite can bring a person into relationship with God; with that many Jews would have agreed. But Paul goes beyond any first-century Jewish viewpoint in suggesting that physical circumcision is no longer required and in implicitly applying the term “Jew” to those who were not ethnically Jews. As Ridderbos puts it, we find here “a radicalizing of the concept Jew, and thereby of the definition of the essence of the people of God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.175.46",
      "id": "FN.175.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" Paul in these verses reaches ahead to the argument that he will unfold in 3:21–4:25. It is “an advance sounding of the message of salvation,” as Bornkamm puts it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.175.47",
      "id": "FN.175.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', [_vm._v("The last clause in v. 29 picks up the outward/inward contrast of vv. 28–29a. The “true” Jew, like the sincere worshiper (cf. Matt. 6:2–18), is praised not by people but by God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.175.48",
      "id": "FN.175.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" This praise, in keeping with the focus on judgment throughout Rom. 2, is probably that praise with which God will honor his own people on the last day."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.175.49",
      "id": "FN.175.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.176"
    }
  }), _vm._v("Paul’s argument against the Jews in Rom. 2 has come in for severe criticism. These critics charge that the argument of the chapter is basically “un-Christian,” or at least “un-Pauline,” in its assumptions. Few have gone as far as O’Neill, who dismisses large sections of the chapter as later glosses. But it is more widely believed that Paul’s teaching in this chapter cannot be easily harmonized, or perhaps harmonized at all, with his teaching elsewhere."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.176.50",
      "id": "FN.176.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" Some have been so struck by these differences that they think Paul may have taken over almost intact a synagogue homily."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.176.51",
      "id": "FN.176.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" Why so radical a conclusion? Three areas of difficulty are singled out: the teaching that justification can come by works (2:6–11, 13, 26–27), that the law can be fulfilled (2:14–15, 26–27), and, related to both of these, that Gentiles also have ability and virtue. These points, it is suggested, are the product of Paul’s excessive zeal to remove any distinction between Jews and Gentiles. To this end, the Gentiles are presented in as positive a light as possible. Paul’s conviction that Christ was the only solution is what came first, and that conviction required that he accuse all people of being lost in sin.")]), _vm._v(" "), _c('p', [_vm._v("This criticism can only be met by a demonstration, through careful exegesis, that the teachings of the chapter found to be incompatible with Paul’s theology are not, in fact, there. I hope to have made at least a start on this demonstration above. But a general criticism might be noted here: such a view of Rom. 2 requires either that Paul was unaware that he was creating a contradiction with Rom. 1:18–32 and 3:9, 19–20"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.176.52",
      "id": "FN.176.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿52")]), _vm._v(" or that he was not ultimately interested in a logically coherent theology."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.176.53",
      "id": "FN.176.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" Both suppositions are problematic. The former makes Paul into an obtuse person indeed—so obtuse that it is hard to know how he could ever have written a letter like Romans, let alone convince anyone to embrace his teaching. The latter, while justly stressing the need to recognize the social and contingent factors behind Paul’s teaching, errs in thinking that Paul could have accomplished these social objectives with a logically contradictory theology. Surely those groups whom he was seeking to persuade would have spotted the inconsistencies and used them as an excuse to ignore his teaching.")]), _vm._v(" "), _c('p', [_vm._v("Finally, although the direction of Paul’s original thinking was probably from “solution to plight,” the argumentation of Rom. 1–3, as Sanders admits, moves “from plight to solution.” Thus, it is overwhelmingly probable that Paul devoted more attention to the nature of this plight, and found more reason "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.177"
    }
  }), _vm._v("in human inability for the necessity of the solution, than Sanders has allowed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.177.54",
      "id": "FN.177.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" In a legitimate reaction against the excessively anthropological focus of Bultmann, Sanders and others have gone too far in eliminating anthropology from its structural role in Paul’s theology.")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY3.1.2.3"
    }
  }, [_vm._v("c. God’s Faithfulness and the Judgment of Jews (3:1–8)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("What, then, is the advantage of being a Jew, or what is the profit of circumcision? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("Much, in every way. First of all, they have been entrusted with the oracles of God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("For what then? Though some of them were unfaithful, their unfaithfulness will not nullify the faithfulness of God, will it? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("By no means! Let God be true, though every person is a liar, just as it is written, “so that you may be justified in your words, and that you might triumph when you judge.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.3.A",
      "id": "FN.3.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("But if our unrighteousness commends the righteousness of God, what shall we say? God is not unjust to inflict his wrath, is he? I am speaking in a human fashion. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("By no means! For how, then, would God judge the world? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("And"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.177.1",
      "id": "FN.177.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" if the truth of God abounded to his glory through my lie, why am I yet being judged as a sinner? "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("And why not conclude—as some are slanderously reporting that we say—“Let us do evil things, in order that good things might come”? God’s judgment of such people is just.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The unwary commentator approaches this paragraph thinking to find rather clear sailing after the exegetical whirlpools of chap. 2 and before the theological storms of 3:21. He or she quickly realizes (or at least this commentator "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.178"
    }
  }), _vm._v("did) the justice of Godet’s claim: the paragraph 3:1–8 is “one of the most difficult, perhaps, in the Epistle.” The chief cause of the obscurity is the rapid-fire sequence of questions, cast in a dialogical style. Is Paul citing and rejecting false consequences as he follows the “inner logic” of his own argument?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.178.2",
      "id": "FN.178.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" or is he reproducing a debate with a definite opponent?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.178.3",
      "id": "FN.178.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" In either case, which points are the false statements Paul rejects and which the correct teaching that he is defending? The difficulty of the passage is revealed in the fact that even this question is hotly debated. Stowers has shown that this passage manifests many of the characteristics of the diatribe style and can be compared with the use of questions and false conclusions typical of that style."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.178.4",
      "id": "FN.178.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" But few solid exegetical results come from this identification, not least because the diatribe style itself is quite amorphous and variable; and as Stowers notes, Paul shows evidence of having adapted it rather considerably."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.178.5",
      "id": "FN.178.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("The difficulties presented by this passage have led one commentator to brand Paul’s argument as “obscure and feeble” (Dodd). Others, convinced that Paul does argue coherently, nevertheless disagree dramatically on the nature of that argument. Without exploring these differences in detail,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.178.6",
      "id": "FN.178.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" we might note two "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.179"
    }
  }), _vm._v("broadly different approaches to the text. The first, the more “traditional” model, posits a shift in subjects at v. 5 (or v. 4). In vv. 1–4 (or 1–3), Paul focuses on the Jewish people, affirming the continuing faithfulness of God to them despite their widespread unfaithfulness. The strength of this affirmation, however, leads to another, far broader, question about the ways of God with humankind generally: How is it “right” for God to judge people when their sin magnifies his goodness and glory? On this view, the antecedent of the pronouns in vv. 5–8 (“our,” “us,” “my”) is “people” or “man”/“woman.” The other approach, which, while not unknown in the history of exegesis, has become more popular recently, insists that Paul’s focus remains on the Jews throughout the paragraph. Verses 5–8, on this view, do not take up a general objection to the fairness and consistency of God, but affirm the faithfulness of God to Israel or the “right” of God to judge even his own covenant people.")]), _vm._v(" "), _c('p', [_vm._v("In my view, this second approach is nearer to the truth. Verses 1–4a reject the inference that the judgment under which disobedient Jews stand (2:17–29) means that the Jews have no advantage at all. Rather, Paul insists, they have a great advantage, in possessing the words of God (vv. 1–2). The widespread unfaithfulness of the Jews in no way annuls God’s faithfulness to those words (vv. 3–4a). Then, with the quotation of Ps. 51:4b in v. 4b, Paul’s argument takes a decisive turn. Here he shows that God’s faithfulness, or "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.180"
    }
  }), _vm._v("“righteousness,” is manifested even through the sin of his people, for God’s words promise judgment for disobedience as well as blessing for obedience. Verse 5, then, is Paul’s formulation of a Jewish objection to the effect that Jewish sin, since it manifests God’s righteousness, should not be subject to the wrath of God. This inference Paul rejects, simply noting that it is incompatible with the biblical doctrine that God is a just judge (v. 6). The objector repeats his or her objection again, however (v. 7), and adds to it the claim that Paul’s doctrine actually encourages sinning (v. 8a). Paul again curtly rejects this line of reasoning, announcing the justice of God’s condemnation (v. 8b). Taken as a whole, then, the passage both affirms the continuing faithfulness of God to his covenant people and argues that this faithfulness in no way precludes God from judging the Jews. Provoking this discussion is the Jewish tendency to interpret God’s covenant faithfulness solely in terms of his salvific promises. Paul meets that conception with a broader and deeper view of God’s faithfulness—his faithfulness to remain true to his character and to "), _c('i', [_vm._v("all")]), _vm._v(" his words: the promises of cursing for disobedience as well as blessing for obedience."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.180.7",
      "id": "FN.180.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', [_vm._v("What begins, then, as an attempt to answer an objection to Paul’s ironing out of distinctions between Jews and Gentiles (vv. 1–2) becomes a frustratingly brief discussion of the relationship between Israel’s unbelief and God’s righteousness and, ultimately, between human sin and God’s purposes. Indeed, many of our difficulties in interpretation are caused by the fact that Paul is touching here very briefly and sometimes allusively on themes that he develops at greater length elsewhere in the letter—especially chaps. 9–11."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.180.8",
      "id": "FN.180.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿8")]), _vm._v(" The paragraph as a whole, then, while something of an “excursus” in Paul’s exposition, contributes in important ways to our understanding of Paul’s view of God’s righteousness in its relationship to Israel’s unbelief. In thus allowing the Roman Christians to “listen in” on this dialogue, Paul warns his mainly Gentile audience that they should not interpret the leveling of distinctions between Jew and Gentile in terms of God’s judgment and salvation as the canceling of all the privileges of Israel. As Rom. 11:11–24 makes clear, Paul knows that the Gentile Christians, in Rome and elsewhere, need to hear this caution.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" Paul frequently uses the words “what, then,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.180.9",
      "id": "FN.180.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" in Romans to raise questions about what he has taught and so further his argument. While it is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.181"
    }
  }), _vm._v("possible that Paul “quotes” a real interlocutor, it is more likely that he himself poses these questions to his readers. In other words, Paul is not so much reproducing for his readers an argument between himself and another person as he is posing questions and objections to himself in order to make his views clear to the Romans. Remembering Paul’s own rich Jewish heritage, we might even regard the dialogue as one between Paul the Jew and Paul the Christian."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.181.10",
      "id": "FN.181.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" In chap. 2, Paul, writing from the vantage point of the fulfillment of salvation history in Christ, has asserted that possession of the law and circumcision—in a word, being Jewish—makes no essential difference for the day of judgment. The question in v. 1 is therefore entirely natural: “What, then, is the advantage"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.181.11",
      "id": "FN.181.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" of being a Jew, or what is the profit"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.181.12",
      "id": "FN.181.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿12")]), _vm._v(" of circumcision?”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" Dodd maintains that the logical reply to the questions of v. 1 is “none,” and that it is only because of Paul’s Jewish prejudice that he insists on continuing prerogatives for the Jews. But Dodd’s opinion illustrates his failure to understand the particular purpose of chap. 2. Paul’s intention there was not to deny that the Jews have privileges that the Gentiles do not have, but to contest the notion that these privileges give to the Jew an advantage in the judgment. Therefore, while acknowledging that the Jews have unparalleled access to God’s truth in their law (vv. 17–20), he insists that it is only the doing of the law, not the simple possession of the law, that will satisfy God. There is nothing at all inconsistent, then, with Paul’s positive response in v. 2, “much,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.181.13",
      "id": "FN.181.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" in every way.” “In every way,” if taken literally, claims an advantage for the Jew “in every respect,” but Paul’s meaning is more likely to be that the Jews’ advantage extends to a significant number of matters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.181.14",
      "id": "FN.181.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" What specific matters Paul may have in mind, in addition to the one advantage actually listed in this verse, can be gathered from 9:4–5: “adoption, the glory, the covenants, the giving of the law, the worship, and the promises; … the patriarchs, and of their race according to the flesh, … Christ.” That Paul "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.182"
    }
  }), _vm._v("intended to list more than the one item he actually includes is suggested by the phrase “first of all.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.15",
      "id": "FN.182.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" Indeed, some think the word may mean simply “chiefly,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.16",
      "id": "FN.182.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" or be used to single out that advantage which stands supreme among the other privileges,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.17",
      "id": "FN.182.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" but it is likely that Paul intended to give a longer list, only to be forestalled by his concern about the Jews’ response to “the oracles” and its implications."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.18",
      "id": "FN.182.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', [_vm._v("Even if the syntax does not justify our translating “chiefly,” it is clear that the first advantage Paul enumerates is the supreme privilege granted to the Jews: “they have been entrusted with"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.19",
      "id": "FN.182.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿19")]), _vm._v(" the oracles of God.” Paul uses the third person (“they”) because, as in 9:1–5, he is thinking not of all Jews, including Jewish-Christians like himself, but only of unbelieving Jews. The word “oracles” (e.g., “divine utterances”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.20",
      "id": "FN.182.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" is used in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of Balaam’s “oracle” (Num. 24:4, 16) and frequently of God’s “words” to his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.21",
      "id": "FN.182.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" The general meaning of the word gives rise to a plethora of suggestions about its specific reference here: “unmistakably divine” utterances of the OT;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.22",
      "id": "FN.182.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" God’s self-revelation in both the OT and NT;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.23",
      "id": "FN.182.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" the law, especially the Decalogue;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.24",
      "id": "FN.182.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" and the promises of the OT,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.25",
      "id": "FN.182.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" or the OT as a whole, with special reference, perhaps, to the promises."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.182.26",
      "id": "FN.182.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" Of these alternatives, the last suits best the general application of the word in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" and the NT. Paul sets forth "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.183"
    }
  }), _vm._v("as the greatest of Jewish distinctions the fact that God has spoken to them and entered, with these words, into a special relationship with them. Material, though not linguistic, parallels to Paul’s assertion are found in Deut. 4:8—“What other nation is so great as to have such righteous decrees and laws as this body of laws I am setting before you today?”—and Ps. 147:19–20—“He has revealed his word to Jacob, his laws and decrees to Israel. He has done this for no other nation; they do not know his laws.” That the promises of God are included in “the oracles” is, of course, obvious; and Paul has probably chosen to use this word, rather than, for example, “the Scriptures,” because he wants to highlight those “sayings” of the OT in which God committed himself to certain actions with reference to his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.183.27",
      "id": "FN.183.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" This nuance is suggested also by the words “unbelief” and “unfaithfulness” (v. 3) to designate Israel’s failure and the words “faithfulness” and “reliability” to denote God’s commitment.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3")]), _vm._v(" Being entrusted with the stewardship of God’s revelation is a great distinction. But in light of the sad history of Israel’s rebellion, a rebellion that has (largely) continued right up to the present time, it could be asked whether this distinction any longer has meaning. This is the question raised in v. 3, as Paul departs from his “script” to deal with implications of, and objections to, his assertion of Jewish “advantage.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.183.28",
      "id": "FN.183.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The precise form of that question, however, hinges on how the verse is punctuated and whether any of it is to be attributed to an objector. One alternative is to follow most English translations and divide the verse into two substantive questions: “What if some were unfaithful? Will their faithlessness nullify the faithfulness of God?” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _vm._v("). On this reading, the first question could be that of an objector to Paul, with the second, rhetorical, question being his response. The objector: “But Paul, what of the fact that some Jews have not proven faithful?” Paul: “What of it—their unfaithfulness cannot cancel God’s faithfulness, can it?” Another option is to attribute both questions to Paul: “What, you might ask, of the fact that some Jews have not proven faithful? This does not mean, does it, that God will be any less faithful on his part?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.183.29",
      "id": "FN.183.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" It is also possible, however, to divide the verse into a short interjectory question—“For what then?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.183.30",
      "id": "FN.183.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v("—and a longer substantive question—“Though some of them were unfaithful, their unfaithfulness will not nullify the faithfulness of God, will it?” The substantive question may then be that "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.184"
    }
  }), _vm._v("of an objector"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.31",
      "id": "FN.184.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" or be Paul’s own."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.32",
      "id": "FN.184.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" Paul’s preference for short, pointed, questions when he writes in the dialogical style favors this second punctuation, and it is probable that Paul himself formulates the question."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.33",
      "id": "FN.184.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', [_vm._v("Paul’s use of “some”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.34",
      "id": "FN.184.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" to designate the unfaithful Jews must be motivated partially by a desire to lessen the offense, since Rom. 9–11 shows that he regarded most Jews as having failed to respond appropriately to God’s word."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.35",
      "id": "FN.184.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" By using the words “be unfaithful” and “unfaithfulness” to denote the Jews’ failure, Paul creates an ironic antithesis to “entrust” in v. 2: God’s “entrusting” of “the oracles” to Israel has not met with a corresponding “trust” on their part."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.36",
      "id": "FN.184.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" But, more importantly, these words point up the contrast between Israel’s “faith"), _c('i', [_vm._v("less")]), _vm._v("ness” and God’s “faith"), _c('i', [_vm._v("ful")]), _vm._v("ness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.37",
      "id": "FN.184.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" This faithfulness of God, a concept that Paul picks up from the OT, refers especially to God’s commitment to carry out the terms of the covenant with Israel. In contrast, then, the Jews’ “faithlessness” will denote particularly their failure to meet their covenant obligations."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.38",
      "id": "FN.184.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" “Faith” in God and the promises is, of course, a significant and indispensable ingredient of true faithfulness to the covenant, and in that sense “lack of belief” is not excluded by this translation. Particularly, especially in light of 11:17, we should include in this “unfaithfulness” to the word of God the Jews’ failure to embrace Jesus as the Messiah promised by that word."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.184.39",
      "id": "FN.184.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" While, then, Paul’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.185"
    }
  }), _vm._v("reference cannot be confined to the failure of Jews to believe in Christ, this would certainly be a prominent component of his meaning."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.185.40",
      "id": "FN.185.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" But, as is also the case in some of the key OT passages, Paul affirms that the failure of “some” Jews to abide by the terms of the covenant does not “nullify”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.185.41",
      "id": "FN.185.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" God’s continuing care for and commitment to his people.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("4")]), _vm._v(" The form of the question in v. 3 has already anticipated its answer; but Paul leaves no doubt. He uses a formula of emphatic rejection, variously translated “God forbid” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v("), “Of course not!” (Phillips), and, most literally, “May it never be!” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.185.42",
      "id": "FN.185.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" The contrast in v. 4a between God’s being “true” and the human being a “liar” restates the contrast between Israel’s unfaithfulness and God’s faithfulness in v. 3. When the OT speaks of God being “true,” it usually means not that he is honest but that he is reliable, or trustworthy; “true” to his word."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.185.43",
      "id": "FN.185.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" And, while the promise to which God is “true” is usually his promise of blessing for his people, God’s truth is also displayed when he carries out his threat of judgment for disobedience. Note especially Neh. 9:32–33, where the Levites acknowledge that God has “done truth” in bringing judgment upon Israel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.185.44",
      "id": "FN.185.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" It is possible, then, that Paul may already be suggesting what is made explicit in v. 4b: that God is “reliable,” faithful in fulfilling his word, even when people suffer his judgment.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.186"
    }
  }), _vm._v("Paul continues to enhance the contrast between God and human beings by again (cf. “unfaithfulness” versus “faithfulness” in v. 3) choosing linguistic opposites to make his point: “Let God be true, though every person is a liar.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.186.45",
      "id": "FN.186.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Just as “true” characterizes God as being one who is reliable, so “liar,” by contrast, and with analogies in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", designates human beings as “unreliable, perfidious, faithless.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.186.46",
      "id": "FN.186.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" The precise meaning of this assertion is not clear."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.186.47",
      "id": "FN.186.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Cranfield thinks that it refers generally to the nature of human beings as opposed to God. Wilckens confines the reference to Jews, arguing that Paul is condemning them all as covenant breakers. Käsemann, finding in “every” evidence of a significant move from Israel to the world at large, and interpreting v. 4b as an apocalyptic trial scene, argues that v. 4a pictures God as the victor and the human being as the loser in this trial. However, a concessive translation (“though,” as in most of the English versions) makes perhaps best sense. Not only is God faithful when “some” are unfaithful, but he remains true "), _c('i', [_vm._v("even if")]), _vm._v(" every person should prove unreliable.")]), _vm._v(" "), _c('p', [_vm._v("Paul uses his customary introductory formula—“just as it is written”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.186.48",
      "id": "FN.186.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v("—to introduce a quotation from Ps. 51:4 that substantiates his point about the reliability and consistency of God: “so that you may be justified in your words, and that you might triumph when you judge.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.186.49",
      "id": "FN.186.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Psalm 51 is David’s moving "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.187"
    }
  }), _vm._v("confession of his sin with Bathsheba, and v. 4b is a purpose clause in which David expresses the intention either of his confession (v. 3) or of his sin (v. 4a)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.187.50",
      "id": "FN.187.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" This purpose is that God might be “right”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.187.51",
      "id": "FN.187.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" in the sentence he has pronounced over David (cf. 2 Sam. 12:9–14) and “be clear” in his judgment of him. What makes Paul’s quotation of this verse difficult is that the negative application of God’s justice in the Psalm—God is right when he judges—is used to support what is apparently a positive revelation of God’s faithfulness to his people (vv. 3–4a). It is possible, of course, that Paul uses the quotation very generally to support the notion that God is faithful. But if this were so, it is peculiar that he would include the troublesome “in order that” or the second line in his quotation. If we seek a closer connection between the quotation and the context, three main possibilities present themselves.")]), _vm._v(" "), _c('p', [_vm._v("(1) Paul might ignore the original meaning of the Psalm verse and quote it with a positive meaning. On this view, the second line would be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.188"
    }
  }), _vm._v("translated “and that you might triumph "), _c('i', [_vm._v("when you are judged.")]), _vm._v("”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.188.52",
      "id": "FN.188.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" While this interpretation gives a satisfactory sense, it suffers from the necessity to give the words in Romans a very different meaning from what they have in the Psalm. While Paul can sometimes quote the OT without reproducing the exact meaning of the original, it is not wise to suggest such a solution unless it becomes necessary. Moreover, it is likely that we should translate the key verb “when you judge.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.188.53",
      "id": "FN.188.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('p', [_vm._v("(2) A second possibility, then, is to understand the quotation to be demonstrating “what sins do "), _c('i', [_vm._v("not")]), _vm._v(" do to God (abrogate his faithfulness) by showing what in fact they "), _c('i', [_vm._v("do")]), _vm._v(" do to God (justify his judgment).”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.188.54",
      "id": "FN.188.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" This view has the merit of maintaining the original meaning of Ps. 51:4b, but must take it as supporting, not v. 4a, with which it is directly connected, but v. 3.")]), _vm._v(" "), _c('p', [_vm._v("(3) We are left, then, with the third alternative—that Paul quotes a verse expressing the faithfulness of God when he judges sin because the “truthfulness” of God in v. 4a itself includes this negative aspect of God’s faithfulness to his word."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.188.55",
      "id": "FN.188.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" “The oracles of God” include warnings that God will judge sin as well as promises that he will bless his people. Because of this, the OT insists that God is equally faithful when he judges his people’s sin and when he fulfills his promises."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.188.56",
      "id": "FN.188.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" We must assume, then, a transition of sorts between vv. 3 and 4. The faithfulness of God is expressed generally in v. 3 and would undoubtedly imply, to a Jewish objector as well as to the readers, a commitment on God’s part to maintain Israel’s special and blessed place in God’s purpose. In v. 4, however, Paul shows that God’s faithfulness must also be recognized when he judges his people’s sins. As Paul has shown at length in chap. 2, the special place of the Jews in God’s plan does not protect them from the judgment of God. In 3:1–4, Paul reaffirms their special status by appealing to the invariability of God with respect to his word. But he also reminds us that this word includes warnings of judgment as well as promises of blessing. It is “the Jew first,” but in judgment (2:9) as well as blessing (1:16; 2:10).")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.189"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" Verse 5, which is parallel in form to v. 3, is Paul’s statement of a possible objection to his teaching in vv. 1–4: “But if our unrighteousness commends the righteousness of God, what shall we say?” Paul is himself responsible for the formulation of this objection, as is clear from (1) the transitional clause “what shall we say,” which Paul always uses to introduce his own conclusion or question, (2) the form of the question,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.189.57",
      "id": "FN.189.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" and (3) the “apology” at the end of the verse for the “human” way of putting the problem. While the objection Paul formulates in this question may come in response to the argument in vv. 3–4a,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.189.58",
      "id": "FN.189.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" its basis is more likely to be found in v. 4b. This is suggested by the similarity between v. 5a and v. 4b in both vocabulary"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.189.59",
      "id": "FN.189.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿59")]), _vm._v(" and content: the issue in both is the causal relationship between human sin and God’s righteousness. It is hard to know whether “our unrighteousness” has a general meaning—human sinfulness"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.189.60",
      "id": "FN.189.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿60")]), _vm._v("—or a narrower focus—Jewish unfaithfulness."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.189.61",
      "id": "FN.189.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" On the one hand, Paul never elsewhere uses “unrighteousness”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.189.62",
      "id": "FN.189.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" to denote specifically Jewish unfaithfulness, and the first person plural “our,” in light of “every person” in v. 4, could naturally denote Paul, his readers, and people in the most general sense. On the other hand, “unrighteousness” is parallel to “unfaithfulness” (v. 3) and “liar” (v. 4), both of which specify Jewish unfaithfulness to the covenant. What tips the scales slightly in favor of the latter view is the concern of Paul with the implications of Jewish disobedience throughout this passage.")]), _vm._v(" "), _c('p', [_vm._v("Just as “our unrighteousness” parallels “unfaithfulness,” so we would expect “God’s righteousness” to parallel “the faithfulness of God” (v. 3). God’s “righteousness” can denote his faithfulness, as "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" usage makes clear (see the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY2"
    }
  }, [_vm._v("excursus")]), _vm._v(" after 1:17 for details). But this is not to say that the phrase must denote God’s "), _c('i', [_vm._v("covenant")]), _vm._v(" faithfulness specifically or that this faithfulness must be limited to God’s “saving” faithfulness. In fact, the context points to a broader notion, since the cognate verb “be in the right” in v. 4b designates God’s being in the right when he "), _c('i', [_vm._v("judges.")]), _vm._v(" Of course, this argument would not apply if Paul were quoting an objector here. But we have seen that, even if an objection lies below the surface, it is Paul who is responsible for the formulation of the verse. In light of v. 4b, then, “God’s righteousness” cannot "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.190"
    }
  }), _vm._v("refer to God’s saving righteousness,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.63",
      "id": "FN.190.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" nor to his “[distributive] justice” (his “fairness”),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.64",
      "id": "FN.190.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" nor to his fidelity and forensic victory over all creation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.65",
      "id": "FN.190.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" Nor is he using the phrase in the same way as he did in 1:17, to describe the activity by which God justifies people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.66",
      "id": "FN.190.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" Rather, “God’s righteousness” here designates God’s faithfulness to his own person and word, particularly, as v. 4b reveals, as this is revealed in his judgment of sin."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.67",
      "id": "FN.190.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" This broad application of the phrase has parallels in the OT, and God’s being “true” in v. 4a, as we suggested, may already encompass this dimension of God’s reliability.")]), _vm._v(" "), _c('p', [_vm._v("If human sin has “manifested” something good—for even if God’s righteousness is expressed in judgment, that righteousness is still good"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.68",
      "id": "FN.190.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿68")]), _vm._v("—it might well be asked if God is not “unjust” when he punishes that sin. The reference is to the eschatological wrath that God will “inflict”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.69",
      "id": "FN.190.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" on the last day; and since “unrighteousness” in v. 5a refers to the sin of Jews, they are also the objects of this wrath. It is generally assumed that Paul uses “unjust”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.190.70",
      "id": "FN.190.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" with the meaning “unfair,” “acting against principles of justice.” But several expositors argue that the word continues the covenantal emphasis of the previous verses. They maintain that the question raised in this verse has behind it the Jewish conviction that God’s “righteousness” guarantees salvation to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.191"
    }
  }), _vm._v("Israel. Is not, then, God in violation of this covenant agreement—"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("a-dikos,")]), _vm._v(" “acting against his commitment to Israel”—if he inflicts wrath on his covenant people?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.191.71",
      "id": "FN.191.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" This interpretation correctly sees a certain Jewish view of divine righteousness behind the passage and establishes continuity with vv. 3–4. But it cannot give a satisfactory explanation for the sequence of sentences in vv. 5–6a. If v. 5 is attributed to an objector, who assumes that God’s righteousness is purely salvific,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.191.72",
      "id": "FN.191.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" it is hard to understand why v. 5a speaks of human sin “manifesting” God’s righteousness. In addition, as we have seen, it is unlikely that v. 5 can be construed as the statement of an objector.")]), _vm._v(" "), _c('p', [_vm._v("On the other hand, if v. 5 is attributed to Paul, with v. 5b the logical conclusion to be drawn from the assertion of God’s punitive righteousness in v. 5a,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.191.73",
      "id": "FN.191.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" these difficulties are avoided, but others are encountered. Primary among these is the emphatic “By no means!” in v. 6a, which always rejects a false conclusion in Paul. This strong rejection makes little sense if Paul has already stated his conclusion in v. 5b. The only way to make sense of the sequence of thought, then, is to view the issue in v. 5 as the “justness” of God’s condemning Jews for sins that manifest his righteousness. This “justness,” in keeping with the theocentric focus of Scripture, is not God’s conformity to some external norm, but his acting in accordance with his own character. Paul has already used "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dik-")]), _vm._v(" language in this broader sense in 2:5, where he affirmed that the judgment of God will be just, being based on the works of each person. Now the question is posed whether this principle can still hold when the sinful works of God’s people manifest his own righteousness. But Paul’s concern to distance himself from any suggestion that God might be unrighteous leads him immediately to add the parenthetical “I am speaking in a human fashion.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.191.74",
      "id": "FN.191.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" With his characteristic “By no means,” Paul makes emphatically explicit what was already implicit in the way he formulated the matter in v. 6: God certainly does not act “unjustly” if he inflicts wrath on his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.191.75",
      "id": "FN.191.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" And "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.192"
    }
  }), _vm._v("Paul explains his rejection with a counterquestion: “For how, then, would God judge the world?” The point of this question is to draw out the absurd and clearly impossible consequences of the supposition stated in v. 5. It is certainly not the case that God is unjust to inflict wrath, for if it were otherwise"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.192.76",
      "id": "FN.192.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿76")]), _vm._v(" (that is, if God were unjust), how could God judge the world? While Paul clearly appeals to a principle that he, his readers, and any objectors would agree to, the exact purpose of the citation in unclear. Most expositors think that Paul alludes to the OT doctrine that “the Judge of all the earth must deal justly” (Gen. 18:25). And while some commentators have suggested more pointed or more subtle interpretations,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.192.77",
      "id": "FN.192.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" it is probably simply this point that Paul wants to make. Since the justice of God as judge has been questioned, it is reasonable for Paul to allude to the common OT postulate that attributes absolute justice to God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.192.78",
      "id": "FN.192.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("7")]), _vm._v(" Uncertainty about the logical progression of the passage arises again in v. 7. And since this verse is joined to v. 8 by “and,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.192.79",
      "id": "FN.192.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" a decision about the function of v. 7 will determine also the function of v. 8. There are two main possibilities. First, these verses may repeat and elaborate the objection in v. 5: How is it fair for God to judge me if my sin brings him glory (v. 7); and does not this viewpoint of yours, Paul, actually encourage sin (v. 8a)? To these renewed objections, Paul replies simply with a pronouncement of judgment (v. 8b)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.192.80",
      "id": "FN.192.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" The second possibility is that these verses explain v. 6. The reason why God could not judge the world if it were unfair for him to punish sins that manifest his righteousness (v. 6) is that anyone (“I”) could come before God with the same excuse (v. 7). Moreover, Paul reasons, does not such a view actually encourage sin (v. 8a)?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.192.81",
      "id": "FN.192.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" The issue, then, is whether these verses contain further objections to Paul’s teaching, or Paul’s reply to his objectors. Both interpretations are "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.193"
    }
  }), _vm._v("compatible with the viewpoints that Paul and his interlocutor have adopted in the paragraph."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.193.82",
      "id": "FN.193.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', [_vm._v("One of the major disadvantages of finding in these verses further objections to Paul’s teaching is the apparent failure of Paul to make any reply to them. Would Paul have cited such serious accusations about his doctrine and been content simply to condemn their advocates? The second reading, to its undeniable advantage, avoids this problem. But it suffers from an even greater one: v. 7 does not naturally read as an explanation of v. 6. If this had been Paul’s intention, we would have expected him to have made explicit a key link in the argument—that the sins of all people lead to God’s glory—and to have phrased the question in these general terms (e.g., “who, then, could be judged as a sinner?”). Verse 7 reads much more naturally as a reiteration (“from the side of man” ["), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SH"
    }
  }, [_vm._v("S-H")]), _vm._v("]) of the objection stated in v. 5. Both vv. 5–6 and vv. 7–8, then, take up the problem created by Paul in v. 4, the former verses relating to v. 4b and the latter to v. 4a, in a chiastic arrangement."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.193.83",
      "id": "FN.193.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', [_vm._v("I take it, then, that Paul in v. 7 is restating the basic objection heard already in v. 5: “if the truth of God abounded"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.193.84",
      "id": "FN.193.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿84")]), _vm._v(" to his glory through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.193.85",
      "id": "FN.193.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿85")]), _vm._v(" my lie, why am I"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.193.86",
      "id": "FN.193.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿86")]), _vm._v(" yet"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.193.87",
      "id": "FN.193.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿87")]), _vm._v(" being judged as a sinner?” This being the case, his use of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.194"
    }
  }), _vm._v("the first person singular is a rhetorical variant of the first person plural in v. 5. It is clear, however, from the formulation of the objection, that Paul is speaking more in the person of the objector himself than he was in v. 5. This objector is likely once again to be the Jew, who questions why God should treat him like other “sinners” when his unfaithfulness has been the occasion for God’s faithfulness and led to an increase in his glory. The contrasting words “truth” and “lie” are picked up from v. 4a, and the covenantal flavor of the words there will be present here also. The new word in the verse, “glory,” makes more specific the positive implications of “righteousness” in v. 5, and thereby sharpens the objection. As in vv. 4b and 5a, the central concern is again the relationship between Jewish unrighteousness and divine righteousness/glory.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("8")]), _vm._v(" If v. 7 is an objector’s question, then v. 8 can be understood in one of two basic ways: either it adds a second objection, parallel to the one in v. 7,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.194.88",
      "id": "FN.194.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿88")]), _vm._v(" or it responds to the objection of v. 7 with a rhetorical counterquestion."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.194.89",
      "id": "FN.194.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" In favor of taking the verse as an additional objection is the “and” that joins the verses and the fact that “let us do evil that good may come” is a natural reaction to Paul’s stress on God’s providential use of even human sin, as the parenthetical statement clearly shows. Construing the verse as Paul’s reply to the objection of v. 7, on the other hand, supplies a response from Paul that would otherwise be missing, and provides a more natural explanation for the form of the question"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.194.90",
      "id": "FN.194.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿90")]), _vm._v(" and for the shift from the first person singular of v. 7 to the plural of v. 8. If Paul intended v. 8 as a reply to v. 7, however, it is almost inconceivable that he would have introduced it with “and” rather than “but”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.194.91",
      "id": "FN.194.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" or even “By no means!” This “and” suggests that the main clause of v. 8 is coordinate with v. 7 and thus continues the Jewish objector’s criticism of Paul’s doctrine."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.194.92",
      "id": "FN.194.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")]), _vm._v(" If vv. 7–8 are then "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.195"
    }
  }), _vm._v("connected in this manner, it is better to view v. 8 as a separate question than as a continuation of the sentence of v. 7."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.195.93",
      "id": "FN.195.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿93")]), _vm._v(" The verse presents certain other syntactical problems, but they are best resolved in the way reflected in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(": “Why not say—as we are being slanderously reported and as some claim that we say—‘Let us do evil that good may result’?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.195.94",
      "id": "FN.195.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('p', [_vm._v("Paul wants to say two things: that he (and other apostles?) has been accused of teaching the very doctrine that the Jewish objector claims is the logical conclusion of his viewpoint, and that such accusations are “blasphemous.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.195.95",
      "id": "FN.195.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" Paul indicates that the objection to his teaching that he puts here in the mouth of a Jewish objector is one that he has heard before and one, more than likely, that the Roman Christians had also heard."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.195.96",
      "id": "FN.195.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" Why, then, does Paul not answer the objection? A very common suggestion is that Paul does so, but not until Rom. 6—note the similarity between what is said here and 6:1: “should we continue in sin in order that grace might increase?” However, 6:1 is the question of a Christian in light of the abundance of God’s grace; the objection here is posed by a Jew, questioning whether his or her actions really have any meaning in light of Paul’s assertion that even sin leads to God’s glory."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.195.97",
      "id": "FN.195.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(" And Paul’s response in Rom. 6 is not really appropriate to the issue raised here. We must suppose, then, that Paul intends the very absurdity of the objection to imply its dismissal. The viewpoint taken by the Jewish objector, that it would not be right for God to punish his people for their sins, is implied to be fallacious, and, indeed, blasphemous, by the absurd conclusion to which his objection leads."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.195.98",
      "id": "FN.195.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.196"
    }
  }), _vm._v("Depending on what we identify as the antecedent of “whose,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.99",
      "id": "FN.196.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")]), _vm._v(" the final sentence of v. 8 may state the “justness” of God’s condemnation"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.100",
      "id": "FN.196.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿100")]), _vm._v(" of the evil actions of people, such as are mentioned in vv. 7–8,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.101",
      "id": "FN.196.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿101")]), _vm._v(" or of some particular people who have been mentioned in vv. 7–8—those who have maligned Paul,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.102",
      "id": "FN.196.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" the person claiming exemption from God’s judgment in v. 7,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.103",
      "id": "FN.196.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿103")]), _vm._v(" or the people arguing “let us do good that evil may come” in v. 8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.104",
      "id": "FN.196.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿104")]), _vm._v(" Or, if we understand this curt sentence of judgment as the capstone to Paul’s argument in 2:1–3:8, the antecedent could be the Jews generally."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.105",
      "id": "FN.196.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" The closest, and most natural, antecedent is the subject of the main clause in v. 8—those who object that Paul’s doctrine encourages the practice of sin. But, since these people are expressing essentially the same viewpoint as the “I” in v. 7, Paul’s sentence of condemnation embraces the objectors in vv. 7–8 as a whole. Paul, then, both rejects the excuse put forward in v. 7—God "), _c('i', [_vm._v("is")]), _vm._v(" “just” to judge the sinner whose “lie” brings God glory—and imposes the sentence appropriate for the “blasphemy” of those who have maligned Paul and, by implication, the God who has manifested his righteousness in Christ. This paragraph concludes on the note that sounds throughout Rom. 1:18–3:20 as a key theme: the “justness”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012a#FN.196.106",
      "id": "FN.196.106r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")]), _vm._v(" of God’s judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("In sum: Paul begins by warning his readers not to draw the wrong conclusion from his invective against Jewish presumption of salvation through circumcision and the law (chap. 2). God is faithful to his promises to Israel; his “righteousness” is steady and dependable. But Paul quickly turns from defense of Israel to further attack, reminding the Roman Christians that God’s faithfulness is ultimately not to Israel but to his own person and promises. God is therefore “righteous” when he punishes his people for their sin as well as when he rewards them for obedience. But this does not mean, Paul concludes, that we should excuse sin simply because it always magnifies God’s righteousness. Such an attitude brings God’s own name into disrepute.")]), _vm._v(" "), _c('p', [_vm._v("The problem Paul attacks in these verses is not confined to the people of God of his day. All too often we Christians have presumed that God’s grace to us exempts us from any concern about our sin. Particularly is this a danger among Christians who share with me the belief that God sovereignly maintains "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.197"
    }
  }), _vm._v("the regenerate in their salvation till the end. Too easily do we forget that God’s ultimate concern is for his own glory and not for our blessing; that his righteousness is beautifully displayed when he judges as well as when he saves. We want to “stand on the promises”—and this is entirely appropriate. But we must not forget that God promises (in the NT as well as in the OT) to rebuke and chastise his people for sin as well as to bless them out of the abundance of his grace.")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY3.1.3"
    }
  }, [_vm._v("3. The Guilt of All Humanity (3:9–20)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _c('i', [_vm._v("What then? Do we have an advantage? By no means!")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.197.1",
      "id": "FN.197.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" For we have already accused all people, whether Jews or Greeks, of being under sin. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("Even as it is written,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("There is no one who is righteous,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("there is no one who understands,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("there is no one who seeks for God.")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("All have turned aside and together gone wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("There is no one who is doing good,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("there is not"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.197.2",
      "id": "FN.197.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" even one person."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.4.A",
      "id": "FN.4.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")])]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("Their throat is an open grave,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("they speak deceptively with their tongues,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.5.B",
      "id": "FN.5.Br",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b")])]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.198"
    }
  }), _vm._v("and the poison of asps is under their lips."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.6.C",
      "id": "FN.6.Cr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c")])]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("Their mouth is filled with curses and bitterness,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.7.D",
      "id": "FN.7.Dr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d")])]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("their feet are swift to shed blood,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("ruin and misery are in their paths,")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("and they do not know the way of peace."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.8.E",
      "id": "FN.8.Er",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e")])]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("There is no fear of God in their eyes."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.9.F",
      "id": "FN.9.Fr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f")])]), _vm._v(" "), _c('p', {
    staticClass: "wlf"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("Now we know that whatever the law says, it speaks to those who are in the law, in order that every mouth might be stopped and the whole world be held accountable to God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("For no human being will be justified before him by works of the law, for through the law comes knowledge of sin.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("While the brief questions that open v. 9 connect it with the dialogue of vv. 1–8,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.198.3",
      "id": "FN.198.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" it is also clear that Paul is moving toward a summary and application of the teaching he has been developing since 1:18. He labels this long section an “accusation.” In it, he charges all people, Jews and Gentiles, with being “under the power of sin” (v. 9b). A string of loosely related OT quotations confirms the universality and describes the variety of the sin that so characterizes all humanity (vv. 10–18). Finally, in vv. 19–20, Paul draws out the implications of this universal bondage to sin: all stand condemned before the divine bar of judgment and are unable to escape that condemnation by anything they do. Thus is the way prepared for the proclamation of God’s righteousness in Christ (vv. 21–26).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9")]), _vm._v(" The opening words of v. 9 present several related problems, involving the original text, the punctuation, and the meaning. Assuming the text printed in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NA"
    }
  }, [_vm._v("NA")]), _c('sup', [_vm._v("27")]), _vm._v(", and accepted by the great majority of scholars, to be correct,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.198.4",
      "id": "FN.198.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" it is most natural to divide the opening words of the verse into two questions—“What then?” “Do we have an advantage?”—with a short answer to the second—“By no means!” Following the diatribe style, Paul uses the brief transitional “What then?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.198.5",
      "id": "FN.198.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" to introduce a question stimulated by something that has been said in the previous discussion. Precisely what in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.199"
    }
  }), _vm._v("his earlier teaching it is that stimulates the question depends on just what this question is. For both the meaning of the verb Paul uses"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.199.6",
      "id": "FN.199.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿6")]), _vm._v(" and the identity of the persons he has in mind with his first person plural form—“we Jews,” “we Gentiles,” “we Christians,” “we apostles,” Paul himself?—are uncertain. Four main possibilities must be considered.")]), _vm._v(" "), _c('p', [_vm._v("(1) “Am I [Paul] making an excuse for the Jews?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.199.7",
      "id": "FN.199.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Since the second verb in this verse—“we have already accused”—has Paul as its subject, we might well think that the first verb does also. This solution makes good contextual sense also: in reply to the question whether Paul is trying to excuse the Jews, he responds, “No! For I have already accused both Jews and Greeks.…” But this rendering has an insuperable lexical problem: it must assume, against all evidence of usage, that the object of the “excusing”—the Jews—is different from its subject—Paul.")]), _vm._v(" "), _c('p', [_vm._v("(2) “Are we Jews trying to excuse ourselves?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.199.8",
      "id": "FN.199.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" If Paul is not the subject of the verb, then the next most likely option would seem to be that the Jews are. For, as we have seen, the Jews are probably the subject in most of the first person verbs in vv. 5–8. But to make the Jews the subject of the verb would require that we paraphrase the question to mean something like “Do we Jews have anything to protect us from God’s wrath?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.199.9",
      "id": "FN.199.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" And this reads more into the verb than is justified.")]), _vm._v(" "), _c('p', [_vm._v("(3) “Are we Jews surpassed [by them]”; “Are we Jews at a disadvantage?” (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _vm._v("mg, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.REB"
    }
  }, [_vm._v("REB")]), _vm._v("mg)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.199.10",
      "id": "FN.199.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" Such a question might seem inappropriate to the context, since 3:1–8 has stressed the privileges, not the disadvantages, of the Jews."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.199.11",
      "id": "FN.199.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" But such an objection fails to reckon with the polemic against Jewish covenant security in vv. 4–8. In light of Paul’s stress in those verses on the reality of God’s judgment of his people (vv. 4, 5b, 8b), it would be quite natural for Paul’s Jewish discussion partner to ask whether Jews were, then, at a disadvantage, and for Paul to reject that inference with a reminder that he had already condemned Gentiles as well as Jews. On the other hand, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.200"
    }
  }), _vm._v("nothing in the previous context has suggested that the Jews might be "), _c('i', [_vm._v("worse off")]), _vm._v(" (even if they are no better off) than the Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.200.12",
      "id": "FN.200.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_vm._v("(4) “Do we Jews have an advantage?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.200.13",
      "id": "FN.200.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" On this view, the question would be stimulated by the assertion of Jewish “advantage” in vv. 1–3, an assertion that Paul wants to qualify by warning again that, whatever historical privileges the Jews may have, these do not place Jews in a superior position in God’s judgment. Since affirming distinguishing privileges for the Jewish people after the polemic of 2:17–29 is Paul’s main intention in 3:1–8 (however far from that he may have strayed with qualifications and discussion), tying the question of v. 9 back to that point presents no difficulty. The main problem with this view is linguistic: no other example of this form of the verb with this meaning has been found,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.200.14",
      "id": "FN.200.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" and no early Christian interpreter apparently took the verb this way."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.200.15",
      "id": "FN.200.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" This makes a decision between the third and the fourth views very difficult. Fortunately, though the translations are at opposite poles, these alternatives do not materially alter the central point: Gentile and Jew are on equal terms when it comes to the judgment of God.")]), _vm._v(" "), _c('p', [_vm._v("Whether Paul asks if the Jews are at a disadvantage or an advantage, his answer is a negative one."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.200.16",
      "id": "FN.200.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" At first sight, it might seem that this answer conflicts "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.201"
    }
  }), _vm._v("with what Paul has said in vv. 1–2. But Paul is making complementary, not contradictory, points. The Jews have an unassailable salvation-historical advantage: God has spoken to them and he has given them promises that will not be retracted (vv. 1–2). But, as Paul has repeatedly emphasized in chap. 2, the Jews have no advantage at all when it comes to God’s impartial judgment of every person “according to his or her works.” And this is the issue that Paul is addressing in v. 9, as his explanation"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.201.17",
      "id": "FN.201.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿17")]), _vm._v(" of his negative response indicates: “we have already accused"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.201.18",
      "id": "FN.201.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿18")]), _vm._v(" all people, whether Jews or Greeks, of being under sin.” Paul is referring to the comprehensive indictment of humanity in 1:18–2:29, as first the Greek or the Gentile (1:19b–32) and then the Jew (2:1–29) were brought before the divine bar and found wanting. We have, then, in this statement, Paul’s own comment on his purpose in this section of his letter. All people who have not experienced the righteousness of God by faith are “under sin”: that is, they are helpless captives to its power."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.201.19",
      "id": "FN.201.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" However arrived at, Paul’s understanding that all people, Jews as well as Gentiles, were not just sinners but helpless pawns under sin’s power, distinguished him sharply from his Jewish contemporaries."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.201.20",
      "id": "FN.201.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Nothing that Paul has said suggests that there are exceptions to this rule, and nothing shows more clearly the desperate need for the message of the gospel. For the problem with people is not just that they commit sins; their problem is that they are enslaved to sin. What is needed, therefore, is a new power to break in and set people free from sin—a power found in, "), _c('i', [_vm._v("and only in,")]), _vm._v(" the gospel of Jesus Christ.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.202"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("10a")]), _vm._v(" “Even as it is written”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.202.21",
      "id": "FN.202.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" is the formula Paul typically uses to introduce quotations of the OT. But nowhere else does Paul use a quotation so long or one drawn from so many different (at least six) OT passages. There are resemblances between this collection of thematically linked verses and what the rabbis called “pearl-stringing,” and some have suggested that Paul is quoting an early Christian psalm or “florilegium.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.202.22",
      "id": "FN.202.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" This is not clear, however; and, in any case, Paul’s purpose in citing these verses is clearly to substantiate the accusation of v. 9, and, in particular, his claim that sin is universal. Thus, the “all” of v. 9 is taken up in the repeated “there is no”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.202.23",
      "id": "FN.202.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" of the quotations; and the way is prepared, in turn, for the application of vv. 19–20: “"), _c('i', [_vm._v("every")]), _vm._v(" mouth,” “"), _c('i', [_vm._v("all")]), _vm._v(" flesh.” While the collection appears at first sight to be haphazard, there is evidence of attention to structure and sequence. The first line (v. 10) is the heading of what follows, with the last line (v. 18) coming back to the same theme in an inclusio."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.202.24",
      "id": "FN.202.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Verses 11–12 develop the first line with a series of five generally synonymous repetitions of the theme “there is no one righteous,” all introduced with “there is no,” and with a reference to “all people”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.202.25",
      "id": "FN.202.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" breaking them up in the middle (v. 12a). The next four lines (vv. 13–14) describe sins of speech, each line referring to a different organ of speech. Verses 15–17, on the other hand, focus on sins of violence against others. The fact that many of these quotations denounce only the wicked or unrighteous within Israel—and hence do not seem to fit Paul’s universalistic intention—has been taken as indication that Paul’s intention is not to condemn "), _c('i', [_vm._v("all")]), _vm._v(" people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.202.26",
      "id": "FN.202.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" But Paul’s actual intention is probably more "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.203"
    }
  }), _vm._v("subtle; by citing texts that denounce the unrighteous and applying them, implicitly, to all people, including all Jews, he underscores the argument of 2:1–3:8 that, in fact, not even faithful Jews can claim to be “righteous.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.203.27",
      "id": "FN.203.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10b–12")]), _vm._v(" The quotations begin with a series of phrases taken from Ps. 14:1–3 ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" 13:1–3) (Ps. 53:1–3 is almost identical). As is the case with most of the quotations in this series, Paul’s wording agrees closely with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v("."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.203.28",
      "id": "FN.203.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" But there is one important difference: where the Psalms text has “there is no one who does "), _c('i', [_vm._v("good,")]), _vm._v("” Paul has “there is no one who is "), _c('i', [_vm._v("righteous.")]), _vm._v("” Granted the importance of the language of “righteousness” in this part of Romans (cf. 3:4, 5, 8, 19, 20), the word is almost certainly Paul’s own editorial change."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.203.29",
      "id": "FN.203.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" It will thus carry with it Paul’s specifically forensic nuance (cf. 1:17). What he means is that there is not a single person who, apart from God’s justifying grace, can stand as “right” before God. This meaning is not far from David’s intention in the Psalm, as he unfolds the myriad dimensions of human folly.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("13–14")]), _vm._v(" In the rest of the quotations, the focus on the universality of sin is abandoned in favor of a description of representative sins. The inclusion of these verses, which are not directly related to Paul’s purpose, is one of the main arguments for regarding the collection of quotations as pre-Pauline. Taken from three similar denunciations of the wicked in the Psalms, vv. 13–14 depict the sinfulness of human speech. The order of the quotations may intentionally reproduce the sequence of organs involved in producing speech: throat—tongue—lips—mouth."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.203.30",
      "id": "FN.203.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of Ps. 5:9 ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" 5:10) provides the source for the first two lines of v. 13. Describing the throat"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.203.31",
      "id": "FN.203.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" as an “open grave” highlights both the inner corruption and the deadly effects of the speech of the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.204"
    }
  }), _vm._v("psalmist’s enemies. “They speak deceptively"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.32",
      "id": "FN.204.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" with their tongues” refers to the deceptive flatteries of those who intend evil. The last line of v. 13 reproduces the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of Ps. 140:3b ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(" 140:4b; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" 139:4b). The last quotation in this sequence, in v. 14, is adapted from Ps. 10:7 ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" 9:28)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.33",
      "id": "FN.204.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("15–17")]), _vm._v(" The three lines in these verses are all taken from Isa. 59:7–8a, with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" again being the source for the quotations. Verse 15 is an abridgment of Isa. 59:7a."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.34",
      "id": "FN.204.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" That this, rather than Prov. 1:16 (which has in common with Isa. 59:7 the words that Paul quotes), is Paul’s source, is probable because vv. 16–17 continue to use Isa. 59. Verses 16–17, in contrast, contain almost exact quotations of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of Isa. 59:7b–8a."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.35",
      "id": "FN.204.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" While Ps. 14, quoted in vv. 10–12, describes human beings generally and the Psalm verses cited in vv. 13–14 characterize the enemies of the psalmists, Isa. 59:7–8a is directed against the unrighteous in Israel. Again, then, Paul implies that Israel as a whole must now be considered in this category of the “wicked.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("18")]), _vm._v(" The final quotation, from Ps. 36:1b ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(" 36:2b; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" 35:2b), reverts to the introductory “there is not”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.36",
      "id": "FN.204.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" of vv. 10–12, acting therefore as a kind of concluding frame for the series. The text exposes the root error that gives rise to the manifold sins of humanity: lack of “fear of God.” Paul’s wording is again very close to that of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v("."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.37",
      "id": "FN.204.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("19")]), _vm._v(" Paul now draws out the implications of the series of quotations for the position of human beings before the divine judge."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.38",
      "id": "FN.204.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" “We know” introduces a circumstance that would be generally acknowledged by Paul and his readers."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.39",
      "id": "FN.204.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" In this case, the circumstance is the applicability of “whatever the law says”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.204.40",
      "id": "FN.204.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" to those who are “in the law.” The first occurrence of “law” "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.205"
    }
  }), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(nomos)")]), _vm._v(" refers to the series of quotations just concluded. Since these quotations are drawn from the Psalms and Isaiah, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" does not designate, as it usually does in Paul, the law of Moses, the torah, but the OT canon (cf. also 1 Cor. 9:8, 9; 14:21, 34; Gal. 4:21b)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.41",
      "id": "FN.205.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" The second occurrence of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos—")]), _vm._v("“it speaks to those who are in the "), _c('i', [_vm._v("law")]), _vm._v("”—may also refer to the OT as a whole,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.42",
      "id": "FN.205.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" or it may revert to the more usual narrower meaning, “Mosaic law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.43",
      "id": "FN.205.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" The difference is not great since in either case “those in the law” are the Jews, who live within the sphere of"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.44",
      "id": "FN.205.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿44")]), _vm._v(" the revelation of God given in the Scripture/law. This interpretation is preferable to giving "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" the more broad signification of divine law in any form, and, in line with 2:14–15, expanding “those in the law” to include all people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.45",
      "id": "FN.205.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" For, while the explicitly universal terms of the last part of the verse might suggest so broad a scope, this view has against it the close identification of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" with the written Scripture in this context (cf. vv. 10–18). And it is clear that, whatever access to God’s law Gentiles may have, it does not come in this “written,” “inscripturated” form. Paul’s purpose is to insist that the OT passages quoted in vv. 10–18, while not all originally directed to Israel as a whole, are, indeed, “speaking to” the Jews generally. They cannot be excluded from the scope of sin.")]), _vm._v(" "), _c('p', [_vm._v("The purpose for which the words of Scripture address the Jews is “that every mouth might be stopped and the whole world be held accountable to God.” The terminology of this clause reflects the imagery of the courtroom. “Shutting the mouth” connotes the situation of the defendant who has no more to say in response to the charges brought against him or her."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.46",
      "id": "FN.205.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" The Greek word translated “accountable”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.47",
      "id": "FN.205.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" occurs nowhere else in the Scriptures, but it is used in extrabiblical Greek to mean “answerable to” or “liable to prosecution,” “accountable.” Paul pictures God both as the one offended and as the judge who weighs the evidence and pronounces the verdict."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.48",
      "id": "FN.205.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" The image, then, is of all humanity standing before God, accountable to him for willful and inexcusable violations of his will, awaiting the sentence of condemnation that their actions deserve."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.205.49",
      "id": "FN.205.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.206"
    }
  }), _vm._v("But how is it that Paul can use accusations addressed to Jews (“those in the law”) to declare that all people are guilty? Some would limit the reference of “every mouth” to Jews,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.206.50",
      "id": "FN.206.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" but the parallelism with “the whole world” makes this unlikely. Probably Paul is using an implicit “from the greater to the lesser” argument: if Jews, God’s chosen people, cannot be excluded from the scope of sin’s tyranny, then it surely follows that Gentiles, who have no claim on God’s favor, are also guilty."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.206.51",
      "id": "FN.206.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" We must remember that Paul’s chief purpose throughout Rom. 1:18–3:20 is not to demonstrate that Gentiles are guilty and in need of God’s righteousness—for this could be assumed—but that Jews bear the same burden and have the same need. It is for this reason that, while all people are included in the scope of vv. 19–20, there is particular reference to the Jews and their law.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("20")]), _vm._v(" This verse may give the reason why the whole world is accountable to God,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.206.52",
      "id": "FN.206.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" or it may serve to confirm this accountability."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.206.53",
      "id": "FN.206.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" The latter suggestion is best—Paul counters any Jewish evasion of v. 19 by explicitly denying that the law can offer any hope of defense. Paul alludes to the OT to make his point; for his words, while not a quotation, resemble Ps. 143:2b: “no one living is righteous before you.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.206.54",
      "id": "FN.206.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" Paul’s most significant addition, of course, is his reference to the law: it is not “out of works of the law” that a person is justified. The meaning of this phrase, which also occurs in Rom. 3:28; Gal. 2:16; 3:2, 5, 10, has been the subject of considerable debate and influences significantly our understanding of Paul’s doctrines of justification and of the law.")]), _vm._v(" "), _c('p', [_vm._v("Interpreters of Paul have traditionally thought that “works of the law” refers to anything done in obedience to the law, particularly those “good works” that one might put forth as a reason why God should accept a person. These interpreters then viewed “works of the law” as a subset of the larger category “good works”; and they understood this verse, and others like it, to be refuting the idea that a person could gain a right standing with God by anything that that person did."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.206.55",
      "id": "FN.206.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" Alternatives to this interpretation of “works "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.207"
    }
  }), _vm._v("of the law” have been advocated in the past."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.207.56",
      "id": "FN.207.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" But especially popular of late has been the idea that “works of the law” is Paul’s way of referring to Jewish existence—to the Jews’ special covenantal relationship with the Lord, a relationship that came to be expressed especially in the Jews’ observance of those “works of the law,” like circumcision, avoidance of certain food, and observance of special days, that marked them off from their Gentile environment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.207.57",
      "id": "FN.207.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" If we interpret the phrase this way, Paul’s point is that the covenant, as the Jews understood it, is inadequate to maintain them in right standing with the Lord. On this view, in other words, the problem Paul has with the Jews here does not have to do with their "), _c('i', [_vm._v("performance")]), _vm._v(" of the law but with their "), _c('i', [_vm._v("possession")]), _vm._v(" of it. Advocates of this view do not usually trace the inadequacy of the covenant to human inability; they think, rather, that Paul drew this conclusion because Christ’s coming rendered obsolete the Jewish covenant and/or because the Jewish covenant focused too narrowly on the Jewish people to the exclusion of Gentiles.")]), _vm._v(" "), _c('p', [_vm._v("I think, however, that this new interpretation of the phrase “works of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.208"
    }
  }), _vm._v("the law” is wrong. First, the new interpretation is closely related to a new approach to first-century Judaism. And, while this new view of Judaism has many attractive features, it is also ultimately inadequate (see the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY4"
    }
  }, [_vm._v("excursus")]), _vm._v(" following this section). To the extent, then, that the new approach to the meaning of “works of the law” is tied to this new view of Judaism, it must be questioned. Second, the linguistic basis for this new interpretation is weak. While the Greek phrase Paul uses here"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.208.58",
      "id": "FN.208.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿58")]), _vm._v(" is not attested before Paul, it has a close equivalent in several Hebrew phrases current in the Judaism of Paul’s day."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.208.59",
      "id": "FN.208.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" These phrases, because of their Jewish context, of course refer to an obedience of the law set within an understanding of the Jewish covenant. But none of the phrases, in their contexts, suggests that they, in themselves, refer to the covenant as such. Each clearly refers to performance of the law. Third, the context does not favor a restricted or nuanced meaning. Paul emphasizes that what he is saying about the inadequacy of “works of the law” applies to all people (cf. “all flesh”—a reference in this context to Gentiles as well as Jews [cf. 3:9]). “Works of the law” cannot be, then, so interpreted as to restrict the principle to Jews only."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.208.60",
      "id": "FN.208.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" Another contextual factor is the apparent formal equivalence between “works of the law” here (and in 3:28) and the simple “works” in 4:2–6 (cf. also 9:32). This suggests that “works of the law” is one specific form of “works” generally—not a technical reference to “Jewish only” torah obedience. And this general equivalence is supported by the previous context. We would expect “works "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.209"
    }
  }), _vm._v("of the law” here to be something of a summary of the extended discussion of Jewish “doing” in chap. 2. But the context of chap. 2 makes it clear that this “doing” is not restricted to any particular kind of “works.” In fact, Paul makes clear that the problem with Jewish works is essentially the same as the problem with Gentile works (cf. vv. 2–3, 22–23, 25, 27). Again, this makes it impossible to conclude that the problem with “works of the law” is narrowly Jewish.")]), _vm._v(" "), _c('p', [_vm._v("“Works of the law,” then, as most interpreters have recognized, refers simply to “things that are done in obedience to the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.209.61",
      "id": "FN.209.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Paul uses the phrase “works of the law” instead of the simple “works” because he is particularly concerned in this context to deny to Jews an escape from the general sentence pronounced in v. 19."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.209.62",
      "id": "FN.209.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿62")]), _vm._v(" But, since “works of the law” are simply what we might call “good works” defined in Jewish terms, the principle enunciated here has universal application; nothing a person does, whatever the object of obedience or the motivation of that obedience, can bring him or her into favor with God. It is just at this point that the significance of the meaning we have given “works of the law” emerges so clearly. Any restricted definition of “works of the law” "), _c('i', [_vm._v("can")]), _vm._v(" have the effect of opening the door to the possibility of justification by works—“good” deeds that are done in the right spirit, with God’s enabling grace, or something of the sort. This, we are convinced, would be to misunderstand Paul at a vital point. The heart of his contention in this section of Romans is that "), _c('i', [_vm._v("no one")]), _vm._v(" is capable of doing "), _c('i', [_vm._v("anything")]), _vm._v(" to gain acceptance with God; this is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.210"
    }
  }), _vm._v("why for "), _c('i', [_vm._v("everyone")]), _vm._v(" faith in Christ is the only possible way to God. In this verse, Paul does not spell out the “logic” of "), _c('i', [_vm._v("why")]), _vm._v(" works cannot justify. But the context, where the principle that “doers of the law will be justified” has been enunciated (2:13), and where it has been shown that all are under the power of sin (3:9; cf. 3:10–18), suggests that it is because no one is able to do the law sufficiently well to gain favor with God"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.210.63",
      "id": "FN.210.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿63")]), _vm._v(" (see, further, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/#BODY4"
    }
  }, [_vm._v("excursus")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The last part of v. 20 supports Paul’s contention in the first part of the verse by setting forth what it is that the law does accomplish (as opposed to that which it cannot accomplish). The law does not justify; rather, “through”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.210.64",
      "id": "FN.210.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" it comes “knowledge of sin.” Since “knowledge” in the Bible can sometimes designate personal experience of something (cf. 2 Cor. 5:21, where Christ is said not to have “known” sin), “knowledge of sin” might mean the actual experience of sinning. On this view, the law, because it encourages people to perform good works, entices them to seek to determine their own destiny and to “boast” in their accomplishments. Thus are people (and especially Jews) led by the law into sinning."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.210.65",
      "id": "FN.210.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" This conception, which is particularly associated with Bultmann and his followers, is a basic misrepresentation of Paul. He does not view the attempt to do the law as bad, nor is the doing of the law wrong. It is people’s failure to do it that creates the problem."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.210.66",
      "id": "FN.210.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" “Knowledge of sin,” on the other hand, does not simply mean that the law defines sin; rather, what is meant is that the law gives to people an understanding of “sin” (singular) as a power that holds everyone in bondage and brings guilt and condemnation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.210.67",
      "id": "FN.210.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" The law presents people with the demand of God. In our constant failure to attain the goal of that demand, we recognize ourselves to be sinners and justly condemned for our failures.")]), _vm._v(" "), _c('p', {
    staticClass: "sh",
    attrs: {
      "id": "BODY4"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.211"
    }
  }), _vm._v("EXCURSUS: PAUL, “WORKS OF THE LAW,” AND FIRST-CENTURY JUDAISM")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Two significant issues are raised by Paul’s assertion in 3:20 that “no one is justified by works of the law.”")]), _vm._v(" "), _c('p', [_vm._v("The first is the question of the logic of this denial. Why can’t “works of the law” justify? We might take our starting point in the juxtaposition of 2:13—“doers of the law will be justified”—and 3:20—“no one will be justified by works of the law.” There appear to be only five ways of explaining this contrast. First, one could argue that 2:13 states only a hypothetical promise: only for the sake of argument does Paul suggest such a possibility. As I have noted in the exegesis of 2:13, this is unlikely. Second, one could find a salvation-historical distinction between the two: in the “old age,” doing the law could justify, but in the “new age” it no longer can. Not only does this make Paul’s argument in 2:13 irrelevant to his present readers (who are in the “new age”), but it contradicts the express denial of Paul that the law could justify (see Gal. 3:21). Third, one could argue that “justify” in 2:13 refers to the judgment, or to a “second justification,” while “justify” in 3:20 relates to the initial entrance into salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.211.68",
      "id": "FN.211.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" But, while there is some precedent in Judaism and in James for the use of “justify” to depict the judgment, evidence from Paul’s usage for this meaning is lacking. Fourth, one could define “doing the law” and “works of the law” in different ways, so that the former means “fulfilling the law in Christ,” or “obeying God as a response to grace” while the latter connotes simple doing of the law or doing it in a legalistic spirit. We have also found reason for rejecting this interpretation: lexical and contextual evidence does not justify any sort of distinction.")]), _vm._v(" "), _c('p', [_vm._v("We are left, then, with the supposition that one must insert a step in the argument between the two statements, to the effect that “no one can do the law.” Not only does this make the best sense of both statements in their contexts, but it is, in effect, the assertion that Paul inserts between the two verses: “all are under the power of sin … there is no one righteous, no, not one” (3:9–10). We should add that a view like Dunn’s, according to which “works of the law” are defined as Jewish identity markers and do not justify because the covenant that they represent cannot justify simply moves the question back one step further: Why doesn’t the covenant justify? Paul has shown why in 2:1–3:19: the law cannot be “done” to the extent necessary to secure justification through that "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.212"
    }
  }), _vm._v("“law” covenant. It is far more likely, then, that this is the ultimate logic undergirding his denial that works of the law can justify here—a logic rooted not (or at least not only) in salvation history, or in concern about social barriers, but, more deeply, in the human condition itself.")]), _vm._v(" "), _c('p', [_vm._v("The second issue, related to the first, has to do with the viewpoint that Paul is opposing with his statement. Traditionally, it has been understood as a denial that a person can “earn” salvation by doing anything: no “works,” however “good”—even those done in obedience to God’s holy law—can bring a person into relationship with God. It has, furthermore, usually been assumed that this thesis was directed against Jews in Paul’s day who believed that, indeed, they could get into relationship with God by obedience to the law. Many modern interpreters (some of whom label this traditional view the “Lutheran orthodox” interpretation) question this explanation of the situation. i think, however, that, properly nuanced, the traditional view remains the best explanation of the Pauline polemic. The attentive reader will recognize in the commentary on texts such as 2:11 and 13 and 3:20 our general endorsement of this view. But here I would like to explore perhaps the most attractive counterposition and explain why I do not find it convincing.")]), _vm._v(" "), _c('p', [_vm._v("We must begin with the work of E. P. Sanders. His monograph, "), _c('i', [_vm._v("Paul and Palestinian Judaism")]), _vm._v(" (1977), is the stimulus for most of the recent reconstructions of Paul’s interaction with Judaism on the law. To understand his position, then, we must understand his basic thesis about Palestinian Judaism.")]), _vm._v(" "), _c('p', [_vm._v("Sanders argues that Palestinian Judaism in Paul’s day was characterized by a “pattern of religion” that he labels “covenantal nomism.” In contrast to the “traditional” picture of Judaism as a religion that required works as a means of entry into salvation, this pattern of covenantal nomism features obedience to the law as the means to "), _c('i', [_vm._v("maintain")]), _vm._v(" the Jews’ status in the covenant, a status that was freely granted to Jews through their election. Thus, obedience to the law was not the means of “getting in” but of “staying in.” While this portrait is drawn on the basis of the surviving literature of early Palestinian Judaism, Sanders insists that, for lack of conflicting evidence, this must have been the common first-century Jewish belief.")]), _vm._v(" "), _c('p', [_vm._v("If Sanders’s view of first-century Judaism is adopted as accurate—and it has met with wide acceptance—then it is necessary to ask: “Why has Paul so often and so emphatically denied that ‘works of the law’ can justify”? If no one in first-century Judaism really believed that a person could be justified by doing the law, then why deny it? To this question Sanders in his original monograph gave no clear answer beyond asserting that Paul ruled the law out of court on the basis of his “exclusivist soteriology”: because Christ was the only means of salvation, the law could not be. But others quickly rushed in to fill the void. Two basic approaches can be distinguished.")]), _vm._v(" "), _c('p', [_vm._v("First are those who think that both Sanders’s view of Judaism "), _c('i', [_vm._v("and")]), _vm._v(" the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.213"
    }
  }), _vm._v("traditional understanding of Paul—that he implied that Jews sought justification through the law—are correct and that the consequence is that Paul either misunderstood or deliberately misrepresented Judaism for polemical purposes. Jews did not really believe that “a person could be justified by works of the law”; but Paul implies that they did as a result of an overreaction against his previous religion and with the purpose of distancing Christianity from Judaism."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.213.69",
      "id": "FN.213.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" We think so extreme a conclusion is unwarranted. Not only does it presume to judge Paul on the basis of questionable claims about what Jews believed in Paul’s day (see below), but it also makes the unlikely assumption that Paul would misrepresent a position that some of the people he was trying to convince would know very well.")]), _vm._v(" "), _c('p', [_vm._v("The second general attempt to explain Paul against the background of Sanders’s interpretation of Judaism is found among scholars who think that Paul can be “reinterpreted” in such a way that his teaching meshes with Jewish “covenantal nomism.” Several specific proposals that take this general tack have emerged. One, associated especially with J. Gager and L. Gaston, argues that virtually all Paul’s negative statements about the law are directed against those who wanted to impose the law on Gentiles."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.213.70",
      "id": "FN.213.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" But the best-supported and most reasonable proposal is the one that J. D. G. Dunn has made prominent and which we touch on in the commentary on 3:20: that “works of the law” connotes Jewish obedience to the law in its function as establishing a boundary around the Jewish people, marking them off from the Gentile peoples around them. Jews did not see these works as bringing them into relationship with God but as maintaining their “national righteousness,” their peculiar status as God’s covenant people. Throughout Rom. 2–3, then, Paul argues against this presumption of “favored status,” showing that Jews cannot rely on their supposed special relationship with God for salvation. “No one is justified by works of the law” means, then, that no Jew can expect to be justified through those works “by which a member of the covenant people identified himself as a Jew and maintained his status within the covenant.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.213.71",
      "id": "FN.213.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" What the Jews, need, then, is a more inclusive understanding of salvation history and of the law, by which Gentiles can be allowed to take their rightful place alongside Jews within God’s covenant community."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.213.72",
      "id": "FN.213.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.214"
    }
  }), _vm._v("Despite its popularity, Dunn’s proposal suffers from some serious drawbacks. First, while Rom. 2 certainly has a great deal to say about Jewish complacency because of a misunderstanding of the covenant, it must be questioned whether we can confine Paul’s polemic to this one issue. Dunn consistently downplays the role that transgression of the law—not just adherence to certain ethnic identity markers—plays in Paul’s argument. Again and again, Paul insists in 2:1–29 that it is not dependence on the law or circumcision as such that renders the Jews liable to judgment, but their "), _c('i', [_vm._v("disobedience")]), _vm._v(" of the law. Transgressions of the law are the "), _c('i', [_vm._v("reason")]), _vm._v(" why the Jews cannot presume on the covenant for salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.214.73",
      "id": "FN.214.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" And these transgressions are said to involve the “same things” that Gentiles do (2:2–3)—clearly making it a matter not of “inner” Jewish issues but of sin against God generally. It is this larger and more basic problem of transgression of the law that informs Paul’s conclusion to this section in 3:20: “no human being will be justified by works of the law.” The “works” mentioned here must, as Dunn says, be the “works” Paul has spoken of in chap. 2."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.214.74",
      "id": "FN.214.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿74")]), _vm._v(" But it is not circumcision—let alone other “identity markers” that are not even mentioned in Rom. 1–3—that the Jew “does” in Rom. 2; it is, generally, what is demanded by the law, the “precepts” (v. 26; cf. vv. 22–23, 25, 27)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.214.75",
      "id": "FN.214.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" Therefore, 3:20 must deny not the adequacy of Jewish "), _c('i', [_vm._v("identity")]), _vm._v(" to justify, but the adequacy of Jewish "), _c('i', [_vm._v("works")]), _vm._v(" to justify. Belonging to the Jewish people does not justify because no Jew does the law sufficiently to give to that identity salvific power. It is this root "), _c('i', [_vm._v("anthropological")]), _vm._v(" issue—human inability—that informs 3:20, and justifies its application to the circumstance of any person."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.214.76",
      "id": "FN.214.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', [_vm._v("This, however, brings us back to the question: Against whom is the polemic in 3:20 directed? Two things can be said here.")]), _vm._v(" "), _c('p', [_vm._v("First, as Sanders argues, Paul’s denial that works of the law can justify may signify simply an attack on the covenant as understood by Jews. As Sanders points out, Jews regarded the "), _c('i', [_vm._v("intention")]), _vm._v(" to obey the commandments as sufficient to maintain one’s covenant status."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.214.77",
      "id": "FN.214.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" Paul, however, insists that only what is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.215"
    }
  }), _c('i', [_vm._v("actually done")]), _vm._v(" counts. This argument is an outright attack on the “covenantal nomism” that Sanders has sketched."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.215.78",
      "id": "FN.215.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" The denial of special status to the Jews is an implicit rejection of the election that was the foundation for “covenantal nomism,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.215.79",
      "id": "FN.215.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" and coheres closely with the polemic of John the Baptist (cf. Matt. 3:7–10) and of Jesus."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.215.80",
      "id": "FN.215.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" How does this critical attitude toward the covenant cohere with the OT itself? As we have seen, Paul is close to the prophets in his criticism of those who rely on the covenant as an automatic protection from judgment. And, while he is more explicit, Paul’s polemic against the Mosaic covenant is in keeping with the pessimistic attitude expressed toward that covenant in Deuteronomy (cf. chap. 32) and many of the prophets (e.g., Jer. 31:31–34). Paul stresses that the Abrahamic promise, to which one must respond with faith, and which is now fulfilled in Christ, is the true locus of salvation (Rom. 4). He therefore does not deny the promise of salvation given in the Scriptures to the Jews, but attaches it not to the Mosaic covenant, as did Judaism, but to the Abrahamic."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.215.81",
      "id": "FN.215.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" One could, at the least, make a very good case for finding Paul’s interpretation of the OT to be more accurate than that of “covenantal nomism.” “Works of the law”—those things done by Jews in obedience to the law by which they sought to maintain their covenant status—cannot justify because the covenant within which they performed those works was inadequate to bring justification. Jewish works, then, are no different from Gentile works, once the larger framework of the covenant—as usually understood in first-century Judaism—is eliminated.")]), _vm._v(" "), _c('p', [_vm._v("But a second possibility should also be considered—that Palestinian Judaism was more “legalistic” than Sanders allows, and that Paul is also responding to Jews who did, in some sense, think to be justified by doing the law. Even in Sanders’s proposal, works play such a prominent role that it is fair to speak of a “synergism” of faith and works that elevates works to a crucial salvific role. For, while works, according to Sanders, are not the means to “getting in,” they are essential to “staying in.” When, then, we consider the matter from the perspective of the final judgment—which we must in Jewish theology—it is clear that “works,” even in Sanders’s view, play a necessary and instrumental role in “salvation.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.215.82",
      "id": "FN.215.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v(" But this is what "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.216"
    }
  }), _vm._v("Paul denies, by equating “initial” justification with the final verdict of salvation and by stressing faith "), _c('i', [_vm._v("alone")]), _vm._v(" as the necessary corollary to the grace of God. In effect, then, while not denying the role of faith, Jews were insisting on works as a means of justification. But this is just what Paul denies in 3:20, and why he distinguishes in principle between faith and works (see 3:27–28; 4:1–5).")]), _vm._v(" "), _c('p', [_vm._v("Moreover, there is some question as to whether Sanders’s reconstruction of first-century Judaism is to be accepted "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("in toto.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.216.83",
      "id": "FN.216.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" While agreeing with Sanders that many interpreters have ignored the importance of election and covenant in Palestinian Judaism, and have been guilty, thereby, of caricaturing Jewish theology, I think that there is reason to conclude that Judaism was more “legalistic” than Sanders thinks. In passage after passage in his scrutiny of the Jewish literature, he dismisses a “legalistic” interpretation by arguing that the covenantal framework must be read into the text or that the passage is homiletical rather than theological in intent. But was the covenant as pervasive as Sanders thinks? Might not lack of reference in many Jewish works imply that it had been lost sight of in a more general reliance on Jewish identity?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.216.84",
      "id": "FN.216.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" And does not theology come into expression in homiletics? Indeed, is it not in more practically oriented texts that we discover what people "), _c('i', [_vm._v("really")]), _vm._v(" believed? Sanders may be guilty of underplaying a drift toward a more legalistic posture in first-century Judaism."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.216.85",
      "id": "FN.216.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" We must also reckon with the possibility that many “lay” Jews were more legalistic than the surviving literary remains of Judaism would suggest. Certainly the undeniable importance of the law in Judaism would naturally open the way to viewing doing the law in itself as salvific. The gap between the average believer’s theological views and the informed views of religious leaders is often a wide one. If Christianity has been far from immune from legalism, is it likely to think that Judaism, at any stage "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.217"
    }
  }), _vm._v("of its development, was?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.217.86",
      "id": "FN.217.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(" Finally, and, I think, most important, I am convinced that the teaching of Paul—and of Jesus and Matthew and Luke and Mark and Peter—cannot satisfactorily be explained without the assumption that some Jews, at least, had drifted from a biblical conception of the primacy and sufficiency of God’s grace into a belief that accorded their own works done in obedience to the law as basic to their justification/salvation.")]), _vm._v(" "), _c('p', [_vm._v("We conclude, then, that Paul criticizes Jews for thinking that the Mosaic covenant is adequate without that perfection in “works” without which any system of law must fail to bring one into relationship with God. The Jews become, as it were, representative of human beings generally. If the Jews, with the best law that one could have, could not find salvation through it, then "), _c('i', [_vm._v("any")]), _vm._v(" system of works is revealed as unable to conquer the power of sin. The “bottom line” in Paul’s argument, then, is his conviction that sin creates for every person a situation of utterly helpless bondage. “Works of the law” are inadequate not because they are “works of "), _c('i', [_vm._v("the law")]), _vm._v("” but, ultimately, because they are “works.” This clearly removes the matter from the purely salvation-historical realm to the broader realm of anthropology. No person can gain a standing with God through works because no one is able to perform works to the degree needed to secure such a standing. This human inability to meet the demands of God is what lies at the heart of Rom. 3. On this point, at least, the Reformers understood Paul correctly."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.217.87",
      "id": "FN.217.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY4.1"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.218"
    }
  }), _vm._v("B. JUSTIFICATION BY FAITH (3:21–4:25)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Romans 1:18–3:20, while important in its own right, is nevertheless preliminary to the main point that Paul wants to establish in this part of his letter: the availability of God’s righteousness to all who respond in faith. This “good news,” announced in 1:17, is now elaborated. The essential points are packed into 3:21–26, a passage that Luther called “the chief point, and the very central place of the Epistle, and of the whole Bible.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.218.1",
      "id": "FN.218.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" The remainder of the section develops one major element of this extraordinarily dense passage: faith as the only basis for justification. In 3:27–31, Paul highlights the exclusivity of faith (3:28) as he makes a number of points clearly directed to a Jewish viewpoint: faith excludes all boasting (3:27), provides for the inclusion of the Gentiles (3:29–30), and complements rather than nullifies the law (3:31). In chap. 4, each of these points is reiterated with respect to Abraham, as other elements are also drawn into the picture: the place of circumcision, the cruciality of grace, the promise, and the nature of faith. From this emphasis, we can surmise that Paul was well aware of the point at which his gospel was most often (and not only in Galatia) attacked and wanted to demonstrate as clearly as possible that faith was both the necessary and necessarily exclusive response of human beings to God’s work of redemption.")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY4.1.1"
    }
  }, [_vm._v("1. Justification and the Righteousness of God (3:21–26)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("But now, apart from the law, the righteousness of God has been made manifest, being witnessed to by the law and the prophets, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("the righteousness of God that is through faith in Jesus Christ for all"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.218.2",
      "id": "FN.218.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" who believe. For there is no distinction, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("for all have sinned and are falling short of the glory of God, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("being justified freely by his grace through the redemption that is in Christ Jesus. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("God set forth Jesus as a propitiatory sacrifice through faith,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.218.3",
      "id": "FN.218.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" in his blood, for a demonstration "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.219"
    }
  }), _vm._v("of his righteousness because of the passing over of sins committed beforehand "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("in the forbearance of God, for a demonstration of his righteousness at the present time, in order that he might be just and the justifier of the person who has faith in Jesus.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In a passage that is loaded with key theological terms, the phrase “righteousness of God” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē theou)")]), _vm._v(" stands out. It occurs four times (vv. 21, 22, 25, 26 [“his righteousness” in the last two]), while the related verb “justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaioō)")]), _vm._v(" is found twice (vv. 24, 26) and the adjective “just” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaios)")]), _vm._v(" once (v. 26). After a section in which the need for this righteousness has been demonstrated in detail (1:18–3:20), Paul is now prepared to explain how the righteousness of God—his eschatological justifying activity—empowers the gospel to mediate salvation to sinful human beings (cf. 1:16–17). The passage falls into four parts. In the first, Paul reiterates (cf. 1:17) the revelation of God’s righteousness and relates it to the OT (v. 21). The second section focuses on the way in which all human beings, equal in their sin, have equal access also to God’s righteousness through faith (vv. 22–23). The source of God’s righteousness in the gracious provision of Christ as an atoning sacrifice is the theme of the third part of the passage (vv. 24–25a). Finally, Paul shows how the atonement not only provides for the justification of sinners but also demonstrates the “just-ness” of God throughout the process (vv. 25b–26). In making this last point, we are presuming that “righteousness of God,” which refers in vv. 21–22 to the justifying act of God, refers in vv. 25–26 to the “integrity” of God, his always acting in complete accordance with his own character."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.219.4",
      "id": "FN.219.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" Most contemporary exegetes and theologians reject this interpretation; but we are convinced that this shift in meaning is required by the data of the text, and, indeed, gives to the text its extraordinary power and significance. For, as James Denney says,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("There can be no gospel unless there is such a thing as a righteousness of God for the ungodly. But just as little can there be any gospel unless the integrity of God’s character be maintained. The problem of the sinful world, the problem of all religion, the problem of God in dealing with a sinful race, is how to unite these two things. The Christian answer to the problem is given by Paul in the words: “Jesus Christ, whom God set forth a propitiation (or, in propitiatory power) in his blood.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.219.5",
      "id": "FN.219.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.220"
    }
  }), _vm._v("The occurrence in this passage of some words and concepts that are not typical of Paul’s presentation of the gospel"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.220.6",
      "id": "FN.220.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿6")]), _vm._v(" suggests to many scholars that Paul is quoting an early Christian tradition."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.220.7",
      "id": "FN.220.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" This is possible, but it is more likely that Paul has himself written these verses in dependence on a certain Jewish-Christian interpretation of Jesus’ death. This interpretation, which appears also in Heb. 9–10, viewed Jesus’ death as the fulfillment of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.221"
    }
  }), _vm._v("the Day of Atonement ritual."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.8",
      "id": "FN.221.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Perhaps Paul used such a tradition at this point in Romans both because it suited his argument and because it created yet another point of contact with the Jewish Christians in Rome.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("21")]), _vm._v(" Paul signals the transition to a new phase of his exposition of the gospel with “but now.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.9",
      "id": "FN.221.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" The phrase could have a purely logical force—“but now here is the situation apart from the law”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.10",
      "id": "FN.221.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v("—but is more likely to preserve its normal temporal meaning. As in 6:22, 7:6, 1 Cor. 15:20, Eph. 2:13, and Col. 1:22, “but now” marks the shift in Paul’s focus from the old era of sin’s domination to the new era of salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.11",
      "id": "FN.221.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" This contrast between two eras in salvation history is one of Paul’s most basic theological conceptions, providing the framework for many of his key ideas. Rom. 1:18–3:20 has sketched the spiritual state of those who belong to the old era: justly condemned, helpless in the power of sin, powerless to escape God’s wrath. “But now” God has intervened to inaugurate a new era, and all who respond in faith—not only after the cross, but, as Rom. 4 will show, before it also—will be transferred into it from the old era. No wonder Lloyd-Jones can exclaim, “there are no more wonderful words in the whole of Scripture than just these two words ‘But now.’ ”")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.222"
    }
  }), _vm._v("As “the wrath of God” dominated the old era (1:18), so “the righteousness of God” dominates the new. “Righteousness of God” means the same here as in Rom. 1:17: the justifying activity of God. From God’s side, this includes his eschatological intervention to vindicate and deliver his people, in fulfillment of his promises. From the human side, it includes the status of acquittal acquired by the person so declared just."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.12",
      "id": "FN.222.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" In 1:17, Paul asserts that this “righteousness of God” is constantly revealed"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.13",
      "id": "FN.222.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" through the preaching of the gospel. Here he simply asserts its presence as a dominating force in God’s interaction with humanity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.14",
      "id": "FN.222.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("The relationship of this manifestation of God’s righteousness to the OT is indicated in two prepositional phrases that together display the combination of continuity and discontinuity in salvation history that is characteristic of Romans. “Apart from the law” could go with “righteousness of God” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v(", “the righteousness of God without the law is manifested”),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.15",
      "id": "FN.222.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" but it makes better sense if taken with the verb “is manifested” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NAB"
    }
  }, [_vm._v("NAB")]), _vm._v(", “the righteousness of God has been manifested apart from the law”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.16",
      "id": "FN.222.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Paul’s purpose is to announce the way in which God’s righteousness has been manifest rather than to contrast two kinds of righteousness.")]), _vm._v(" "), _c('p', [_vm._v("What does Paul mean by this? In Rom. 2:1–3:20 Paul has made clear that the law has failed to rescue Jews from the power of sin because compliance with its demands to the extent necessary to secure justification has not been—and cannot be—forthcoming. “Apart from the law” might mean, then, “apart from doing the law”: God’s righteousness is now attained without any contribution from “works of the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.17",
      "id": "FN.222.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" While this may, indeed, be part of what Paul intends, it is questionable whether it goes far enough; for there is, as Paul will show in chap. 4, nothing really “new” about this: justification "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.223"
    }
  }), _vm._v("has always been by faith, apart from the law. Furthermore, it is not the manner in which God’s righteousness is "), _c('i', [_vm._v("received")]), _vm._v(" that Paul is talking about here, but the manner in which it is "), _c('i', [_vm._v("manifested—")]), _vm._v("the divine side of this “process” by which people are made right with God. This phrase, then, reiterates the salvation-historical shift denoted by “but now.” In the new era inaugurated by Christ’s death God has acted to deliver and vindicate his people “apart from” the law. It is not primarily the law as something for humans to do, but the law as a system, as a stage in God’s unfolding plan, that is in view here. “Law” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(nomos),")]), _vm._v(" then, refers to the “Mosaic covenant,” that (temporary) administration set up between God and his people to regulate their lives and reveal their sin until the establishment of the promise in Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.18",
      "id": "FN.223.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" One aspect of this covenant, of course, is those Jewish “identity markers,” such as circumcision, the Sabbath, and food laws; Paul is certainly affirming, then, that the righteousness of God is now being manifested “outside the national and religious parameters set by the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.19",
      "id": "FN.223.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" But Paul’s point cannot be confined to this. The reason these “identity markers” are no longer required is that the covenant of which they were a part has been made “obsolete” (cf. Heb. 8:7–13). It is this basic shift in salvation history that Paul alludes to here, and much of his discussion of the law in the rest of this letter (cf. 3:27–31; 4:15; 5:13, 20; 6:14; and especially chap. 7) is an attempt to explain this “apart from the law,” while at the same time justifying his assertion that faith “establishes” the law (cf. 3:31; 8:4).")]), _vm._v(" "), _c('p', [_vm._v("But Paul hastens to balance this discontinuity in salvation history with a reminder of its continuity. While God’s justifying activity in the new age takes part outside the confines of the Old Covenant, the OT as a whole anticipates and predicts this new work of God: God’s righteousness is “witnessed to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.20",
      "id": "FN.223.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿20")]), _vm._v(" by the law and the prophets.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.21",
      "id": "FN.223.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.224"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("22a")]), _vm._v(" “Righteousness of God,” repeated for clarity because of the distance from its first occurrence, is now considered from the “human” side of the transaction: it is “through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.22",
      "id": "FN.224.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" faith in Jesus Christ for all who believe.” Picking up another key theme from 1:17, Paul highlights faith as the means by which God’s justifying work becomes applicable to individuals. This, at least, is how this phrase has usually been interpreted (and cf. almost all modern English translations). But an alternative interpretation has been gaining favor. On this view, Paul asserts not that God’s righteousness is attained “through faith "), _c('i', [_vm._v("in")]), _vm._v(" Jesus Christ,” but “through the faith "), _c('i', [_vm._v("of")]), _vm._v(" Jesus Christ,” or “through the faithfulness "), _c('i', [_vm._v("shown by")]), _vm._v(" Jesus Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.23",
      "id": "FN.224.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" Advocates of this interpretation argue that it is the more likely linguistically"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.24",
      "id": "FN.224.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" and that it makes better sense in the context. For this interpretation avoids the tautology involved in the traditional view, which has Paul asserting the importance of human faith twice: “faith in Jesus Christ,” “for all who believe.” On the other hand, the translation “through the faithfulness of Jesus Christ” results in a natural Pauline combination of divine initiative and human response."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.25",
      "id": "FN.224.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.225"
    }
  }), _vm._v("Despite these arguments, the traditional interpretation of the phrase is preferable. The linguistic argument in favor of the alternative rendering is by no means compelling."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.26",
      "id": "FN.225.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" In addition, contextual considerations favor the objective genitive in Rom. 3:22. While the Greek word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" can mean “faithfulness” (see 3:3), and Paul can trace our justification to the obedience of Christ (5:19), little in this section of Romans would lead us to expect a mention of Christ’s “active obedience” as basic to our justification."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.27",
      "id": "FN.225.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" Moreover, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" in Paul almost always means “faith”; very strong contextual features must be present if any other meaning is to be adopted."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.28",
      "id": "FN.225.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" But these are absent in 3:22. If, on the other hand, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" is translated “faith,” it is necessary to introduce some very dubious theology in order to speak meaningfully about “the faith exercised by Jesus Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.29",
      "id": "FN.225.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" Finally, and most damaging to the hypothesis in either form, is the consistent use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" throughout 3:21–4:25 to designate the faith exercised by people in God, or Christ, as the sole means of justification. Only very strong reasons would justify giving to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" any other meaning in this, the theological summary on which the rest of the section depends. The simple references to “faith” in 3:28 and 3:30 are abbreviations of the “faith in Christ/Jesus” that is enunciated in 3:22 and 26 (cf. v. 25)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.30",
      "id": "FN.225.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', [_vm._v("But if Paul mentions human faith in this phrase, why then does he add the phrase “for all who believe”? Comparison has been made with the combination “from faith for faith” in 1:17, but this is to appeal from the uncertain "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.226"
    }
  }), _vm._v("to the obscure (see the notes on 1:17). Paul’s purpose is probably to highlight the universal availability of God’s righteousness. This theme is not only one of the most conspicuous motifs of the epistle, but is explicitly mentioned in vv. 22b–23. God’s righteousness is available only through faith in Christ—but it is available to "), _c('i', [_vm._v("anyone")]), _vm._v(" who has faith in Christ.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("22b–23")]), _vm._v(" Paul tells us in vv. 22b–23 why this righteousness is available to all, and why, also, all need this righteousness. “There is no distinction” summarizes a key element of Paul’s presentation in 1:18–3:20, and is likely, therefore, to have special application to Jew and Gentile."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.31",
      "id": "FN.226.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" In v. 23, Paul elaborates this point. His “no distinction,” as we would expect, has to do with the absence of any basic difference among people with respect to their standing before God. Jews may have the law and circumcision; Americans may lay claim to a great religious heritage; “good” people may point to their works of charity; but all this makes no essential difference to one’s standing before the righteous and holy God. Paul reduces the argument of 1:18–3:20 to its essence in a justly famous statement of the condition of all people outside Christ: “all have sinned"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.32",
      "id": "FN.226.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" and are falling short of the glory of God.” The second verb states the consequences of the first: because all have sinned, all are falling short"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.33",
      "id": "FN.226.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿33")]), _vm._v(" of the glory of God. “Glory” in the Bible characteristically refers to the magnificent presence of the Lord, and the eternal state was often pictured as a time when God’s people would experience and have a part in that “glory” (e.g., Isa. 35:2; Rom. 8:18; Phil. 3:21; 2 Thess. 2:14)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.34",
      "id": "FN.226.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" And just as this sharing in God’s “glory” involves conformity to the “image of Christ” (Rom. 8:29–30; Phil. 3:21), so the absence of glory involves a declension from the “image of God” in which human beings were first made. “The future glory may be regarded as the restoration of the lost, original glory.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.35",
      "id": "FN.226.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Paul, then, is indicating that all people fail to exhibit that “being-like-God” for which they were created; and the present "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.227"
    }
  }), _vm._v("tense of the verb, in combination with Rom. 8, shows that even Christians “fall short” of that goal until they are transformed in the last day by God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.36",
      "id": "FN.227.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("24")]), _vm._v(" The connection between this verse and the previous verses is not clear. Those who think a pre-Pauline fragment begins here find in the difficult transition evidence for a shift from Paul’s original dictation to the citation of a tradition. But whatever his dependence on tradition, Paul is himself composing the verses, and we need to determine what connection he intends. The participle “being justified”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.37",
      "id": "FN.227.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" is most naturally taken as a modifier of one or both of the finite verbs in v. 23: “sinned” and/or “falling short.” If so, Paul’s purpose in highlighting the gift character of justification in the participial clause would presumably be to provide evidence for the total religious impotence of humanity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.38",
      "id": "FN.227.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" The objection to this interpretation is that it gives to a verse (24) that continues the main theme of the paragraph (justification/righteousness) a relatively subordinate role. Scholars suggest several other ways of relating this participle to its context,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.39",
      "id": "FN.227.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" but perhaps the best suggestion is Cranfield’s. He argues that “being justified” is dependent on v. 23, to the extent that it has as its subject “all,” but that it also picks up and continues the main theme of the paragraph from vv. 21–22a. With this we would agree, with the caveat that “all” in its connection with “being justified” indicates not universality (“everybody”) but lack of particularity (“anybody”). Paul’s stress on the gift character of justification in v. 24 illuminates from the positive side the “lack of distinction” in God’s dealings (vv. 22b–23) even as it continues and explains the theme of “righteousness by faith” from v. 22a.")]), _vm._v(" "), _c('p', [_vm._v("Paul uses the verb “justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaioō)")]), _vm._v(" for the first time in Romans to depict his distinctive understanding of Christian salvation. As Paul uses it in these contexts, the verb “justify” means not “to make righteous” (in an ethical sense) nor simply “to treat as righteous” (though one is really not righteous), but “to declare righteous.” No “legal fiction,” but a legal "), _c('i', [_vm._v("reality")]), _vm._v(" of the utmost significance, “to be justified” means to be acquitted by God from all “charges” that could be brought against a person because of his or her sins."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.40",
      "id": "FN.227.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.228"
    }
  }), _vm._v("This judicial verdict, for which one had to wait until the last judgment according to Jewish theology, is according to Paul rendered the moment a person believes. The act of justification is therefore properly “eschatological,” as the ultimate verdict regarding a person’s standing with God is brought back into our present reality.")]), _vm._v(" "), _c('p', [_vm._v("Characteristic also of Paul’s theology is his emphasis on the gift character of this justifying verdict; we are “justified freely"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.41",
      "id": "FN.228.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿41")]), _vm._v(" by his grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.42",
      "id": "FN.228.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" “Grace” is one of Paul’s most significant theological terms."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.43",
      "id": "FN.228.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" He uses it typically not to describe a quality of God but the way in which God has acted in Christ: unconstrained by anything beyond his own will."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.44",
      "id": "FN.228.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" God’s justifying verdict is totally unmerited. People have done, and can do, nothing to earn it. This belief is a “theological axiom” for Paul and is the basis for his conviction that justification can never be attained through works, or the law (cf. Rom. 4:3–5, 13–16; 11:6), but only through faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.45",
      "id": "FN.228.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Once this is recognized, the connection between v. 22a and v. 24 is clarified; that justification is a matter of grace on God’s side means that it must be a matter of faith on the human side. But the gracious nature of justification also answers to the dilemma of people who are under the power of sin (v. 23). As Pascal says, “Grace is indeed needed to turn a man into a saint; and he who doubts it does not know what a saint or a man is.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.46",
      "id": "FN.228.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.229"
    }
  }), _vm._v("What gives this paragraph its unparalleled significance is the number of perspectives from which God’s justification of sinners is considered. If “freely by his grace” indicates the mode of justification, as entirely free and unmerited, “through the redemption” illumines the costly means by which this acquitting verdict is rendered possible. “Redemption”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.47",
      "id": "FN.229.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" means, basically, “liberation through payment of a price.” Thus, in the second and first centuries "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.C.")]), _vm._v(", “redemption” often refers to the “ransoming” of prisoners of war, slaves, and condemned criminals."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.48",
      "id": "FN.229.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" If “redemption” has this connotation here, then Paul would be presenting Christ’s death as a “ransom,” a “payment” that takes the place of that penalty for sins “owed” by all people to God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.49",
      "id": "FN.229.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Though widely rejected today,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.50",
      "id": "FN.229.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" this interpretation of the significance of the word should be retained."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.51",
      "id": "FN.229.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" While it is not clear whether Paul was thinking specifically "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.230"
    }
  }), _vm._v("of slave manumissions when he applied the word to Christian salvation,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.230.52",
      "id": "FN.230.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" it is likely that Paul views sin as that power from which we need to be liberated (cf. 3:9)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.230.53",
      "id": "FN.230.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" If we ask further the question “To whom was the ‘ransom’ paid?” it is not clear that we need to answer it. The usage of the word makes it clear that there need be no specific person who “receives” the “payment.” Certainly we are not to think of Christ’s death as a payment of God made to Satan, a view that became very popular in the first centuries of the Christian church. A more biblical answer, and one that might be implied by v. 25, would be that God, the judge who must render just verdicts, is the recipient of the ransom. If so, an equal emphasis must be placed on the fact that God is also the originator of the liberating process.")]), _vm._v(" "), _c('p', [_vm._v("As he does in Eph. 1:7 and Col. 1:14, Paul adds that this redemption is “in Christ Jesus.” It is not clear whether Paul means by it that the liberation was accomplished by Christ at the cross or that the liberation occurs “in relation to” Christ, whenever sinners trust Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.230.54",
      "id": "FN.230.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" Favoring the latter, however, is the connection of “redemption” with the forgiveness of sins in Eph. 1:7 and Col. 1:14, and 1 Cor. 1:30: “Christ was made … "), _c('i', [_vm._v("our")]), _vm._v(" redemption.” While, then, the “price” connoted by the word “redemption” was “paid” at the cross in the blood of Christ, the redeeming work that the payment made possible is, like justification, applied to each person when he or she believes.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("25")]), _vm._v(" Although the Greek word for “whom” connects v. 25 to v. 24, the connection is so loose that v. 25 may be considered as beginning a new sentence. The focus shifts from human reception of God’s justifying work to God’s initiative in providing for it. Specifically, Paul now unfolds the nature and means of “the redemption that is in Christ Jesus,” showing that this redemption takes place at the will and initiative of God the Father. While the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.231"
    }
  }), _vm._v("persons of God the Father and God the Son must be kept distinct as we consider the process of redemption, it is a serious error to sever the two with respect to the will for redemption, as if the loving Christ had to take the initiative in placating the angry Father. God’s love and wrath meet in the atonement, and neither can be denied or compromised if the full meaning of that event is to be properly appreciated. “Our own justification before God rests on the solid reality that the fulfilling of God’s justice in Christ was at the same time the fulfilling of this love for us.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.55",
      "id": "FN.231.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', [_vm._v("The first five Greek words of v. 25 form the main clause of this new sentence, with the series of prepositional phrases and clauses in the rest of v. 25 and v. 26 dependent on it. The verb in this clause could be translated either “propose, plan” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.REB"
    }
  }, [_vm._v("REB")]), _vm._v(", “designed”) or “display publicly” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.56",
      "id": "FN.231.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" A good case can be made for the former,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.57",
      "id": "FN.231.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" but the latter fits better with the background and imagery of the concept Paul alludes to here (see below on "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(") and should probably be preferred."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.58",
      "id": "FN.231.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" Redemption is “in Christ” in that God “displayed him publicly,” or “set him forth as a sacrifice” on the cross as a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion.")]), _vm._v(" Nor should it be missed that it is God who thus takes the initiative in the process of redemption—not Christ, and certainly not human beings. As P. T. Forsyth remarks, “The prime doer in Christ’s cross was God. Christ was God reconciling. He was God doing the very best for man, and not man doing his very best for God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.59",
      "id": "FN.231.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', [_vm._v("What Paul means by designating Christ a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" has been the subject of considerable debate."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.60",
      "id": "FN.231.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" When the use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.61",
      "id": "FN.231.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿61")]), _vm._v(" in the Bible is considered, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.232"
    }
  }), _vm._v("a strong case can be made for taking the word as a reference to the OT “mercy seat,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.62",
      "id": "FN.232.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" the cover over the ark where Yahweh appeared (Lev. 16:2), and on which sacrificial blood was poured. For this is what the word refers to in its one other NT occurrence (Heb. 9:5), as well as in 21 of its 27 "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" occurrences."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.63",
      "id": "FN.232.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" Particularly significant are the several occurrences of the word in the description in Lev. 16 of the “Day of Atonement” ritual. According to this text, the high priest is to enter the “Holy of Holies” once a year and sprinkle on the mercy seat (= "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(") the blood of a sacrificial victim, thereby “making atonement.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.64",
      "id": "FN.232.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" In the OT and Jewish tradition, this “mercy seat” came to be applied generally to the place of atonement."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.65",
      "id": "FN.232.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" By referring to Christ as this “mercy seat,” then, Paul would be inviting us to view Christ as the New Covenant equivalent, or antitype, to this Old Covenant “place of atonement,” and, derivatively, to the ritual of atonement itself. What in the OT was hidden from public view behind the veil has now been “publicly displayed” as the OT ritual is fulfilled and brought to an end in Christ’s “once-for-all” sacrifice. This interpretation, which has an ancient and respectable heritage,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.66",
      "id": "FN.232.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" has been gaining strength in recent years."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.67",
      "id": "FN.232.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" It is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.233"
    }
  }), _vm._v("attractive because it gives to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" a meaning that is derived from its “customary” biblical usage, and creates an analogy between a central OT ritual and Christ’s death that is both theologically sound and hermeneutically striking.")]), _vm._v(" "), _c('p', [_vm._v("To be sure, there are objections to taking "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" as a reference to the “mercy seat.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.233.68",
      "id": "FN.233.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" Some claim, for instance, that the imagery would have been foreign to the Gentile Christian church in Rome; and Paul would hardly have used imagery that he knew they would fail to understand."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.233.69",
      "id": "FN.233.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" However, arguments based on what the Gentile congregation in Rome would, or would not, have been familiar with are precarious. Paul’s letters furnish abundant proof that he expected his Gentile readers to be fully conversant with the OT. Surely he could expect his Gentile readers in Rome to have some knowledge of the Day of Atonement ritual and the significance within it of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.233.70",
      "id": "FN.233.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.234"
    }
  }), _vm._v("In fact, we do not find anything that would render the interpretation of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" against the background of the OT mercy seat improbable. Before drawing conclusions, however, other alternatives must be considered.")]), _vm._v(" "), _c('p', [_vm._v("While Deissmann has shown that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" usually means “means of propitiation” in ordinary Greek,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.71",
      "id": "FN.234.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" C. H. Dodd has argued that the word in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" means “means of expiation,” and he accordingly opts for this translation in Rom. 3:25. “Propitiation” has reference to the turning away of wrath, and the appeasement of the “wrath of the gods” by various means is a frequent theme in Greek literature. This theme Dodd finds totally absent in the Bible. The verb cognate to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" has as its object sin, not God. The idea conveyed by the word and its cognates is thus, Dodd argues, the “covering,” or forgiving, of sins, not the appeasing of God’s wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.72",
      "id": "FN.234.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" Others, while not endorsing all Dodd’s conclusions, agree that reference to God’s wrath should be eliminated from the word, and translate generally “means of atonement,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.73",
      "id": "FN.234.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" or “atoning,” or “expiatory sacrifice.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.74",
      "id": "FN.234.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.235"
    }
  }), _vm._v("But Dodd is almost certainly wrong on this point. The OT frequently connects the “covering,” or forgiving, of sins with the removal of God’s wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.235.75",
      "id": "FN.235.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" It is precisely the basic connotation of “propitiate” that led the translators of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" to use the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilask-")]), _vm._v(" words for the Hebrew words denoting the covering of sins."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.235.76",
      "id": "FN.235.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" This is not, however, to deny the connotation “expiation”; the OT cult serves to “wipe away” the guilt of sin at the same time as—and indeed, because—the wrath of God is being stayed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.235.77",
      "id": "FN.235.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" When to the linguistic evidence we add the evidence of the context of Rom. 1–3, where the wrath of God is an overarching theme (1:18; cf. 2:5), the conclusion that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" includes reference to the turning away of God’s wrath is inescapable.")]), _vm._v(" "), _c('p', [_vm._v("This propitiation is, of course, altogether different from pagan notions of propitiation. First, as we have seen, the biblical conception of the wrath of God is far removed from the pagan picture of a capricious and often vindictive deity. God’s wrath is the inevitable and necessary reaction of absolute holiness to sin. Second, in contrast to the secular religious tradition, it is God himself who initiates the propitiatory offering. “In the heathen "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.236"
    }
  }), _vm._v("view expiation renders the gods willing to forgive; in the Biblical view expiation enables God, consistently with his holiness, to do what he was never unwilling to do. In the former view sacrifice changes the sentiment of the gods toward men; in the latter it affects the consistency of his procedure in relation to sin.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.78",
      "id": "FN.236.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', [_vm._v("Finally, we must decide whether Paul intends to present this wrath-averting sacrifice of Christ against the background of the typology of the mercy seat. Our main reason for hesitating to find allusion to the mercy seat is the lack of evidence for an early Christian or Jewish Greek tradition in which "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" was given the symbolic importance this interpretation suggests."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.79",
      "id": "FN.236.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" Nevertheless, in this, as in so many other areas, Paul may have been the theological innovator; and the lexical data, combined with the theological appropriateness of the image, make it likely that Paul intends such an allusion. Christ, Paul implies, now has the place that the “mercy seat” had in the Old Covenant: the center and focal point of God’s provision of atonement for his people. Since this atonement takes place by means of Christ’s death as a sacrifice, and the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" includes reference to propitiation, translations such as “means of propitiation”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.80",
      "id": "FN.236.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" and “propitiatory sacrifice”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.81",
      "id": "FN.236.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" are not inaccurate. But they may be too restrictive. “Mercy seat” would be all right if the broader theological connotations of the phrase were obvious; but, considering the breadth of the concept to which the term refers, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.82",
      "id": "FN.236.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" “sacrifice of atonement” is as good as we can do.")]), _vm._v(" "), _c('p', [_vm._v("In a piling up of prepositional phrases that are often seen as indicative of a confessional or hymnic style, Paul now expands on the significance and implications of God’s setting forth Christ as the New Covenant “propitiatory.” “Through faith” is not likely to modify “set forth,” since faith was not the instrument through which God “set forth” Christ as "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.83",
      "id": "FN.236.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" Rather, the phrase modifies "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" and indicates the means by which individuals appropriate the benefits of the sacrifice. It is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.237"
    }
  }), _vm._v("harder to know whether “in his blood” indicates the object of “faith”—“faith in his blood” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v("),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.84",
      "id": "FN.237.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" modifies the verb “set forth”—“through his blood God has presented him,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.85",
      "id": "FN.237.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" or modifies "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion—")]), _vm._v("“a propitiation in blood” (note the reversal of terms in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(": “a propitiation in his blood through faith”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.86",
      "id": "FN.237.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(" But Paul never elsewhere makes Christ’s blood an object of faith,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.87",
      "id": "FN.237.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" so the latter is preferable. “In his blood” singles out Christ’s blood as the means by which God’s wrath is propitiated."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.88",
      "id": "FN.237.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" As in several other texts where Christ’s blood is the means through which salvation is secured (Rom. 5:9; Eph. 1:7; 2:13; Col. 1:20), the purpose is to designate Christ’s death as a sacrifice."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.89",
      "id": "FN.237.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('p', [_vm._v("The third prepositional phrase in the series indicates the purpose for which God “set forth Christ as a sacrifice of atonement”: “for"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.90",
      "id": "FN.237.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿90")]), _vm._v(" a demonstration"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.91",
      "id": "FN.237.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿91")]), _vm._v(" of his righteousness because of the passing over of sins committed beforehand in the forbearance of God.” Just what Paul means by this phrase is disputed, the pivotal issue being the meaning of “his righteousness.” Scholars have proposed many interpretations, but there are two general approaches. The first takes “righteousness” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē)")]), _vm._v(" to designate what we might call an aspect of God’s character, whether this be his “justice” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(iustitia distributiva),")]), _vm._v(" his impartiality and fairness, or his acting in accordance with his own character and for his own glory. The whole clause would, then, be interpreted along the lines of the following paraphrase: “in order to demonstrate [or show] that God is just, acting in accordance with his own character, [which was necessary] because he had passed over sins committed before, in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.238"
    }
  }), _vm._v("the time of his forbearance.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.92",
      "id": "FN.238.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")]), _vm._v(" The second interpretation understands “righteousness” here to be God’s saving, covenant faithfulness, which requires that the clause as a whole be translated something like “in order to manifest his saving faithfulness through his forgiving of sins committed before, in the time of his forbearance.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.93",
      "id": "FN.238.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(" On the first view, this clause makes an important contribution to our understanding of the “internal” mechanism of the atonement, explaining the necessity of Christ’s propitiating work in terms of the requirements of God’s holy character. God’s past restraint in punishing sins with the full measure of punishment they deserved calls into question his fair and impartial “justice,” or holiness, creating the need for this justice to be “satisfied,” a satisfaction rendered by the propitiatory sacrifice of Christ. On the second view, the clause ties God’s work in Christ to his fulfilling of his covenant promises. God now fulfills those salvific promises by putting forth Christ as the means by which sins are forgiven. While the second view has been preferred by most contemporary scholars, there are sound reasons for adopting the first. Since the interpretation of “his righteousness” is so dependent on the meaning of other key words in the clause, we will begin with these words and come back to this phrase.")]), _vm._v(" "), _c('p', [_vm._v("Especially critical is the interpretation of the prepositional phrase “because of the passing over of sins committed beforehand.” Those who argue that “his righteousness” refers to God’s covenant faithfulness insist that this translation of the phrase is incorrect. It should, they claim, be rendered something like “through [or for the sake of] the forgiveness of sins committed beforehand.” The phrase would then express the means (or purpose) by which God has demonstrated his saving faithfulness: by acting to secure forgiveness for the sins committed under the Old Covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.94",
      "id": "FN.238.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" But this rendering has insufficient lexical support. The word we translate “passing over” does not mean “forgiveness,” but, when applied to legal charges or sins, “postponement of punishment” (“pretermission”) or “neglect” of prosecution."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.95",
      "id": "FN.238.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" Nor "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.239"
    }
  }), _vm._v("is it likely that the preposition "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dia")]), _vm._v(" can here be translated “through.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.96",
      "id": "FN.239.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" The preposition could have virtually a telic meaning (“with a view to”),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.97",
      "id": "FN.239.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(" but this makes little sense with the word “passing over.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.98",
      "id": "FN.239.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" The translation “through [or for the purpose of] forgiveness of sins” must, then, be rejected as requiring strained and unusual meanings for too many words."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.99",
      "id": "FN.239.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")]), _vm._v(" But this further makes it very difficult for “his righteousness” to refer to God’s saving faithfulness. For it makes no sense for Paul to say that “passing over” former sins was the "), _c('i', [_vm._v("reason")]), _vm._v(" for God’s demonstration of his saving faithfulness.")]), _vm._v(" "), _c('p', [_vm._v("But what are these “former sins” to which Paul is referring? The phrase at the beginning of v. 26 points toward an answer. “In the forbearance of God” should be connected with “passing over,” and in light of Paul’s only other use of “forbearance” (Rom. 2:4),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.100",
      "id": "FN.239.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")]), _vm._v(" it will refer to the period of time "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.240"
    }
  }), _vm._v("before the cross (cf. also Acts 14:16; 17:30). The sins “committed beforehand” will not, then, be sins committed before conversion, or baptism,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.101",
      "id": "FN.240.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" but before the new age of salvation. This does not mean that God failed to punish or “overlooked” sins committed before Christ; nor does it mean that God did not really “forgive” sins under the Old Covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.102",
      "id": "FN.240.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" Paul’s meaning is rather that God “postponed” the full penalty due sins in the Old Covenant, allowing sinners to stand before him without their having provided an adequate “satisfaction” of the demands of his holy justice (cf. Heb. 10:4).")]), _vm._v(" "), _c('p', [_vm._v("In view of this, it is clear that “his righteousness” must have reference to some aspect of God’s character that might have been called into question because of his treating sins in the past with less than full severity, and that has now been demonstrated in setting forth Christ as “the propitiatory.” “God’s righteousness” in v. 25 (and 26) must, then, mean something different than it does in vv. 21–22, where the process by which God justifies sinful people is designated."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.103",
      "id": "FN.240.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" Ridderbos thinks Paul refers to God’s punitive righteousness,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.104",
      "id": "FN.240.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")]), _vm._v(" Piper to God’s acting always to uphold his glory,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.105",
      "id": "FN.240.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" but we prefer a more general reference to God’s “consistency” in always acting in accordance with his own character."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.106",
      "id": "FN.240.106r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("26")]), _vm._v(" We have already dealt with the first phrase of this verse in conjunction with the last clause in v. 25. The next part of the verse seems unnecessarily to repeat what Paul has already said in v. 25: “for a demonstration"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.107",
      "id": "FN.240.107r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿107")]), _vm._v(" of his righteousness at the present time.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.108",
      "id": "FN.240.108r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")]), _vm._v(" Some think that the phrase "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.241"
    }
  }), _vm._v("expresses the ultimate purpose of vv. 25b–26a: God let sins go unpunished, in his forbearance, “with a view to” demonstrating his righteousness at the present time."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.109",
      "id": "FN.241.109r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")]), _vm._v(" But it is better to take the clause as parallel to “for a demonstration …” in v. 25. It resumes the topic of the demonstration of God’s righteousness after the intervening qualifiers and adds the important point that this demonstration has significance not only for the past but also for the present age."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.110",
      "id": "FN.241.110r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")]), _vm._v(" A reference back to “but now” at the beginning of the paragraph is obvious, as Paul focuses again on the time after Christ’s coming as the climactic, eschatological age of salvation history.")]), _vm._v(" "), _c('p', [_vm._v("There are only two ways to make sense of the connection between the final clause of the verse and the preceding context. Either Paul is indicating the ultimate purpose or result"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.111",
      "id": "FN.241.111r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿111")]), _vm._v(" of the sentence he began in v. 25—“God set forth Christ as a propitiation in order that [or with the result that] he is just and the justifier of the one who has faith in Jesus”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.112",
      "id": "FN.241.112r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")]), _vm._v("—or it explains the immediately preceding clause—“for a demonstration of his righteousness at the present time, in order that he might show that he is just and the justifier of the person who has faith in Jesus.” Despite its somewhat weak support in the commentaries, this last rendering should be preferred, because it preserves what seems to be a natural connection between “the present time” and “justifying the one who has faith in Jesus.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.113",
      "id": "FN.241.113r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")]), _vm._v(" On this view, the two purpose clauses in vv. 25 and 26—both beginning “for a demonstration”—are parallel modifiers of “set forth,” the former focusing on how the propitiatory sacrifice of Christ enabled God to maintain his righteous character in postponing punishment of sins in the past, the latter showing how this same sacrifice "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.242"
    }
  }), _vm._v("preserved God’s righteous character as he justifies those who, in this age of salvation, place their faith in Jesus. This being so, it is likely that “the justifier”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.114",
      "id": "FN.242.114r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")]), _vm._v(" is not coordinate with “just”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.115",
      "id": "FN.242.115r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")]), _vm._v("—“just "), _c('i', [_vm._v("and")]), _vm._v(" justifying,” nor instrumental to it—“just "), _c('i', [_vm._v("by means of")]), _vm._v(" justifying,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.116",
      "id": "FN.242.116r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")]), _vm._v(" but concessive—“just "), _c('i', [_vm._v("even in")]), _vm._v(" justifying.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.117",
      "id": "FN.242.117r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")]), _vm._v(" Paul’s point is that God can maintain his righteous character (“his righteousness” in vv. 25 and 26) even while he acts to justify sinful people (“God’s righteousness” in vv. 21 and 22) because Christ, in his propitiatory sacrifice, provides full satisfaction of the demands of God’s impartial, invariable justice."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.118",
      "id": "FN.242.118r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")]), _vm._v(" To be sure, this way of viewing the atonement is out of fashion these days, frequently being dismissed as involving ideas completely foreign to the biblical teaching about God’s sovereignty and love. But whatever the mistakes of Anselm of Canterbury, whose famous treatise "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Cur Deus Homo")]), _vm._v(" (“Why God Became Man”) is widely regarded as the fountainhead of this approach, his emphasis on the divine character as incapable of dismissing sin lightly is a vital component in the biblical doctrine of God. Those who ignore or minimize the problem inherent in a holy God accepting sinners may well heed Anselm’s own warning: “You have not yet considered the weight of sin.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.119",
      "id": "FN.242.119r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("Luther called this paragraph “the chief point … of the whole Bible” (see the introduction to his paragraph) because it focuses on what Luther thought was the heart of the Bible: justification by faith. Luther believed that this “article” was vital: “if that article stands, the church stands; if it falls, the church falls.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.120",
      "id": "FN.242.120r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")]), _vm._v(" Later Lutherans coined the slogan “the article by which the church stands or falls” to highlight the central role that they accorded this doctrine. In Luther’s day, of course, “justification by faith” was a polemical thrust against a Roman Catholic teaching that insisted on the place of human cooperation in the grace of justification. Hence to the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola fide")]), _vm._v(" of the Reformers was added "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola gratia—")]), _vm._v("“by grace alone.” With these phrases, the Reformers expressed their conviction that justification is, from first to last, a matter of God’s own doing, to which human beings must respond but to which they can add nothing.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.243"
    }
  }), _vm._v("Despite important and welcome moves toward reconciliation between Protestants and Roman Catholics, the division between the two groups over justification remains. In an age that minimizes doctrine, there is a danger that this difference will be too easily swept under the carpet. But it is a significant one, affecting one’s understanding of salvation, the sacraments, assurance, and other matters both doctrinal and practical.")]), _vm._v(" "), _c('p', [_vm._v("The Reformation doctrine of justification by faith is also being challenged from other fronts these days. Chief among them, perhaps, is the tendency to read Paul’s justification by faith as having primary focus on the inclusion of the Gentiles. The Reformers’ justification by faith, referring to the acceptance before a holy God of a sinful individual through that individual’s believing, becomes the acceptance of the Gentiles within the people of God through Christ’s faithfulness or act of believing."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.243.121",
      "id": "FN.243.121r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")]), _vm._v(" As I suggest in my comments on a number of passages (cf. 3:20, 3:22, and the excursuses after 1:17 and 3:20), I think this general tendency both exegetically indefensible and theologically dangerous. Our era is one that—quite rightly—manifests deep concern for social issues. Interpreting Paul’s gospel in social terms (e.g., as having primary focus on the inclusion of Gentiles along with Jews in the people of God) is correspondingly very attractive. But for all Paul’s very vital interest in the unity of the people of God, he is even more vitally concerned about the relationship of the individual Jew or Gentile to the Lord of history.")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY4.1.2"
    }
  }, [_vm._v("2. “By Faith Alone” (3:27–4:25)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 3:27–4:25, Paul expounds the great theological thesis of 3:21–26. Or, to be more accurate, he expounds one key element in that thesis. For we hear no more in 3:27–4:25 about the atonement, or the demonstration of God’s righteousness, or the provision for sins under the Old Covenant. Rather, Paul concentrates on the vital theme stated in v. 22: “the righteousness of God through faith in Jesus Christ to all who believe.” Faith is the topic in every paragraph of this section of the letter, as Paul uses a series of antitheses to draw out the nature and implications of faith as the sole means of justification. Faith is contrasted with “works of the law” (3:28), “works” (4:1–8), circumcision (4:9–12), the law (4:13–16), and “sight” (4:17–22). With these contrasts Paul enunciates what has become a hallmark of the Reformation teaching: "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola fide—")]), _vm._v("that “faith alone” is the means by which a person can be brought into relationship with the God of the Bible. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Sola fide,")]), _vm._v(" Paul argues in this "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.244"
    }
  }), _vm._v("section, is necessary in order to maintain "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola gratia:")]), _vm._v(" “by grace alone.” But it is also necessary in order to ensure that Gentiles have equal access with Jews to the one God. The inclusion of Gentiles in the people of God has been God’s plan all along, as his dealings with Abraham demonstrate. The revelation of God’s righteousness “apart from the law” (v. 21) has now opened up this possibility in a way that was not the case before. This concern with the inclusion of the Gentiles is thus also an important theme in this section; but, contrary to many contemporary scholars, who are reacting to what they perceive to be an excessive concern with the individual and his or her relationship to God in traditional theology, it is not the main theme. The inclusion of the Gentiles within the people of God continues to crop up—3:29–30; 4:9–12, 16–17—but only as one motif within the larger argument.")]), _vm._v(" "), _c('p', [_vm._v("The antitheses in this section reveal its polemical thrust. Paul is once again “arguing” with a Jewish or Jewish-Christian viewpoint, contesting the importance of the law (3:27–28; 4:13–15), works (4:2–8), and circumcision (4:9–12). Indicative of this thrust is the return to the “dialogical” style of 2:1–5, 17–19; 3:1–8. On the other hand, in the balance that so characterizes Paul’s presentation of his gospel in Romans, he is at pains to maintain continuity with the OT and with Judaism. Justification by faith is nothing more than what the OT itself teaches (chap. 4, passim); faith “establishes” the law (3:31); and even circumcision, while no longer the necessary sign of those who belong to God, is upheld as valid for Jews (4:11–12). These positive remarks about OT and Jewish institutions stand in marked contrast to the somewhat parallel passage in Galatians (chap. 3), where Paul’s polemical concerns force him to take a more one-sided slant. In Romans, however, Paul is intent on showing how his gospel breaks the boundaries of the Old Covenant while at the same time standing in continuity with it; continuity within discontinuity is his theme. Such balance was necessary if the Romans were to understand and appreciate Paul’s gospel as a message that meets the needs of all people.")]), _vm._v(" "), _c('p', [_vm._v("While the preoccupation with Abraham in chap. 4 sets apart that chapter from the last paragraph of chap. 3, the two sections are closely related. In fact, an impressive degree of parallelism between the two is evident:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.244.1",
      "id": "FN.244.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tdul"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.245"
    }
  }), _vm._v("Boasting is excluded (3:27a)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("Abraham has no right to boast (4:1–2)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("… because one is justified by faith, not works of the law (3:27b–28)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("… because Abraham was justified by faith, not works (4:3–8)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("Circumcised and uncircumcised are united under the one God through faith (3:29–30)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("Circumcised and uncircumcised are united as children of Abraham through faith (4:9–17)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Naturally, the much longer chap. 4 introduces a number of points not found in 3:27–31,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.245.2",
      "id": "FN.245.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" but the similarity in general theme and development is striking. We may, then, view 3:27–31 as the initial statement of the theme, with chap. 4 as its elucidation and elaboration."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.245.3",
      "id": "FN.245.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY4.1.2.1"
    }
  }, [_vm._v("a. “By Faith Alone”: Initial Statement (3:27–31)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("Where then is boasting? It is excluded. Through what law? Of works? No, but through the law of faith. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("For"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.245.4",
      "id": "FN.245.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")]), _vm._v(" we reckon that a person is justified by faith apart from works of the law. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("Or is God the God of Jews only? Is he not also the God of Gentiles? Yes, he is God also of the Gentiles, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("since there is one God, who will justify the circumcision on the basis of faith and the uncircumcision through that faith. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("Do we then nullify the law through faith? By no means! Rather, we establish the law.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.246"
    }
  }), _vm._v("Paul moves quickly through several implications of and arguments for justification by faith. He begins by showing how justification by faith excludes any possibility of boasting on the part of Jews (vv. 27–28). The next two verses provide further reason for accepting the principle that justification must be by faith with no admixture of “works of the law”; only so can God truly be the God of Gentiles as well as Jews. Finally, in v. 31, Paul responds briefly to a Jewish objection to his stress on faith; no, he argues, faith does not nullify but “establishes” the law—enables it to be truly fulfilled. The style, as in 2:1–5, 17–29 and 3:1–8, reflects the diatribe method of argumentation, with its question-and-answer format. As in the earlier sections, it is difficult to say—and perhaps not all that important—whether we have here a “real” dialogue between Paul and a Jewish interlocutor,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.5",
      "id": "FN.246.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" or whether Paul himself is responsible for posing questions to himself as a means of making his points."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.6",
      "id": "FN.246.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("27")]), _vm._v(" The question “Where then is boasting?” with its answer “It is excluded”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.7",
      "id": "FN.246.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" draws an inference from vv. 21–26. “Boasting,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.8",
      "id": "FN.246.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" of course, is a sin common to all people—it reflects the pride that is at the root of so much human sinfulness. But Paul is probably thinking here particularly of Jews and their boasting. This is suggested by his elaboration in terms of the “law” in vv. 27b–28, by his dialogical style—the “Jew” has been his dialogue partner earlier (cf. 2:17), and by the focus on Jew and Gentile in vv. 29–30. What is the nature of this boasting? and why is it wrong? One interpretation holds that Paul is thinking of the pride of the Jews in their special covenant relationship to God (cf. 2:17). Such pride, Paul would then be arguing, has now been ruled out by the revelation of God’s righteousness apart from that covenant and its law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.9",
      "id": "FN.246.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" There is considerable truth in this view, as is clear from the Jewish emphasis throughout these chapters and from Paul’s stress that God has now revealed his righteousness “apart from the law” (3:27). But this “salvation-historical” explanation does not, in itself, go far enough. Paul’s reason for "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.247"
    }
  }), _vm._v("excluding boasting has to do with a contrast between faith and works (vv. 27b–28)—two kinds of human response to God (reasons for not limiting “works of the law” to Jewish covenant privileges will be given below). And this is confirmed by the parallel teaching about Abraham in chap. 4. The hypothetical basis for Abraham’s boasting is not simply covenant “identity markers” but “works” in a general sense. Moreover, Paul’s use of Abraham as a key example shows also that it is not just with the coming of Christ that boasting becomes wrong;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.10",
      "id": "FN.247.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" Abraham, many centuries before Christ, had no cause to boast either.")]), _vm._v(" "), _c('p', [_vm._v("The root issue here, then, is not salvation-historical, but anthropological. It is not the Jew’s pride in a covenant relationship with God, but the pride in accomplishments, the tendency for the Jew to think that his obedience to the law constituted some kind of claim on God, that Paul rejects."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.11",
      "id": "FN.247.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" This does not mean, however, that the very doing of the law was wrong because it involved sinful, boastful presumption."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.12",
      "id": "FN.247.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" There is nothing at all wrong with doing the law, according to Paul. The problem, rather, is when doing the law is regarded as an achievement on the basis of which a relationship with God could be established or maintained. This is wrong because justification can come only by faith: not only now that Christ has been revealed (vv. 21–24)—although this makes it even clearer—but in the past also (chap. 4). This is not to say, either, that all Jews were prone to such a “legalistic” attitude. Certainly, the centrality of the law in the Jewish religion rendered Jews very susceptible to such a tendency; but all people, being fallen, exhibit the same tendency: Greeks, boasting in their wisdom (cf. 1 Cor. 1:19–31); Americans, boasting in their “American way of life”; and all too many Christians, boasting in their “good deeds” instead of in the grace of God.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s explanation for the exclusion of boasting, as we have seen, rests on a contrast between “works” and “faith” (v. 27b). What is striking about this contrast is that Paul formulates it with the help of the word “law” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(nomos):")]), _vm._v(" “Through what "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" [is boasting excluded]? [Through the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v("]"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.13",
      "id": "FN.247.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" of works? No, but through the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" of faith.” What is his purpose in using this word here? Paul’s normal usage of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" would suggest that he uses the word throughout the verse with reference to the law of Moses, the torah. Paul would then be contrasting two different ways of understanding, or using, the law of Moses: understood simply in terms of “works,” it could lead to boasting; but "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.248"
    }
  }), _vm._v("understood in terms of “faith,” it excludes all such boasting."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.248.14",
      "id": "FN.248.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Advocates of this view sometimes point to the word we have translated “what?” as important support for their view. For the “literal” meaning of this word is “what kind of?” and this qualitative connotation supports the idea that Paul is asking here about contrasting qualities of the same law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.248.15",
      "id": "FN.248.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" But the “literal” translation is, in fact, not clearly dominant in the NT, where the translation “what?” receives strong support."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.248.16",
      "id": "FN.248.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" On either translation, it is straining the wording to think that Paul is referring to two perspectives on the same law rather than to two different laws.")]), _vm._v(" "), _c('p', [_vm._v("But an even more serious objection to this interpretation is the close relationship between the law of Moses and faith that it assumes. For such a positive relationship between these two contradicts both the movement of this passage and Paul’s larger teaching about the law. In both 3:21–26 and 3:28, the faith that gains a standing with God is explicitly distanced from the Mosaic law (“apart from the law”; “apart from works of the law”). It is just this distance that gives rise to the question in v. 31: “Do we then nullify the law through faith?” This question does not make sense unless Paul has, in this context, fully separated “faith” from the law of Moses. And this same careful distinction between believing and “doing” (the law, works of the law) is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.249"
    }
  }), _vm._v("maintained throughout Romans (cf. 2:25–29; 3:20; 4:2–8; 9:31–10:8) and the Pauline writings (cf. esp. Gal. 3:12). An allusion to a connection—however it is viewed—between faith and the Mosaic law in v. 27 would run quite counter to this clear principial distinction. It is our faith, “apart from works of the law” (v. 28), that rules out of court any possibility of boasting—not a new way of looking at the law (cf. also the plain antitheses in 4:2–6 and 13–15).")]), _vm._v(" "), _c('p', [_vm._v("A second interpretation is, then, to be preferred: that Paul is contrasting two different “laws.” On this view, the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos,")]), _vm._v(" in both its actual occurrences in the verse, has a metaphorical sense: “principle,” or “rule.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.249.17",
      "id": "FN.249.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Some scholars think, then, that there is no direct allusion to the law of Moses at all here; Paul simply contrasts the “principles” of works and faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.249.18",
      "id": "FN.249.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But Paul connects the Mosaic law and “works” too often in Romans (cf. 2:6–16, 25–27; 3:20) to make it possible to eliminate reference here to the torah. We take it, then, that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" in Paul’s question, while meant to have a general reference—“what ‘rule’ or ‘system of demands’ excludes boasting?”—would naturally bring to mind "), _c('i', [_vm._v("the")]), _vm._v(" law, the torah. Paul then adds the contrasting modifiers to make clear his point: no, it is not through the torah, that law which demands works, through which boasting is excluded; it is through the “rule” of faith, the “ordinance” or “demand” of God for faith as the basis for justification (v. 28)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.249.19",
      "id": "FN.249.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Rather than being entirely metaphorical, then, Paul’s use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.250"
    }
  }), _vm._v("embodies a “play on words,” in which the characteristic demand of the Mosaic covenant—works—is contrasted with the basic demand of the New Covenant (and of the OT, broadly understood; cf. chap. 4)—faith.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s point is that the narrow focus of most of his fellow Jews on the Mosaic law as the system within which their relationship to God was established gives rise to an implicit “boast” in human achievement; what a person does in obedience to the law becomes, in some sense and to varying degrees, critical to one’s “righteousness.” Once it is seen, however, that God’s righteousness comes to people “apart from the law,” there can be no more cause for any pride in human achievement."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.20",
      "id": "FN.250.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("28")]), _vm._v(" In this verse Paul explains"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.21",
      "id": "FN.250.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿21")]), _vm._v(" “the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" of faith.” It is a “rule” or “principle” pertaining to faith that “a person"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.22",
      "id": "FN.250.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" is justified by faith"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.23",
      "id": "FN.250.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" apart from works of the law.” Paul here promulgates no new rule; the first person plural “we reckon” probably indicates that he assumes that his readers would join him in this assessment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.24",
      "id": "FN.250.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Paul’s concern to meet Jewish views is evident in his addition “apart from works of the law.” As in 3:20, what is meant is not certain kinds of works, or works viewed in a certain light, but anything a person does in obedience to the law and, by extrapolation, anything a person does. This being the case, Luther’s famous addition of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola")]), _vm._v(" (“alone”) to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("fide")]), _vm._v(" (“faith”)—in which he was preceded by others, including Thomas Aquinas"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.25",
      "id": "FN.250.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿25")]), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.251"
    }
  }), _vm._v("—brings out the true sense intended by Paul. A serious erosion of the full significance of Paul’s gospel occurs if we soften this antithesis; no works, whatever their nature or their motivation, can play any part in making a sinner right with God.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("29–30")]), _vm._v(" “Or”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.26",
      "id": "FN.251.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" introduces the alternative to the principle set forth in v. 28: if justification is by works of the law, then only those “in the law” can be justified, and God becomes the God of Jews only. Paul rejects this alternative with the question, “Is he not also the God"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.27",
      "id": "FN.251.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿27")]), _vm._v(" of Gentiles?” To this question Paul gives the answer already implied by the form of the question:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.28",
      "id": "FN.251.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" “Yes, he is God also of the Gentiles.” In v. 30, Paul both explains why"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.29",
      "id": "FN.251.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" God must be God of the Gentiles as well as of the Jews and draws an implication from that truth. The explanation comes in the main clause: “there is one God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.30",
      "id": "FN.251.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" Paul takes one of the most basic of Jewish beliefs, monotheism, and turns it against Judaism. The “oneness” of God was confessed by the pious Jew every day: “the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(" our God is one "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v("” (Deut. 6:4). Yet if this is so, then God must be God of the Gentiles; else they would be left with no god. To be sure, Jews also believed that God was God of the whole world. But the limitations they placed upon this concept illustrate the radicality of Paul’s argument. For, in Judaism, God was the God of Gentiles only by virtue of his creative work, while only the Jews enjoy any meaningful relationship with God; this is expressed in later Jewish text: “I am God over all that came into the world, but I have joined my name only with you [Israel]; I am not called the God of the idolaters, but the God of Israel.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.31",
      "id": "FN.251.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" Only by accepting the torah could Gentiles hope to become related to God in the same way as Jews. In this paragraph, and in many other places in Romans, Paul makes clear that the torah no longer functions as the “dividing wall” between those who are outside and those who are inside the sphere of God’s people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.32",
      "id": "FN.251.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" In the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.252"
    }
  }), _vm._v("OT, while the law was not the means of salvation, it did function to “mark out” the people of God; and in Judaism, it became an impenetrable barrier. But for Paul monotheism, as he has come to see it in Christ, means that there can be no such barrier; all must have equal access to God, and this can be guaranteed only if faith, not works in obedience to the Jewish law, is made the “entrance requirement.”")]), _vm._v(" "), _c('p', [_vm._v("Paul states this radical implication of monotheism in a relative clause: “who will justify"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.33",
      "id": "FN.252.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿33")]), _vm._v(" the circumcision on the basis of faith and the uncircumcision through that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.34",
      "id": "FN.252.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿34")]), _vm._v(" faith.” The variation in prepositions in Paul’s description of the faith of the circumcised (“"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ek")]), _vm._v(" faith”) and that of the uncircumcised (“"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dia")]), _vm._v(" faith”) has stimulated the ingenuity of commentators for years."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.35",
      "id": "FN.252.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" But none of the suggested distinctions makes very good sense; the change in prepositions is probably simply a stylistic variation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.36",
      "id": "FN.252.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("31")]), _vm._v(" The function of this verse in the context can be determined only after the meaning of Paul’s assertion that “faith establishes the law” has been decided. This assertion comes in response to the question, raised by Paul himself (“we”), but undoubtedly reflecting an objection he had heard frequently as he preached to Jews: “Do we then nullify"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.37",
      "id": "FN.252.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿37")]), _vm._v(" the law through faith?” How would faith nullify "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.253"
    }
  }), _vm._v("the law? Through Paul’s emphasis on faith “alone,” to the exclusion of “works of the law,” in justification. The polemical situation forced Paul to harp on the inadequacy of works and the limited, and passing, importance of the Mosaic law; and this gave to his preaching an “anti-law” flavor. But, as on other occasions when Paul faces such an objection (cf. Rom. 7:7), he responds with a forthright denial: “By no means!” He then follows this up with a counterassertion: “Rather,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.253.38",
      "id": "FN.253.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" we establish the law.” That Paul affirms here a continuing role for the law, despite its playing no part in justification, is clear. But what role Paul may intend for the law is disputed.")]), _vm._v(" "), _c('p', [_vm._v("The main possibilities are three, according to whether Paul views the law as testifying, convicting, or commanding.")]), _vm._v(" "), _c('p', [_vm._v("(1) The first is the most popular."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.253.39",
      "id": "FN.253.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" Its advocates point to 3:19 and 3:21 for evidence that Paul in this context uses “law” broadly as a reference to Scripture. And, in both 3:21 and chap. 4 (Gen. 15:6), Paul affirms just this “testifying” role of the law in relationship to his teaching of justification by faith. While, then, it is faith, not the law, that justifies, this stress on faith “establishes” the law by setting forth that to which the law bears witness. While a “testifying” role of the OT is plainly asserted in this context, this interpretation suffers from two major problems. First, the connection between v. 31b and chap. 4, on which so much rests, is questionable. Had this been the function of v. 31b, we would have expected chap. 4 to begin with “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.253.40",
      "id": "FN.253.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" rather than with “therefore.” A second objection is more serious. That Paul sees in the OT a witness to his teaching about "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.254"
    }
  }), _vm._v("justification by faith is clear. But when denoting that function of the OT, he uses “the law and the prophets” (v. 21) or the “Scripture” (Gal. 3:8). Nowhere does he use “law” by itself to indicate this witnessing role of the OT. Even in Rom. 4, “law” is used in a negative sense and is not linked with the “witness” of Gen. 15:6. Perhaps most significant is 4:3, which introduces the quotation of this verse by asking, not “What does the ‘law’ say?” but “What does the Scripture say?” These points do not make it impossible that Paul refers here to the testifying role of the law—but they make it unlikely."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.41",
      "id": "FN.254.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', [_vm._v("(2) According to a second interpretation, the law is established in its role of condemning sinners and preparing the way for Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.42",
      "id": "FN.254.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" This function of the law is also mentioned in the context (3:19) and receives extensive treatment in Gal. 3:15–4:7. While this view deserves more consideration than it has been given, it has against it the fact that “law” is not used with this reference in the immediately preceding verses. Yet it is these verses, 27–30, that spark the objection in v. 31.")]), _vm._v(" "), _c('p', [_vm._v("(3) When the meaning of “law” in the immediate paragraph is considered, it is clear that it is the commanding aspect of the law that is prominent: “[law] of works” (v. 27); “works of the law” (v. 28). In fact, as we have noted, Paul normally uses “law” to denote the body of commands given by God through Moses."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.43",
      "id": "FN.254.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" And in other contexts where the continuing validity of the law is discussed, this is also the significance of “law” (cf. 7:7–12; 8:2–4; 13:8–10). This makes it likely that Paul argues here for the establishment of the Mosaic law in its commanding aspect. But in what sense is the law as demand established? (a) Does Paul mean that Christians are obliged to continue to obey the (“moral”) demands of the law?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.44",
      "id": "FN.254.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" (b) Or does he anticipate 13:8–10, where the command to love is set forth as the “fulfillment” of the law?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.45",
      "id": "FN.254.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" (c) Or is he thinking of the way in which our faith in Christ provides for the full satisfaction of the demands of the law "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.255"
    }
  }), _vm._v("(cf. 8:4)?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.255.46",
      "id": "FN.255.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" The brevity of Paul’s assertion and the lack of any immediate explanation make a decision difficult. But the stress on "), _c('i', [_vm._v("faith")]), _vm._v(" as establishing the law suggests that it is law as fulfilled in and through our faith in Christ that Paul thinks of here. In 8:4, Paul will argue that those who are in Christ and who “walk according to the Spirit” have the law fulfilled “in them,” in the sense that their relationship to Christ by faith fully meets the demands of God’s law. While we cannot be certain, it is likely that Paul means essentially the same thing here: that Christian faith, far from shunting aside the demands of the law, provides (and for the first time!) the complete fulfillment of God’s demand in his law.")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY4.1.2.2"
    }
  }, [_vm._v("b. “By Faith Alone”: Elaboration with Respect to Abraham (4:1–25)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In this chapter, Paul appeals to Abraham to support his insistence that righteousness can be attained only through faith. But, as in 3:27–31, Paul’s purpose is not only to establish the doctrine of justification by faith alone, but also, indeed especially, to draw out the implications of this "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola fide.")]), _vm._v(" To accomplish these purposes, Paul “exposits” Gen. 15:6: “Abraham believed God, and it was reckoned to him as righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.255.1",
      "id": "FN.255.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" This text is quoted in v. 3 after Paul sets up his problem in terms of Abraham’s “right” to boast (vv. 1–2). Thereafter, Paul quotes or alludes to this text in every paragraph of the chapter, using a series of antitheses to draw out its meaning and implications. In vv. 3–8, Paul shows that the “reckoning” of Abraham’s faith for righteousness is an entirely gracious act that by its nature excludes any appeal to works. The contrast between circumcision "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.256"
    }
  }), _vm._v("and uncircumsion dominates vv. 9–12. Here Paul shows that the “reckoning” of Abraham’s faith for righteousness took place before he was circumcised, thereby enabling him to become the “father” of both Jewish and Gentile believers. This same concern with the inclusive importance of Abraham is stressed in vv. 13–22, where Paul focuses on the promise that Abraham would be the father of “many nations,” or “all the seed.” The ruling contrast—though not so clearly sustained as those in the previous two paragraphs—is between “faith” and “law,” with a minor contrast perhaps suggested in vv. 18–21 between faith and “sight.” The quotation of Gen. 15:6 at the end of v. 22 brings Paul’s exposition back to where it began in v. 3; the final three verses of the chapter apply the lessons Paul has drawn from his text to his Christian readers."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.2",
      "id": "FN.256.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("As we noted in the introduction to 3:27–4:25, the parallels between them show that Paul in chap. 4 expands on the themes he introduced in 3:27–31. But why has Paul singled out Abraham as the reference point for this expansion? One reason is undoubtedly polemical. Abraham was revered by the Jews as their “father”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.3",
      "id": "FN.256.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" and his life and character were held up as models of God’s ways with his people and of true piety. “Abraham was perfect in all his deeds with the Lord, and well-pleasing in righteousness all the days of his life” ("), _c('i', [_vm._v("Jub.")]), _vm._v(" 23:10); Abraham “did not sin against thee” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.PR.MAN"
    }
  }, [_vm._v("Pr. Man.")]), _vm._v(" 8); “no one has been found like him in glory” (Sir. 44:19)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.4",
      "id": "FN.256.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" In keeping with the nomistic focus of first-century Judaism, Abraham was held up particularly as a model of obedience to God. His righteousness and mediation of the promise were linked to this obedience, it even being argued that he had obeyed the law perfectly before it had been given."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.5",
      "id": "FN.256.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Paul would naturally want to show his Roman readers that this understanding of Abraham, which his Jewish and Jewish-Christian opponents undoubtedly cited against his teaching (cf. Gal. 3–4), was not in accord with the OT. Through Paul’s interpretation of Gen. 15:6, Abraham is wrested from the Jews as an exemplar of torah-obedience and made into an exemplar of faith. As a result, Abraham ceases to be for Paul the father of Jews exclusively but the father of all who believe. Käsemann’s judgment is therefore justified: “The polemic which runs through the whole chapter shows that we are dealing here not with an extension or modification of the Jewish view, but with its contrast.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.6",
      "id": "FN.256.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.257"
    }
  }), _vm._v("But Paul is drawn to Abraham for more than polemical considerations. That Paul cites Abraham as an example for believers is clear. But Abraham is much more than an example. After all, the Jews focused as much as they did on Abraham because of the decisive role the OT gives to him in the formation of the people of Israel and in the transmission of the promise. Both Paul’s insistence that justification is by faith alone and his concern for the full inclusion of the Gentiles in the people of God make it necessary for him to integrate Abraham theologically into his scheme."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.257.7",
      "id": "FN.257.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" At least, it was necessary if Paul’s teaching was to have any claim to continuity with the OT. It is also evident that Paul considered this continuity to be essential—not just for polemical reasons, but for the sake of the gospel itself, which is the gospel of "), _c('i', [_vm._v("God")]), _vm._v(" (1:1)—“the God of Abraham, Isaac and Jacob.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.257.8",
      "id": "FN.257.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.1"
    }
  }, [_vm._v("i. Faith and Works (4:1–8)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("What then shall we say that Abraham, our forefather according to the flesh, has found?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.257.9",
      "id": "FN.257.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("For if Abraham was justified by works, he has "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.258"
    }
  }), _vm._v("reason to boast, but not before God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("For what does the Scripture say? “Abraham believed in God, and it was reckoned to him as righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.10.A",
      "id": "FN.10.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("Now for the one who works, the wages are not reckoned according to grace, but according to obligation. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("But to the one who does not work but believes on the one who justifies the ungodly, his faith is reckoned for righteousness. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("Just as also David pronounces a blessing on the person to whom God reckons righteousness apart from works:")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("Blessed are those whose lawless acts are forgiven")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("and whose sins are covered;")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("blessed is the person whose sin the Lord does not reckon."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.11.B",
      "id": "FN.11.Br",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The argument of the paragraph unfolds in four stages. In vv. 1–2 Paul denies that Abraham is any exception to the principle laid down in 3:27–28: all boasting is excluded because justification is by faith. Verse 3 cites the scriptural evidence for Abraham’s justification by faith. This reckoning of Abraham’s faith for righteousness is shown in vv. 4–5 to be a gracious act of the “God who justifies the ungodly,” thereby eliminating any place for “works” in the process. Finally, vv. 6–8 confirm the sovereign character of God’s “reckoning,” here defined in terms of forgiveness, with appeal to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.259"
    }
  }), _vm._v("David’s words in Ps. 32:1–2. Verses 4–5, which appeal to the gracious nature of God’s dealings with his people as support for justification by faith apart from works, are the heart of this paragraph. In this sense, we may characterize 4:1–8 as a kind of “commentary” on 3:27–28."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.10",
      "id": "FN.259.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" As so often in Romans, Paul uses a rhetorical question to introduce the next stage of his argument: “What then"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.11",
      "id": "FN.259.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" shall we say that Abraham, our forefather"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.12",
      "id": "FN.259.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿12")]), _vm._v(" according to the flesh, has found?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.13",
      "id": "FN.259.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" But just how does Paul’s discussion of Abraham in chap. 4 advance his argument? As we saw in the commentary on 3:31, many scholars take this verse as the heading of chap. 4. On this view, Paul in chap. 4 would be explaining what he means by “we establish the law” in 3:31c: we uphold the testimony of the Pentateuch (Gen. 15:6), which also makes clear that a person is justified by faith (cf. 3:28)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.14",
      "id": "FN.259.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" However, we have argued that this reading of 3:31c is unlikely. It is better viewed as a quick riposte to the objection raised in v. 31a, and not as a “heading” or introduction to chap. 4. This being the case, the deliberative question in 4:1 will connect the chapter generally with the discussion in 3:27–31."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.15",
      "id": "FN.259.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿15")]), _vm._v(" Paul in chap. 4 elaborates through the history of Abraham each of the key points he has made in 3:27–31."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.16",
      "id": "FN.259.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")])]), _vm._v(" "), _c('p', [_vm._v("“According to the flesh” is attached by some expositors to the verb. Paul would then be asking what Abraham discovered “by his own [fleshly] exertions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.17",
      "id": "FN.259.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" But the stress in the chapter on the expansion of Abraham’s “fatherhood” to include the spiritual paternity of all believers (cf. vv. 12, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.260"
    }
  }), _vm._v("16–18) suggests rather that this phrase limits “our forefather.” This limitation may involve physical as opposed to spiritual generation—“our [the Jews’] forefather ‘according to natural physical generation.’ ”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.18",
      "id": "FN.260.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But something of the usual pejorative sense of the phrase “according to the flesh” is probably to be found here as well: Abraham’s “paternity” in relationship to Paul and other Jewish Christians (“we”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.19",
      "id": "FN.260.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" is limited not just by physical descent but also by a narrow, “old era” perspective."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.20",
      "id": "FN.260.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" For from a “new era” perspective, Abraham is the father of all believers, both Jewish and Gentile (cf. 4:11–12).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" In this verse, Paul explains why"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.21",
      "id": "FN.260.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿21")]), _vm._v(" he has asked about Abraham’s experience in v. 1."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.22",
      "id": "FN.260.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" The flow of thought may be paraphrased: “What shall we say about Abraham? "), _c('i', [_vm._v("For")]), _vm._v(" if we say he was justified by works, he has reason to boast, and my claim in 3:27–28 that all boasting is excluded is called into question.” The question about Abraham’s being justified by works is no idle one. As we have seen, the Jewish interpretation of Abraham stressed his works as the essence of his piety and the basis for his extraordinary, exemplary relationship to God. Paul’s conditional sentence assumes the reality of this situation for the sake of argument—“if Abraham was justified by works”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.23",
      "id": "FN.260.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v("—and draws out the consequence: he “has reason to boast.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.24",
      "id": "FN.260.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Paul contests the conclusion in a brief rejoinder: “but not before God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.25",
      "id": "FN.260.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" But does this rejoinder limit Abraham’s boasting or reject it altogether? If the former, Paul would be implying that Abraham’s boasting was limited to the sphere of his fellow human beings: before people Abraham has some reason for pride; but “before God” he has no reason to boast."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.26",
      "id": "FN.260.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" If Paul were speaking simply about Abraham’s works, this would be a possible interpretation. But Paul is speaking of Abraham’s works in relation to his justification. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.261"
    }
  }), _vm._v("And since Paul rejects any possibility of justification by works (cf. vv. 3–5), it is more likely that Paul rejects Abraham’s claim altogether: "), _c('i', [_vm._v("all")]), _vm._v(" boasting in this context, whether before God or people, must be ruled out. “But not before God,” then, rejects the logic stated in the conditional sentence: when God’s viewpoint is considered, Abraham has no right to boast at all."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.27",
      "id": "FN.261.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" The abrupt “but not before God” states in preliminary fashion the conclusion of Paul’s argument, in which the protasis of the sentence (“if Abraham was justified by works”) is disproved."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.28",
      "id": "FN.261.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3")]), _vm._v(" Paul now explains"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.29",
      "id": "FN.261.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" this “but not before God” by citing the scriptural teaching about Abraham’s justification. The text that he cites, and which becomes the reference point for the rest of the chapter, is Gen. 15:6."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.30",
      "id": "FN.261.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿30")]), _vm._v(" While Jewish authors had already seized on Gen. 15:6 as a particularly important text,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.31",
      "id": "FN.261.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" Paul has more than a polemical purpose in citing the verse. Not only is this the first time the word “believe”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.32",
      "id": "FN.261.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" occurs in Scripture, but it is connected with the attaining of righteousness—one of the very few times in the OT that this connection is made. And the verse, of course, describes Abraham—the “father” of Israel and recipient of God’s promise. Paul therefore has very good reasons from within the OT itself to make this a banner verse for his gospel, as he does both here and in Gal. 3.")]), _vm._v(" "), _c('p', [_vm._v("In Gen. 15:6, Abraham’s “faith” is his complete trust in God with reference to God’s promise that he would have a natural descendant (vv. 4–5). But since this promise is a renewal of the one that God made to Abraham in Gen. 12:1–3, the promise with reference to which Abraham believes in Yahweh "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.262"
    }
  }), _vm._v("includes the worldwide blessing promised in the earlier text."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.33",
      "id": "FN.262.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" Of considerable importance for Paul’s use of the text is the meaning of God’s “reckoning” Abraham’s faith “for” righteousness. The language could suggest that his faith is considered as the “equivalent” of righteousness—that God sees Abraham’s faith as itself a “righteous” act, well pleasing to him."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.34",
      "id": "FN.262.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" But if we compare other verses in which the same grammatical construction as is used in Gen. 15:6 occurs, we arrive at a different conclusion. These parallels suggest that the “reckoning” of Abraham’s faith as righteousness means “to account to him a righteousness that does not inherently belong to him.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.35",
      "id": "FN.262.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Abraham’s response to God’s promise leads God to “reckon” to him a “status” of righteousness. If this interpretation of Gen. 15:6 is correct, then Paul’s application of the verse is both fair and appropriate. To be sure, the new connotations given the terms “faith” and “righteousness” as a result of Paul’s christological focus cannot be ignored. But the essential point, that Abraham’s relationship with God is established as an act of God’s grace in response to Abraham’s faith, is the same in both Genesis and Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.36",
      "id": "FN.262.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" Here Paul distances himself emphatically from the typical interpretation. For Jewish interpreters often viewed Gen. 15:6 through the lens of Gen. 22, so that Abraham’s “faith” became his obedience to God and was regarded as a “work” for which God owed Abraham a reward."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.37",
      "id": "FN.262.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Paul’s interpretation stands squarely against this tradition and is also a more faithful interpretation of the original.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.263"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("4")]), _vm._v(" In vv. 4–5, Paul draws two theological consequences from what is said about Abraham’s justification in Gen. 15:6: (1) works have no part in justification; and (2) this is so because God’s justifying verdict is not earned, but given freely. To be sure, Paul does not state things in just this way. His argument is more involved and even somewhat unclear. This is because he disrupts what would seem to be an intended parallelism between vv. 4 and 5 by shifting from the contrast between grace and obligation in v. 4 to a conclusion about justification in v. 5. Nevertheless, the two points isolated above emerge clearly enough.")]), _vm._v(" "), _c('p', [_vm._v("The theological application of Gen. 15:6 that Paul makes in vv. 4–5 reveals his true interest in Abraham’s justification and illustrates the hermeneutical principle he states in vv. 23–24: “the words ‘it was reckoned to him’ were written not for his sake alone, but for ours also.” And it is particularly the nature of the “reckoning” that Paul is interested in. Verse 4 picks up this key word"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.38",
      "id": "FN.263.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿38")]), _vm._v(" from the quotation in v. 3, as Paul lays down a general principle about the “reckoning” or “accounting” of “wages”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.39",
      "id": "FN.263.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" to a worker. If a person “works,” says Paul, the pay he or she receives in return is a matter of obligation, or fair compensation; the employer “owes” the worker a certain wage and is not giving it “freely,” or “without compulsion.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.40",
      "id": "FN.263.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" This contrast, which is found in secular commercial language"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.41",
      "id": "FN.263.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿41")]), _vm._v(" as well as in the religious discussions of Judaism,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.42",
      "id": "FN.263.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" is never given its theological application in this context. But the implicit “theo-logic” of Paul is clear: since work means the reward is given by obligation, the reward of righteousness must not be dependent on work—for God is never obliged by his creatures; justification is a gift, freely bestowed, not a wage, justly earned. That God acts toward his creatures graciously—without compulsion or necessity—is one of Paul’s nonnegotiable theological axioms. He uses it here to show that the faith that gained righteousness for Abraham was a faith that excluded works."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.43",
      "id": "FN.263.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" For many of us, accustomed by four centuries of Protestant theology to the Pauline “faith vs. works” contrast, this point might appear mundane. But it flew in the face of the dominant Jewish theology of the day, which joined faith and works closely together, resulting in a kind of synergism with respect to salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.44",
      "id": "FN.263.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" Against this, Paul argues that the “reckoning” of faith "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.264"
    }
  }), _vm._v("for righteousness—in Abraham’s life, or in anyone else’s—is a reckoning that is wholly of grace and must be, then, based on faith. Viewed in this light, Paul’s point does not rest on an alleged Hebrew concept of reckoning;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.45",
      "id": "FN.264.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" nor is he arguing that grace is the necessary consequence of reckoning,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.46",
      "id": "FN.264.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" or of faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.47",
      "id": "FN.264.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Grace is not the end point but the beginning of his logic; from the fact of grace comes the conclusion that the faith that justifies must be a faith that is “apart from” all works (cf. 3:28).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" The transition from general principle to theological principle explains the contrast between “the one who works” in v. 4 and “the one who does not work” at the beginning of this verse. With this last clause Paul is not “canonizing laziness” (Morris); nor does he mean that a Christian need never produce “good works.” As Calvin rightly emphasizes, Paul is the last theologian who would countenance a complacent Christian, unconcerned with the active putting into practice of one’s faith. Rather, what Paul has in mind, in light of the contrast with “[the one who] believes on the one who justifies the ungodly,” is the person who does not depend on her works for her standing before God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.48",
      "id": "FN.264.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" “The one who justifies the ungodly”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.49",
      "id": "FN.264.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" is justly famous as a succinct and bold statement of Paul’s conviction that our standing with God is wholly of God’s free grace. To appreciate the boldness of this characterization, we must set it beside OT condemnations of human judges who “justify” the guilty (Isa. 5:23; Prov. 17:15), and especially with God’s declaration in Exod. 23:7 that “I will not justify the wicked.” What is involved, of course, is a new application of the word “justify.” The OT texts refer to the declaration or recognition of an existing situation. But Paul has in mind a creative act, whereby the believer is freely given a new “status.” What is highlighted by the phrase is the nature of God—loving, freely giving, and incapable of being put under obligation to any human being. It is the person who believes in "), _c('i', [_vm._v("this")]), _vm._v(" God, and who thereby in his belief renounces any claim on God that his good works might exert, whose “faith is reckoned for righteousness.” Likewise, it becomes clear again that faith for Paul is something qualitatively distinct from any human-originated endeavor. "), _c('i', [_vm._v("We")]), _vm._v(" believe, but we can take no credit for it. As Jonathan Edwards puts it, the point of the verse is,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.265"
    }
  }), _vm._v("… that God, in the act of justification, has no regard to anything in the person justified, as godliness, or any goodness in him; but that immediately before this act, God beholds him only as an ungodly creature; so that godliness in the person to be justified is not so antecedent to his justification as to be the ground of it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.50",
      "id": "FN.265.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', [_vm._v("Paul’s purpose in vv. 4–5, then, is to show that the faith that justifies is “faith alone,” faith “apart from works.” And, as Chrysostom remarks, it is significant that this point is made with reference to Abraham:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("For a person who had no works, to be justified by faith was nothing unlikely. But for a person richly adorned with good deeds, not to be made just from these, but from faith, this is the thing to cause wonder, and to set the power of faith in a strong light.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" Paul’s concern to exclude “works” from justification surfaces again in this verse: “Just as also David"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.51",
      "id": "FN.265.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿51")]), _vm._v(" pronounces"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.52",
      "id": "FN.265.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿52")]), _vm._v(" a blessing"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.53",
      "id": "FN.265.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿53")]), _vm._v(" on the person"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.54",
      "id": "FN.265.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿54")]), _vm._v(" to whom God reckons"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.55",
      "id": "FN.265.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿55")]), _vm._v(" righteousness apart from works.” Paul’s addition of the negative “apart from works” makes it likely that vv. 6–8 confirm vv. 4–5."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.56",
      "id": "FN.265.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿56")]), _vm._v(" But Paul probably also intends to add a further OT confirmation of his doctrine of justification by faith (v. 3). If so, Paul may be imitating Jewish homiletical practice by adding to his primary proof from the Pentateuch a secondary witness from “the prophets and the writings.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.266"
    }
  }), _vm._v("7–8")]), _vm._v(" The words of David are taken from Ps. 32:1–2a."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.266.57",
      "id": "FN.266.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" One of the reasons why Paul quotes these verses is the presence in them of the key word “reckon.” The practice of associating verses from the OT on the basis of verbal parallels was a common Jewish exegetical technique."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.266.58",
      "id": "FN.266.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" But unlike the extremely artificial connections between verses often established through this method by Jewish exegetes, Paul’s association of Ps. 32:1–2 with Gen. 15:6 and his exposition of it is very much to the point. For the Psalm verses closely associate the forgiveness of sins (v. 1) with the Lord’s “not reckoning” a person’s sins against her (v. 2). In other words, it is not the “reckoning” of people’s good works but God’s act in "), _c('i', [_vm._v("not")]), _vm._v(" reckoning their sins against them that constitutes forgiveness. This perfectly accords with Paul’s concern to portray justification as a free act of God that has no basis in a person’s works. Two other implications follow from the association of these Psalm verses with Paul’s exposition. First, it is clear that the forgiveness of sins is a basic component of justification. Second, Paul reveals again his strongly forensic understanding of justification. For he uses this quotation to compare justification to the non-accrediting or not “imputing” of sins to a person. This is an act that has nothing to do with moral transformation, but “changes” people only in the sense that their relationship to God is changed—they are “acquitted” rather than condemned.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.2"
    }
  }, [_vm._v("ii. Faith and Circumcision (4:9–12)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("Therefore, was this blessing given to the circumcised, or to the uncircumcised also? For we are saying, “Faith was reckoned to Abraham for righteousness.” "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("How, then, was it reckoned? When he was circumcised or when he was yet uncircumcised? It was not when he was circumcised but when he was uncircumcised. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And he received circumcision as a sign, a seal of the righteousness of faith that was his when he was uncircumcised, in order that he might be the father of all those who believe while not circumcised—so that righteousness might also"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.266.1",
      "id": "FN.266.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" be reckoned to them—"), _c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("and the father of the circumcised"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.267"
    }
  }), _vm._v("—those who are not only circumcised but also walk in the steps of our father Abraham, who believed while still uncircumcised.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Quickly returning to his key text, Paul notes another significant aspect of the reckoning of Abraham’s faith for righteousness—it took place before he was circumcised. This circumstance allows Paul to claim Abraham as the father of "), _c('i', [_vm._v("all")]), _vm._v(" believers, both circumcised and uncircumcised. Paul thereby makes clear that it is not necessary to be Jewish to become a member of the people of God. Faith "), _c('i', [_vm._v("alone—")]), _vm._v("apart from works (4:3–8), apart from circumcision (4:9–12)—is sufficient to gain entrance into Abraham’s spiritual “family.” It becomes evident here that Abraham is much more than an “example” of faith. As the recipient and mediator of the promise, his experience becomes paradigmatic for his spiritual progeny.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9")]), _vm._v(" Having used Ps. 32:1–2 to confirm and interpret Gen. 15:6, Paul now turns back to Gen. 15:6 to add a further dimension to his application of Ps. 32:1–2. The question that is raised is whether “the blessing” of forgiveness of sins, accomplished through the Lord’s gracious “non-reckoning” of them against a person (cf. vv. 7–8), is applicable only “to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.2",
      "id": "FN.267.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" the circumcised,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.3",
      "id": "FN.267.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" or to the uncircumcised also.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.4",
      "id": "FN.267.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" The second sentence of the verse, in which Paul cites Gen. 15:6 again, does not explain the opening question,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.5",
      "id": "FN.267.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" nor does it gives its answer."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.6",
      "id": "FN.267.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Rather, Paul here sets the stage for his answer by reminding his readers"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.7",
      "id": "FN.267.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿7")]), _vm._v(" of the OT text that speaks authoritatively about these matters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.8",
      "id": "FN.267.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10")]), _vm._v(" As in vv. 3–5, Paul focuses on the meaning and circumstances of the “reckoning” of Abraham’s faith: “How, then, was it reckoned? When he "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.268"
    }
  }), _vm._v("was"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.9",
      "id": "FN.268.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿9")]), _vm._v(" circumcised"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.10",
      "id": "FN.268.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" or when he was yet uncircumcised?” Paul’s answer is clear and direct: “It was not when he was circumcised but when he was uncircumcised.” Paul does not justify this answer, but the course of the argument in v. 11 makes clear that Paul has in mind the chronological progression of the Genesis narrative about Abraham. Abraham’s faith “is reckoned for righteousness” when God promised him a son (Gen. 15); but it is not until much later—twenty-nine years, according to the rabbis—that he is circumcised (Gen. 17)")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11")]), _vm._v(" In the first part of this verse, Paul amplifies his answer at the end of v. 10 by showing the relationship between Abraham’s justification by faith and his later circumcision."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.11",
      "id": "FN.268.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" What was the significance of Abraham’s circumcision? It was, Paul claims, a “sign.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.12",
      "id": "FN.268.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" Paul tells us what this “sign” was in an appositive addition: “a seal of the righteousness of faith that was his"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.13",
      "id": "FN.268.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" when he was uncircumcised.” Genesis 17:11 calls circumcision a “sign of the covenant.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.14",
      "id": "FN.268.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" In light of the tendency among Paul’s Jewish contemporaries to identify this covenant as the Mosaic covenant, Paul’s decision to connect the signatory value of circumcision with “the righteousness of faith” (Gen. 15:6) is emphatic."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.15",
      "id": "FN.268.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" Everything in Abraham’s experience with the Lord, Paul suggests, has its source in his justification by faith. While there are Jewish texts that characterize circumcision as a “seal,” their late date makes it uncertain whether the description "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.269"
    }
  }), _vm._v("was known in Paul’s day."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.16",
      "id": "FN.269.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" In any case, Paul uses the word to denote something that “confirms” the truth or reality of something else, as in 1 Cor. 9:2, where Paul describes the Corinthian believers themselves as the “seal,” the confirmation and authentication, of his apostleship. In like manner, Abraham’s circumcision confirms his righteous status, a status that was his by virtue of his faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.17",
      "id": "FN.269.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Circumcision, therefore, has no independent value. It cannot effect one’s entrance into the people of God; nor does it even “mark” a person as belonging to God’s people apart from a prior justifying act. Abraham was declared righteous while still uncircumcised. His later circumcision added nothing materially to that transaction; it simply signified and confirmed it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.18",
      "id": "FN.269.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', [_vm._v("In verses 11b–12 we have one long purpose clause, with a result clause (“so that righteousness might also be reckoned to them”) stuck inside it. In the major purpose clause, Paul depicts Abraham as the spiritual father of all believers, both Gentiles and Jews. It is dependent on v. 11a, although the two parts of the clause relate to different elements in 11a: because Abraham believed while uncircumcised, he is the father of all Gentile believers; because he believed and was "), _c('i', [_vm._v("also")]), _vm._v(" circumcised, he is qualified to be the father of all Jewish believers. As we have seen, Abraham is specially reverenced as the “father” of the Jewish nation (cf. 4:1); and with salvation practically confined to Israel, this meant that one could become Abraham’s spiritual descendant only through incorporation into Israel—through birth, or, occasionally, through conversion."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.19",
      "id": "FN.269.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Paul now claims Abraham and the inheritance that is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.270"
    }
  }), _vm._v("his (cf. vv. 16–17), for anyone who believes. It is through faith, and not through incorporation into the nation of Israel, that one becomes Abraham’s spiritual “child.” Indeed, Abraham’s Gentile “children” are mentioned first in the compound purpose clause. Paul at this point inserts a parenthetical remark in which he notes a consequence"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.20",
      "id": "FN.270.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿20")]), _vm._v(" of the belief of the Gentiles; they, like Abraham, have their faith reckoned to them for righteousness.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("12")]), _vm._v(" After the brief interruption at the end of v. 11, Paul now resumes his main purpose clause. Paul indicates that Abraham’s receiving of circumcision had the purpose of qualifying him to be the “father of the circumcised—those who are not only circumcised but also walk in the steps of our father Abraham, who believed while still uncircumcised.” But who comprises this category of “the circumcision”? A few expositors think the word might have a spiritual sense here, designating the Christian community as a whole (cf. Phil. 3:3)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.21",
      "id": "FN.270.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" But the context of Rom. 4 focuses too much on the distinction between Jews and Gentiles to make that likely. Others think that the long explanatory clause Paul adds to the word “circumcision” makes it clear that he has two groups in mind: both Jewish believers, “children” of Abraham as participants in the righteousness of faith, and Jews generally, who continue to be the beneficiaries of at least some of the promises God made to Abraham (see Rom. 9:5 and 11:28). Advocates of this view argue that the wording of the qualifying clause could point to a translation in which two separate groups are denoted: “not only to those who are ‘of the circumcision’ but also to those who follow in the footsteps of faith that our father Abraham had when uncircumcised.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.22",
      "id": "FN.270.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" But there are other elements of the wording that point to one group; and the context strongly suggests that Paul is referring to Jewish Christians: those of the circumcision “who"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.23",
      "id": "FN.270.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" are not only circumcised but also walk in the steps of our father Abraham,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.24",
      "id": "FN.270.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" who believed while still uncircumcised.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.25",
      "id": "FN.270.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.271"
    }
  }), _vm._v("In addition to Gentiles who believe, Abraham’s children are also comprised of Jews who believe. In keeping with the theme of the paragraph, Paul stresses again that the faith of Abraham that Jewish Christians imitate is a faith that was first exercised when Abraham was in an “uncircumcised state.” Jews who follow their biblical paradigm will place the proper value on their circumcision: as a mark of a relationship they enjoy with the Lord through their faith rather than as a visa that will automatically insure their entrance into heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.3"
    }
  }, [_vm._v("iii. Faith, Promise, and the Law (4:13–22)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("For it was not through the law that the promise was to Abraham or to his seed, that they should be the heirs of the world, but through the righteousness of faith. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("For if those who are of the law were heirs, faith would be emptied and the promise would be nullified. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("For the law produces wrath. And"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.271.1",
      "id": "FN.271.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" where there is no law, neither is there transgression.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("Because of this, it is of faith, in order that it might be according to grace, so that the promise might be confirmed to all the seed, not to those who are of the law only, but also to those who are of the faith of Abraham, who is the father of us all. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("Even as it is written, “I have appointed you as the father of many nations,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.12.A",
      "id": "FN.12.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")]), _vm._v(" before the God in whom he believed, the God who gives life to the dead and calls those things that are not as though they were. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("Who against hope, on the basis of hope, believed, so that he became the father of many nations, according to what was said, “So shall your seed be.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.13.B",
      "id": "FN.13.Br",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b")]), _vm._v(" "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("And he did not weaken in faith when he observed"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.271.2",
      "id": "FN.271.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" his own body, already"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.271.3",
      "id": "FN.271.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" dead—being about "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.272"
    }
  }), _vm._v("a hundred years old—and the deadness of the mother Sarah. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("He did not doubt the promise of God because of unbelief, but grew strong in faith, giving glory to God, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("and being fully convinced that he was able also to do what had been promised. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("Wherefore also"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.272.4",
      "id": "FN.272.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")]), _vm._v(" “it was reckoned to him for righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.14.C",
      "id": "FN.14.Cr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Many expositors divide this passage into two paragraphs, putting a break after v. 16 or v. 17. But while Paul’s focus does shift at this point from a polemical contrast between law and faith to a more positive portrayal of Abraham’s faith, the theme of the promise runs throughout vv. 13–22, binding them together in an overall unity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.272.5",
      "id": "FN.272.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" The noun “promise,” which occurs for the first time here in the letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.272.6",
      "id": "FN.272.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" is used four times in these verses, the verb “to promise” once. In each case, the reference is to the promise given to Abraham, with Paul emphasizing particularly how it was faith that secured what God had promised. There is evidence that Paul has built his exposition on the foundation of a traditional Jewish and Jewish-Christian interpretation of Abraham’s faith. This interpretation, whose general outline can be discerned in Philo, Acts 7, Heb. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.273"
    }
  }), _vm._v("11, and "), _c('i', [_vm._v("1 Clem.")]), _vm._v(" 10, focuses particularly on the miracle-working power of God and the way Abraham (and Sarah) experienced this power by ignoring the “facts” of the situation and trusting rather in the promise of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.7",
      "id": "FN.273.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" However, while this theme is evident in vv. 17–21, the first part of Paul’s exposition departs from the traditional interpretation with its polemical contrast between the law and faith and, to a lesser extent, with its inclusion of the Gentiles in the “seed” of Abraham. Paul’s concern to claim Abraham as the spiritual ancestor of Christians is evident here again. Surfacing again also is his concern with grace and universalism, which Paul believes can be upheld only if faith rather than the law is the instrument by which what had been promised to Abraham is attained. Verses 13–22 continue, then, Paul’s exposition of faith by way of contrasts: to “faith apart from works” (vv. 3–8) and “faith apart from circumcision” (vv. 9–12), we can add “faith apart from the law” (vv. 13–16) and “faith apart from sight” (vv. 17–21).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("13")]), _vm._v(" As the “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.8",
      "id": "FN.273.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" suggests, the paragraph beginning in v. 13 has an explanatory function—it explains why Paul made no mention of the law in tracing the spiritual descendants of Abraham (vv. 11–12). This omission, in light of the standard Jewish view that it was Abraham’s fidelity to the law that secured God’s blessing (see the introduction to 4:1–25) and that one could be Abraham’s child only by taking on oneself “the yoke of the torah,” requires explanation and defense. Paul makes his position clear in v. 13: it was not “through law”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.9",
      "id": "FN.273.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" but “through the righteousness of faith” “that the promise was to Abraham or to his seed, that they"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.10",
      "id": "FN.273.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" should be the heirs of the world.” “Law” refers, as the Jewish polemical context makes clear, to the Mosaic law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.11",
      "id": "FN.273.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" In Gal. 3, Paul makes his case for the exclusion of the law from God’s dealings with Abraham on the basis of simple chronology—the law, given four hundred and thirty years after the promise, cannot annul or substantially alter this previous agreement between God and Abraham (vv. 15–17). Some think that his argument is presumed here in Romans also."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.12",
      "id": "FN.273.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" But this is not "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.274"
    }
  }), _vm._v("clear. Probably Paul has not used the chronological argument because he wants to apply his reasoning to Abraham’s descendants as well as to Abraham. And, since most of Abraham’s putative descendants lived after the giving of the Mosaic law, the chronological argument would obviously have no point.")]), _vm._v(" "), _c('p', [_vm._v("“Not through the law” denies, then, that what had been promised to Abraham was attained by him or by his descendants through the law, for example, by their doing of the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.13",
      "id": "FN.274.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Rom. 4 does not focus on the christological implications of “seed” that Paul brings out in Gal. 3."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.14",
      "id": "FN.274.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿14")]), _vm._v(" The word here is purely collective, the reference being to all who are numbered among the “descendants” of Abraham (cf. also vv. 16, 18; 9:7–8). The clause “that they should be the heirs of the world” explains what the promise is."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.15",
      "id": "FN.274.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" This language does not exactly match any promise to Abraham found in the OT but succinctly summarizes the three key provisions of the promise as it unfolds in Genesis: that Abraham would have an immense number of descendants, embracing “many nations” (Gen. 12:2; 13:16; 15:5; 17:4–6, 16–20; 22:17), that he would possess “the land” (Gen. 13:15–17; 15:12–21; 17:8), and that he would be the medium of blessing to “all the peoples of the earth” (Gen. 12:3; 18:18; 22:18). Particularly noteworthy is the promise in Gen. 22:17b that Abraham’s seed would “possess"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.16",
      "id": "FN.274.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")]), _vm._v(" the gate of their enemies.” Later in the OT, there are indications that the promise of the land had come to embrace the entire world (cf. Isa. 55:3–5),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.17",
      "id": "FN.274.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" and many Jewish texts speak of Israel’s inheritance in similar terms."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.18",
      "id": "FN.274.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" Against this background—to which we can add Jesus’ beatitude, “Blessed are the gentle, for they shall inherit the earth”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.19",
      "id": "FN.274.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v("—Paul probably refers generally to all that God promised his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.20",
      "id": "FN.274.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("14")]), _vm._v(" Paul now explains (“for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.21",
      "id": "FN.274.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(") why the promise cannot be attained “through the law”: “if"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.22",
      "id": "FN.274.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" those who are of the law were heirs,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.23",
      "id": "FN.274.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" faith would be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.275"
    }
  }), _vm._v("emptied"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.24",
      "id": "FN.275.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" and the promise would be nullified.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.25",
      "id": "FN.275.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" “Those who are out of the law” is a literal and rather awkward translation of a phrase that appears to means something like “those who are basing their hope for the inheritance on the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.26",
      "id": "FN.275.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" The phrase does not, then, refer to Jews per se,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.27",
      "id": "FN.275.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" but to those who have nothing more than their status as Jews as a basis for inheriting the blessings promised to Abraham. For there are Jews who, living “in the sphere of the law,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.28",
      "id": "FN.275.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" add to their Jewishness faith in Christ; and the righteousness before God they gain by that faith makes them, like Abraham, heirs of the promise. As “only” is appropriately added to “faith” in 3:28 to bring out the meaning, so also here we might paraphrase “if those who have only the law are heirs.…”")]), _vm._v(" "), _c('p', [_vm._v("Why, if Jews as such were heirs, would faith and the promise be jeopardized? Paul might mean that the granting of the inheritance to Jews on the basis of their relationship to the law would empty the terms “faith” and “promise” of their essential theological meaning. One can hardly apply the word “promise” to something that a person has a “right” to; nor is faith, in the Pauline sense of absolute trust in God, an appropriate word to use for what is one’s “birthright” or “wage.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.29",
      "id": "FN.275.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" However true this may be (cf. 4:4–5), the verbs Paul uses do not naturally suggest this interpretation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.30",
      "id": "FN.275.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" In light of these verses, Paul probably means that the exercise of faith has failed to attain its end. Why are faith and the promise rendered futile if Jews apart from faith are the heirs? The reason that is suggested by the logic of Rom. 1–3 and by the explanation in v. 15 is the inherent impossibility of any person adhering to the law to the extent necessary to gain the inheritance. In other words, Paul is arguing: “If it is the case that the inheritance is to be based on adherence to the law, then there will be no heirs, because no fallen human being can adequately adhere to the law—and that means that faith is exercised in vain and the promise will never be fulfilled.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.31",
      "id": "FN.275.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.276"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("15")]), _vm._v(" The first clause of this verse substantiates the conclusion drawn in v. 14 by showing what the law "), _c('i', [_vm._v("does—")]), _vm._v("“produces"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.32",
      "id": "FN.276.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" wrath”—as opposed to what it "), _c('i', [_vm._v("cannot do—")]), _vm._v("secure the inheritance. Paul is countering the very positive, and sometimes even salvific, function given the law in Jewish theology. The second clause in the verse is a parenthetical explanation of the reason why the law produces wrath: “And"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.33",
      "id": "FN.276.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿33")]), _vm._v(" where there is no law, neither is there transgression.” It is difficult to decide whether the clause is a statement about the Mosaic law specifically or a kind of “gnomic” statement about the nature and function of law, as “law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.34",
      "id": "FN.276.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" In either case, the application is to the Mosaic law, which is clearly referred to in the first part of the verse. But what is the point of this statement? Murray thinks that Paul is justifying the universal infliction of God’s wrath. According to him, Paul’s logic goes like this:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("God justly inflicts wrath for transgressions")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Wherever there is “law,” there is “transgression”")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("“Law” is universal (Paul here assuming what he argued in Rom. 2:12–16)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Therefore: God’s infliction of wrath on all people is just")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Another way of reading the clause, however, is to attribute to it the more limited purpose of explaining why the Mosaic law works wrath. Paul’s logic would then be:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("Violation of law turns “sin” into the more serious offense of “transgression,” meriting God’s wrath")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("God gave the law to the Jews")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("The Jews have transgressed the law (cf. 2:1–29; 3:9–19)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("The law brought wrath to the Jews"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.35",
      "id": "FN.276.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿35")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This second interpretation is the more likely. A statement about the negative results of the Mosaic law fits well in the context, since vv. 13–16 are dominated by the “not through the law” of v. 13a. An explanation of the causes of God’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.277"
    }
  }), _vm._v("wrath does not fit nearly as well and appears to be a needless repetition of the argument of Rom. 1:18–3:20. Moreover, Paul’s use of the word “transgression” rather than “sin” suggests that he is not thinking of the general condition of sin that justifies the infliction of God’s wrath, but the more specific situation that obtains wherever people are confronted with clearly defined, verbally transmitted laws and commands. For Paul does not use “transgression” as a synonym for “sin.” “Transgression” denotes a specific kind of sin, the “passing beyond” the limits set by a definite, positive law or command."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.36",
      "id": "FN.277.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" While every “transgression” is also a “sin,” not every “sin” is a “transgression.” Paul, then, is not claiming that there is no “sin” where there is no law, but, in almost a “truism,” that there is no deliberate disobedience of positive commands where there is no positive command to disobey. As Calvin puts it: “He who is not instructed by the written law, when he sins, is not guilty of so great a transgression as he is who knowingly breaks and transgresses the law of God.” Paul’s real point emerges in the application of this principle to the Mosaic law as an explanation of how it is that “the law works wrath.” Before and outside the Mosaic law wrath certainly exists, for all people, being sinners, stand under God’s sentence of condemnation (1:18). But the Mosaic law “produces” even more wrath; rather than rescuing people from the sentence of condemnation, it confirms their condemnation. For by stating clearly, and in great detail, exactly what God requires of people, the law renders people even more accountable to God than they were without the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.37",
      "id": "FN.277.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("16")]), _vm._v(" In vv. 14–15 Paul has elaborated the negative point in v. 13: the inheritance comes “not through the law.” Now Paul turns to its positive antithesis: the inheritance is given “through the righteousness of faith.” “Because of this”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.38",
      "id": "FN.277.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" may, then, refer back to the negative argument of vv. 14–15: “because of this” incapacity of the law to secure the promise, it must be by faith that it is attained."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.39",
      "id": "FN.277.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" However, the phrase “because of this” often looks ahead to a following clause in the NT,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.40",
      "id": "FN.277.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" and this makes good sense here. The antecedent of “this” will then be the purpose clause “in order that it might be according to grace.” It is for that reason, that grace might be preserved, that “it is of faith.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.41",
      "id": "FN.277.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" But what is this “it,” the implied subject of the verse? Probably, in light of v. 13, “the promised inheritance.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.42",
      "id": "FN.277.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" The intimate relation "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.278"
    }
  }), _vm._v("in Paul’s thought between faith and grace emerges again here. As Paul has shown in vv. 4–5, grace is the necessary corollary to faith, as “obligation” is to works. Thus, “God’s plan was made to rest upon faith on man’s side in order that on God’s side it might be a matter of grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.43",
      "id": "FN.278.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" But there was, according to Paul, a still further purpose in God’s provision of the inheritance through faith: “that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.44",
      "id": "FN.278.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿44")]), _vm._v(" the promise might be confirmed to all the seed.” The benefit denoted by this clause is, as Chrysostom notes, twofold: that the promise might be “firm”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.45",
      "id": "FN.278.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v("—that it might come to fruition—and that the promise might be confirmed to "), _c('i', [_vm._v("every")]), _vm._v(" descendant of Abraham. Neither blessing would have come to pass if it had depended on human “works” or obedience to the law; but because faith grasps the absolutely sure promise of God, a promise that he has determined freely to give, the inheritance God has promised can become a reality, and a reality for anyone who believes.")]), _vm._v(" "), _c('p', [_vm._v("Paul puts a particular spin on “all the seed” in two contrasting phrases: “not to those"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.46",
      "id": "FN.278.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿46")]), _vm._v(" who are of the law only, but also to those who are of the faith of Abraham.” As is the case throughout Romans, and certainly in chap. 4, Paul’s “universalism” is a “qualified” universalism that gives the Gentiles the same opportunity as Jews to respond to the gospel and to become part of the people whom God is calling out of the world in the last days. While Paul does not express himself extremely clearly, this inclusion of both Jew and Gentile in the “seed” of Abraham is what is in view in this last part of v. 16. “Those who are of the law only” could, especially in light of the contrast with “those who are of the faith of Abraham,” refer to unbelieving Jews."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.47",
      "id": "FN.278.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" In this case, Paul would be asserting that Jews continue to be part of the “seed of Abraham,” in a different way, however, from that in which Christians are the seed of Abraham. Such a point would not, if properly nuanced, be incompatible with Paul’s thought (see Rom. 11:11–30). But it is perhaps unlikely that this is what he intends here. Paul has forcefully stated that the true descendants of Abraham are those who believe (vv. 11–12); and when he uses the word “seed” here, it must be with this spiritual meaning that he has given the word. Moreover, the phrase “out of faith” rules "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.279"
    }
  }), _vm._v("the entire verse and must be carried over to this latter part of it. The meaning, then, is that the promise is for the Jew who is part of the seed through faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.48",
      "id": "FN.279.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" “Out of the law” must mean something a bit different from what it does in v. 11, and designate Jews as such, “those who had the advantage of being under the Mosaic economy.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.49",
      "id": "FN.279.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" In light of the contrast indicated by “not only … but also,” “those out of the faith of Abraham” are Gentile believers."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.50",
      "id": "FN.279.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" It is in this sense that Abraham is the “father of us all”—the spiritual forefather of all of “us” who are believers.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("17")]), _vm._v(" This verse is composed of two main clauses:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("Even as it is written, “I have appointed you as the father of many nations”")]), _vm._v(" "), _c('p', {
    staticClass: "bqs"
  }, [_vm._v("before the God in whom he believed,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.51",
      "id": "FN.279.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" the one who gives life to the dead and calls those things that are not as though they were.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("They can be related to one another and to the larger context in several ways. (1) The two clauses could follow one another in a straightforward, consecutive sequence, with the quotation from Gen. 17:5 confirming “who is the father of us "), _c('i', [_vm._v("all")]), _vm._v("” at the end of v. 16, and the second clause being dependent on the first clause."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.52",
      "id": "FN.279.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" (2) The first clause could confirm “to all the seed” in the middle of v. 16, with the second clause again dependent on the first."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.53",
      "id": "FN.279.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" (3) According to most commentators, v. 17a depends on 16b, as in the first reading, but is somewhat parenthetical, with 17b taken with “father of us all” in v. 16b."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.54",
      "id": "FN.279.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" (4) Again, as in v. 1, the first clause may be attached to v. 16b, with the second "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.280"
    }
  }), _vm._v("clause going as far back as “all the seed” in v. 16."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.55",
      "id": "FN.280.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿55")]), _vm._v(" (5) Finally, one could construe the first clause according to any of these suggestions, with the second clause initiating a new paragraph."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.56",
      "id": "FN.280.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', [_vm._v("The connection between “father” in the quotation in v. 17a and “father” in v. 16b is so clear that we must take these clauses closely together, as is done in all the alternatives except the second. There is some truth in the last suggestion, for v. 17b does prepare the way for the exposition of Abraham’s faith, with its application to Christians, in vv. 18–25. But the relative clause also looks backward—it functions as the pivot in Paul’s argument."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.57",
      "id": "FN.280.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" But to what, exactly, does it look back? This is the most difficult problem, and the one that serves to differentiate the remaining three alternatives (1, 3, and 4). The connection is awkward in any case, because the preposition “before” does not naturally follow on any of the verbs found in the three immediately preceding clauses. But the connection that makes the most sense is with the immediately preceding clause (e.g., option 1). It adds little to Paul’s point to note that the confirmation of the seed (v. 16a) or the spiritual fatherhood of Abraham (v. 16b) exists “in the sight of God,” for, while true, it hardly needs to be said. On the other hand, to add to the quotation of a promise that is couched in the past tense—“I "), _c('i', [_vm._v("have")]), _vm._v(" made you the father of many nations”—a reminder of the nature of this God “in the presence of whom” the promise is given and accepted explains the certainty expressed in that past tense. God can promise Abraham—and Abraham can believe—that certain things not now existing "), _c('i', [_vm._v("will")]), _vm._v(" exist because God is the God who “gives life to the dead and calls those things that are not as though they were.”")]), _vm._v(" "), _c('p', [_vm._v("The quotation in v. 17a, from Gen. 17:5,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.58",
      "id": "FN.280.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿58")]), _vm._v(" substantiates v. 16, the “many nations” including both Jews and Gentiles. The promise in Genesis probably has a similar intention, although whether it refers simply to physical ancestry or spiritual “fatherhood” also is not clear. Paul’s further characterization of God in terms of his “making alive” and “calling” picks up widespread OT and Jewish teaching. God’s power to give life is underscored in the OT (Deut. 32:39; 1 Sam. 2:6) and was featured in the important Jewish liturgy, the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Shemoneh Ezreh")]), _vm._v(", the “Eighteen Benedictions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.59",
      "id": "FN.280.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" In light of the promise quoted in v. 17a, Paul is thinking to some extent of God’s bringing life from the body of Abraham and the womb of Sarah."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.60",
      "id": "FN.280.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" The exposition of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.281"
    }
  }), _vm._v("Abraham’s faith that follows confirms this, as v. 19 notes the “deadness” of Abraham’s body and the barrenness of Sarah as the visible evidence that Abraham’s faith had to transcend. However, this characterization of God receives a further application in the context, vv. 24–25 defining as the object of Christian belief “the one who raised Jesus our Lord from the dead.” Finally, it is possible, though perhaps unlikely, that Paul is also thinking of the application of these words to the rescue of Isaac from his near death (cf. Heb. 11:19).")]), _vm._v(" "), _c('p', [_vm._v("It is more difficult to know what Paul intends by describing God as the one “who calls those things that are not as though they were.” Our conclusion will depend on the meaning we give to “call.” If it means, prosaically, “name” or “address,” then Paul would be further alluding to the certainty of the fulfillment of God’s promise to Abraham: although “the many nations” do not yet exist, God can address them as if they did."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.61",
      "id": "FN.281.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Somewhat similar is the interpretation that takes “call” to mean “summon”: God summons, calls up before Abraham’s view, these nations that “are not” as if they were."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.62",
      "id": "FN.281.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" While each of these explanations fits the syntax and the context well, some interpreters discern a further reference. In the OT, the verb “call” refers to God’s creative work (cf. Isa. 41:4; 48:13), and later Jewish authors perpetuate this usage, sometimes adding the idea that this creative “calling” involves a bringing into being things that were not."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.63",
      "id": "FN.281.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" It may be, then, this tradition of a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("creatio ex nihilo")]), _vm._v(" to which Paul alludes, with the purpose of reminding his readers of God’s creative power generally."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.64",
      "id": "FN.281.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" Moreover, several texts apply this language to spiritual conversion, and sometimes, as here, with reference to God’s giving life to the dead."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.65",
      "id": "FN.281.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" These parallels make it possible that Paul’s description of God as “the one who calls into being things that are not” is a reminder that God “justifies the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.282"
    }
  }), _vm._v("ungodly” (v. 5): he creates out of the nothingness of people’s empty, sinful lives a new, vibrant, spiritual life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.66",
      "id": "FN.282.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('p', [_vm._v("There can be no doubt that Paul’s language is quite close to this Jewish "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("creatio ex nihilo")]), _vm._v(" tradition and that an allusion to either God’s general creative power or his spiritual creative power would not be out of place in the context. However, if this were Paul’s purpose, it is surprising that he speaks of God’s calling things “as though” they existed; we would have expected him to say “calls things into being.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.67",
      "id": "FN.282.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" This leads us to conclude, somewhat hesitantly and reluctantly, that the clause cannot refer to God’s creative power as such, whether general or spiritual. It is, then, the nature of God as “speaking of” or “summoning” that which does not yet exist as if it does that Paul must mean. And this interpretation fits the "), _c('i', [_vm._v("immediate")]), _vm._v(" context better than a reference to God’s creative power, for it explains the assurance with which God can speak of the “many nations” that will be descended from Abraham.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("18")]), _vm._v(" As we have seen, a number of commentators hold that a new paragraph begins here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.68",
      "id": "FN.282.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" However, while it is true that Paul shifts his focus a bit, spotlighting the positive characteristics of Abraham’s faith in vv. 18–21, his attention is still on the promise: how Abraham responded to the promise—in faith—and how it was "), _c('i', [_vm._v("that")]), _vm._v(" faith which secured righteousness and what had been promised. The emphasis in v. 18 falls on the paradoxical description of Abraham’s faith as “against hope, on the basis of hope.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.69",
      "id": "FN.282.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" No better explanation of the phrase can be found than Chrysostom’s: “It was against man’s hope, in hope which is of God.” As Paul will explain in v. 19, Abraham had every reason, from a human point of view, to give up the attempt to produce a child through Sarah. His faith flew in the face of that hope which is founded on the evidence of reason and common sense—“hope” as we often use the word (“I hope to win the lottery”). Yet his faith was firmly based on the hope that springs from the promise of God. We note here that Abraham’s faith is not described as a “leap into the dark,” a completely baseless, almost irrational “decision”—as Christian faith is pictured by some "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.283"
    }
  }), _vm._v("“existentialist” theologians—but as a “leap” from the evidence of his senses into the security of God’s word and promise.")]), _vm._v(" "), _c('p', [_vm._v("As a consequence of his strong faith, Abraham “became the father of many nations.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.70",
      "id": "FN.283.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" Paul indicates that Abraham’s clinging in faith to the divine promise resulted in the fulfillment of what he had been promised. Instead of Gen. 17:5, Paul quotes an earlier promise to Abraham, from Gen. 15:5. After inviting Abraham to contemplate the star-strewn desert sky, God promises him: “Thus shall your descendants be.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.71",
      "id": "FN.283.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" This suggests that, in Paul’s mind, the “many nations” of which Abraham is the father are equivalent to the spiritual “seed” made up of believing Jews and Gentiles (see v. 16).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("19")]), _vm._v(" Verses 19–20 detail the way in which Abraham believed “against hope on the basis of hope.” Almost all commentators make “weakening” subordinate to “observed,” the normal relationship between a participle and finite verb. But Greek does allow for a reversal of these roles, with the finite verb expressing the subordinate thought, and this makes good sense in the present verse: “He did not weaken in faith"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.72",
      "id": "FN.283.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿72")]), _vm._v(" when he observed his own body.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.73",
      "id": "FN.283.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" The “against hope” aspect of Abraham’s faith is accentuated, as Paul stresses that Abraham continued to believe God’s promise to him even as he observed the physical condition that rendered the fulfillment of that promise so unlikely.")]), _vm._v(" "), _c('p', [_vm._v("This physical evidence would certainly have given Abraham reason to doubt that he would produce offspring through Sarah. His own body was “already dead,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.74",
      "id": "FN.283.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(" in the sense that he was past the age when procreation was likely to occur—he was “about a hundred years old” (cf. also Heb. 11:12)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.75",
      "id": "FN.283.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.284"
    }
  }), _vm._v("Since Gen. 17:1 claims that Abraham was ninety-nine years old when the promise of offspring was renewed, Paul’s is an acceptable approximation. But standing in the way of the fulfillment of the promise was not only Abraham’s advanced age but the “deadness,” the “barrenness,” of Sarah, the woman predicted to be the mother of the child through whom Abraham’s “seed” would come. Since the word “deadness”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.76",
      "id": "FN.284.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" is not the normal word for a woman’s barrenness, Paul has deliberately chosen his language to make clear that Abraham’s faith with respect to this promise was specifically faith in the “God who gives life to the dead” (v. 17b). In another way, also, our faith is to be like Abraham’s, as Calvin eloquently notes:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("Let us also remember, that the condition of us all is the same with that of Abraham. All things around us are in opposition to the promises of God: He promises immortality; we are surrounded with mortality and corruption: he declares that he counts us just; we are covered with sins: He testifies that he is propitious and kind to us; outward judgments threaten his wrath. What then is to be done? We must with closed eyes pass by ourselves and all things connected with us, that nothing may hinder or prevent us from believing that God is true.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("20")]), _vm._v(" This verse resumes and expands on what we have identified as the main point of v. 19: “[Abraham] did not weaken when he considered.…”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.77",
      "id": "FN.284.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" The Greek phrase equivalent to “the promise of God”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.78",
      "id": "FN.284.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" comes first in the sentence for emphasis. When Paul says that Abraham did not “doubt … because of unbelief,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.79",
      "id": "FN.284.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" he means not that Abraham never had "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.285"
    }
  }), _vm._v("momentary hesitations, but that he avoided a deep-seated and permanent attitude of distrust and inconsistency in relationship to God and his promises."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.80",
      "id": "FN.285.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" Unlike the “double-souled” person who displays a deeply rooted division in his attitude toward God (Jas. 1:6–8), Abraham maintained a single-minded trust in the fulfillment of God’s promise."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.81",
      "id": "FN.285.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('p', [_vm._v("In contrast to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.82",
      "id": "FN.285.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" Abraham’s refusal to waver in disbelief, he “grew strong"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.83",
      "id": "FN.285.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿83")]), _vm._v(" in faith.” This phrase might refer to the procreative power that Abraham attained through his faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.84",
      "id": "FN.285.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" But the natural contrast between “he did not weaken in faith” in v. 19a and this clause makes it probable that “faith” is the object rather than the means or cause of the “strengthening”: it was Abraham’s faith itself that grew stronger."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.85",
      "id": "FN.285.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" In what way did Abraham’s faith “grow strong”? In the sense that anything gains strength in meeting and overcoming opposition—muscles when weights are raised; holiness when temptation is successfully resisted. So Abraham’s faith gained strength from "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.286"
    }
  }), _vm._v("its victory over the hindrance created by the conflict between God’s promise and the physical evidence. And in this strengthening of his faith, Abraham gave “glory"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.286.86",
      "id": "FN.286.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿86")]), _vm._v(" to God.” In his faithful response to God’s word, Abraham therefore accomplished what the idolaters of 1:21 failed to do.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("21")]), _vm._v(" The sentence begun in v. 20 is continued. As “giving glory to God” denotes the result of Abraham’s growing strong in faith, “being fully convinced"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.286.87",
      "id": "FN.286.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿87")]), _vm._v(" that he was able also to do what had been promised” repeats and further describes what this “growing strong” means. It is Abraham’s conviction that God is fully able to do whatever he promised that enabled his faith to overcome the obstacle of the tangible and visible “facts.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("22")]), _vm._v(" “Wherefore”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.286.88",
      "id": "FN.286.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" indicates that this verse draws a consequence or conclusion from the preceding verses. Paul certainly sees this as the conclusion of the immediately preceding verses, in which he has described Abraham’s faith (vv. 18–21). And since these verses include aspects of the promise that are brought out in Gen. 17 and later, it would seem that Paul agrees to this extent with the Jewish tradition, that the faith Abraham exercised in Gen. 15:6 is explained and exemplified in the later career of the patriarch. But the verse may serve to conclude more than the immediate section. With a last reference to Gen. 15:6, Paul rounds off the discussion of that verse which has been the constant touchstone since v. 3. Now, in a sense, Paul’s “historical” exposition is ended, and he can turn in application to his Christian readers.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.4"
    }
  }, [_vm._v("iv. The Faith of Abraham and the Faith of the Christian (4:23–25)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("And it was not written for him only, that “it was reckoned to him,” "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("but also for us, to whom it was going to be reckoned, to those who believe in the one who raised Jesus our Lord from the dead, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("who was handed over because of our trespasses and raised for our justification.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("While these three verses are related to vv. 18–22, they can be considered a separate paragraph because they draw conclusions from the entire exposition of vv. 3–22. Paul has, of course, applied his far-ranging exposition of Gen. 15:6 to Christians throughout the chapter, in both explicit and implicit ways. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.287"
    }
  }), _vm._v("But nowhere does he so solemnly and clearly state the application as he does here.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("23")]), _vm._v(" The conviction expressed in vv. 23–24 that what is written in Genesis about Abraham has relevance to the Christian believer has been the implicit assumption of the whole of chap. 4. There is a close relationship between vv. 23–24 and v. 22: “[It was the faith delineated in vv. 18–21 that] ‘was reckoned’ to Abraham for righteousness (22), but this ‘it was reckoned’ was written not for his sake only (23), but also for ours.…” Paul’s conviction that the OT everywhere speaks to Christians is fundamental to his theology and preaching."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.287.1",
      "id": "FN.287.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" In the interests of avoiding hermeneutical foolishness, however, we must be quite clear in what way various parts and verses of the OT are relevant to the Christian. In the case of Gen. 15:6, the significance is clear and very direct. Christians share with Abraham the same basis for justification—faith—and the same God as the object of that faith. Paul cites only the words “it was reckoned to him” from Gen. 15:6 in v. 23, perhaps as a “shorthand” allusion to the verse, or perhaps because all along it has been Paul’s concern to unfold the meaning of that “reckoning.” It is "), _c('i', [_vm._v("faith")]), _vm._v(" that is “reckoned”: a faith that is "), _c('i', [_vm._v("apart from works, apart from circumcision, apart from the law, apart from sight—")]), _vm._v("and therefore a “reckoning” that is solely a matter of "), _c('i', [_vm._v("grace")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("24")]), _vm._v(" Paul chooses to describe Christians in two parallel clauses,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.287.2",
      "id": "FN.287.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" each of which brings out their connection with Abraham. First, Christians are those “to whom it was going to be"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.287.3",
      "id": "FN.287.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" reckoned”: that is, those people who experience in its eschatological fullness the righteousness that Abraham attained by faith. Second, Christians are “those who believe in the one who raised Jesus our Lord from the dead.” It is typical for Paul to designate God as the one who raised Jesus from the dead (cf. 8:11; 10:9; 1 Cor. 6:14; 15:15; 2 Cor. 4:14), but it is somewhat unusual for him to designate God himself as the object of Christian faith. Undoubtedly he does so here to bring Christian faith into the closest possible relationship to Abraham’s faith. Not only is our faith of the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.288"
    }
  }), _vm._v("same nature as Abraham’s; it ultimately has as its object the same God, “who gives life to the dead” (cf. v. 17b). And the connection is even closer. For Abraham’s faith in God had to do not just with the miraculous creation of life where there was “deadness,” but with the fulfillment of God’s promise to bless the world through him. It is the God of the promise, the promise given to Abraham but ultimately fulfilled in Christ and Christians, in whom both Abraham and we believe. While, therefore, the locus of faith has shifted as the course of salvation history has filled out and made ever more clear the specific content of the promise, the ultimate object of faith has always been the same.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("25")]), _vm._v(" The last words of v. 24 have a rather solemn tone, and this is continued in v. 25. The two clauses of the verse exhibit a clear parallelism:")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("who")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("was handed over")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("because of our trespasses"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.4",
      "id": "FN.288.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("was raised")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("because of our justification"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.5",
      "id": "FN.288.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿5")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Most commentators think that this parallelism betrays the presence of a pre-Pauline tradition."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.6",
      "id": "FN.288.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" This may well be the case, although it must be insisted that, if so, Paul has fully integrated the elements of the tradition into his exposition. But, whether traditional or not, the wording resembles that of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of Isa. 53, particularly v. 12: “because of their sins he was handed over.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.7",
      "id": "FN.288.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" As is probably the case in Isaiah, and certainly in Paul (cf. 8:32), the passive “was handed over” is a “divine passive,” God being the implied agent of the action. God the Father has himself taken the initiative in giving up his Son to and for sinful people (cf. 3:25: “God set forth Christ as a propitiation”).")]), _vm._v(" "), _c('p', [_vm._v("The second line of the formula—“who was raised because of our justification”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.8",
      "id": "FN.288.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v("—may allude to Isa. 53 as well, for the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of v. 11 (which differs widely from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(") speaks of the servant as “justifying the righteous.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.9",
      "id": "FN.288.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.289"
    }
  }), _vm._v("But the allusion is not clear, since the meaning of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" is not the same as Paul’s. The puzzling feature of the second line is the connection Paul suggests between Jesus’ resurrection and our justification. Paul uses a preposition that normally means “because of”; and if we give it this meaning here, Paul will be suggesting that our justification was in some sense a cause of Jesus’ resurrection. Godet, who argues for this meaning, suggests that Paul is teaching that Christ’s death had definitively effected justification and that his resurrection was therefore the “necessary effect.” Yet it is difficult to see why this would be so, and Paul has hitherto used “justification” with reference to the subjective appropriation through faith. Accordingly, we can give the preposition a “prospective” reference—“because of” in the sense of “because of the need to,” “for the sake of”: Christ was raised “for the sake of” our justification."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.289.10",
      "id": "FN.289.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" The problem with this interpretation is that it is difficult to give this meaning to the same preposition because it is used in the parallel first clause. Some attempt to find this meaning there also by suggesting that we add an inference: “he was handed over for the sake of [for the purpose of] "), _c('i', [_vm._v("taking care of")]), _vm._v(" transgressions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.289.11",
      "id": "FN.289.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" But since maintaining the same meaning for this preposition in both lines requires questionable additions or interpretations of one line or the other, it is probably best to give the word a retrospective meaning in the first line and a prospective meaning in the second: “he has handed over "), _c('i', [_vm._v("because of")]), _vm._v(" our trespasses [e.g., because we are sinners], and was raised "), _c('i', [_vm._v("for the sake of")]), _vm._v(" our justification [e.g., in order to secure our justification].”")]), _vm._v(" "), _c('p', [_vm._v("Finally, the theological implications of the formula need to be explored. Particularly striking, because unusual, is the connection made between Christ’s resurrection and our justification. To be sure, it would be easy to make too much of this; the division of the lines may be purely for rhetorical effect, the whole formula saying no more than that Jesus’ death and resurrection are basic to the believer’s salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.289.12",
      "id": "FN.289.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" There is some truth to this, as is clear from "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.290"
    }
  }), _vm._v("the fact that Paul would obviously not want to separate Christ’s death (the first line) from our justification (the second line). But when due allowance is made for rhetoric, we must still insist that Paul is affirming here a theological connection between Jesus’ resurrection and our justification (cf. 5:10). As Jesus’ death provides the necessary grounds on which God’s justifying action can proceed, so his resurrection, by vindicating Christ and freeing him forever from the influence of sin (cf. 6:10), provides for the ongoing power over sins experienced by the believer in union with Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BODY5"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rBODY5"
    }
  }, [_vm._v("III. THE ASSURANCE PROVIDED BY THE GOSPEL: THE HOPE OF SALVATION (5:1–8:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In this letter to the Romans, Paul explains and defends his gospel to a Christian community he has neither founded nor visited but which he hopes to enlist as supporters of an evangelistic campaign in the western Mediterranean. To accomplish this purpose, Paul writes a “tractate”-style letter with a careful and logical structure. After introducing himself as one “set aside for the gospel” and announcing his plans to bring that “good news” to Rome (1:1–15), Paul justifies his commitment to the gospel because it transmits “God’s power that brings salvation” (1:16). And why does the gospel have such power? Because, Paul explains, it reveals God’s justifying activity—and all who respond to that activity in faith become “just” before God (1:17). This teaching of “justification by faith,” so basic to Paul’s gospel, is the theme of the first major section of the letter (1:18–4:25). To explain why God has manifested this new justifying activity, and why it can be experienced only by faith, Paul shows that all people have rebelled against God and are helpless under the power of sin, unable of themselves to do anything to escape God’s impartial judgment (1:18–3:20). But, expanding on 1:17, Paul shows how God’s sacrifice of his Son has enabled him both to rescue people from this dilemma and to do it without violating his own holy justice (3:21–26). Again, though, Paul stresses that this new relationship with God is available only for those who believe—it cannot be attained by works, or by circumcision, or by the law (3:27–4:25). But, as these last negations reveal, Paul’s exposition of the gospel has constant reference to Jewish viewpoints. In both major sections of 1:18–4:25, Paul shows how the revelation of God’s righteousness erases distinctions between Jews and Gentiles: the Jew, like the Gentile, is under the power of sin (3:9); the Jew, like the Gentile, can be justified only by faith (3:28–30).")]), _vm._v(" "), _c('p', [_vm._v("How does chap. 5 carry on Paul’s argument? Since Paul continues to stress justification (5:1, 9, 16–19, 21) and only at 6:1 breaks the course of the argument with a rhetorical question about the Christian life, chap. 5 could be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.291"
    }
  }), _vm._v("closely connected to 1:18–4:25, with chaps. 6–8 forming the second major section of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.1",
      "id": "FN.291.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" This has been a very popular way of outlining the letter, with 1:18–5:21 and 6–8 often being viewed as describing, respectively, “justification” and “sanctification.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.2",
      "id": "FN.291.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Another way of looking at the matter is to place a major transition at the middle of the chapter, with 1:18–5:11 being dominated by the antithesis between sin and justification and 5:12–8:39 by the antithesis between life and death."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.3",
      "id": "FN.291.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Each section would then go over similar ground, with an introductory section on sin (1:18–3:20; 5:12–21) and a concluding section on hope (5:1–11; 8:18–39)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.4",
      "id": "FN.291.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" Still others insist that the chapter is transitional and refrain from attaching it more to what precedes or to what follows."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.5",
      "id": "FN.291.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" But, as the heading to the section indicates, I think it better to place the transitional point between chaps. 4 and 5. To be sure, this whole question requires caution, lest we impose on the letter a rigidly logical, dogmatically oriented outline that Paul may never have intended. After all, he is writing a letter, not a systematic theology."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.6",
      "id": "FN.291.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Nevertheless, while mindful of the danger of oversystematizing and of erecting barriers between sections so that the continuity of Paul’s argument is lost,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.7",
      "id": "FN.291.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Paul "), _c('i', [_vm._v("is")]), _vm._v(" arguing, and arguing "), _c('i', [_vm._v("theologically;")]), _vm._v(" therefore, it is quite appropriate to look for transitions in that argument. While we must not draw too heavy a line between chaps. 4 and 5, the progress of Paul’s argument reveals a transition in topic at this point."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.8",
      "id": "FN.291.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.292"
    }
  }), _vm._v("Four main arguments combine to show that Paul intends a transition in the letter at 5:1. First, the opening phrase of the chapter, “having been justified by faith,” summarizes the argument of 1:18–4:25 while preparing the way for a new topic that will build on it. Second, a shift in style at 5:1 is noticeable. 1:18–4:25 has a polemical tone—Paul is plainly "), _c('i', [_vm._v("arguing")]), _vm._v(" against a (mainly) Jewish viewpoint, sometimes addressing his opponent directly in the second person singular. But with 5:1, the first person plural begins to dominate, Paul including fellow Christians with him in a more “confessional” style: “"), _c('i', [_vm._v("we")]), _vm._v(" have peace,” “access,” “"), _c('i', [_vm._v("we")]), _vm._v(" rejoice,” “Christ died for "), _c('i', [_vm._v("us,")]), _vm._v("” “"), _c('i', [_vm._v("we")]), _vm._v(" are now justified,” “"), _c('i', [_vm._v("we")]), _vm._v(" have now received our reconciliation.” While not as concentrated as in 5:1–11 (from which the quotations are taken), this style recurs throughout chaps. 5–8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.292.9",
      "id": "FN.292.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿9")]), _vm._v(" A third indication that a shift in focus occurs at 5:1 is the relative frequency of certain key words in chaps. 5–8 in comparison with 1:18–4:25. Particularly striking is the contrast between the 33 occurrences of “faith” and “believe” in 1:18–4:25 and the three uses in chaps. 5–8 (and two of the latter refer back to the argument in 1:18–4:25). On the opposite side, “life” and “to live,” used only twice in the first section, occur 24 times in chaps. 5–8. No such clear contrast is present in “righteousness” words: there are 26 in 1:18–4:25 and 16 in chaps. 5–8. But a closer analysis reveals a significant difference. In the earlier section, the great majority of occurrences focus on justification as the status attained by the sinner through faith, while in chaps. 5–8 the connection with faith is rare, the words denoting the status of justification as the means to eternal life (5:12–21) or having a more “ethical” connotation as a description of the Christian obligation (6:15–23). While statistics are easily used (or abused!) to prove anything anyone wants, these figures concern key words in Paul’s argument and signal a significant shift in focus."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.292.10",
      "id": "FN.292.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', [_vm._v("The fourth, and most important, argument for connecting chap. 5 more closely with what follows than with what precedes is that it provides a more convincing reading of what Paul is teaching in this part of the letter than any "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.293"
    }
  }), _vm._v("alternative is able to give. As several scholars have noticed, key words found in 5:1–11 recur again in 8:18–39. Note the following:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:1–11")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:12–8:16")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:18–39")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("“love” (of God/Christ)")])]), _vm._v(" "), _c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:5, 8")])]), _vm._v(" "), _c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:35, 39")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“justify”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:1, 9")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("6:7")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:30 (twice), 33")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“glory”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("6:4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:18, 21, 30 (“glorify”)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“peace”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("8:6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“hope”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:2, 4, 5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:20, 24 (four times), 25")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“tribulation”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:3 (twice)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:35")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“save”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:9, 10")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:24")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“endurance”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:3, 4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:25")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Both 5:1–11 and 8:18–39 affirm, against the threat of tribulation and suffering, the certainty of the Christian’s final salvation because of God’s love, the work of Christ, and the ministry of the Holy Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.293.11",
      "id": "FN.293.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" This theme, the “hope of sharing in God’s glory” (cf. 5:2 and 8:18, 30), “brackets” all of chaps. 5–8. Assurance of glory is, then, the overarching theme in this second major section of Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.293.12",
      "id": "FN.293.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" The verdict of justification, which Jews relegated to the day of judgment, has, Paul proclaims, already been rendered over the person who believes in Jesus. But can that verdict, “hidden” to the senses, guarantee that one will be delivered from God’s wrath when it is poured out in the judgment? Yes, affirms Paul. Nothing can stand in its way: not death (5:12–21), not sin (chap. 6), not the law (chap. 7)—nothing! (chap. 8). What God has begun, having justified and reconciled us, he will bring to a triumphant conclusion, and save us from wrath.")]), _vm._v(" "), _c('p', [_vm._v("As 8:18–39 shares a common theme with 5:1–11, so 8:1–17 has much in common with 5:12–21 (see the introduction to chap. 8). And sandwiched between these passages is 6:1–7:25. Here Paul focuses on the situation of the Christian in this life—a situation of some tension and conflict because, while "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.294"
    }
  }), _vm._v("transferred through our justification into the new realm of God’s kingdom, the powers of the old realm to which we no longer belong nevertheless continue to influence us. Temptations to sin, the sufferings that are a part of our sin-sick world, and the last enemy—the death of the body—must still be faced. But, proclaims Paul, the God who has provided for the beginning of spiritual life (justification) and the end (glorification) also provides for the period “between.” In union with Christ, we have been delivered from the tyranny of sin (chap. 6) and the law (chap. 7). At the risk of oversimplifying a complex section and obscuring many other significant connections, we may view the "), _c('i', [_vm._v("main development")]), _vm._v(" of chaps. 5–8 as a “ring composition,” or chiasm:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A. 5:1–11")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("assurance of future glory")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl1"
  }, [_vm._v("B. 5:12–21")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("basis for this assurance in work of Christ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl2"
  }, [_vm._v("C. 6:1–23")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("the problem of sin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl2"
  }, [_vm._v("C′. 7:1–25")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("the problem of the law")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl1"
  }, [_vm._v("B′. 8:1–17")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("ground of assurance in the work of Christ, mediated by the Spirit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A′. 8:18–39")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("assurance of future glory")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In a certain sense, then, 6:1–7:25 is parenthetical to the main point of the section."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.294.13",
      "id": "FN.294.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" But there are many points of contact between this central section and both chaps. 5 and 8, and the topics that are treated in it are hardly incidental."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.294.14",
      "id": "FN.294.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" It is also important to see that the concern for Jewish/Gentile relationships, and the related topic of the Mosaic law, so basic to Paul’s argument in chaps. 1–4, is by no means dropped. In the midst of his depiction of life in Christ, Paul keeps inserting comments about the law (5:13–14, 20; 6:14–15), climaxing in the chapter-long discussion in 7, and spilling over into 8 (vv. 1–4, 7, 15). Paul does not lose sight of the larger theological issue against which, and in relation to which, he hammers out his teaching in Romans. Indeed, Paul contributes in a major way to this motif by showing how many of those privileges and blessings the Jews thought were their own through the law have been “transferred” to the new covenant community that exists “in Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.294.15",
      "id": "FN.294.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', [_vm._v("In chaps. 5–8, then, Paul invites the Christian to join with him in joyful "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.295"
    }
  }), _vm._v("thanksgiving for what the gospel provides—a new life given to God’s service in this life and a certain, glorious hope for the life to come. At the same time Paul is continuing his defense of the gospel. His opponents (probably Jewish, mainly) attacked his message as proclaiming no more than a legal fiction—a “declaration” of a relationship that cannot be proved and which effects no change—and requires no change!—in this life and which offers no security for the day of judgment. Quite the contrary, Paul affirms, the person who has experienced the gospel as the justifying activity of God (cf. 1:17) is assured of finding that gospel to be truly “God’s power for salvation” (cf. 1:16)—power for dedicated Christian service in this life and for deliverance from all the forces of evil and of judgment in the next."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.295.16",
      "id": "FN.295.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY5.1"
    }
  }, [_vm._v("A. THE HOPE OF GLORY (5:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "chaft",
    attrs: {
      "id": "BODY5.1.1"
    }
  }, [_vm._v("1. From Justification to Salvation (5:1–11)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("Having, therefore, been justified by faith, we have"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.295.17",
      "id": "FN.295.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿17")]), _vm._v(" peace with "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.296"
    }
  }), _vm._v("God through our Lord Jesus Christ, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("through whom also we have access"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.296.18",
      "id": "FN.296.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿18")]), _vm._v(" into this grace in which we stand; and we boast in the hope of the glory of God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("And not only this, but we boast also in our tribulations, knowing that tribulation produces endurance, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("and endurance a proven character, and proven character hope.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("Now this hope will not put us to shame, because the love of God has been poured out into our hearts by the Holy Spirit who has been given to us. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("For while we were still weak, at just the right time,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.296.19",
      "id": "FN.296.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Christ died for godless people. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("For hardly ever will someone die for a righteous person; although for a good person one might dare to die. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("But God commends his own love for us, in that while we were still sinners Christ died for us.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("Therefore how much more, having now been justified through his blood, will we be saved through him from wrath. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("For if, while we were enemies, we were reconciled to God through the death of his Son, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.297"
    }
  }), _vm._v("how much more, being reconciled, will we be saved through his life. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And not only this, but we also boast in God through our Lord Jesus Christ, through whom we have received this reconciliation.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In this paragraph, Paul invites us to join with him in celebrating the marvelous benefits conferred upon the justified believer: “the Apostle speaks as one who is extremely happy and full of joy” (Luther); “it is now the believer who is speaking—in fact we might almost say, singing” (Leenhardt). Paul highlights two blessings in particular: “peace with God” (or reconciliation) and hope. The former theme occurs at the beginning (vv. 1–2a) and end (v. 11) of the paragraph while the latter is the focus of vv. 2b–10. Some scholars single out reconciliation as the key theme of the paragraph,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.20",
      "id": "FN.297.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" while a greater number think that hope is the central concept."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.21",
      "id": "FN.297.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" Still others decline to make a choice and give the paragraph a general heading such as “the blessings of justification”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.22",
      "id": "FN.297.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" This last alternative is alone broad enough to encompass everything in the paragraph. Paul proclaims that Christians are not only “justified”—“acquitted” in a legal sense—but placed into an entirely new situation, both in the present (“reconciliation”) and in the future (“sharing the glory of God”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.23",
      "id": "FN.297.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" Nevertheless, of these two topics, it is “hope” that comes to dominate the paragraph—in v. 10, for instance, Paul argues from reconciliation to hope. Moreover, it is the topic of “hope” and “glory” that Paul elaborates on in 5:12–21 and 8:14–39, while reconciliation is mentioned without further attention or description.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.298"
    }
  }), _vm._v("The central thrust of the passage is summarized in v. 2b—“we boast in the hope of the glory of God”—and v. 5a—“hope will not put us to shame.” The enumeration of present benefits in vv. 1–2a leads up to this climax in v. 2b. The paradoxical boasting in tribulations of vv. 3–4 is something of an excursus, although it contributes to the central theme by showing that even the sufferings of the Christian lead on to hope (v. 4b). Verses 5–8 set Christian hope on the unshakable foundation of the love of God revealed in the cross. The parallel “how much more” arguments of vv. 9–10 reveal Paul’s concern to show the unbreakable connection between the Christian’s present status (“justified,” “reconciled”) and his fate in the judgment (“saved from wrath”). Verse 11, finally, picks up the “boasting” theme from vv. 2b–3a, returning to the peaceful relationship with God the believer may enjoy in this life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.298.24",
      "id": "FN.298.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Paul invites believers to take joyful pride in what God has given them; and, especially, he wants us to have complete assurance that God will deliver us from the final outpouring of his wrath on the day of judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.298.25",
      "id": "FN.298.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" The opening phrase of Rom. 5 is transitional. “Therefore, having been justified by faith” not only sums up the central teaching of Rom. 1–4, but, dependent as it is on the first person plural verb following, presents it as a blessing experienced by the readers of the letter. By believing in Jesus Christ, the divine agent in God’s climactic act of deliverance, Paul and the Roman Christians—and Christians of all ages and places—have been declared innocent of all charges justly brought against those who “sin and fall short of God’s glory” (3:23). Paul presents this declaration of justification as a past act, a perspective that is maintained throughout chaps. 5–8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.298.26",
      "id": "FN.298.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿26")]), _vm._v(" While justification brings to the believer a new and permanent status, justification itself is a once-for-all act by which God acquits the sinner. But what is the exact nature of this new status? What are its implications for our present lives and for the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.299"
    }
  }), _vm._v("future? It is these questions that Paul takes up in this section, and in chaps. 5–8 as a whole.")]), _vm._v(" "), _c('p', [_vm._v("The first implication of our justification is that “we have peace with God.” “Peace” is a word that, like so many in Paul and in the NT, must be understood according to its use in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", where it translates the wide-ranging Hebrew word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("shalōm.")]), _vm._v(" As a result, the word “peace”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.27",
      "id": "FN.299.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" moves beyond the largely negative signification of the word in secular Greek—“peace” as the cessation or absence of hostilities—to a more positive nuance—the well-being, prosperity, or salvation of the godly person. These are often expressly treated as the gifts of God, as in the well-known benediction, “The "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(" lift up his countenance on you and give you peace” (Num. 6:26). But especially important for Paul’s usage is the OT prophets’ use of the term peace to characterize the salvation that God would bring to his people in the “last days.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.28",
      "id": "FN.299.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" This background defines for us what Paul means by “peace with God”: not an inner sense of well-being, or “feeling at peace” (what we might call the “peace "), _c('i', [_vm._v("of")]), _vm._v(" God” [cf. Phil. 4:7]), but the outward situation of being in a relationship of peace "), _c('i', [_vm._v("with")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.29",
      "id": "FN.299.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.30",
      "id": "FN.299.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" While the word is not used again in this paragraph, the language of “reconciliation” in vv. 10–11 picks up this concept. “Peace,” or “reconciliation” with God, then, “frames” this paragraph. And, despite our emphasis on the “positive” dimensions of “peace” in the OT, we must recognize that Paul conceives this “peace with God” or “reconciliation” as created out of a situation of hostility; it was while we were “enemies” of God that he reconciled us (v. 10). We were weak, ungodly, sinners (vv. 6–8) when God in his love brought us into a new relationship of peace with him.")]), _vm._v(" "), _c('p', [_vm._v("“Peace with God” comes through, and only through, “our Lord Jesus Christ.” As the ultimate locus of God’s atoning, wrath-averting work, Christ is the one through whom the believing sinner receives justification (Rom. 3:25–26). Since peace with God, or reconciliation, is one way of viewing the new relationship into which we have been put by God’s justifying act in Christ, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.300"
    }
  }), _vm._v("it can no more be achieved apart from Christ than can justification itself. That all God has for us is to be found “in” or “through” Jesus Christ our Lord is a persistent motif in Rom. 5–8: peace with God comes “through our Lord Jesus Christ” (5:1); our boasting in God is “through our Lord Jesus Christ” (5:11); grace reigns through righteousness, resulting in eternal life “through Jesus Christ our Lord” (5:21); the gift of God bringing eternal life is “in Christ Jesus our Lord” (6:23); thanks for deliverance are due to God “through Jesus Christ our Lord” (7:25); the love of God, from which nothing can ever separate the believer is “in Christ Jesus our Lord” (8:39). When we consider that these phrases occur in only one other verse in Romans (15:30), and that every chapter in this part of the letter concludes on this note, a very definite focus on this matter is evident here. It is well known that Romans lacks any extended christological discussion per se, but Paul’s repeated insistence in these chapters that all the believer experiences of God’s blessings comes only through Christ develops a very significant christological focus in its own right. Christology, we might say, is not the topic of any part of Rom. 5–8, but it is the basis for everything in these chapters.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" As it is “through Jesus Christ our Lord” that we enjoy peace with God, it is through him also that “we have"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.31",
      "id": "FN.300.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" access into this grace in which we stand.” It is very difficult to know whether we should follow the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(" in translating “introduction” or the majority of English translations (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.REB"
    }
  }, [_vm._v("REB")]), _vm._v(", and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NAB"
    }
  }, [_vm._v("NAB")]), _vm._v(") and translate “access.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.32",
      "id": "FN.300.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" With the former translation, Paul would be focusing on the believer’s initial entry into the presence of the Lord Christ;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.33",
      "id": "FN.300.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" with the latter, the attention is more on the believer’s continuing ability to enjoy the presence of Christ. As my translation suggests, however, I think the context—in which Paul focuses on the blessings enjoyed by the believer as a result of being justified—favors the translation “access.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.34",
      "id": "FN.300.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Rather than making “God” the object of “access,” as we "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.301"
    }
  }), _vm._v("might have expected (see Eph. 2:18), Paul chooses “grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.35",
      "id": "FN.301.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" But it is not just to “grace” in general that we have access; but to “this grace in which we stand.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.36",
      "id": "FN.301.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" Paul has stressed at key points in his argument that all the believer has comes by grace (3:24; 4:16). Grace describes the free, unconstrained manner in which God acts toward his creatures (see also Rom. 11:5–6). Later in Rom. 5, Paul will use “grace” to denote the act of God in Christ (vv. 15, 17). Here, however, grace is used with a slightly different nuance, denoting not the manner in which God acts, or the gift that God gives, but the “state” or “realm” into which God’s redeeming work transfers the believer. It is the realm in which “grace reigns” (5:21), a realm that is set in contrast to the realm or domain of the law (6:14, 15: the believer is not “under the law” but “under grace”; cf. also Gal. 5:4)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.37",
      "id": "FN.301.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Without denying the presence of God’s grace throughout human history, Paul, along with the rest of the NT (cf. John 1:17), so focuses on God’s work in Christ as that act in which God’s grace was decisively and finally realized that he can picture the new status of the believer as one in which grace is characteristic and dominant. While this state of grace includes our justification as a key element,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.38",
      "id": "FN.301.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" the notion goes beyond justification to all that is conveyed to us by God in Christ.")]), _vm._v(" "), _c('p', [_vm._v("Included in that panoply of blessings is hope. As Paul in vv. 1–2a looks at the present situation of the Christian in light of the past, he now begins to contemplate that situation in light of the future."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.39",
      "id": "FN.301.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" This is the note that will dominate this paragraph, and “we boast in the hope of the glory of God”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.40",
      "id": "FN.301.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" is the key assertion in the passage. The word “boast” suggests here confidence "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.302"
    }
  }), _vm._v("and joy; perhaps we could render “we are joyfully confident of.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.302.41",
      "id": "FN.302.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" “Boasting” in human achievement is excluded by the gospel (3:27; cf. 4:2), but “boasting” because of the gracious provision of God in Christ is entirely appropriate. As in 3:23, “the glory of God” is that state of “God-like-ness” which has been lost because of sin, and which will be restored in the last day to every Christian (cf. 8:17, 18, 21, 30). A joyful confidence in this prospect, overcoming our (proper) frustration at our present failure to be all that God would want us to be, should be the mark of every believer.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3a")]), _vm._v(" As Paul in the parallel 8:18–30 contrasts the “glory that will be revealed in us” with “present sufferings” (v. 18), so he here turns quickly from our boasting in the hope of God’s glory to our boasting in “tribulations.” As Gifford puts it, “No sooner has the Apostle pointed to ‘the glory of God,’ as a light shining afar to cheer the believer on his course, than he thinks of the contrast between that bright distance and the darkness that lies around him here.” It is probably to head off criticism of his teaching that Paul introduces the “problem” of suffering. For (particularly) Jewish objectors would be likely to question Paul sharply about his affirmation that the Christian is enjoying “peace with God” when that same Christian is facing illness, persecution, and difficulties of all kinds. Indeed, Christians themselves, then as today, were surely wondering about the reality of these blessings in the face of suffering. Characteristically, Paul takes an offensive posture. Not only do sufferings not overthrow the reality of these blessings, but they are themselves occasions for joyful boasting! The believer should boast “not only” in the hope of the glory of God “but also” in afflictions. This means not merely that we are to exult “in the midst of” afflictions but that we are to exult “in”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.302.42",
      "id": "FN.302.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" the afflictions themselves: that is, to view them as a basis for further confidence in our redeemed status.")]), _vm._v(" "), _c('p', [_vm._v("What are these “afflictions”?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.302.43",
      "id": "FN.302.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" Some would confine them to those sufferings caused directly by the believer’s profession of Christ. But Paul’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.303"
    }
  }), _vm._v("use of the word “affliction(s)” makes any such restriction questionable. Indeed, in a certain sense, all sufferings are “on behalf of Christ.” This is so because all the evil that the Christian experiences reflects the conflict between “this age,” dominated by Satan, and “the age to come,” to which the Christian has been transferred by faith. All suffering betrays the presence of the enemy and involves attacks on our relationship to Christ. If met with doubt in God’s goodness and promise, or bitterness toward others, or despair and even resignation, these sufferings can bring spiritual defeat to the believer. But if met with the attitude of “confidence and rejoicing” that Paul encourages here, these sufferings will produce those valuable spiritual qualities that Paul lists in vv. 3b–4.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3b–4")]), _vm._v(" The reason why the believer can “rejoice in afflictions” is that he or she “knows”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.44",
      "id": "FN.303.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" that affliction “produces"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.45",
      "id": "FN.303.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿45")]), _vm._v(" endurance,” and endurance, in turn, “a tested character,” and a tested character, in turn, hope. Sequences of this kind, in which suffering inaugurates a chain of linked virtues, are introduced as a stimulus to face difficulties with joy in two other NT texts (1 Pet. 1:6b–7; Jas. 1:2–4) and must have been popular in the early church—probably reflecting earlier Jewish exhortation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.46",
      "id": "FN.303.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" As in Jas. 1:3, the first virtue in the list is “endurance,” a word that denotes the spiritual fortitude that bears up under, and is, indeed, made even stronger by, suffering."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.47",
      "id": "FN.303.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" It suggests that “stick-to-itiveness” which is required if the word of God is to produce fruit in us (Luke 8:15) and that long-distance, marathoner’s endurance which will enable us to run the race set before us right to the finish line (Heb. 12:1). “Endurance,” in turn, will, if our attitude is right, produce a “tested character.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.48",
      "id": "FN.303.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" As a result of this tested character, finally, the Christian who responds to sufferings with the proper attitude will find, at the end of the line, that hope has been strengthened. Sufferings, rather than threatening or weakening our hope, as we might expect to be the case, will, instead, increase our certainty in that hope. Hope, like a muscle, will not be strong if it goes unused. It is in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.304"
    }
  }), _vm._v("suffering that we must exercise with deliberation and fortitude our hope, and the constant reaffirmation of hope in the midst of apparently “hopeless” circumstances will bring ever-deeper conviction of the reality and certainty of that for which we hope (see Rom. 4:18–19).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" This verse makes clear that “hope” is the focal point of 5:1–11. It functions as a “hinge” in the paragraph (Godet), attached on the one side to v. 2b, which v. 5a reiterates and expands, and on the other side to vv. 6–10, which v. 5b introduces. We can rejoice in hope, knowing it will not disappoint us, because of the “amazing grace” of God’s love (vv. 5b–8) and because of the decisive and final significance of what God has done for us in Christ (vv. 9–10).")]), _vm._v(" "), _c('p', [_vm._v("The first part of v. 5—“Now this hope will not put us to shame”—is reminiscent of OT passages that affirm that those who hope in God will not “be put to shame.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.49",
      "id": "FN.304.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Christians need not fear that the judgment will “put them to shame,” in the sense that the foundation on which they have built their lives and hope for eternal blessing should prove inadequate. The last clause of the verse is causal: Christians are confident that they will not be put to shame “because"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.50",
      "id": "FN.304.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿50")]), _vm._v(" the love of God has been poured out into our hearts by the Holy Spirit who has been given to us.” Granted this purpose, and Paul’s choice of the verb “pour out,” it is certain that we should paraphrase “the love of God for us” rather than “our love for God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.51",
      "id": "FN.304.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" The confidence we have for the day of judgment is not based only on our intellectual recognition of the fact of God’s love, or even only on the demonstration of God’s love on the cross (although that is important; cf. vv. 6–8), but also on the inner, subjective certainty that God does love us. This is the point Paul is making by affirming that God’s love has been “poured out in our hearts through the Holy Spirit who was given to us.” The verb “pour out”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.52",
      "id": "FN.304.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" connotes an abundant, “extravagant,” effusion: “he does not say ‘given’ but ‘shed abroad in our hearts,’ so showing the profusion of it” (Chrysostom). Paul uses this same "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.305"
    }
  }), _vm._v("verb to depict the “pouring out” of God’s Spirit (Tit. 3:6; cf. Acts 2:17, quoting Joel 2:28–32). This raises the possibility that the “real” subject of “pour out” is the Holy Spirit, who witnesses to our hearts of the love of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.53",
      "id": "FN.305.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" But we must respect Paul’s decision to make “the love of God” the subject of the verb."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.54",
      "id": "FN.305.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" Paul is asserting two things at once: that God’s love has been poured into our hearts in the past, and that this love is now within us."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.55",
      "id": "FN.305.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" And this love is conveyed to our sensations by the Holy Spirit, who resides in every believer."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.56",
      "id": "FN.305.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', [_vm._v("For the first time in Romans, Paul speaks of God’s love, a topic that is more prominent in Paul than we sometimes realize (cf. Morris). Paul stresses that God’s love for us is active—it is a love that gives to us and takes possession of us (cf., e.g., 2 Cor. 5:14: “the love of Christ controls us”), and which can stand for all that God has done and will do for us (cf. 8:35: “Who shall separate us from the love of Christ?”). Paul’s language reflects prophetic descriptions of the eschatological gift of God’s Spirit as part of the inauguration of the New Covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.57",
      "id": "FN.305.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" That covenant promises a new and permanent relationship between God and his people, a relationship in which our “sins are remembered no more” (Jer. 31:34) and in which we are given a hope that involves “being changed into Christ’s likeness from one degree of glory to another” (2 Cor. 3:12–18)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.58",
      "id": "FN.305.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" What in the Old Covenant was (in some respects, at least) external has been internalized in the New Covenant. And it is this internal, subjective—yes, even emotional—sensation within the believer that God does indeed love us—love expressed and made vital in real, concrete actions on our behalf—that gives to us the assurance that “hope will not disappoint us.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.59",
      "id": "FN.305.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" Verses 6–8 form a single argument that demonstrates the abundant and absolute nature of God’s love for us. We may summarize Paul’s argument (making explicit some points that are implicit) as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.306"
    }
  }), _vm._v("a. Human love, at its best, will motivate a person to give his or her life for a truly “good” person (v. 7);")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("b. Christ, sent by God, died, not for “righteous” people, or even for “good” people, but for rebellious and undeserving people (v. 6);")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("c. Therefore: God’s love is far greater in its magnitude and dependability than even the greatest human love (v. 8).")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This argument functions not only to provide evidence for the love of God (and especially its profusion [“poured out”]) by tracing that love we experience in our hearts to its source but also, in doing so, to substantiate the utter dependability of our hope (v. 5a)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.60",
      "id": "FN.306.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" Paul accentuates the unity of the argument in vv. 6–8 by ending each sentence (in the Greek text) with the verb “die.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.61",
      "id": "FN.306.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', [_vm._v("The first sentence in Paul’s argument (v. 6) is syntactically complex, but clear enough in its meaning: “For while we were still weak, at just the right time, Christ died for godless people.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.62",
      "id": "FN.306.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" Paul makes clear the point he especially wants to convey here by characterizing the human beings Christ died for as both “godless” and “weak.” “Godless” is a strong pejorative term in Paul (cf. Rom. 4:5); “weak” is not always as negative, but here designates that “total incapacity for good” which is characteristic of the unredeemed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.63",
      "id": "FN.306.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" Paul thereby stresses that God’s love came to us when we were utterly helpless."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.64",
      "id": "FN.306.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.307"
    }
  }), _vm._v("Paul’s assumptions about the intimate relationship between God and Christ, as well as his concern to highlight the practical, concrete nature of God’s love, surfaces in his argument that "), _c('i', [_vm._v("Christ’s")]), _vm._v(" dying “for"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.65",
      "id": "FN.307.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿65")]), _vm._v(" us” demonstrates the love "), _c('i', [_vm._v("“of God”")]), _vm._v(" (v. 5; and note the reference to the Holy Spirit in v. 5b). Paul never thinks of God’s love for us apart from the cross, and he never thinks of Christ’s dying for us apart from the Father’s giving of the Son (cf. Rom. 3:25). The most puzzling element in this verse is the prepositional phrase “at just the right time.” The phrase probably modifies the main clause of the verse, “Christ died for godless people.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.66",
      "id": "FN.307.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" But what does Paul mean by saying that Christ died “at the appropriate time”?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.67",
      "id": "FN.307.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" He may mean that it was the “right” time in world history for the sending of Christ and the proclamation of the gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.68",
      "id": "FN.307.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" Or he may be thinking of the time as “right” because it was the time when, had not Christ died, God’s wrath would have been poured out."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.69",
      "id": "FN.307.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" Related to both these suggestions, but with better foundation in Paul’s theology, is the interpretation that takes “right time” to mean the culminating, eschatological “time” of God’s intervention in Christ (see Rom. 3:26; 8:18; 13:11)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.70",
      "id": "FN.307.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" This last suggestion, which is the best of the three, is yet open to the objection that Paul usually adds a qualifier to “time” when it has this meaning. Considering the context, it is best to give the phrase a less theological and more prosaic meaning, and take it as further emphasizing “still”: “Christ died for the ungodly just "), _c('i', [_vm._v("at that very time")]), _vm._v(" when we were weak.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.71",
      "id": "FN.307.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("7")]), _vm._v(" The main point of this verse is clear enough. Paul accentuates the love of God manifested in the cross of Christ by reminding us that the pinnacle of human love is the giving of one’s life for a person one is close to—a spouse, child, or combat buddy—whereas God sent his Son to die for people who hated "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.308"
    }
  }), _vm._v("him (v. 8)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.72",
      "id": "FN.308.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" But Paul’s way of stating this point creates some confusion. For it is not clear what the relationship between the two clauses is—“hardly ever"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.73",
      "id": "FN.308.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿73")]), _vm._v(" will someone die"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.74",
      "id": "FN.308.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿74")]), _vm._v(" for a righteous person; although for a good person one might dare to die.” Interpretations fall into two categories. On the one hand are those that do not make any important distinction between “righteous person” in the first sentence and “good person” in the second. If this is so, the second sentence could be the replacement for the first, Tertius, Paul’s scribe, accidentally leaving in the first, “uncorrected,” sentence."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.75",
      "id": "FN.308.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" Or it could clarify the first by “softening” the assertion that a person would “scarcely” die for anyone else."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.76",
      "id": "FN.308.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" In the second category are those interpretations that give to the second sentence a concessive force: “one would scarcely die for a righteous person, "), _c('i', [_vm._v("although")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.77",
      "id": "FN.308.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿77")]), _vm._v(" for a good person, one might, indeed, be willing to die.” On this view, a “good person” would be one who has a stronger claim on one’s emotions than the “righteous person” of the first clause. While the “righteous person” would be one who is just and upright in his dealings and would therefore have some claim on our respect, the “good person” would be one for whom we have a strong personal attachment and for whom, therefore, we would be more willing to die."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.78",
      "id": "FN.308.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" It is true that a distinction of this sort between “righteous” and “good” does not have much NT support."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.79",
      "id": "FN.308.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" But it does find some support in extrabiblical materials."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.80",
      "id": "FN.308.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.309"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("8")]), _vm._v(" In contrast to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.81",
      "id": "FN.309.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿81")]), _vm._v(" the very best of human love is God’s love; for he “commends"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.82",
      "id": "FN.309.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" his own"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.83",
      "id": "FN.309.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿83")]), _vm._v(" love for us,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.84",
      "id": "FN.309.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" in that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.85",
      "id": "FN.309.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿85")]), _vm._v(" while we were still sinners Christ died for us.” Again we see the assumption that "), _c('i', [_vm._v("God’s")]), _vm._v(" love is shown in "), _c('i', [_vm._v("Christ’s")]), _vm._v(" death (cf. v. 6). We notice also that Paul finds a basic unity, even identity, between the love of God as it is shown in the objective, factual event of Christ’s death on the cross and as it is experienced “in the heart” by the believer (v. 5b). An emotional feeling of God’s love, in itself, is little comfort to the person who is lost, condemned, doomed for hell. But a cold, sober, historical interpretation that indeed God “loved the world” on the cross is of little benefit to a person until that love is experienced, is received, by faith in Christ. It is when these are properly experienced as two aspects of one great love, ultimately indivisible, that our assurance that “hope will not put us to shame” (v. 5a) will be strong and unshakable.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9")]), _vm._v(" In vv. 9–10, Paul gathers together the main pieces of vv. 1–8 into a synthesis that reiterates and expands the central point of the paragraph as a whole: the certainty of Christian hope (vv. 2b, 5a). The two verses are parallel statements of the same point, as the following layout shows:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "borderbot"
  }, [_c('p', {
    staticClass: "tchleft"
  }, [_vm._v("v. 9")])]), _vm._v(" "), _c('td', {
    staticClass: "borderbot"
  }, [_c('p', {
    staticClass: "tchleft"
  }, [_vm._v("v. 10")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("if, while we were enemies,")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("having now been justified")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("we were reconciled to God")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through his blood")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through the death of his Son")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("how much more")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("how much more")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("being reconciled")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("will we be saved")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("will we be saved")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("from wrath")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through him")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through his life")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The argument in each of the verses takes the form of a popular logical sequence, called by the rabbis "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qal wayyōmer")]), _vm._v(" (“light and heavy”) and in the western tradition "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("a minori ad maius")]), _vm._v(" (“from the minor to the major”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.86",
      "id": "FN.309.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(" In "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.310"
    }
  }), _vm._v("this case, however, the “how much more” in Paul’s transition suggests that the argument proceeds from the “major” to the “minor”:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.87",
      "id": "FN.310.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" if God has already done the most difficult thing—reconcile and justify unworthy sinners—how much more can he be depended on to accomplish the “easier” thing—save from eschatological wrath those who have been brought into such relationship with him. In this double statement, Paul incorporates in the first member many of the elements of present Christian experience that he has touched on in vv. 1–8: “being justified by faith” (v. 1a; alluded to in v. 9a), “having peace with God” (v. 1b; picked up in the language of reconciliation in v. 10), having the love of God, revealed on the cross, in our hearts (vv. 5b–8; suggested by the stress on the death of "), _c('i', [_vm._v("God’s")]), _vm._v(" Son in v. 10), having experienced all this when we were “ungodly,” “weak,” “sinners” (vv. 6–8; cf. v. 10a: “enemies”). Similarly, the second part of the argument restates and elaborates the “hope” of vv. 2b and 5a.")]), _vm._v(" "), _c('p', [_vm._v("As in v. 1, “being justified”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.88",
      "id": "FN.310.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" alludes to the past declaration of acquittal pronounced over the sinner who believes in Christ. But the “now” adds the nuance of the continuing “just” status of those so acquitted. The means by which this justifying act takes place is Christ’s blood."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.89",
      "id": "FN.310.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" As in 3:25, “blood” signifies Christ’s death as a sacrifice for sins. These are the only two places in Romans in which “blood” has this sacrificial sense, and the other similarities between vv. 9–10 and 3:21–26 (justification, deliverance from wrath [alluded to with "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v("]) suggest that Paul may here be drawing from that compact summary of the work of Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.90",
      "id": "FN.310.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" The justified status conveyed to the believer on the basis of Christ’s sacrificial death issues in salvation from wrath. The temporal element in the verse makes clear that wrath refers here to eschatological judgment (cf. 2:5). “We will be saved” is, then, a genuine temporal future. As he typically does, Paul uses salvation language to depict the final deliverance of the believer from sin, death, and judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.91",
      "id": "FN.310.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" Salvation, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.311"
    }
  }), _vm._v("accomplished in Christ and the believer’s appropriation of Christ, is finally realized only in the last day. This double temporal conception is typical of NT teaching, which insists on the absolute and final nature of the believer’s acceptance of salvation while also maintaining that salvation is not complete until the body is redeemed and glorified (cf. Rom. 8:23; Phil. 3:21). It is precisely the tension set up by this “already-not yet” perspective that gives rise to the need to proclaim the unbreakable connection between the believer’s justification and his or her salvation from the wrath of God still to be poured out in the last day. Paul suggests the unbreakable connection between the two by insisting that, as initial salvation is “through his blood,” so final salvation is also “through him.” In light of the parallel phrase in v. 11, “in his life,” Paul probably means by this the mediation of the risen Christ, who, through his resurrection, has been “appointed as Son-of-God-in-power” (cf. 1:4; 8:35)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.92",
      "id": "FN.311.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10")]), _vm._v(" The parallelism between this verse and v. 9 renders the differences between them all the more significant. Perhaps the most interesting is the substitution of “reconciled” for “justified.” Justification language is legal, law-court language, picturing the believer being declared innocent by the judge. Reconciliation language, on the other hand, comes from the world of personal relationships. “To reconcile” means to bring together, or make peace between, two estranged or hostile parties (cf. 1 Cor. 7:11)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.93",
      "id": "FN.311.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(" The language of reconciliation is seldom used in other religions because the relationship between human beings and the deity is not conceived there in the personal categories for which the language is appropriate."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.94",
      "id": "FN.311.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" Reconciliation in Paul has two aspects, or “moments”: the accomplishment of reconciliation through Christ on the cross (cf. 2 Cor. 5:19: “in Christ God was reconciling the world to himself”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.95",
      "id": "FN.311.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" and the acceptance of that completed work by the believer (cf. 2 Cor. 5:20b: “We beseech you on behalf of Christ, be reconciled to God”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.96",
      "id": "FN.311.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.312"
    }
  }), _vm._v("Naturally, while the focus can be on one of these moments or the other, the reconciling activity of God is ultimately one act; and in the present verse the complete process is in view. Paul makes explicit the hostile relationship implicit in the language of reconciliation: it was “while we were enemies” that we were reconciled to God. Paul may mean by this simply that we, rebellious sinners, are hostile toward God—violating his laws, putting other gods in his place."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.97",
      "id": "FN.312.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(" But, as Paul has repeatedly affirmed in this letter (cf. 1:18; 3:25), God is also “hostile” toward us—our sins have justly incurred his wrath, which stands as a sentence over us (1:19–32), to be climactically carried out on the day of judgment (2:5). Probably, then, the “enmity” to which Paul refers here includes God’s hostility toward human beings as well as human beings’ hostility toward God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.98",
      "id": "FN.312.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" Outside of Christ, people are in a situation of “enmity” with God; and in reconciliation, it is that status, or relationship, that changes: we go from being God’s “enemies” to being his “children” (cf. Rom. 8:14–17).")]), _vm._v(" "), _c('p', [_vm._v("As in v. 9 justification is accomplished “through” Christ’s blood, so here reconciliation takes place “through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.99",
      "id": "FN.312.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿99")]), _vm._v(" the death of [God’s] Son.” Similarly, “we will be saved,” though not further defined, must have the same referent as the same verb in v. 9: salvation from the wrath of God on the day of judgment. The meaning of the phrase “through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.100",
      "id": "FN.312.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿100")]), _vm._v(" his life” is not so clear. In light of Paul’s frequent, and theologically significant, use of “in Christ” language in Rom. 5–8, he could intend to depict our salvation as occurring “in the sphere of” Christ, or his life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.101",
      "id": "FN.312.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" On the other hand, it is unusual for Paul to use “in Christ” language with another noun intervening between the preposition and “Christ”; and the phrase seems to be parallel to “through him” in v. 9, where an instrumental meaning is certain. Probably, then, the phrase indicates that the new life won by Christ and in which believers share is the means by which they will be saved in the judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.102",
      "id": "FN.312.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11")]), _vm._v(" This verse wraps up the section by rehearsing many of its key "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.313"
    }
  }), _vm._v("elements: “boasting/rejoicing” (cf. vv. 2–3); the present experience of reconciliation with God (vv. 1b, 10); and, most of all, the fact that this boasting, and this reconciliation, are “through our Lord Jesus Christ” (vv. 1, 2, 6–8, 9, 10)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.103",
      "id": "FN.313.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" But the exact relationship of this verse to the rest of the paragraph is dependent on decisions we must make about two syntactical issues. First is the question of the point of comparison in the transitional phrase “and not only this.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.104",
      "id": "FN.313.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")]), _vm._v(" If Paul intends these words as a transition from the immediately preceding verse, then the point of comparison could be “we will be saved”—“and not only will we be saved, but …”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.105",
      "id": "FN.313.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v("—or “being reconciled”—“and not only [are we those] who are reconciled, but [we are those] rejoicing.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.106",
      "id": "FN.313.106r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")]), _vm._v(" On the other hand, Paul may want us to go further back into the text for the implied connection: either to the last use of “rejoice” in v. 3—“and not only do we rejoice in afflictions, but we rejoice also in …”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.107",
      "id": "FN.313.107r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")]), _vm._v("—or, more generally, to the teaching of vv. 3–10 as a whole—“and not only is all this true, but.…”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.108",
      "id": "FN.313.108r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")]), _vm._v(" Since Paul elsewhere uses this transitional phrase to pick up an immediately preceding statement,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.109",
      "id": "FN.313.109r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")]), _vm._v(" it is more likely that Paul wants us to supply something from v. 10; and “salvation” is more likely than “reconciliation,” since the latter occurs later in the verse.")]), _vm._v(" "), _c('p', [_vm._v("The second issue has to do with the mood of the verb we have translated “boast.” It is a participle in Greek,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.110",
      "id": "FN.313.110r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")]), _vm._v(" and it could well then be a subordinate verb, with a main verb to be discovered. This main verb could be “we will be saved” from v. 10."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.111",
      "id": "FN.313.111r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿111")]), _vm._v(" But taking the participle as the main verb of the sentence is grammatically unobjectionable"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.112",
      "id": "FN.313.112r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿112")]), _vm._v(" and makes for a smoother reading. We take it, then, that Paul in v. 11 is turning back from the future prospect of the believer, with which he has been occupied in vv. 5–10, to the “boasting” or “rejoicing”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.113",
      "id": "FN.313.113r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")]), _vm._v(" that marks the reaction of the believer in this life to all that God has done for him or her (cf. vv. 1–4)—rejoicing that everything God gives us is “through our Lord Jesus Christ.” But perhaps we should say, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.314"
    }
  }), _vm._v("“should mark” the reaction of the believer—for although Paul states our boasting as a fact, he undoubtedly wants to encourage any who are faltering or downhearted to contemplate again what he or she has in Christ—a new relationship with God (“justification,” “peace with God,” “reconciliation”) that overcomes all present adversity (“rejoicing in afflictions”) and that provides absolute security for the life to come (“rejoicing in the glory of God,” “hope does not disappoint us,” “saved from wrath”). And such contemplation can lead only to rejoicing. So Chrysostom: “And so the fact of his saving us, and saving us too when we were in such plight, and doing it by means of his only-begotten, and not merely by his only-begotten, but by his blood, weaves for us endless crowns to glory in.”")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467422697',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(178)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(180);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 180 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.59e5bd65c547fcf4e216.js